// empty icon 8x8
export const EMPTY_SYMBOL_8 = {
	d: '',
	size: 8,
};

// empty icon 16x16
export const EMPTY_SYMBOL_16 = {
	d: '',
	size: 16,
};

// empty icon 24x24
export const EMPTY_SYMBOL_24 = {
	d: '',
	size: 24,
};

// empty icon 32x32
export const EMPTY_SYMBOL_32 = {
	d: '',
	size: 32,
};

// 32x32/home/outline.svg
export const HOME_OUTLINE_32 = {
	d: 'M25 26c0 1.103-.897 2-2 2h-2v-9a5 5 0 00-5-5 5 5 0 00-5 5v9H9c-1.103 0-2-.897-2-2V11.926l9-7.616 9 7.616V26zm4.646-12.764l-13-10.999a.998.998 0 00-1.292 0l-13 10.999A1.007 1.007 0 002 14a.992.992 0 00.236.646c.357.421.988.473 1.41.118L5 13.617V26c0 2.206 1.794 4 4 4h14c2.206 0 4-1.794 4-4V13.617l1.354 1.147a1 1 0 001.292-1.528z',
	size: 32,
};

export const HOME_32 = HOME_OUTLINE_32;
// 32x32/home/filled.svg
export const HOME_FILLED_32 = {
	d: 'M21 28H11v-9a5 5 0 015-5 5 5 0 015 5v9zm8.646-14.764l-13-10.999a.998.998 0 00-1.292 0l-13 10.999a1.006 1.006 0 00-.118 1.41c.357.421.989.473 1.41.118L5 13.617V26c0 2.206 1.794 4 4 4h14c2.206 0 4-1.794 4-4V13.617l1.354 1.147a1 1 0 001.292-1.528z',
	size: 32,
};

// 32x32/bookmark add/outline.svg
export const BOOKMARK_ADD_OUTLINE_32 = {
	d: 'M28 7h-4V3a1 1 0 10-2 0v4h-4a1 1 0 100 2h4v4a1 1 0 102 0V9h4a1 1 0 100-2zm-6 9h2v13.724l-8-4.573-8 4.573V5a3 3 0 013-3h9v2h-9a1 1 0 00-1 1v21.276l5.008-2.861a2 2 0 011.984 0L22 26.276V16z',
	size: 32,
};

export const BOOKMARK_ADD_32 = BOOKMARK_ADD_OUTLINE_32;
// 32x32/bookmark add/filled.svg
export const BOOKMARK_ADD_FILLED_32 = {
	d: 'M28 7h-4V3a1 1 0 10-2 0v4h-4a1 1 0 100 2h4v4a1 1 0 102 0V9h4a1 1 0 100-2zm-5 9h1v14l-8-5-8 5V5a3 3 0 013-3h9v3h-2a3 3 0 100 6h2v2a3 3 0 003 3z',
	size: 32,
};

// 32x32/comment/outline.svg
export const COMMENT_OUTLINE_32 = {
	d: 'M24 14a2 2 0 11-4.001-.001A2 2 0 0124 14zm-6 0a2 2 0 11-4.001-.001A2 2 0 0118 14zm-6 0a2 2 0 11-4.001-.001A2 2 0 0112 14zm13.414 7.019C23.597 22.37 20.605 23 16 23c-.579 0-1.14-.011-1.665-.03l-.56-.022-.489.272L9 25.601v-3.332l-1.163-.536C5.939 20.859 4 19.258 4 14c0-4.566 1.476-6.192 2.586-7.019C8.403 5.63 11.395 5 16 5c4.605 0 7.597.63 9.414 1.981C26.524 7.808 28 9.434 28 14c0 4.566-1.476 6.192-2.586 7.019zM16 3C6.378 3 2 5.673 2 14c0 5.032 1.611 7.989 5 9.55V29l7.258-4.032c.56.021 1.14.032 1.742.032 9.622 0 14-2.673 14-11S25.622 3 16 3z',
	size: 32,
};

export const COMMENT_32 = COMMENT_OUTLINE_32;
// 32x32/comment/filled.svg
export const COMMENT_FILLED_32 = {
	d: 'M22 16a2 2 0 11.001-4.001A2 2 0 0122 16zm-6 0a2 2 0 11.001-4.001A2 2 0 0116 16zm-6 0a2 2 0 11.001-4.001A2 2 0 0110 16zm6-13C6.378 3 2 5.673 2 14c0 5.032 1.611 7.989 5 9.55V29l7.258-4.032c.56.021 1.14.032 1.742.032 9.622 0 14-2.673 14-11S25.622 3 16 3z',
	size: 32,
};

// 32x32/label add/outline.svg
export const LABEL_ADD_OUTLINE_32 = {
	d: 'M29.5 23.5a1 1 0 01-1 1h-3v3a1 1 0 11-2 0v-3h-3a1 1 0 110-2h3v-3a1 1 0 112 0v3h3a1 1 0 011 1zm-8-10a3 3 0 110-6 3 3 0 010 6zm7-11h-11a.996.996 0 00-.707.293l-14 14a.999.999 0 000 1.414l11 11a.997.997 0 001.414 0l2.89-2.889-.569-2.26-3.028 3.028L4.914 17.5l13-13H27.5v9.586l-2.442 2.442 2.26.568 1.89-1.889a.996.996 0 00.292-.707v-11a1 1 0 00-1-1z',
	size: 32,
};

export const LABEL_ADD_32 = LABEL_ADD_OUTLINE_32;
// 32x32/trash/outline.svg
export const TRASH_OUTLINE_32 = {
	d: 'M26 5a1 1 0 00-1-1h-3a2 2 0 00-2-2h-8a2 2 0 00-2 2H7a1 1 0 100 2h18a1 1 0 001-1zM9 10v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10H9zM7 26V8h18v18a4 4 0 01-4 4H11a4 4 0 01-4-4z',
	size: 32,
};

export const TRASH_32 = TRASH_OUTLINE_32;
// 32x32/trash/filled.svg
export const TRASH_FILLED_32 = {
	d: 'M25 4a1 1 0 110 2H7a1 1 0 110-2h3a2 2 0 012-2h8a2 2 0 012 2h3zm0 22V8H7v18a4 4 0 004 4h10a4 4 0 004-4z',
	size: 32,
};

// 32x32/book/outline.svg
export const BOOK_OUTLINE_32 = {
	d: 'M22 8.5a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 010-3h9A1.5 1.5 0 0122 8.5zM8 28a1 1 0 110-2h16v2H8zM7 5a1 1 0 011-1h17v20H7V5zm20 19V4a2 2 0 00-2-2H8a3 3 0 00-3 3v22a3 3 0 003 3h18a1 1 0 100-2v-2.277c.596-.347 1-.985 1-1.723z',
	size: 32,
};

export const BOOK_32 = BOOK_OUTLINE_32;
// 32x32/book/filled.svg
export const BOOK_FILLED_32 = {
	d: 'M24 28H8a1 1 0 110-2h16v2zM11.5 7h9a1.5 1.5 0 010 3h-9a1.5 1.5 0 010-3zM27 24V4a2 2 0 00-2-2H8a3 3 0 00-3 3v22a3 3 0 003 3h18a1 1 0 100-2v-2.277c.596-.347 1-.985 1-1.723z',
	size: 32,
};

// 32x32/folder move/outline.svg
export const FOLDER_MOVE_OUTLINE_32 = {
	d: 'M17 15.5v3h-6a1 1 0 100 2h6v3l6-4-6-4zm-12-5v-4c0-.552.449-1 1-1h4c1.322 0 2.138 1.052 2.927 2.068.155.2.304.392.451.57.19.229.473.362.77.362H26c.551 0 1 .448 1 1v1h2v-1c0-1.654-1.346-3-3-3H14.629l-.122-.158C13.577 5.143 12.302 3.5 10 3.5H6c-1.654 0-3 1.346-3 3v4h2zm21.293 14.293C26.918 24.104 28 18.755 28 14.5c0-.683-.318-1-1-1H5c-.682 0-1 .317-1 1 0 4.255 1.082 9.604 1.71 10.296.397.397 2.323 1.704 10.29 1.704 7.967 0 9.893-1.307 10.293-1.707zM27 11.5c1.794 0 3 1.206 3 3 0 3.195-.809 10.224-2.293 11.707C26.186 27.729 22.247 28.5 16 28.5c-6.247 0-10.186-.771-11.707-2.293C2.809 24.724 2 17.695 2 14.5c0-1.794 1.206-3 3-3h22z',
	size: 32,
};

export const FOLDER_MOVE_32 = FOLDER_MOVE_OUTLINE_32;
// 32x32/folder move/filled.svg
export const FOLDER_MOVE_FILLED_32 = {
	d: 'M23 19.5l-6 4v-3h-6a1 1 0 110-2h6v-3l6 4zm7-5c0-1.794-1.206-3-3-3H5c-1.794 0-3 1.206-3 3 0 3.195.758 10.224 2.242 11.707C5.764 27.729 9.753 28.5 16 28.5c6.247 0 10.135-.771 11.656-2.293C29.14 24.724 30 17.5 30 14.5zm-27-5h26v-1a2 2 0 00-2-2H14c-.966-1.166-1.878-3-4-3H5c-1.104 0-2.051.896-2.051 2L3 9.5z',
	size: 32,
};

// 32x32/mail alt1/outline.svg
export const MAIL_ALT1_OUTLINE_32 = {
	d: 'M26 24H6c-1.103 0-2-.897-2-2V11.674l12 6.462 12-6.462V22c0 1.103-.897 2-2 2zM6 8h20c.91 0 1.672.615 1.913 1.449L16 15.864 4.087 9.449A1.996 1.996 0 016 8zm20-2H6a4 4 0 00-4 4v12a4 4 0 004 4h20a4 4 0 004-4V10a4 4 0 00-4-4z',
	size: 32,
};

export const MAIL_ALT1_32 = MAIL_ALT1_OUTLINE_32;
// 32x32/mail alt1/filled.svg
export const MAIL_ALT1_FILLED_32 = {
	d: 'M16 18.134L2 10.667V22a4 4 0 004 4h20a4 4 0 004-4V10.667l-14 7.467zM2.281 8.55A3.994 3.994 0 016 6h20a3.994 3.994 0 013.719 2.55L16 15.866 2.281 8.55z',
	size: 32,
};

// 32x32/calendar/filled.svg
export const CALENDAR_FILLED_32 = {
	d: 'M18 15a2 2 0 10-4 0 2 2 0 004 0zm-7.5-2a2 2 0 110 4 2 2 0 010-4zm5.5 6a2 2 0 110 4 2 2 0 010-4zm12-3c0-5-.73-7.72-2.5-9.5A7.66 7.66 0 0022 4.6v1.9a1.5 1.5 0 01-3 0V4.12C18.1 4 17.11 4 16 4s-2.1 0-3 .12V6.5a1.5 1.5 0 01-3 0V4.6a7.66 7.66 0 00-3.5 1.9C4.73 8.28 4 11 4 16c0 4.32.44 5.09 3.46 8.46 3.02 3.37 4.19 3.54 8.1 3.54H16c5 0 7.73-.72 9.5-2.5C27.27 23.72 28 21 28 16zm-2 0c0 4.32-.58 6.73-1.92 8.08C22.74 25.43 20.32 26 16 26h-.33a10.66 10.66 0 01-3.67-.33v-3.75a3 3 0 00-3-3H6.16A15.35 15.35 0 016 16a24.06 24.06 0 01.42-5h19.16a24.03 24.03 0 01.42 5zm-4.5 3a2 2 0 110 4 2 2 0 010-4zm0-6a2 2 0 110 4 2 2 0 010-4z',
	size: 32,
};

// 32x32/mail unread/outline.svg
export const MAIL_UNREAD_OUTLINE_32 = {
	d: 'M26 5a4 4 0 110 8 4 4 0 010-8zM16 26c-5.254 0-8.192-.562-9.791-1.863l5.404-6.177L16 21.25l4.387-3.29 5.405 6.177C24.192 25.438 21.254 26 16 26zM4 16c0-1.396.072-2.572.208-3.595l5.801 4.352-5.03 5.749C4.309 21.085 4 19.018 4 16zm23.973-1.339c.016.426.027.865.027 1.339 0 3.018-.309 5.085-.979 6.506l-5.029-5.749 2.579-1.936a5.936 5.936 0 01-2.065-.95L16 18.75 4.674 10.257c.341-1.02.809-1.785 1.442-2.327C7.693 6.577 10.649 6 16 6c1.837 0 3.373.074 4.687.218a5.987 5.987 0 011.459-1.813C20.447 4.125 18.432 4 16 4c-5.583 0-9.083.608-11.187 2.412C2.709 8.216 2 11.216 2 16c0 4.784.709 7.784 2.813 9.588C6.917 27.393 10.417 28 16 28c5.583 0 9.083-.607 11.187-2.412C29.292 23.784 30 20.784 30 16c0-.886-.034-1.691-.086-2.458a6 6 0 01-1.941 1.119z',
	size: 32,
};

export const MAIL_UNREAD_32 = MAIL_UNREAD_OUTLINE_32;
// 32x32/mail unread/filled.svg
export const MAIL_UNREAD_FILLED_32 = {
	d: 'M22 9a4 4 0 108 0 4 4 0 00-8 0zm-6 12.271l-4.327-3.399-6.859 7.717C6.918 27.393 10.418 28 16 28s9.082-.607 11.186-2.411l-6.859-7.717L16 21.271zM26 15a6.012 6.012 0 01-1.702-.248l-2.397 1.883 6.585 7.407C29.592 22.211 30 19.616 30 16c0-.886-.033-1.693-.088-2.456A5.975 5.975 0 0126 15zm-3.66-1.253A5.984 5.984 0 0120 9c0-1.846.834-3.495 2.146-4.595C20.447 4.125 18.432 4 16 4c-5.582 0-9.082.608-11.187 2.412-.699.599-1.232 1.346-1.648 2.231L16 18.729l6.34-4.982zm-12.241 2.888l-6.585 7.407C2.408 22.211 2 19.616 2 16c0-2.121.151-3.873.489-5.344l7.61 5.979z',
	size: 32,
};

// 32x32/wallet/outline.svg
export const WALLET_OUTLINE_32 = {
	d: 'M25 18a3 3 0 11-6 0 3 3 0 016 0zm3 8a1 1 0 01-1 1H5a1 1 0 01-1-1V10a1 1 0 011-1h22a1 1 0 011 1v16zM27 7V3a1.001 1.001 0 00-1.231-.972S6.576 6.542 4.798 7.022C3.02 7.5 2 8.412 2 10v16a3 3 0 003 3h22a3 3 0 003-3V10a3 3 0 00-3-3z',
	size: 32,
};

export const WALLET_32 = WALLET_OUTLINE_32;
// 32x32/wallet/filled.svg
export const WALLET_FILLED_32 = {
	d: 'M22 21a3 3 0 110-5.999 3 3 0 010 6zM17 8c-.292 0-.572-.142-.572-.5 0-.357.28-.5.572-.5h10V3a1.001 1.001 0 00-1.231-.972S6.576 6.542 4.798 7.022C3.02 7.5 2 8.412 2 10v16a3 3 0 003 3h22a3 3 0 003-3V11a3 3 0 00-3-3H17z',
	size: 32,
};

// 32x32/menu rubik/outline.svg
export const MENU_RUBIK_OUTLINE_32 = {
	d: 'M27.833 23.427a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26c.508.11 1.034.167 1.574.167a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm-9 0a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26c.508.11 1.034.167 1.574.167a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm-9 0a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26C5.934 27.943 6.46 28 7 28a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm18-9a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26c.508.11 1.034.167 1.574.167a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm-9 0a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26c.508.11 1.034.167 1.574.167a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm-9 0a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26C5.934 18.943 6.46 19 7 19a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm18-9a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26c.508.11 1.034.167 1.574.167a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm-9 0a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26c.508.11 1.034.167 1.574.167a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146zm-9 0a1.646 1.646 0 00-1.26-1.26 7.476 7.476 0 00-3.146 0 1.646 1.646 0 00-1.26 1.259 7.492 7.492 0 000 3.147 1.645 1.645 0 001.259 1.26C5.934 9.943 6.46 10 7 10a7.41 7.41 0 001.573-.167 1.645 1.645 0 001.26-1.26 7.469 7.469 0 000-3.146z',
	size: 32,
};

export const MENU_RUBIK_32 = MENU_RUBIK_OUTLINE_32;
// 32x32/label/outline.svg
export const LABEL_OUTLINE_32 = {
	d: 'M17.5 2.5h11a1 1 0 011 1v11c0 .266-.105.52-.293.707l-14 14a.997.997 0 01-1.414 0l-11-11a.999.999 0 010-1.414l14-14A.997.997 0 0117.5 2.5zm10 11.586l-13 13L4.914 17.5l13-13H27.5v9.586zm-9-3.586a3 3 0 116 0 3 3 0 01-6 0z',
	size: 32,
};

export const LABEL_32 = LABEL_OUTLINE_32;
// 32x32/label/filled.svg
export const LABEL_FILLED_32 = {
	d: 'M17.5 2.5h11a1 1 0 011 1v11c0 .266-.105.52-.293.707l-14 14a.997.997 0 01-1.414 0l-11-11a.999.999 0 010-1.414l14-14A.997.997 0 0117.5 2.5zm1 8a3 3 0 106 0 3 3 0 00-6 0z',
	size: 32,
};

// 32x32/warning/outline.svg
export const WARNING_OUTLINE_32 = {
	d: 'M17.5 22.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM18 15c0-1-1-2-2-2s-2 1-2 2 1 5 1 5h2s1-4 1-5zM4.752 26h22.496L16 6.966 4.752 26zM29 28H3a1.001 1.001 0 01-1-1c0-.163.047-.353.139-.509l13-22A.96.96 0 0116 4a.96.96 0 01.861.491l13 22a.997.997 0 01.008 1.005c-.179.312-.51.504-.869.504z',
	size: 32,
};

export const WARNING_32 = WARNING_OUTLINE_32;
// 32x32/warning/filled.svg
export const WARNING_FILLED_32 = {
	d: 'M17 20h-2s-1-4-1-5 1-2 2-2 2 1 2 2-1 5-1 5zm-1 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm13.861 2.491l-13-22A1.018 1.018 0 0016 4c-.341 0-.681.187-.861.491l-13 22a1.004 1.004 0 00-.008 1.005c.179.312.51.504.869.504h26a1.001 1.001 0 00.861-1.509z',
	size: 32,
};

// 32x32/notifications/outline.svg
export const NOTIFICATIONS_OUTLINE_32 = {
	d: 'M16 3a7 7 0 017 7c0 8 4 11 4 11s-4 4-11 4-11-4-11-4 4-3 4-11a7 7 0 017-7zm0 2c-2.757 0-5 2.243-5 5 0 5.399-1.695 8.832-3.072 10.729 1.568.993 4.316 2.27 8.072 2.27 3.754 0 6.501-1.275 8.072-2.27C22.695 18.83 21 15.399 21 9.999c0-2.756-2.243-5-5-5zm-3 21h6a3 3 0 11-6 0z',
	size: 32,
};

export const NOTIFICATIONS_32 = NOTIFICATIONS_OUTLINE_32;
// 32x32/notifications/filled.svg
export const NOTIFICATIONS_FILLED_32 = {
	d: 'M23 10a7 7 0 10-14 0c0 8-4 11-4 11s4 4 11 4 11-4 11-4-4-3-4-11zM13 26h6a3 3 0 11-6 0z',
	size: 32,
};

// 32x32/web/outline.svg
export const WEB_OUTLINE_32 = {
	d: 'M27.3 20h-3.636c.216-1.269.336-2.609.336-4s-.12-2.731-.336-4H27.3c.445 1.253.7 2.596.7 4s-.255 2.747-.7 4zm-6.27 6.88c.925-1.311 1.673-2.98 2.19-4.88h3.156a12.054 12.054 0 01-5.346 4.88zM5.624 22H8.78c.517 1.9 1.265 3.569 2.19 4.88A12.065 12.065 0 015.624 22zM4.7 12h3.636A23.856 23.856 0 008 16c0 1.391.12 2.731.336 4H4.7a11.922 11.922 0 01-.7-4c0-1.404.255-2.747.7-4zm6.27-6.88C10.045 6.431 9.297 8.1 8.78 10H5.624a12.065 12.065 0 015.346-4.88zM17 10V4.203c1.62.628 3.215 2.727 4.153 5.797H17zm0 17.797V22h4.153c-.938 3.07-2.532 5.169-4.153 5.797zM15 22v5.797c-1.621-.628-3.215-2.727-4.152-5.797H15zm0-17.797V10h-4.152c.937-3.07 2.53-5.169 4.152-5.797zM10 16c0-1.431.135-2.768.364-4H15v8h-4.636A21.874 21.874 0 0110 16zm12 0c0 1.431-.135 2.768-.364 4H17v-8h4.636c.229 1.232.364 2.569.364 4zm4.376-6H23.22c-.517-1.9-1.265-3.569-2.19-4.88A12.054 12.054 0 0126.376 10zM16 2C8.268 2 2 8.268 2 16s6.268 14 14 14c7.733 0 14-6.268 14-14S23.733 2 16 2z',
	size: 32,
};

export const WEB_32 = WEB_OUTLINE_32;
// 32x32/flag/outline.svg
export const FLAG_OUTLINE_32 = {
	d: 'M18 8h9l-3 7 3 7h-8a3 3 0 01-3-3H7v10a1 1 0 11-2 0V3a1 1 0 112 0v1h8a3 3 0 013 3v1zM7 17V6h8a1 1 0 011 1v10H7zm15.162-1.212L23.967 20H19c-.551 0-1-.448-1-1v-9h5.967l-1.805 4.212-.337.788.337.788z',
	size: 32,
};

export const FLAG_32 = FLAG_OUTLINE_32;
// 32x32/flag/filled.svg
export const FLAG_FILLED_32 = {
	d: 'M17 19V7a3 3 0 00-3-3H7V3a1 1 0 10-2 0v26a1 1 0 102 0V19h10zm2-11h9l-3 7 3 7h-6a3 3 0 01-3-3V8z',
	size: 32,
};

// 32x32/download/outline.svg
export const DOWNLOAD_OUTLINE_32 = {
	d: 'M8 4c3.859 0 7 3.141 7 7v5H8l8 10 8-10h-7v-5c0-4.963-4.037-9-9-9a1 1 0 100 2zm22 19v3c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4v-3a1 1 0 112 0v3c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2v-3a1 1 0 112 0z',
	size: 32,
};

export const DOWNLOAD_32 = DOWNLOAD_OUTLINE_32;
// 32x32/download/filled.svg
export const DOWNLOAD_FILLED_32 = {
	d: 'M10.242 5.3a13.388 13.388 0 011.86 3.694c.39 1.28.618 2.575.717 3.902.097 1.028.114 2.029.146 3.104H8l8 10 8-10h-4.995a16.774 16.774 0 00-.644-4.226c-.518-1.736-1.316-3.435-2.45-4.89a12.81 12.81 0 00-4.062-3.511C10.304 2.529 8.614 2.146 7 2c1.263 1.066 2.388 2.118 3.242 3.3zM30 23v3c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4v-3a1 1 0 112 0v3c0 1.103.897 2 2 2h20c1.102 0 2-.897 2-2v-3a1 1 0 112 0z',
	size: 32,
};

// 32x32/image/outline.svg
export const IMAGE_OUTLINE_32 = {
	d: 'M10.5 11a3 3 0 116 0 3 3 0 01-6 0zM16 27c-6.143 0-9.01-.908-10.221-4.317l5.094-3.396 2.42 2.42a1 1 0 001.288.106L21 17.229l5.607 4.004C25.692 25.84 22.932 27 16 27zm0-22c9.047 0 11 1.953 11 11 0 1.099-.03 2.089-.098 2.987l-5.321-3.8a.997.997 0 00-1.162 0l-6.311 4.507-2.401-2.401a.998.998 0 00-1.262-.125L5.282 20.61C5.084 19.326 5 17.812 5 16 5 6.953 6.953 5 16 5zm0-2C5.879 3 3 5.879 3 16s2.879 13 13 13 13-2.879 13-13S26.121 3 16 3z',
	size: 32,
};

export const IMAGE_32 = IMAGE_OUTLINE_32;
// 32x32/image/filled.svg
export const IMAGE_FILLED_32 = {
	d: 'M10.5 11a3 3 0 116 0 3 3 0 01-6 0zM16 5c9.047 0 11 1.953 11 11 0 1.099-.03 2.089-.098 2.987l-5.321-3.8a.997.997 0 00-1.162 0l-6.311 4.507-2.401-2.401a.997.997 0 00-1.262-.125L5.282 20.61C5.084 19.326 5 17.812 5 16 5 6.953 6.953 5 16 5zm0-2C5.879 3 3 5.879 3 16s2.879 13 13 13 13-2.879 13-13S26.121 3 16 3z',
	size: 32,
};

// 32x32/time alt1/outline.svg
export const TIME_ALT1_OUTLINE_32 = {
	d: 'M19.8 20.6a.998.998 0 00-.2-1.4l-3.47-2.6 1.84-7.356a.997.997 0 00-.728-1.212.996.996 0 00-1.212.727l-2 8a.999.999 0 00.37 1.042l4 3a.994.994 0 001.399-.2zM16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4zm0 2c5.514 0 10 4.487 10 10 0 5.514-4.486 10-10 10-5.513 0-10-4.486-10-10 0-5.513 4.487-10 10-10z',
	size: 32,
};

export const TIME_ALT1_32 = TIME_ALT1_OUTLINE_32;
// 32x32/time alt1/filled.svg
export const TIME_ALT1_FILLED_32 = {
	d: 'M19.8 20.6a.994.994 0 01-1.4.2l-4-3a.999.999 0 01-.37-1.042l2-8a.996.996 0 011.212-.727.997.997 0 01.728 1.212l-1.84 7.356L19.6 19.2a.998.998 0 01.2 1.399zM16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4z',
	size: 32,
};

// 32x32/briefcase/outline.svg
export const BRIEFCASE_OUTLINE_32 = {
	d: 'M26.194 25.402C23.4 25.674 19.364 26 16 26c-3.365 0-7.4-.326-10.195-.598A1.994 1.994 0 014 23.412V17h9v2a1 1 0 001 1h4a1 1 0 001-1v-2h9v6.411c0 1.034-.777 1.89-1.806 1.991zM5.786 9.567C8.334 9.308 12.173 9 16 9c3.826 0 7.666.308 10.214.567A1.989 1.989 0 0128 11.557V15H4v-3.444c0-1.03.767-1.885 1.786-1.989zM12 6a1 1 0 011-1h6c.551 0 1 .448 1 1v1.098A88.64 88.64 0 0016 7c-1.352 0-2.7.04-4 .098V6zm14.416 1.578c-1.254-.128-2.77-.26-4.416-.368V6c0-1.655-1.346-3-3-3h-6c-1.655 0-3 1.345-3 3v1.21c-1.647.107-3.162.24-4.416.368A3.994 3.994 0 002 11.556v11.855c0 2.06 1.56 3.781 3.611 3.981 2.87.281 6.956.608 10.39.608 3.431 0 7.518-.327 10.387-.608A3.998 3.998 0 0030 23.412V11.555a3.994 3.994 0 00-3.584-3.978z',
	size: 32,
};

export const BRIEFCASE_32 = BRIEFCASE_OUTLINE_32;
// 32x32/briefcase/filled.svg
export const BRIEFCASE_FILLED_32 = {
	d: 'M19 17h11v6.411a4 4 0 01-3.611 3.982C23.52 27.673 19.433 28 16 28c-3.433 0-7.52-.327-10.389-.607A4 4 0 012 23.411V17h11v2a1 1 0 001 1h4a1 1 0 001-1v-2zm-7-9.901V6a1 1 0 011-1h6a1 1 0 011 1v1.099A87.141 87.141 0 0016 7c-1.352 0-2.699.039-4 .099zm14.416.479c-1.254-.128-2.77-.261-4.416-.368V6c0-1.654-1.346-3-3-3h-6c-1.654 0-3 1.346-3 3v1.21c-1.646.107-3.162.24-4.416.368A3.995 3.995 0 002 11.557V15h28v-3.443a3.995 3.995 0 00-3.584-3.979z',
	size: 32,
};

// 32x32/diamond/outline.svg
export const DIAMOND_OUTLINE_32 = {
	d: 'M8.515 6h3.159l-1.43 5h-5.3l3.57-5zm13.206 7h5.09l-8.272 9.543L21.72 13zm-9.394-2l1.428-5h4.49l1.429 5h-7.347zm7.286 2L16 23.839 12.388 13h7.225zm-9.333 0l3.18 9.543L5.19 13h5.09zm16.777-2h-5.302l-1.428-5h3.159l3.57 5zm2.757.419l-5-7A1 1 0 0024 4H8a.997.997 0 00-.813.419l-5 7a.997.997 0 00.057 1.236l13 15a1.003 1.003 0 001.512 0l13-15A.987.987 0 0030 12a1.01 1.01 0 00-.186-.581z',
	size: 32,
};

export const DIAMOND_32 = DIAMOND_OUTLINE_32;
// 32x32/settings/outline.svg
export const SETTINGS_OUTLINE_32 = {
	d: 'M18 29a1 1 0 001-1l.04-2.48a8.62 8.62 0 001.57-.67l1.75 1.76a1 1 0 001.42 0l2.83-2.83a1 1 0 000-1.42l-1.74-1.77a9.453 9.453 0 00.66-1.59H28a1 1 0 001-1v-4a1 1 0 00-1-1h-2.48a8.934 8.934 0 00-.67-1.61l1.76-1.75a1 1 0 000-1.42l-2.83-2.83a1 1 0 00-1.42 0L20.6 7.13a9.577 9.577 0 00-1.6-.66V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v2.48a8.93 8.93 0 00-1.61.67L9.64 5.39a1 1 0 00-1.42 0L5.39 8.22a1 1 0 00-.29.71c.004.265.107.518.29.71l1.74 1.76a9.94 9.94 0 00-.66 1.6H4a1 1 0 00-1 1v4a1 1 0 001 1h2.48a8.93 8.93 0 00.67 1.61l-1.76 1.75a1 1 0 000 1.42l2.83 2.83a1 1 0 001.42 0l1.77-1.74a9.453 9.453 0 001.59.66V28a1 1 0 001 1h4zm-3-2v-1.47a2 2 0 00-1.38-1.88 7.933 7.933 0 01-1.24-.52 2 2 0 00-2.35.34l-1.05 1-1.42-1.42 1-1.05a2 2 0 00.34-2.33 7.932 7.932 0 01-.52-1.24A2 2 0 006.47 17H5v-2h1.47a2 2 0 001.91-1.43c.136-.428.31-.843.52-1.24A2 2 0 008.56 10L7.51 8.93l1.44-1.37 1.05 1a2 2 0 002.33.34 7.932 7.932 0 011.24-.52A2 2 0 0015 6.47V5h2v1.47a2 2 0 001.41 1.91c.428.136.843.31 1.24.52A2 2 0 0022 8.56l1.07-1.05 1.37 1.44-1 1.05a2 2 0 00-.34 2.33c.21.397.384.812.52 1.24A2 2 0 0025.53 15H27v2h-1.47a2 2 0 00-1.86 1.38 7.933 7.933 0 01-.52 1.24 2 2 0 00.34 2.35l1 1.05-1.42 1.42-1.05-1a2 2 0 00-2.35-.34c-.397.21-.812.384-1.24.52A2 2 0 0017 25.53V27h-2zm1-6a5 5 0 100-10 5 5 0 000 10zm0-8a3 3 0 110 6 3 3 0 010-6z',
	size: 32,
};

export const SETTINGS_32 = SETTINGS_OUTLINE_32;
// 32x32/close/outline.svg
export const CLOSE_OUTLINE_32 = {
	d: 'M17.414 16l6.293 6.293a.999.999 0 11-1.414 1.414L16 17.414l-6.293 6.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L14.586 16 8.293 9.707a.999.999 0 111.414-1.414L16 14.586l6.293-6.293a.999.999 0 111.414 1.414L17.414 16z',
	size: 32,
};

export const CLOSE_32 = CLOSE_OUTLINE_32;
// 32x32/bookmark/outline.svg
export const BOOKMARK_OUTLINE_32 = {
	d: 'M21 2H11a3 3 0 00-3 3v25l8-5 8 5V5a3 3 0 00-3-3zm0 2a1 1 0 011 1v21.392l-4.94-3.088a2.006 2.006 0 00-2.12 0L10 26.392V5a1 1 0 011-1h10z',
	size: 32,
};

export const BOOKMARK_32 = BOOKMARK_OUTLINE_32;
// 32x32/bookmark/filled.svg
export const BOOKMARK_FILLED_32 = {
	d: 'M8 5v25l8-5 8 5V5a3 3 0 00-3-3H11a3 3 0 00-3 3z',
	size: 32,
};

// 32x32/folder add/outline.svg
export const FOLDER_ADD_OUTLINE_32 = {
	d: 'M11 23.5a1 1 0 110 2H8v3a1 1 0 11-2 0v-3H3a1 1 0 110-2h3v-3a1 1 0 112 0v3h3zm16-12c1.795 0 3 1.206 3 3 0 3.195-.809 10.224-2.293 11.707C26.186 27.729 22.246 28.5 16 28.5a59.32 59.32 0 01-3.194-.088 6.96 6.96 0 00.911-1.955c.704.026 1.453.043 2.283.043 7.967 0 9.893-1.307 10.293-1.707C26.918 24.104 28 18.755 28 14.5c0-.683-.318-1-1-1H5c-.682 0-1 .317-1 1 0 1.152.081 2.384.209 3.582-.688.3-1.314.709-1.866 1.202C2.117 17.479 2 15.713 2 14.5c0-1.794 1.205-3 3-3h22zm-22-1v-4c0-.552.449-1 1-1h4c1.322 0 2.139 1.052 2.927 2.068.155.2.303.392.452.57a.999.999 0 00.769.362H26c.551 0 1 .448 1 1v1h2v-1c0-1.654-1.346-3-3-3H14.629l-.122-.158C13.576 5.143 12.303 3.5 10 3.5H6c-1.654 0-3 1.346-3 3v4h2z',
	size: 32,
};

export const FOLDER_ADD_32 = FOLDER_ADD_OUTLINE_32;
// 32x32/folder add/filled.svg
export const FOLDER_ADD_FILLED_32 = {
	d: 'M11.05 23.5a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3h-3a1 1 0 110-2h3v-3a1 1 0 112 0v3h3zM27 11.5c1.795 0 3 1.206 3 3 0 3.195-.808 10.224-2.293 11.707C26.186 27.729 22.246 28.5 16 28.5c-1.134 0-2.164-.034-3.145-.085A7 7 0 007.05 17.5a6.968 6.968 0 00-4.702 1.825c-.23-1.819-.35-3.602-.35-4.825 0-1.794 1.206-3 3-3h22zm-23.95-2h26l-.05-1a2 2 0 00-2-2H14.149c-.967-1.166-2.028-3-4.15-3H5a2 2 0 00-2 2l.052 4z',
	size: 32,
};

// 32x32/__library/outline.svg
export const __LIBRARY_OUTLINE_32 = {
	d: 'M28 25.5v1a.5.5 0 01-.5.5h-23a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h23a.5.5 0 01.5.5zM9 22h3v-9.5H9V22zm7-14.845l5.776 3.345H10.224L16 7.155zM20 22h3v-9.5h-3V22zm-6 0h4v-9.5h-4V22zm-8.518 2h21.036a.2.2 0 00.14-.341L25 22v-9.5h.5a1 1 0 00.501-1.865l-9.5-5.5a.997.997 0 00-1.002 0l-9.5 5.5A.998.998 0 006.5 12.5H7V22l-1.658 1.659a.2.2 0 00.14.341z',
	size: 32,
};

export const __LIBRARY_32 = __LIBRARY_OUTLINE_32;
// 32x32/time/outline.svg
export const TIME_OUTLINE_32 = {
	d: 'M19.707 21.707a.999.999 0 000-1.414l-3.6-3.6 1.863-7.451a1 1 0 00-1.94-.484l-2 8a.997.997 0 00.263.949l4 4a.997.997 0 001.414 0zM16 3c-2.34 0-4.621.25-6.819.725a7.112 7.112 0 00-5.455 5.456A32.172 32.172 0 003 16c0 2.34.25 4.621.726 6.819a7.111 7.111 0 005.455 5.455C11.379 28.75 13.66 29 16 29s4.621-.25 6.819-.726a7.111 7.111 0 005.455-5.455A32.18 32.18 0 0029 16c0-2.34-.25-4.621-.726-6.819a7.111 7.111 0 00-5.455-5.455A32.186 32.186 0 0016 3zm0 2c2.157 0 4.31.228 6.396.681a5.127 5.127 0 013.923 3.922C26.771 11.691 27 13.844 27 16c0 2.156-.229 4.309-.681 6.396a5.13 5.13 0 01-3.923 3.923c-2.087.452-4.24.681-6.396.681-2.156 0-4.309-.229-6.397-.681a5.13 5.13 0 01-3.923-3.923A30.263 30.263 0 015 16c0-2.157.228-4.31.68-6.397A5.13 5.13 0 019.603 5.68 30.293 30.293 0 0116 5z',
	size: 32,
};

export const TIME_32 = TIME_OUTLINE_32;
// 32x32/time/filled.svg
export const TIME_FILLED_32 = {
	d: 'M19.707 21.707a.997.997 0 01-1.414 0l-4-4a.997.997 0 01-.263-.949l2-8a1 1 0 011.94.484l-1.863 7.451 3.6 3.6a.999.999 0 010 1.414zm8.567-12.526a7.111 7.111 0 00-5.455-5.455A32.186 32.186 0 0016 3c-2.34 0-4.621.25-6.819.725a7.112 7.112 0 00-5.455 5.456A32.172 32.172 0 003 16c0 2.34.25 4.621.726 6.819a7.111 7.111 0 005.455 5.455C11.379 28.75 13.66 29 16 29s4.621-.25 6.819-.726a7.111 7.111 0 005.455-5.455C28.75 20.621 29 18.34 29 16s-.25-4.621-.726-6.819z',
	size: 32,
};

// 32x32/notifications off/outline.svg
export const NOTIFICATIONS_OFF_OUTLINE_32 = {
	d: 'M16 26h3c0 1.7-1.3 3-3 3s-3-1.3-3-3h3zm13 2c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-4.9-4.9c-1.7.7-3.9 1.2-6.4 1.2-7 0-11-4-11-4s3.9-2.9 4-10.6L3.3 4.7C3.1 4.5 3 4.3 3 4c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3l24 24c.2.2.3.4.3.7zm-8.2-5.8l-9.9-9.9c-.4 4.1-1.8 6.8-3 8.4 1.6 1 4.3 2.3 8.1 2.3 1.9 0 3.5-.3 4.8-.8zM16 5c2.8 0 5 2.2 5 5 0 4.3 1.1 7.4 2.2 9.4l2.6 2.6c.8-.6 1.2-1 1.2-1s-4-3-4-11c0-3.9-3.1-7-7-7-2.5 0-4.7 1.3-5.9 3.3l1.5 1.5C12.4 6.1 14.1 5 16 5z',
	size: 32,
};

export const NOTIFICATIONS_OFF_32 = NOTIFICATIONS_OFF_OUTLINE_32;
// 32x32/notifications off/filled.svg
export const NOTIFICATIONS_OFF_FILLED_32 = {
	d: 'M29 28c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-4.9-4.9c-1.7.7-3.9 1.2-6.4 1.2-7 0-11-4-11-4s3.9-2.9 4-10.6L3.3 4.7C3.1 4.5 3 4.3 3 4c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3l24 24c.2.2.3.4.3.7zm-2-7s-4-3-4-11c0-3.9-3.1-7-7-7-2.5 0-4.7 1.3-5.9 3.3L25.8 22c.8-.6 1.2-1 1.2-1zm-14 5c0 1.7 1.3 3 3 3s3-1.3 3-3h-6z',
	size: 32,
};

// 32x32/bookmark add alt1/filled.svg
export const BOOKMARK_ADD_ALT1_FILLED_32 = {
	d: 'M19.3 19L16 17.265 12.699 19l.63-3.676-2.671-2.603 3.692-.536L16 8.84l1.65 3.345 3.692.536-2.671 2.603L19.3 19zM21 2H11a3 3 0 00-3 3v25l8-5 8 5V5a3 3 0 00-3-3z',
	size: 32,
};

// 32x32/user detailed/filled.svg
export const USER_DETAILED_FILLED_32 = {
	d: 'M17 18l.93 7.505a.997.997 0 01-.283.848L16 28l-1.647-1.647a.997.997 0 01-.283-.848L15 18h2zm-6-1v12c-1.676 0-6-1-6-4 0-3.065 2.646-6.213 6-8zm16 8c0 3-4.324 4-6 4V17c3.354 1.787 6 4.935 6 8zm-7.273-12.742l-.531.056-.248.472C18.385 13.856 17.314 15 16.001 15c-1.314 0-2.384-1.144-2.947-2.214l-.248-.472-.531-.056a.812.812 0 01-.731-.806c0-.3.17-.575.444-.719l.363-.19h.011l.004-.008.069-.036.03-.197c.945-2.184 3.344-.12 5.089-2.934A3.511 3.511 0 0119.489 10l.077.498.447.235a.814.814 0 01.444.719.812.812 0 01-.73.806zm1.906-2.764C22.179 7.942 21.796 6.809 21 6c-.614-.625-1.342-.914-2.271-.914C17.749 4.404 16.399 4 15 4c-1.746 0-3.246 1-4 2-.791 1.05-1.041 2.44-.737 3.598a2.787 2.787 0 00-.719 1.854c0 1.252.818 2.323 1.977 2.683C12.605 15.913 14.288 17 16.001 17c1.713 0 3.395-1.087 4.48-2.865a2.806 2.806 0 001.976-2.683 2.78 2.78 0 00-.824-1.958z',
	size: 32,
};

// 32x32/user/outline.svg
export const USER_OUTLINE_32 = {
	d: 'M16 2c-3 0-4 2.791-4 5 0 4 1.656 7 4 7 2.344 0 4-3 4-7 0-2.209-1-5-4-5zm0 2c1.856 0 2 2.296 2 3 0 3.098-1.165 5-2 5s-2-1.902-2-5c0-.704.144-3 2-3zm0 13c-8 0-13 2-13 4 0 3 6 9 13 9s13-6 13-9c0-2-5-4-13-4zm0 2c6.917 0 10.302 1.517 10.98 2.2C26.639 23.092 21.831 28 16 28S5.361 23.092 5.02 21.2C5.698 20.517 9.083 19 16 19z',
	size: 32,
};

export const USER_32 = USER_OUTLINE_32;
// 32x32/user/filled.svg
export const USER_FILLED_32 = {
	d: 'M16 2c-3 0-4 2.791-4 5 0 4 1.656 7 4 7 2.344 0 4-3 4-7 0-2.209-1-5-4-5zm13 19c0 3-6 9-13 9S3 24 3 21c0-2 5-4 13-4s13 2 13 4z',
	size: 32,
};

// 32x32/checker normal/outline.svg
export const CHECKER_NORMAL_OUTLINE_32 = {
	d: 'M13.707 22.707l11-11a.999.999 0 10-1.414-1.414L13 20.586l-4.293-4.293a.999.999 0 10-1.414 1.414l5 5a.997.997 0 001.414 0z',
	size: 32,
};

export const CHECKER_NORMAL_32 = CHECKER_NORMAL_OUTLINE_32;
// 32x32/filter/outline.svg
export const FILTER_OUTLINE_32 = {
	d: 'M16 3C10 3 3 4 3 6s10 10 10 10v10l6 3V16S29 8 29 6s-7-3-13-3zm0 2c5.113 0 9.051.696 10.609 1.322-1.364 1.718-5.342 5.303-8.858 8.116A2 2 0 0017 16v9.764l-2-1V16a2 2 0 00-.751-1.562c-3.516-2.813-7.494-6.398-8.858-8.116C6.949 5.696 10.887 5 16 5z',
	size: 32,
};

export const FILTER_32 = FILTER_OUTLINE_32;
// 32x32/filter/filled.svg
export const FILTER_FILLED_32 = {
	d: 'M16 3C10 3 3 4 3 6s10 10 10 10v10l6 3V16S29 8 29 6s-7-3-13-3z',
	size: 32,
};

// 32x32/menu burger typo/outline.svg
export const MENU_BURGER_TYPO_OUTLINE_32 = {
	d: 'M27.824 20v4.512c0 .789-.473 1.589-1.374 1.589-.9 0-1.374-.8-1.374-1.59V20H23.9v4.512c0 1.524 1.096 2.673 2.55 2.673 1.454 0 2.55-1.15 2.55-2.673V20h-1.176zm-7 4.509l-2.79-4.51H16.9v7.063h1.176v-4.51l2.791 4.51H22V20h-1.176v4.509zm-9.924 2.52H15v-1.171h-2.929V24.1h1.952v-1.172h-1.952v-1.757h2.93V20h-4.1v7.029zm-4.95-2.276l-1.877-4.691L4.05 20H2.9v7.084h1.18v-3.617l1.87 3.739 1.87-3.74v3.618H9V20H7.851l-1.9 4.753zM30 13.5a1.5 1.5 0 00-1.5-1.5h-25a1.5 1.5 0 100 3h25a1.5 1.5 0 001.5-1.5zM28.5 7h-25a1.5 1.5 0 110-3h25a1.5 1.5 0 110 3z',
	size: 32,
};

export const MENU_BURGER_TYPO_32 = MENU_BURGER_TYPO_OUTLINE_32;
// 32x32/star/outline.svg
export const STAR_OUTLINE_32 = {
	d: 'M16 2c-.389 0-.778.212-.978.635l-3.731 7.926-8.358 1.273A1.09 1.09 0 002 12.928c0 .293.094.598.327.838l6.053 6.183-1.427 8.724A1.13 1.13 0 008.055 30a.964.964 0 00.48-.134L16 25.752l7.465 4.114a.964.964 0 00.48.134 1.13 1.13 0 001.102-1.327l-1.427-8.724 6.053-6.183c.233-.24.327-.545.327-.838a1.09 1.09 0 00-.933-1.094l-8.358-1.273-3.731-7.926A1.074 1.074 0 0016 2zm0 3.254l2.899 6.159.455.964 1.054.161 6.673 1.016-4.891 4.997-.708.722.164.999 1.134 6.933-5.815-3.204-.965-.532-.965.532-5.815 3.204 1.134-6.933.164-.999-.708-.722-4.891-4.997 6.673-1.016 1.054-.161.455-.964L16 5.254z',
	size: 32,
};

export const STAR_32 = STAR_OUTLINE_32;
// 32x32/star/filled.svg
export const STAR_FILLED_32 = {
	d: 'M16 2c-.389 0-.778.212-.978.635l-3.731 7.926-8.358 1.273A1.09 1.09 0 002 12.928c0 .293.094.598.327.838l6.053 6.183-1.427 8.724A1.13 1.13 0 008.055 30a.964.964 0 00.48-.134L16 25.752l7.465 4.114a.964.964 0 00.48.134 1.13 1.13 0 001.102-1.327l-1.427-8.724 6.053-6.183c.233-.24.327-.545.327-.838a1.09 1.09 0 00-.933-1.094l-8.358-1.273-3.731-7.926A1.074 1.074 0 0016 2z',
	size: 32,
};

// 32x32/folder/outline.svg
export const FOLDER_OUTLINE_32 = {
	d: 'M29 10c0-1.654-1.346-3-3-3H14.629l-.122-.158C13.577 5.643 12.302 4 10 4H6C4.346 4 3 5.346 3 7v4h2V7c0-.552.449-1 1-1h4c1.322 0 2.138 1.052 2.927 2.068.155.2.304.392.451.57.19.229.473.362.77.362H26c.551 0 1 .448 1 1v1h2v-1zM5 14c-.682 0-1 .317-1 1 0 4.255 1.082 9.604 1.71 10.296C6.107 25.693 8.033 27 16 27c7.967 0 9.893-1.307 10.293-1.707C26.918 24.604 28 19.255 28 15c0-.683-.318-1-1-1H5zm11 15c-6.247 0-10.186-.771-11.707-2.293C2.809 25.224 2 18.195 2 15c0-1.794 1.206-3 3-3h22c1.794 0 3 1.206 3 3 0 3.195-.809 10.224-2.293 11.707C26.186 28.229 22.247 29 16 29z',
	size: 32,
};

export const FOLDER_32 = FOLDER_OUTLINE_32;
// 32x32/folder/filled.svg
export const FOLDER_FILLED_32 = {
	d: 'M29 10V9a2 2 0 00-2-2H14c-.966-1.166-1.878-3-4-3H5c-1.104 0-2.051.896-2.051 2L3 10h26zm1 5c0 3-.86 10.224-2.344 11.707C26.135 28.229 22.247 29 16 29c-6.247 0-10.236-.771-11.758-2.293C2.758 25.224 2 18.195 2 15c0-1.794 1.206-3 3-3h22c1.794 0 3 1.206 3 3z',
	size: 32,
};

// 32x32/search/outline.svg
export const SEARCH_OUTLINE_32 = {
	d: 'M14 24C8.486 24 4 19.514 4 14S8.486 4 14 4c5.515 0 10 4.486 10 10s-4.485 10-10 10zm14 1c-1.024-.832-3.344-2.478-4.915-3.175A11.94 11.94 0 0026 14c0-6.627-5.372-12-12-12C7.373 2 2 7.373 2 14s5.373 12 12 12c2.99 0 5.719-1.101 7.82-2.91.692 1.581 2.33 3.913 3.18 4.91 1.145 1.344 1.896 2 3 2a2 2 0 002-2c0-1.104-.428-1.723-2-3z',
	size: 32,
};

export const SEARCH_32 = SEARCH_OUTLINE_32;
// 32x32/mail/outline.svg
export const MAIL_OUTLINE_32 = {
	d: 'M27.021 22.506l-5.03-5.75 5.802-4.351c.134 1.023.207 2.2.207 3.595 0 3.018-.308 5.085-.979 6.506zM6.21 24.136l5.405-6.176L16 21.25l4.387-3.29 5.404 6.177C24.192 25.439 21.255 26 16.002 26c-5.256 0-8.194-.561-9.792-1.863zm-2.003-11.73l5.801 4.352-5.03 5.749C4.308 21.085 4 19.018 4 16c0-1.395.072-2.572.207-3.595zM6.115 7.93C7.693 6.577 10.65 6 16 6s8.306.577 9.884 1.93c.633.542 1.101 1.307 1.442 2.327L16 18.75 4.674 10.257c.34-1.02.81-1.785 1.441-2.327zm21.071-1.518C25.082 4.608 21.582 4 16 4s-9.083.608-11.187 2.412C2.71 8.216 2 11.216 2 16c0 4.784.71 7.784 2.813 9.588C6.917 27.393 10.418 28 16.001 28c5.581 0 9.081-.607 11.185-2.412C29.291 23.784 30 20.784 30 16c0-4.784-.709-7.784-2.814-9.588z',
	size: 32,
};

export const MAIL_32 = MAIL_OUTLINE_32;
// 32x32/mail/filled.svg
export const MAIL_FILLED_32 = {
	d: 'M21.901 16.635l6.584 7.407C29.591 22.21 30 19.616 30 16c0-2.121-.152-3.873-.49-5.344l-7.609 5.979zm-1.574 1.237L16 21.272l-4.328-3.4-6.858 7.717c2.105 1.804 5.604 2.41 11.186 2.41s9.081-.606 11.185-2.41l-6.858-7.717zm-10.229-1.237l-7.609-5.98C2.151 12.128 2 13.88 2 16c0 3.616.408 6.21 1.514 8.042l6.584-7.407zM3.165 8.644c.416-.886.95-1.632 1.648-2.232C6.918 4.608 10.418 4 16 4c5.582 0 9.082.608 11.186 2.412.7.6 1.233 1.346 1.65 2.232L16 18.729 3.165 8.644z',
	size: 32,
};

// 16x16/promote/outline.svg
export const PROMOTE_OUTLINE_16 = {
	d: 'M14 5V0L7 3H3C1.3 3 0 4.3 0 6v2c0 1.7 1.3 3 3 3v2.5c0 .8.7 1.5 1.5 1.5S6 14.3 6 13.5V11h1l7 3V9c1.1 0 2-.9 2-2s-.9-2-2-2zM3 9c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h3v4H3zm9 2L8 9.3V4.7L12 3v8z',
	size: 16,
};

export const PROMOTE_16 = PROMOTE_OUTLINE_16;
// 16x16/promote/filled.svg
export const PROMOTE_FILLED_16 = {
	d: 'M16 7c0 1.1-.9 2-2 2v5l-7-3V3l7-3v5c1.1 0 2 .9 2 2zM6 3H3C1.3 3 0 4.3 0 6v2c0 1.7 1.3 3 3 3v2.5c0 .8.7 1.5 1.5 1.5S6 14.3 6 13.5V3z',
	size: 16,
};

// 16x16/user group/outline.svg
export const USER_GROUP_OUTLINE_16 = {
	d: 'M11 8c-.828 0-1.394.255-2 .642 1.564.51 2 1.358 2 2.358 0 .868-.347 1.295-1 2 4 0 6-1.86 6-3 0-1-2-2-5-2zM5 9c2.656 0 5 .826 5 2 0 1-2.301 3-5 3-2.762 0-5-2-5-3 0-1.174 2.239-2 5-2zm0 1.6c-1.578 0-2.626.296-3.146.533C2.382 11.647 3.546 12.4 5 12.4c1.427 0 2.588-.744 3.129-1.262C7.563 10.885 6.462 10.6 5 10.6zM11 7c.936 0 2-.973 2-3 0-1.381-.936-2-2-2s-2 .619-2 2c0 2.027 1.064 3 2 3zM3 5c0-1.381.936-2 2-2s2 .619 2 2c0 2.027-1.064 3-2 3-.936 0-2-.973-2-3z',
	size: 16,
};

export const USER_GROUP_16 = USER_GROUP_OUTLINE_16;
// 16x16/user group/filled.svg
export const USER_GROUP_FILLED_16 = {
	d: 'M11 8c-.828 0-1.394.255-2 .642 1.564.51 2 1.358 2 2.358 0 .868-.347 1.295-1 2 4 0 6-1.86 6-3 0-1-2-2-5-2zM5 9c-2.761 0-5 .826-5 2 0 1 2.238 3 5 3 2.699 0 5-2 5-3 0-1.174-2.344-2-5-2zm6-2c.936 0 2-.973 2-3 0-1.381-.936-2-2-2s-2 .619-2 2c0 2.027 1.064 3 2 3zM3 5c0-1.381.936-2 2-2s2 .619 2 2c0 2.027-1.064 3-2 3-.936 0-2-.973-2-3z',
	size: 16,
};

// 16x16/minimize/outline.svg
export const MINIMIZE_OUTLINE_16 = {
	d: 'M12 1H4C2.346 1 1 2.346 1 4v1h2V4c0-.552.449-1 1-1h8c.551 0 1 .448 1 1v8c0 .552-.449 1-1 1h-1v2h1c1.654 0 3-1.346 3-3V4c0-1.654-1.346-3-3-3zM8 13H6v2h2c1.103 0 2-.897 2-2v-2H8v2zm0-7H6v2h2v2h2V8c0-1.103-.897-2-2-2zM3 8h1.958V6H3c-1.103 0-2 .897-2 2v2h2V8zm0 5h2.127v2H3c-1.103 0-2-.897-2-2v-2h2v2z',
	size: 16,
};

export const MINIMIZE_16 = MINIMIZE_OUTLINE_16;
// 16x16/warning circle mini/outline.svg
export const WARNING_CIRCLE_MINI_OUTLINE_16 = {
	d: 'M7 9V4h2v5H7zm0 3v-2h2v2H7zm8-4A7 7 0 111 8a7 7 0 0114 0zM2.5 8c0 3.033 2.468 5.5 5.5 5.5s5.5-2.467 5.5-5.5S11.032 2.5 8 2.5A5.506 5.506 0 002.5 8z',
	size: 16,
};

export const WARNING_CIRCLE_MINI_16 = WARNING_CIRCLE_MINI_OUTLINE_16;
// 16x16/warning circle mini/filled.svg
export const WARNING_CIRCLE_MINI_FILLED_16 = {
	d: 'M8 1a7 7 0 110 14A7 7 0 018 1zm1 9H7v2h2v-2zm0-6H7v5h2V4z',
	size: 16,
};

// 16x16/home/outline.svg
export const HOME_OUTLINE_16 = {
	d: 'M12 13h-2V9a2 2 0 00-4 0v4H4V6.414l4-4 4 4V13zm3.707-5.707l-7-7a.997.997 0 00-1.414 0l-7 7a.997.997 0 000 1.414.999.999 0 001.414 0L2 8.414V13c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V8.414l.293.293a.997.997 0 001.414 0 .997.997 0 000-1.414z',
	size: 16,
};

export const HOME_16 = HOME_OUTLINE_16;
// 16x16/home/filled.svg
export const HOME_FILLED_16 = {
	d: 'M10 13H6V9.107c0-.996.681-1.919 1.664-2.08A2.002 2.002 0 0110 9v4zM8.707.293a.997.997 0 00-1.414 0l-7 7a.997.997 0 000 1.414.999.999 0 001.414 0L2 8.414V13a2 2 0 002 2h8a2 2 0 002-2V8.414l.293.293a.997.997 0 001.414 0 .997.997 0 000-1.414l-7-7z',
	size: 16,
};

// 16x16/side panel/outline.svg
export const SIDE_PANEL_OUTLINE_16 = {
	d: 'M14 11.5c0 .275-.225.5-.5.5h-1.314V4H13.5c.275 0 .5.225.5.5v7zm-12 0v-7c0-.275.225-.5.5-.5h7.686v8H2.5a.501.501 0 01-.5-.5zM13.5 2h-11A2.502 2.502 0 000 4.5v7C0 12.879 1.121 14 2.5 14h11c1.379 0 2.5-1.121 2.5-2.5v-7C16 3.121 14.879 2 13.5 2z',
	size: 16,
};

export const SIDE_PANEL_16 = SIDE_PANEL_OUTLINE_16;
// 16x16/side panel/filled.svg
export const SIDE_PANEL_FILLED_16 = {
	d: 'M13.5 12h-1.314V5H14v6.5c0 .275-.225.5-.5.5zM2 11.5V5h8.186v7H2.5a.501.501 0 01-.5-.5zM13.5 2h-11A2.502 2.502 0 000 4.5v7C0 12.879 1.121 14 2.5 14h11c1.379 0 2.5-1.121 2.5-2.5v-7C16 3.121 14.879 2 13.5 2z',
	size: 16,
};

// 16x16/bookmark add/outline.svg
export const BOOKMARK_ADD_OUTLINE_16 = {
	d: 'M15 4h-2V2a1 1 0 10-2 0v2H9a1 1 0 100 2h2v2a1 1 0 102 0V6h2a1 1 0 100-2zm-2 6v6l-5-3-5 3V3a2 2 0 012-2h5v2H5v9.468l2.236-1.322a1.5 1.5 0 011.528 0L11 12.468V10h2z',
	size: 16,
};

export const BOOKMARK_ADD_16 = BOOKMARK_ADD_OUTLINE_16;
// 16x16/bookmark add/filled.svg
export const BOOKMARK_ADD_FILLED_16 = {
	d: 'M13 10h-1a2 2 0 01-2-2V7H9a2 2 0 010-4h1V1H5a2 2 0 00-2 2v13l5-3 5 3v-6zm3-5a1 1 0 01-1 1h-2v2a1 1 0 11-2 0V6H9a1 1 0 110-2h2V2a1 1 0 112 0v2h2a1 1 0 011 1z',
	size: 16,
};

// 16x16/add squircle/outline.svg
export const ADD_SQUIRCLE_OUTLINE_16 = {
	d: 'M9 7V5a1 1 0 10-2 0v2H5a1 1 0 100 2h2v2a1 1 0 102 0V9h2a1 1 0 100-2H9zm3.654 4.249a1.835 1.835 0 01-1.405 1.405C10.189 12.884 9.096 13 8 13s-2.189-.116-3.25-.346a1.838 1.838 0 01-1.405-1.405 15.422 15.422 0 010-6.499A1.838 1.838 0 014.75 3.346 15.364 15.364 0 018 3c1.096 0 2.189.116 3.249.346a1.835 1.835 0 011.405 1.405C12.884 5.811 13 6.904 13 8s-.116 2.188-.346 3.249zm1.955-6.921a3.83 3.83 0 00-2.937-2.937A17.357 17.357 0 008 1c-1.26 0-2.488.135-3.672.391a3.828 3.828 0 00-2.937 2.937A17.357 17.357 0 001 8c0 1.26.135 2.488.391 3.672a3.83 3.83 0 002.937 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.488-.135 3.672-.391a3.83 3.83 0 002.937-2.937C14.865 10.488 15 9.26 15 8c0-1.26-.135-2.488-.391-3.672z',
	size: 16,
};

export const ADD_SQUIRCLE_16 = ADD_SQUIRCLE_OUTLINE_16;
// 16x16/add squircle/filled.svg
export const ADD_SQUIRCLE_FILLED_16 = {
	d: 'M11 9H9v2a1 1 0 11-2 0V9H5a1 1 0 110-2h2V5a1 1 0 112 0v2h2a1 1 0 110 2zm3.541-4.688a3.81 3.81 0 00-2.923-2.923A17.243 17.243 0 007.965 1c-1.254 0-2.476.134-3.653.389a3.81 3.81 0 00-2.923 2.923A17.229 17.229 0 001 7.965c0 1.254.134 2.475.389 3.653a3.81 3.81 0 002.923 2.923c1.177.255 2.399.389 3.653.389 1.253 0 2.476-.134 3.653-.389a3.81 3.81 0 002.923-2.923 17.308 17.308 0 000-7.306z',
	size: 16,
};

// 16x16/phone retro/filled.svg
export const PHONE_RETRO_FILLED_16 = {
	d: 'M11 10c0-1.104-1.343-2-3-2s-3 .896-3 2 1.343 2 3 2 3-.896 3-2zm4 2v.438c0 .946-.656 1.767-1.582 1.958C12.053 14.675 10.852 15 8 15c-2.852 0-4.053-.325-5.418-.604A1.992 1.992 0 011 12.438V12c0-2 2-3 4-5V5h6v2c2 2 4 3 4 5zm1-7.775v1.559C16 6.555 15.552 7 15 7h-2a1 1 0 01-1-1V3.935C10 3 6 3 4 3.935V6a1 1 0 01-1 1H1a1 1 0 01-1-1V4.227c0-.74.454-1.398 1.146-1.657C2.721 1.982 5.302 1 8 1c2.698 0 5.279.982 6.854 1.57A1.76 1.76 0 0116 4.225z',
	size: 16,
};

// 16x16/comment/outline.svg
export const COMMENT_OUTLINE_16 = {
	d: 'M10 8h2V6h-2v2zM7 8h2V6H7v2zM4 8h2V6H4v2zm4 3c-3.316 0-5-.619-5-4 0-3.381 1.684-4 5-4s5 .619 5 4c0 3.381-1.684 4-5 4zM8 1C3.452 1 1 2.582 1 7c0 2.33.688 3.864 2 4.801V15l4-2-.074-.037c.345.022.7.037 1.074.037 4.548 0 7-1.582 7-6s-2.452-6-7-6z',
	size: 16,
};

export const COMMENT_16 = COMMENT_OUTLINE_16;
// 16x16/comment/filled.svg
export const COMMENT_FILLED_16 = {
	d: 'M10 8h2V6h-2v2zM7 8h2V6H7v2zM4 8h2V6H4v2zm4-7C3.452 1 1 2.582 1 7c0 2.33.688 3.864 2 4.801V15l4-2-.074-.037c.345.022.7.037 1.074.037 4.548 0 7-1.582 7-6s-2.452-6-7-6z',
	size: 16,
};

// 16x16/subtract squircle large/outline.svg
export const SUBTRACT_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M11 9H5a1 1 0 110-2h6a1 1 0 110 2zM12.196.446a4.383 4.383 0 013.358 3.358A19.86 19.86 0 0116 8c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.86 19.86 0 018 16c-1.44 0-2.844-.154-4.197-.446a4.381 4.381 0 01-3.357-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.381 4.381 0 013.804.446 19.86 19.86 0 018 0c1.44 0 2.844.154 4.196.446zm-7.97 1.955a2.385 2.385 0 00-1.825 1.825 17.91 17.91 0 000 7.547 2.387 2.387 0 001.825 1.826 17.916 17.916 0 007.548 0 2.387 2.387 0 001.825-1.826 17.9 17.9 0 000-7.547 2.387 2.387 0 00-1.825-1.825 17.91 17.91 0 00-7.548 0z',
	size: 16,
};

export const SUBTRACT_SQUIRCLE_LARGE_16 = SUBTRACT_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/subtract squircle large/filled.svg
export const SUBTRACT_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M12 8a1 1 0 00-1-1H5a1 1 0 100 2h6a1 1 0 001-1zm4 0c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.86 19.86 0 018 16a19.86 19.86 0 01-4.196-.446 4.381 4.381 0 01-3.358-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.381 4.381 0 013.804.446 19.86 19.86 0 018 0c1.44 0 2.844.154 4.196.446a4.383 4.383 0 013.358 3.358A19.86 19.86 0 0116 8z',
	size: 16,
};

// 16x16/label add/outline.svg
export const LABEL_ADD_OUTLINE_16 = {
	d: 'M10 6V4h2v2h-2zm4-5a1 1 0 011 1v5c0 .266-.105.52-.293.707l-.291.291L13 6.586V3H9.414l-6 6L7 12.586 7.586 12l1.32 1.508-1.199 1.199a.997.997 0 01-1.414 0l-5-5a.997.997 0 010-1.414l7-7A.996.996 0 019 1h5zm-1 9V8h-2v2H9v2h2v2h2v-2h2v-2h-2z',
	size: 16,
};

export const LABEL_ADD_16 = LABEL_ADD_OUTLINE_16;
// 16x16/trash/outline.svg
export const TRASH_OUTLINE_16 = {
	d: 'M14 3a1 1 0 01-1 1H3a1 1 0 110-2h2a1 1 0 011-1h4a1 1 0 011 1h2a1 1 0 011 1zM5 7h6v5.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5V7zm-2 5.5A2.5 2.5 0 005.5 15h5a2.5 2.5 0 002.5-2.5V5H3v7.5z',
	size: 16,
};

export const TRASH_16 = TRASH_OUTLINE_16;
// 16x16/trash/filled.svg
export const TRASH_FILLED_16 = {
	d: 'M13 2h-2a1 1 0 00-1-1H6a1 1 0 00-1 1H3a1 1 0 100 2h10a1 1 0 100-2zM3 5h10v7.5a2.5 2.5 0 01-2.5 2.5h-5A2.5 2.5 0 013 12.5V5z',
	size: 16,
};

// 16x16/visibility/outline.svg
export const VISIBILITY_OUTLINE_16 = {
	d: 'M10 7.5A1.5 1.5 0 018.5 6c0-.33.11-.633.291-.881A2.962 2.962 0 008 5a3 3 0 103 3c0-.275-.049-.537-.119-.791A1.489 1.489 0 0110 7.5zM2.202 8c.84 1.185 3.116 4 5.798 4s4.958-2.815 5.798-4C12.958 6.815 10.682 4 8 4S3.042 6.815 2.202 8zM8 14C3.485 14 .277 8.738.143 8.515a1.004 1.004 0 010-1.03C.277 7.262 3.485 2 8 2c4.515 0 7.723 5.262 7.857 5.485a1 1 0 010 1.03C15.723 8.738 12.515 14 8 14z',
	size: 16,
};

export const VISIBILITY_16 = VISIBILITY_OUTLINE_16;
// 16x16/visibility/filled.svg
export const VISIBILITY_FILLED_16 = {
	d: 'M10.881 7.209c.07.254.12.516.12.791a3 3 0 11-3-3c.275 0 .536.049.79.119a1.489 1.489 0 00-.29.881A1.5 1.5 0 0010 7.5c.33 0 .632-.11.88-.291zM8.001 12c-2.207 0-4-1.794-4-4s1.793-4 4-4c2.205 0 4 1.794 4 4s-1.795 4-4 4zm7.857-4.515C15.723 7.262 12.515 2 8 2S.277 7.262.143 7.485a1 1 0 000 1.03C.277 8.738 3.485 14 8 14c4.515 0 7.723-5.262 7.858-5.485a1.012 1.012 0 000-1.03z',
	size: 16,
};

// 16x16/menu burger/outline.svg
export const MENU_BURGER_OUTLINE_16 = {
	d: 'M2 14h12a1 1 0 100-2H2a1 1 0 100 2zm0-5h12a1 1 0 100-2H2a1 1 0 100 2zm0-7h12a1 1 0 110 2H2a1 1 0 110-2z',
	size: 16,
};

export const MENU_BURGER_16 = MENU_BURGER_OUTLINE_16;
// 16x16/phone/filled.svg
export const PHONE_FILLED_16 = {
	d: 'M14 10h-3a1 1 0 00-1 1v1.932C6.097 12.444 4 9.135 4 6h2a1 1 0 001-1V2a1 1 0 00-1-1H4a2 2 0 00-2 2v3c0 4.155 2.971 8.443 8 8.949V15h3a2 2 0 002-2v-2a1 1 0 00-1-1z',
	size: 16,
};

// 16x16/notes/outline.svg
export const NOTES_OUTLINE_16 = {
	d: 'M14.56 3.561a1.5 1.5 0 10-2.12-2.121l-1 1 2.12 2.121 1-1zM5 11l3.06-.939 4.5-4.5-2.12-2.121-4.5 4.5L5 11zm8-3h2v3c0 2.207-1.794 4-4 4H5c-2.205 0-4-1.793-4-4V5c0-2.206 1.795-4 4-4h3v2H5c-1.103 0-2 .898-2 2v6c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V8z',
	size: 16,
};

export const NOTES_16 = NOTES_OUTLINE_16;
// 16x16/book/outline.svg
export const BOOK_OUTLINE_16 = {
	d: 'M10 6H6c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm3 6v1c.6 0 1 .4 1 1s-.4 1-1 1H4c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h9c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1zm-9-2h8V3H4v7zm7 2H4v1h7v-1z',
	size: 16,
};

export const BOOK_16 = BOOK_OUTLINE_16;
// 16x16/book/filled.svg
export const BOOK_FILLED_16 = {
	d: 'M13 12a1 1 0 001-1V2a1 1 0 00-1-1H4a2 2 0 00-2 2v10a2 2 0 002 2h9a1 1 0 100-2v-1zm-2 0H4v1h7v-1zM6 4h4a1 1 0 110 2H6a1 1 0 110-2z',
	size: 16,
};

// 16x16/external link alt/outline.svg
export const EXTERNAL_LINK_ALT_OUTLINE_16 = {
	d: 'M13 9v2a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h2V1H5a4 4 0 00-4 4v6a4 4 0 004 4h6a4 4 0 004-4V9h-2zm1-8a1 1 0 011 1v4a1 1 0 11-2 0V4.41l-4.29 4.3a1 1 0 01-1.42 0 1 1 0 010-1.42L11.59 3H10a1 1 0 110-2h4z',
	size: 16,
};

export const EXTERNAL_LINK_ALT_16 = EXTERNAL_LINK_ALT_OUTLINE_16;
// 16x16/emoji activated/outline.svg
export const EMOJI_ACTIVATED_OUTLINE_16 = {
	d: 'M11.818 9.426C11.414 10.253 10.29 12 8 12s-3.414-1.747-3.819-2.574A.3.3 0 014.455 9h7.09c.22 0 .37.228.273.426zM5 6.5C5 5.672 5.447 5 6 5c.552 0 1 .672 1 1.5S6.552 8 6 8c-.553 0-1-.672-1-1.5zm4 0c0-.828.447-1.5 1-1.5.552 0 1 .672 1 1.5S10.552 8 10 8c-.553 0-1-.672-1-1.5zm3.654 4.749a1.838 1.838 0 01-1.405 1.406 15.43 15.43 0 01-6.499 0 1.839 1.839 0 01-1.405-1.406 15.436 15.436 0 010-6.499A1.837 1.837 0 014.75 3.346C5.81 3.116 6.904 3 8 3s2.19.116 3.25.346a1.835 1.835 0 011.404 1.405 15.428 15.428 0 010 6.498zm1.955-6.921a3.832 3.832 0 00-2.937-2.937A17.364 17.364 0 008 1c-1.26 0-2.489.135-3.672.39A3.832 3.832 0 001.39 4.329 17.356 17.356 0 001 8c0 1.26.134 2.488.39 3.672a3.835 3.835 0 002.938 2.938 17.43 17.43 0 007.344 0 3.834 3.834 0 002.937-2.938 17.422 17.422 0 00.001-7.344z',
	size: 16,
};

export const EMOJI_ACTIVATED_16 = EMOJI_ACTIVATED_OUTLINE_16;
// 16x16/emoji activated/filled.svg
export const EMOJI_ACTIVATED_FILLED_16 = {
	d: 'M11.818 9.426C11.414 10.253 10.29 12 8 12s-3.414-1.747-3.819-2.574A.3.3 0 014.455 9h7.09c.22 0 .37.228.273.426zM6 5c.552 0 1 .672 1 1.5S6.552 8 6 8c-.553 0-1-.672-1-1.5S5.447 5 6 5zm4 0c.552 0 1 .672 1 1.5S10.552 8 10 8c-.553 0-1-.672-1-1.5S9.447 5 10 5zm4.61-.672a3.832 3.832 0 00-2.938-2.937A17.364 17.364 0 008 1c-1.26 0-2.489.135-3.672.39A3.832 3.832 0 001.39 4.329 17.356 17.356 0 001 8c0 1.26.134 2.488.39 3.672a3.835 3.835 0 002.938 2.938 17.43 17.43 0 007.344 0 3.834 3.834 0 002.937-2.938 17.422 17.422 0 00.001-7.344z',
	size: 16,
};

// 16x16/pin/outline.svg
export const PIN_OUTLINE_16 = {
	d: 'M5.897 9.633l.391-1.173-.873-.874L2.828 5 4 3.828l2.585 2.586.84.886 1.172-.392c.003 0 .242-.068.588-.068.343 0 .66.064.954.193l-4.11 4.109a2.228 2.228 0 01-.131-1.51zM16 15l-5.79-5.21L13 7c-1.2-1.8-2.76-2.16-3.816-2.16C8.48 4.84 8 5 8 5L4 1 0 5l4 4s-1 3 2 5l2.793-2.795L13.002 15h3z',
	size: 16,
};

export const PIN_16 = PIN_OUTLINE_16;
// 16x16/pin/filled.svg
export const PIN_FILLED_16 = {
	d: 'M16 15l-5.792-5.209L13 7c-2-3-5-2-5-2L4 1 0 5l4 4s-1 3 2 5l2.794-2.795L13 15h3z',
	size: 16,
};

// 16x16/reject squircle large/outline.svg
export const REJECT_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M9.414 8l2.293-2.293a.999.999 0 10-1.414-1.414L8 6.586 5.707 4.293a.999.999 0 10-1.414 1.414L6.586 8l-2.293 2.293a.999.999 0 101.414 1.414L8 9.414l2.293 2.293a.997.997 0 001.414 0 .999.999 0 000-1.414L9.414 8z',
	size: 16,
};

export const REJECT_SQUIRCLE_LARGE_16 = REJECT_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/reject squircle large/filled.svg
export const REJECT_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M8 0c1.44 0 2.844.154 4.197.447a4.377 4.377 0 013.356 3.356C15.846 5.156 16 6.56 16 8s-.154 2.844-.447 4.196a4.377 4.377 0 01-3.356 3.357A19.769 19.769 0 018 16c-1.44 0-2.844-.154-4.197-.447a4.377 4.377 0 01-3.357-3.357A19.808 19.808 0 010 8c0-1.44.154-2.845.446-4.197A4.379 4.379 0 013.803.446 19.82 19.82 0 018 0zm1.414 8l2.293-2.293a.999.999 0 10-1.414-1.414L8 6.586 5.707 4.293a.999.999 0 10-1.414 1.414L6.586 8l-2.293 2.293a.999.999 0 101.414 1.414L8 9.414l2.293 2.293a.997.997 0 001.414 0 .999.999 0 000-1.414L9.414 8z',
	size: 16,
};

// 16x16/image large/outline.svg
export const IMAGE_LARGE_OUTLINE_16 = {
	d: 'M6.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6.422 5.921c.215-.214.391-.509.541-.87L10.074 9.34l-2.367 2.367a.999.999 0 01-1.414 0L5 10.414l-2.184 2.184c.081.121.168.23.262.323C3.814 13.657 5.378 14 8 14s4.186-.343 4.922-1.079zM2 8c0 .953.047 1.762.14 2.446l2.153-2.153a.999.999 0 011.414 0L7 9.586l2.293-2.293a.999.999 0 011.332-.074l3.3 2.64C13.975 9.31 14 8.694 14 8c0-2.622-.343-4.186-1.078-4.921C12.186 2.343 10.622 2 8 2s-4.186.343-4.922 1.079C2.343 3.814 2 5.378 2 8zm14 0c0 3.114-.443 5.114-1.664 6.336C13.114 15.557 11.114 16 8 16c-3.114 0-5.114-.443-6.336-1.664C.443 13.114 0 11.114 0 8c0-3.114.443-5.114 1.664-6.336C2.886.443 4.886 0 8 0c3.114 0 5.114.443 6.336 1.664C15.557 2.886 16 4.886 16 8z',
	size: 16,
};

export const IMAGE_LARGE_16 = IMAGE_LARGE_OUTLINE_16;
// 16x16/image large/filled.svg
export const IMAGE_LARGE_FILLED_16 = {
	d: 'M6.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM2 8c0 .953.047 1.762.14 2.446l2.153-2.153a.999.999 0 011.414 0L7 9.586l2.293-2.293a1.001 1.001 0 011.332-.074l3.301 2.64C13.975 9.309 14 8.694 14 8c0-2.622-.343-4.186-1.078-4.921C12.186 2.343 10.622 2 8 2s-4.186.343-4.922 1.079C2.343 3.814 2 5.378 2 8zm14 0c0 3.114-.443 5.114-1.664 6.336C13.114 15.557 11.114 16 8 16c-3.114 0-5.114-.443-6.336-1.664C.443 13.114 0 11.114 0 8c0-3.114.443-5.114 1.664-6.336C2.886.443 4.886 0 8 0c3.114 0 5.114.443 6.336 1.664C15.557 2.886 16 4.886 16 8z',
	size: 16,
};

// 16x16/refresh/outline.svg
export const REFRESH_OUTLINE_16 = {
	d: 'M15 7V1l-2.268 2.093C11.357 2.17 9.542 2 7.958 2 3.016 2 1 3.883 1 8.5S3.016 15 7.958 15c2.753 0 5.694-.442 6.634-3.725a1.002 1.002 0 00-.687-1.237 1.006 1.006 0 00-1.237.687C12.267 12.13 11.339 13 7.958 13 4.112 13 3 11.99 3 8.5S4.112 4 7.958 4c1.578 0 2.582.202 3.247.504L8.5 7H15z',
	size: 16,
};

export const REFRESH_16 = REFRESH_OUTLINE_16;
// 16x16/mail alt1/outline.svg
export const MAIL_ALT1_OUTLINE_16 = {
	d: 'M13 11.4H3a.4.4 0 01-.4-.4V7.194l5.4 2.7 5.4-2.7V11a.4.4 0 01-.4.4zM3 4.6h10a.4.4 0 01.4.4v.405L8 8.105l-5.4-2.7V5a.4.4 0 01.4-.4zM13 3H3a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2z',
	size: 16,
};

export const MAIL_ALT1_16 = MAIL_ALT1_OUTLINE_16;
// 16x16/mail alt1/filled.svg
export const MAIL_ALT1_FILLED_16 = {
	d: 'M8 8.105l6.962-3.48A1.998 1.998 0 0013 3H3c-.976 0-1.786.7-1.962 1.624L8 8.105zm7-1.71V11a2 2 0 01-2 2H3a2 2 0 01-2-2V6.394l7 3.5 7-3.5z',
	size: 16,
};

// 16x16/poi/outline.svg
export const POI_OUTLINE_16 = {
	d: 'M10 6a2 2 0 11-4 0 2 2 0 014 0zm-2 7.224C6.28 11.416 4 8.463 4 6c0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.464-2.281 5.417-4 7.224zM8 0a6 6 0 00-6 6c0 4.83 6 10 6 10s6-5.17 6-10a6 6 0 00-6-6z',
	size: 16,
};

export const POI_16 = POI_OUTLINE_16;
// 16x16/poi/filled.svg
export const POI_FILLED_16 = {
	d: 'M8 10a4 4 0 110-8 4 4 0 010 8zM8 0a6 6 0 00-6 6c0 4.83 6 10 6 10s6-5.17 6-10a6 6 0 00-6-6z',
	size: 16,
};

// 16x16/device mobil/outline.svg
export const DEVICE_MOBIL_OUTLINE_16 = {
	d: 'M8.6 12H7.401A.4.4 0 017 11.6v-1.2a.4.4 0 01.401-.4H8.6a.4.4 0 01.4.4v1.2a.4.4 0 01-.4.4zM5 14h6V2H5v12zm6-14H5a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V2a2 2 0 00-2-2z',
	size: 16,
};

export const DEVICE_MOBIL_16 = DEVICE_MOBIL_OUTLINE_16;
// 16x16/favorite/outline.svg
export const FAVORITE_OUTLINE_16 = {
	d: 'M11.5 1c-1.423 0-2.676.673-3.5 1.703C7.176 1.673 5.923 1 4.5 1A4.5 4.5 0 000 5.5c0 6 8 9.5 8 9.5s8-3.5 8-9.5A4.5 4.5 0 0011.5 1zm0 2C12.879 3 14 4.121 14 5.5c0 3.361-3.799 6.094-6 7.272C5.796 11.593 2 8.86 2 5.5 2 4.121 3.121 3 4.5 3 6.317 3 8 5 8 5s1.659-2 3.5-2z',
	size: 16,
};

export const FAVORITE_16 = FAVORITE_OUTLINE_16;
// 16x16/favorite/filled.svg
export const FAVORITE_FILLED_16 = {
	d: 'M11.5 1c-1.423 0-2.676.673-3.5 1.703C7.176 1.673 5.923 1 4.5 1A4.5 4.5 0 000 5.5c0 6 8 9.5 8 9.5s8-3.5 8-9.5A4.5 4.5 0 0011.5 1z',
	size: 16,
};

// 16x16/microphone/filled.svg
export const MICROPHONE_FILLED_16 = {
	d: 'M8 9a2 2 0 002-2V2a2 2 0 00-4 0v5a2 2 0 002 2zm4 5a1 1 0 01-1 1H5a1 1 0 110-2h2v-1.102A5.007 5.007 0 013 7a1 1 0 112 0c0 1.654 1.346 3 3 3s3-1.346 3-3a1 1 0 112 0 5.007 5.007 0 01-4 4.898V13h2a1 1 0 011 1z',
	size: 16,
};

// 16x16/calendar/filled.svg
export const CALENDAR_FILLED_16 = {
	d: 'M14 8c0-1.831-.094-3.105-.43-4H2.43C2.094 4.895 2 6.169 2 8c0 .354.004.686.012 1H4.5A1.5 1.5 0 016 10.5v3.439c.583.042 1.239.061 2 .061 5.271 0 6-.729 6-6zm2 0c0 6.43-1.57 8-8 8-2 0-3.444 0-5.707-2.293C.031 11.414 0 10 0 8 0 3.198.878 1.107 4 .356V1a1 1 0 102 0V.069C6.61.023 7.27 0 8 0s1.39.023 2 .069V1a1 1 0 102 0V.356c3.122.751 4 2.842 4 7.644zm-6 4h2v-2h-2v2zm0-4h2V6h-2v2zm-3 4h2v-2H7v2zm0-4h2V6H7v2zM4 8h2V6H4v2z',
	size: 16,
};

// 16x16/mail unread/outline.svg
export const MAIL_UNREAD_OUTLINE_16 = {
	d: 'M13.136 12.338l-2.894-2.895L8 11.045 5.758 9.443l-2.922 2.922c.094.055.196.099.307.122A23.77 23.77 0 008 13c1.977 0 3.688-.27 4.774-.495a.975.975 0 00.362-.167zM4.357 8.442L2.058 6.8C2.034 7.196 2 7.582 2 8c0 .933.08 1.788.196 2.604l2.161-2.162zm11.559-1.951C15.964 6.986 16 7.49 16 8c0 1.536-.261 3.072-.517 4.206a2.976 2.976 0 01-2.302 2.257C11.921 14.725 10.098 15 8 15c-2.149 0-4.01-.289-5.271-.556a2.977 2.977 0 01-2.302-2.252C.204 11.201 0 9.805 0 8c0-1.805.204-3.201.427-4.191a2.977 2.977 0 012.302-2.253A25.794 25.794 0 018 1c.89 0 1.714.056 2.483.133A3.953 3.953 0 0010 3c0 .031.009.06.009.091A22.902 22.902 0 008 3c-2.013 0-3.753.278-4.857.513a.972.972 0 00-.765.735c-.044.194-.062.418-.098.621L8 8.955l3.732-2.665a3.958 3.958 0 001.972.68l-2.06 1.472 2.118 2.119C13.893 9.778 14 8.891 14 8c0-.337-.024-.673-.051-1.005.018 0 .034.005.051.005a3.96 3.96 0 001.916-.509zM12 3a2 2 0 114.001.001A2 2 0 0112 3z',
	size: 16,
};

export const MAIL_UNREAD_16 = MAIL_UNREAD_OUTLINE_16;
// 16x16/mail unread/filled.svg
export const MAIL_UNREAD_FILLED_16 = {
	d: 'M12 3a2 2 0 104-.001A2 2 0 0012 3zm2 4c-.176 0-.344-.03-.514-.052l-1.906 1.43 3.885 3.884c.004-.019.013-.037.017-.056C15.738 11.072 16 9.536 16 8c0-.511-.033-1.016-.083-1.51A3.95 3.95 0 0114 7zm-6 4.063L5.794 9.408l-4.385 4.385c.373.314.82.546 1.32.651 1.26.267 3.123.556 5.27.556 2.099 0 3.922-.276 5.182-.537a2.996 2.996 0 001.38-.701l-4.355-4.354L8 11.063zm3.635-4.852A3.984 3.984 0 0110 3c0-.678.185-1.308.482-1.867A24.672 24.672 0 008 1c-2.148 0-4.01.289-5.271.555A2.989 2.989 0 00.567 3.363L8 8.937l3.635-2.726zM4.42 8.378L.469 12.33c-.013-.047-.032-.091-.042-.138C.204 11.201 0 9.804 0 8c0-1.087.078-2.008.186-2.799L4.42 8.378z',
	size: 16,
};

// 16x16/volume mute/outline.svg
export const VOLUME_MUTE_OUTLINE_16 = {
	d: 'M7 5.1v5.8L5.3 9.5 4.7 9H3V7h1.7l.6-.5L7 5.1zM8 2c-.2 0-.4.1-.6.2L4 5H2.5C1.7 5 1 5.7 1 6.5v3c0 .8.7 1.5 1.5 1.5H4l3.4 2.8c.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.5-.5.5-.9V3c0-.4-.2-.7-.5-.9C8.3 2 8.2 2 8 2zm6.3 3.3c-.2 0-.4.1-.5.2L12.7 7l-1.2-1.4c-.1-.2-.3-.2-.5-.2s-.3.1-.4.2c-.3.1-.3.5-.1.8L11.8 8l-1.3 1.6c-.2.3-.2.7.1.9.1.1.2.2.4.2s.4-.1.5-.2L12.7 9l1.2 1.4c.1.2.3.2.5.2s.3-.1.4-.2c.3-.2.3-.7.1-.9L13.5 8l1.3-1.6c.2-.3.2-.7-.1-.9-.1-.1-.2-.2-.4-.2z',
	size: 16,
};

export const VOLUME_MUTE_16 = VOLUME_MUTE_OUTLINE_16;
// 16x16/volume mute/filled.svg
export const VOLUME_MUTE_FILLED_16 = {
	d: 'M14.8 9.6c.2.3.2.7-.1.9-.1.1-.3.2-.4.2-.2 0-.4-.1-.5-.2L12.7 9l-1.2 1.4c-.1.2-.3.2-.5.2s-.3-.1-.4-.2c-.3-.1-.3-.5-.1-.8L11.8 8l-1.3-1.6c-.2-.3-.2-.7.1-.9.1-.1.2-.2.4-.2s.4.1.5.2L12.7 7l1.2-1.4c.1-.2.3-.2.5-.2s.3.1.4.2c.3.2.3.7.1.9L13.5 8l1.3 1.6zM8.5 2.1C8.3 2 8.2 2 8 2s-.4.1-.6.2L4 5H2.5C1.7 5 1 5.7 1 6.5v3c0 .8.7 1.5 1.5 1.5H4l3.4 2.8c.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.5-.5.5-.9V3c0-.4-.2-.7-.5-.9z',
	size: 16,
};

// 16x16/private browsing/filled.svg
export const PRIVATE_BROWSING_FILLED_16 = {
	d: 'M16 11c0 2-1.75 4-4 4-1.777 0-3.389-.817-4-1.714C7.389 14.183 5.777 15 4 15c-2.25 0-4-2-4-4 3.777 1.768 5.598-2 8-2s4.223 3.768 8 2zM3.5 4C4.327 4 5 4.673 5 5.5S4.327 7 3.5 7 2 6.327 2 5.5 2.673 4 3.5 4zm9 0c.827 0 1.5.673 1.5 1.5S13.327 7 12.5 7 11 6.327 11 5.5 11.673 4 12.5 4zm-9 5A3.5 3.5 0 007 5.5a1 1 0 012 0A3.5 3.5 0 1012.5 2a3.479 3.479 0 00-2.61 1.189A2.978 2.978 0 008 2.5c-.72 0-1.372.266-1.89.689A3.479 3.479 0 003.5 2a3.5 3.5 0 100 7z',
	size: 16,
};

// 16x16/volume down/outline.svg
export const VOLUME_DOWN_OUTLINE_16 = {
	d: 'M7 5.1v5.8L5.3 9.5 4.7 9H3V7h1.7l.6-.5L7 5.1zM8 2c-.2 0-.4.1-.6.2L4 5H2.5C1.7 5 1 5.7 1 6.5v3c0 .8.7 1.5 1.5 1.5H4l3.4 2.8c.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.5-.5.5-.9V3c0-.4-.2-.7-.5-.9C8.3 2 8.2 2 8 2zm2.7 3.3c-.4 0-.7.3-.7.7v4c0 .4.3.7.7.7.4 0 .7-.3.7-.7V6c-.1-.4-.4-.7-.7-.7z',
	size: 16,
};

export const VOLUME_DOWN_16 = VOLUME_DOWN_OUTLINE_16;
// 16x16/volume down/filled.svg
export const VOLUME_DOWN_FILLED_16 = {
	d: 'M11.3 6v4c0 .4-.3.7-.7.7-.3 0-.6-.3-.6-.7V6c0-.4.3-.7.7-.7.3 0 .6.3.6.7zM8.5 2.1C8.3 2 8.2 2 8 2s-.4.1-.6.2L4 5H2.5C1.7 5 1 5.7 1 6.5v3c0 .8.7 1.5 1.5 1.5H4l3.4 2.8c.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.5-.5.5-.9V3c0-.4-.2-.7-.5-.9z',
	size: 16,
};

// 16x16/renew vertical/outline.svg
export const RENEW_VERTICAL_OUTLINE_16 = {
	d: 'M13 10V7c0-2.757-2.243-5-5-5a1 1 0 100 2c1.654 0 3 1.346 3 3v3H9l3 4 3-4h-2zm-4 3a1 1 0 01-1 1c-2.757 0-5-2.243-5-5V6H1l3-4 3 4H5v3c0 1.654 1.346 3 3 3a1 1 0 011 1z',
	size: 16,
};

export const RENEW_VERTICAL_16 = RENEW_VERTICAL_OUTLINE_16;
// 16x16/menu rubik/outline.svg
export const MENU_RUBIK_OUTLINE_16 = {
	d: 'M3.888 3.05a1.09 1.09 0 01-.839.838 4.963 4.963 0 01-2.098 0 1.095 1.095 0 01-.84-.839 4.96 4.96 0 010-2.098C.204.53.532.203.952.11a4.96 4.96 0 012.098 0c.42.092.749.42.84.84a4.96 4.96 0 010 2.098zM3.05 9.887c.42-.09.749-.418.84-.839a4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.961 4.961 0 00-2.098 0c-.42.092-.748.42-.84.84a4.96 4.96 0 000 2.098c.092.42.42.748.84.84a4.958 4.958 0 002.098 0zm0 6c.42-.09.749-.418.84-.839a4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.961 4.961 0 00-2.098 0 1.1 1.1 0 00-.84.84 4.96 4.96 0 000 2.098c.092.42.42.748.84.84a4.96 4.96 0 002.098 0zm6.84-.839c-.091.42-.42.749-.84.84a4.967 4.967 0 01-2.098 0 1.095 1.095 0 01-.84-.84 4.96 4.96 0 010-2.098c.092-.42.42-.748.84-.84a4.96 4.96 0 012.098 0c.42.091.749.42.84.84a4.96 4.96 0 010 2.098zm-.84-5.16c.42-.091.749-.42.84-.84a4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.961 4.961 0 00-2.098 0c-.42.092-.748.42-.84.84a4.96 4.96 0 000 2.098c.092.42.42.748.84.84a4.958 4.958 0 002.098 0zm6.84 5.16c-.091.42-.42.749-.84.84a4.967 4.967 0 01-2.098 0 1.095 1.095 0 01-.84-.84 4.96 4.96 0 010-2.098 1.1 1.1 0 01.84-.84 4.96 4.96 0 012.098 0c.42.091.748.42.84.84a4.96 4.96 0 010 2.098zm-.84-5.16a1.1 1.1 0 00.84-.84 4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.962 4.962 0 00-2.098 0c-.42.092-.748.42-.84.84a4.96 4.96 0 000 2.098c.091.42.42.748.84.84a4.957 4.957 0 002.098 0zm-6-6c.42-.091.749-.42.84-.84a4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.961 4.961 0 00-2.098 0c-.42.092-.748.42-.84.84a4.96 4.96 0 000 2.098c.092.42.42.748.84.84a4.958 4.958 0 002.098 0zm6.84-.84c-.091.42-.42.749-.84.84a4.963 4.963 0 01-2.098 0 1.095 1.095 0 01-.84-.84 4.96 4.96 0 010-2.098 1.1 1.1 0 01.84-.84 4.96 4.96 0 012.098 0c.42.092.748.42.84.84a4.96 4.96 0 010 2.098z',
	size: 16,
};

export const MENU_RUBIK_16 = MENU_RUBIK_OUTLINE_16;
// 16x16/chevron down/outline.svg
export const CHEVRON_DOWN_OUTLINE_16 = {
	d: 'M14 6a.997.997 0 01-.293.707l-5 5a.997.997 0 01-1.414 0l-5-5a.997.997 0 010-1.414.997.997 0 011.414 0L8 9.586l4.293-4.293a.997.997 0 011.414 0A.997.997 0 0114 6z',
	size: 16,
};

export const CHEVRON_DOWN_16 = CHEVRON_DOWN_OUTLINE_16;
// 16x16/chevron down/filled.svg
export const CHEVRON_DOWN_FILLED_16 = {
	d: 'M14 6a.997.997 0 01-.293.707l-5 5a.997.997 0 01-1.414 0l-5-5a.997.997 0 010-1.414A.997.997 0 013 5h10a.997.997 0 011 1z',
	size: 16,
};

// 16x16/label/outline.svg
export const LABEL_OUTLINE_16 = {
	d: 'M10 6h2V4h-2v2zm3 .586l-6 6L3.414 9l6-6H13v3.586zM14 1H9a.996.996 0 00-.707.293l-7 7a.997.997 0 000 1.414l5 5a.997.997 0 001.414 0l7-7A.996.996 0 0015 7V2a1 1 0 00-1-1z',
	size: 16,
};

export const LABEL_16 = LABEL_OUTLINE_16;
// 16x16/label/filled.svg
export const LABEL_FILLED_16 = {
	d: 'M10 6h2V4h-2v2zm4-5H9a.996.996 0 00-.707.293l-7 7a.997.997 0 000 1.414l5 5a.997.997 0 001.414 0l7-7A.996.996 0 0015 7V2a1 1 0 00-1-1z',
	size: 16,
};

// 16x16/warning/outline.svg
export const WARNING_OUTLINE_16 = {
	d: 'M7 12h2v-1H7v1zm0-2h2V7H7v3zm-4.259 2.995h10.518L8 3.957l-5.259 9.038zM15 15H1a.999.999 0 01-1-1.001c0-.175.045-.35.136-.507l7-12.029C7.315 1.154 7.658 1 8 1c.342 0 .685.154.864.463l7 12.029a1 1 0 01.003 1.005A.999.999 0 0115 15z',
	size: 16,
};

export const WARNING_16 = WARNING_OUTLINE_16;
// 16x16/warning/filled.svg
export const WARNING_FILLED_16 = {
	d: 'M7 10h2V7H7v3zm0 2h2v-1H7v1zm8.864 1.492l-7-12.029C8.685 1.154 8.342 1 8 1c-.343 0-.685.154-.864.463l-7 12.029A.958.958 0 000 14c0 .198.044.341.133.497A.999.999 0 001 15h14a.999.999 0 001-1 .995.995 0 00-.136-.508z',
	size: 16,
};

// 16x16/time large/outline 1.svg
export const TIME_LARGE_OUTLINE_1_16 = {
	d: 'M8 2a18.28 18.28 0 013.77.4 2.38 2.38 0 011.83 1.83A18.24 18.24 0 0114 8a18.282 18.282 0 01-.4 3.77 2.38 2.38 0 01-1.83 1.83A18.24 18.24 0 018 14a18.282 18.282 0 01-3.77-.4 2.38 2.38 0 01-1.83-1.83 18 18 0 010-7.54A2.38 2.38 0 014.23 2.4 17.62 17.62 0 018 2zm0-2a19.44 19.44 0 00-4.2.45A4.36 4.36 0 00.45 3.8 19.44 19.44 0 000 8a19.44 19.44 0 00.45 4.2 4.36 4.36 0 003.35 3.35A19.44 19.44 0 008 16a19.44 19.44 0 004.2-.45 4.36 4.36 0 003.35-3.35A19.44 19.44 0 0016 8a19.44 19.44 0 00-.45-4.2A4.36 4.36 0 0012.2.45 19.44 19.44 0 008 0zm1.71 11.71a1 1 0 000-1.42l-1.6-1.6L9 5.24a1.028 1.028 0 10-2-.48l-1 4a1 1 0 00.26 1l2 2a1 1 0 001.42 0l.03-.05z',
	size: 16,
};

// 16x16/time large/outline.svg
export const TIME_LARGE_OUTLINE_16 = {
	d: 'M15.55 3.8A4.36 4.36 0 0012.2.45 19.44 19.44 0 008 0a19.44 19.44 0 00-4.2.45A4.36 4.36 0 00.45 3.8 19.44 19.44 0 000 8a19.44 19.44 0 00.45 4.2 4.36 4.36 0 003.35 3.35A19.44 19.44 0 008 16a19.44 19.44 0 004.2-.45 4.36 4.36 0 003.35-3.35A19.44 19.44 0 0016 8a19.44 19.44 0 00-.45-4.2zm-5.84 7.91a1 1 0 01-1.42 0l-2-2a1 1 0 01-.26-1l1-4A1.02 1.02 0 119 5.24l-.89 3.45 1.6 1.6a1 1 0 010 1.42z',
	size: 16,
};

export const TIME_LARGE_16 = TIME_LARGE_OUTLINE_16;
// 16x16/info squircle/outline.svg
export const INFO_SQUIRCLE_OUTLINE_16 = {
	d: 'M7 7h2V5H7v2zm0 4h2V8H7v3zm5.654.249a1.835 1.835 0 01-1.404 1.405C10.189 12.884 9.096 13 8 13s-2.189-.116-3.25-.346a1.838 1.838 0 01-1.405-1.405 15.43 15.43 0 010-6.499 1.838 1.838 0 011.406-1.404C5.811 3.116 6.904 3 8 3s2.189.116 3.25.346a1.835 1.835 0 011.404 1.405C12.884 5.812 13 6.904 13 8s-.116 2.188-.346 3.249zm1.955-6.921a3.83 3.83 0 00-2.937-2.937A17.357 17.357 0 008 1c-1.26 0-2.488.135-3.672.391a3.828 3.828 0 00-2.937 2.937A17.357 17.357 0 001 8c0 1.26.135 2.488.391 3.672a3.83 3.83 0 002.937 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.488-.135 3.672-.391a3.83 3.83 0 002.937-2.937C14.865 10.488 15 9.26 15 8c0-1.26-.135-2.488-.391-3.672z',
	size: 16,
};

export const INFO_SQUIRCLE_16 = INFO_SQUIRCLE_OUTLINE_16;
// 16x16/info squircle/filled.svg
export const INFO_SQUIRCLE_FILLED_16 = {
	d: 'M7 7h2V5H7v2zm0 4h2V8H7v3zm7.609-6.672a3.83 3.83 0 00-2.937-2.937A17.357 17.357 0 008 1c-1.26 0-2.488.135-3.672.391a3.828 3.828 0 00-2.937 2.937A17.357 17.357 0 001 8c0 1.26.135 2.488.391 3.672a3.83 3.83 0 002.937 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.488-.135 3.672-.391a3.83 3.83 0 002.937-2.937C14.865 10.488 15 9.26 15 8c0-1.26-.135-2.488-.391-3.672z',
	size: 16,
};

// 16x16/file document/outline.svg
export const FILE_DOCUMENT_OUTLINE_16 = {
	d: 'M12 14v-2H8V8h4V5H9V2H4v12h8zm3-6v4h-1v2a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h6l4 4v4h1z',
	size: 16,
};

export const FILE_DOCUMENT_16 = FILE_DOCUMENT_OUTLINE_16;
// 16x16/file document/filled.svg
export const FILE_DOCUMENT_FILLED_16 = {
	d: 'M8 12h6V9H8v3zm6-4V5H9V0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2v-1h1V8h-1z',
	size: 16,
};

// 16x16/notifications/outline.svg
export const NOTIFICATIONS_OUTLINE_16 = {
	d: 'M4.965 9.435A8.178 8.178 0 008 10a8.178 8.178 0 003.035-.564C10.3 8.166 10 6.801 10 5c0-1.083-.916-2-2-2s-2 .917-2 2c0 1.803-.3 3.167-1.035 4.436zM8 12c-2.851 0-5-1.136-6-2 1.559-1.596 2-2.838 2-5 0-2.16 1.79-4 4-4 2.209 0 4 1.84 4 4 0 2.163.44 3.404 2 5-1 .864-3.15 2-6 2zm0 1h2a2 2 0 11-4 0h2z',
	size: 16,
};

export const NOTIFICATIONS_16 = NOTIFICATIONS_OUTLINE_16;
// 16x16/notifications/filled.svg
export const NOTIFICATIONS_FILLED_16 = {
	d: 'M14 10c-1.559-1.597-2-2.839-2-5s-1.791-4-4-4-4 1.839-4 4-.441 3.403-2 5c1 .863 3.149 2 6 2s5-1.137 6-2zm-6 3h2a2 2 0 01-4 0h2z',
	size: 16,
};

// 16x16/web/outline.svg
export const WEB_OUTLINE_16 = {
	d: 'M10.167 12.485c.354-1.058.556-2.365.613-3.686h2.139a4.99 4.99 0 01-2.752 3.686zM3.081 8.8H5.22c.057 1.321.259 2.628.613 3.686A4.99 4.99 0 013.081 8.8zm2.752-5.285C5.479 4.572 5.277 5.88 5.22 7.2H3.081a4.992 4.992 0 012.752-3.686zM6.826 7.2c.104-2.273.614-3.669.947-4.178C7.851 3.02 7.923 3 8 3c.064 0 .125.016.188.02.366.504.881 1.902.986 4.18H6.826zM8 13c-.064 0-.125-.017-.188-.02-.366-.505-.881-1.902-.986-4.18h2.348c-.104 2.272-.614 3.668-.947 4.177-.078.003-.15.023-.227.023zm4.919-5.8H10.78c-.057-1.32-.259-2.628-.613-3.686A4.992 4.992 0 0112.919 7.2zM8 1a7 7 0 100 14A7 7 0 008 1z',
	size: 16,
};

export const WEB_16 = WEB_OUTLINE_16;
// 16x16/arrow forward/outine.svg
export const ARROW_FORWARD_OUTINE_16 = {
	d: 'M15 5l-5 4V6H6C4.346 6 3 7.346 3 9s1.346 3 3 3h3a1 1 0 110 2H6c-2.757 0-5-2.243-5-5s2.243-5 5-5h4V1l5 4z',
	size: 16,
};

// 16x16/send/outline.svg
export const SEND_OUTLINE_16 = {
	d: 'M9.532 13.118l-1.825-1.825a1.001 1.001 0 00-.949-.263l-.486.121 5.744-6.105-2.484 8.072zm-6.65-6.65l7.284-2.242-5.382 4.166c-.026-.033-.047-.069-.077-.099L2.882 6.468zm11.825-5.175a1 1 0 00-1-.249l-13 4a1.002 1.002 0 00-.413 1.663l2.598 2.599-.862 3.452a.998.998 0 001.212 1.212l3.451-.863 2.6 2.6a1.002 1.002 0 001.663-.413l4-13a1.002 1.002 0 00-.249-1.001z',
	size: 16,
};

export const SEND_16 = SEND_OUTLINE_16;
// 16x16/send/filled.svg
export const SEND_FILLED_16 = {
	d: 'M6.272 11.151l-1.898.475.733-2.934 7.381-5.181-6.216 7.64zm8.435-9.858a1 1 0 00-1-.249l-13 4a1 1 0 00-.413 1.663l2.598 2.599-.862 3.451a.997.997 0 001.212 1.212l3.451-.862 2.6 2.6a1.002 1.002 0 001.663-.413l4-13c.108-.354.012-.74-.249-1.001z',
	size: 16,
};

// 16x16/subtract squircle/outline.svg
export const SUBTRACT_SQUIRCLE_OUTLINE_16 = {
	d: 'M10.965 9h-6a1 1 0 110-2h6a1 1 0 110 2zm1.69 2.25a1.836 1.836 0 01-1.405 1.404 15.428 15.428 0 01-6.5 0 1.836 1.836 0 01-1.405-1.405A15.42 15.42 0 013 8c0-1.097.116-2.19.345-3.25A1.838 1.838 0 014.75 3.345a15.43 15.43 0 016.5 0 1.838 1.838 0 011.405 1.406 15.413 15.413 0 010 6.498zm1.955-6.922a3.833 3.833 0 00-2.938-2.938A17.347 17.347 0 008 1c-1.26 0-2.49.134-3.672.39A3.832 3.832 0 001.39 4.328 17.35 17.35 0 001 8c0 1.26.134 2.488.39 3.671a3.83 3.83 0 002.938 2.938A17.35 17.35 0 008 15c1.258 0 2.488-.135 3.67-.39a3.832 3.832 0 002.939-2.939c.256-1.183.39-2.412.39-3.67 0-1.26-.134-2.49-.39-3.673z',
	size: 16,
};

export const SUBTRACT_SQUIRCLE_16 = SUBTRACT_SQUIRCLE_OUTLINE_16;
// 16x16/subtract squircle/filled.svg
export const SUBTRACT_SQUIRCLE_FILLED_16 = {
	d: 'M10.965 9h-6a1 1 0 110-2h6a1 1 0 110 2zm3.576-4.688a3.81 3.81 0 00-2.923-2.923A17.243 17.243 0 007.965 1c-1.254 0-2.476.134-3.653.389a3.81 3.81 0 00-2.923 2.923 17.229 17.229 0 00-.39 3.653c0 1.254.135 2.475.39 3.653a3.81 3.81 0 002.923 2.923c1.177.255 2.399.389 3.653.389 1.253 0 2.476-.134 3.653-.389a3.81 3.81 0 002.923-2.923c.255-1.178.389-2.399.389-3.653s-.134-2.476-.39-3.653z',
	size: 16,
};

// 16x16/help squircle/outline.svg
export const HELP_SQUIRCLE_OUTLINE_16 = {
	d: 'M8 4a3.012 3.012 0 00-2.598 1.499 1 1 0 101.731 1.002A1.001 1.001 0 118 8H7v2h1c1.654 0 3-1.346 3-3S9.654 4 8 4zm-1 8h2v-1H7v1zm5.654-.75a1.835 1.835 0 01-1.405 1.404C10.19 12.884 9.096 13 8 13s-2.189-.116-3.25-.346a1.838 1.838 0 01-1.405-1.405A15.413 15.413 0 013 8c0-1.097.116-2.19.345-3.25A1.838 1.838 0 014.75 3.346 15.364 15.364 0 018 3c1.096 0 2.19.116 3.25.346a1.835 1.835 0 011.404 1.405c.23 1.06.346 2.153.346 3.25 0 1.095-.116 2.187-.346 3.248zm1.955-6.922a3.831 3.831 0 00-2.937-2.937A17.357 17.357 0 008 1.001c-1.26 0-2.488.134-3.672.39a3.828 3.828 0 00-2.937 2.937A17.357 17.357 0 001.001 8c0 1.26.134 2.488.39 3.672a3.831 3.831 0 002.937 2.937 17.422 17.422 0 007.344.001 3.832 3.832 0 002.937-2.938 17.422 17.422 0 00.001-7.344z',
	size: 16,
};

export const HELP_SQUIRCLE_16 = HELP_SQUIRCLE_OUTLINE_16;
// 16x16/help squircle/filled.svg
export const HELP_SQUIRCLE_FILLED_16 = {
	d: 'M8 10H7V8h1a1.001 1.001 0 000-2c-.356 0-.688.192-.867.501a1 1 0 11-1.731-1.002A3.012 3.012 0 018 4c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-1 2h2v-1H7v1zm6.544-9.544C12.474 1.388 10.724 1 8 1c-2.725 0-4.475.388-5.543 1.456C1.387 3.526 1 5.276 1 8c0 2.725.388 4.475 1.457 5.544C3.525 14.612 5.275 15 8 15s4.475-.388 5.544-1.456C14.612 12.474 15 10.724 15 8c0-2.725-.388-4.475-1.456-5.544z',
	size: 16,
};

// 16x16/flag/outline.svg
export const FLAG_OUTLINE_16 = {
	d: 'M11.764 9H9V5h2.764l-1 2 1 2zM4 7h3V3H4v4zm11-4H9a2 2 0 00-2-2H4a1 1 0 10-2 0v14a1 1 0 102 0V9h3a2 2 0 002 2h6l-2-4 2-4z',
	size: 16,
};

export const FLAG_16 = FLAG_OUTLINE_16;
// 16x16/flag/filled.svg
export const FLAG_FILLED_16 = {
	d: 'M14 3H9v6a2 2 0 002 2h3l-2-4 2-4zM8 3v6H3v6a1 1 0 11-2 0V1a1 1 0 112 0h3a2 2 0 012 2z',
	size: 16,
};

// 16x16/chevron left/outline.svg
export const CHEVRON_LEFT_OUTLINE_16 = {
	d: 'M10 14a.997.997 0 01-.707-.293l-5-5a.997.997 0 010-1.414l5-5a.997.997 0 011.414 0 .997.997 0 010 1.414L6.414 8l4.293 4.293a.997.997 0 010 1.414A.997.997 0 0110 14z',
	size: 16,
};

export const CHEVRON_LEFT_16 = CHEVRON_LEFT_OUTLINE_16;
// 16x16/chevron left/filled.svg
export const CHEVRON_LEFT_FILLED_16 = {
	d: 'M10 14a.997.997 0 01-.707-.293l-5-5a.997.997 0 010-1.414l5-5a.997.997 0 011.414 0A.997.997 0 0111 3v10a.997.997 0 01-1 1z',
	size: 16,
};

// 16x16/square pattern/outline.svg
export const SQUARE_PATTERN_OUTLINE_16 = {
	d: 'M5.8 1H2.2C1.5 1 1 1.5 1 2.2v3.6C1 6.5 1.5 7 2.2 7h3.6C6.5 7 7 6.5 7 5.8V2.2C7 1.5 6.5 1 5.8 1zM5 5H3V3h2v2zm8.8-4h-3.6C9.5 1 9 1.5 9 2.2v3.6c0 .7.5 1.2 1.2 1.2h3.6c.7 0 1.2-.5 1.2-1.2V2.2c0-.7-.5-1.2-1.2-1.2zM13 5h-2V3h2v2zM5.8 9H2.2C1.5 9 1 9.5 1 10.2v3.6c0 .7.5 1.2 1.2 1.2h3.6c.7 0 1.2-.5 1.2-1.2v-3.6C7 9.5 6.5 9 5.8 9zM5 13H3v-2h2v2zm8.8-4h-3.6C9.5 9 9 9.5 9 10.2v3.6c0 .7.5 1.2 1.2 1.2h3.6c.7 0 1.2-.5 1.2-1.2v-3.6c0-.7-.5-1.2-1.2-1.2zm-.8 4h-2v-2h2v2z',
	size: 16,
};

export const SQUARE_PATTERN_16 = SQUARE_PATTERN_OUTLINE_16;
// 16x16/arrow up/outline.svg
export const ARROW_UP_OUTLINE_16 = {
	d: 'M7.617 1.077a.995.995 0 011.09.217l5 4.999A.993.993 0 0114 7a.999.999 0 01-1.707.707L9 4.414V14a1 1 0 11-2 0V4.414L3.706 7.707a.999.999 0 11-1.414-1.414l5.001-5a.982.982 0 01.324-.216z',
	size: 16,
};

export const ARROW_UP_16 = ARROW_UP_OUTLINE_16;
// 16x16/arrow up/filled.svg
export const ARROW_UP_FILLED_16 = {
	d: 'M8 1a.997.997 0 00-.708.293l-5 5A.996.996 0 002 7a.996.996 0 001 1h4v6a1 1 0 102 0V8h4a.998.998 0 00.707-1.707l-5-5A.997.997 0 007.998 1z',
	size: 16,
};

// 16x16/download/outline.svg
export const DOWNLOAD_OUTLINE_16 = {
	d: 'M4 3h1c1.103 0 2 .897 2 2v2H4l4 5 4-5H9V5c0-2.206-1.794-4-4-4H4a1 1 0 100 2zm11 7v2c0 1.654-1.346 3-3 3H4c-1.654 0-3-1.346-3-3v-2a1 1 0 112 0v2a1 1 0 001 1h8a1 1 0 001-1v-2a1 1 0 112 0z',
	size: 16,
};

export const DOWNLOAD_16 = DOWNLOAD_OUTLINE_16;
// 16x16/download/filled.svg
export const DOWNLOAD_FILLED_16 = {
	d: 'M4.9 1.61a6.33 6.33 0 011.057 1.97c.351 1.09.445 2.24.5 3.42H4l4 5 4-5H9.465c-.124-1.552-.628-3.13-1.597-4.46-.584-.801-1.345-1.49-2.209-1.91A5.687 5.687 0 003 0c.753.475 1.404 1.006 1.9 1.61zM15 10v2c0 1.655-1.346 3-3 3H4c-1.655 0-3-1.345-3-3v-2a1 1 0 112 0v2a1 1 0 001 1h8c.551 0 1-.448 1-1v-2a1 1 0 112 0z',
	size: 16,
};

// 16x16/new window/outline.svg
export const NEW_WINDOW_OUTLINE_16 = {
	d: 'M12 13H4a1 1 0 01-1-1V7h10v5a1 1 0 01-1 1zM4 3h8a1 1 0 011 1v1H3V4a1 1 0 011-1zm8-2H4C2.346 1 1 2.346 1 4v8c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3V4c0-1.654-1.346-3-3-3z',
	size: 16,
};

export const NEW_WINDOW_16 = NEW_WINDOW_OUTLINE_16;
// 16x16/new window/filled.svg
export const NEW_WINDOW_FILLED_16 = {
	d: 'M13 12a1 1 0 01-1 1H4a1 1 0 01-1-1V6h10v6zM12 1H4C2.346 1 1 2.346 1 4v8c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3V4c0-1.654-1.346-3-3-3z',
	size: 16,
};

// 16x16/overflow menu vertical/filled.svg
export const OVERFLOW_MENU_VERTICAL_FILLED_16 = {
	d: 'M9 4a1 1 0 10-2 0 1 1 0 102 0zm0 8a1 1 0 10-2 0 1 1 0 102 0zM8 9a1 1 0 110-2 1 1 0 110 2z',
	size: 16,
};

// 16x16/download ios/outline.svg
export const DOWNLOAD_IOS_OUTLINE_16 = {
	d: 'M11 7l-3 4-3-4h2V1a1 1 0 112 0v6h2zm4 6V4c0-1.103-.897-2-2-2h-2v2h2v9H3V4h2V2H3c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2z',
	size: 16,
};

export const DOWNLOAD_IOS_16 = DOWNLOAD_IOS_OUTLINE_16;
// 16x16/image/outline.svg
export const IMAGE_OUTLINE_16 = {
	d: 'M5 5.5a1.5 1.5 0 113.001.001A1.5 1.5 0 015 5.5zM8 13c-2.224 0-3.535-.276-4.13-.87a1.738 1.738 0 01-.25-.336L5 10.414l1.293 1.293a.999.999 0 001.414 0l2.387-2.387 2.543 1.907c-.133.392-.299.695-.507.903-.595.594-1.906.87-4.13.87zM3 8c0-2.224.276-3.535.87-4.13C4.465 3.276 5.776 3 8 3s3.535.276 4.13.87c.594.595.87 1.906.87 4.13 0 .353-.01.675-.023.982L10.6 7.2a.996.996 0 00-1.307.093L7 9.586 5.707 8.293a.999.999 0 00-1.414 0L3.056 9.53A18.904 18.904 0 013 8zm10.544-5.544C12.475 1.388 10.725 1 8 1c-2.725 0-4.475.388-5.544 1.456C1.388 3.525 1 5.275 1 8c0 1.31.093 2.39.305 3.281l-.012.012.018.018c.229.95.595 1.683 1.145 2.233C3.525 14.612 5.275 15 8 15c2.725 0 4.475-.388 5.544-1.456C14.612 12.475 15 10.725 15 8c0-2.725-.388-4.475-1.456-5.544z',
	size: 16,
};

export const IMAGE_16 = IMAGE_OUTLINE_16;
// 16x16/image/filled.svg
export const IMAGE_FILLED_16 = {
	d: 'M5 5.5a1.5 1.5 0 113.001.001A1.5 1.5 0 015 5.5zM3 8c0-2.224.276-3.535.87-4.13C4.465 3.276 5.776 3 8 3s3.535.276 4.13.87c.594.595.87 1.906.87 4.13 0 .353-.01.675-.023.982L10.6 7.2a.996.996 0 00-1.307.093L7 9.586 5.707 8.293a.999.999 0 00-1.414 0L3.056 9.53A18.904 18.904 0 013 8zm10.544-5.544C12.475 1.388 10.725 1 8 1c-2.725 0-4.475.388-5.544 1.456C1.388 3.525 1 5.275 1 8c0 1.31.093 2.39.305 3.281l-.012.012.018.018c.229.95.595 1.683 1.145 2.233C3.525 14.612 5.275 15 8 15c2.725 0 4.475-.388 5.544-1.456C14.612 12.475 15 10.725 15 8c0-2.725-.388-4.475-1.456-5.544z',
	size: 16,
};

// 16x16/external link/outline.svg
export const EXTERNAL_LINK_OUTLINE_16 = {
	d: 'M13 8v3c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2h3V1H5C2.794 1 1 2.794 1 5v6c0 2.206 1.794 4 4 4h6c2.206 0 4-1.794 4-4V8h-2zm-1.208-5.207L10 1h5v5l-1.793-1.793-4.5 4.5a1 1 0 01-1.415-1.414l4.5-4.5z',
	size: 16,
};

export const EXTERNAL_LINK_16 = EXTERNAL_LINK_OUTLINE_16;
// 16x16/time alt1/outline.svg
export const TIME_ALT1_OUTLINE_16 = {
	d: 'M8 1a7 7 0 110 14A7 7 0 018 1zm0 2C5.243 3 3 5.243 3 8s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm.999 8c-.15 0-.303-.034-.446-.105l-2-1a1 1 0 01-.523-1.137l1-4a1 1 0 011.94.484l-.805 3.222 1.282.641A1.001 1.001 0 018.999 11z',
	size: 16,
};

export const TIME_ALT1_16 = TIME_ALT1_OUTLINE_16;
// 16x16/time alt1/filled.svg
export const TIME_ALT1_FILLED_16 = {
	d: 'M9.895 10.447a.999.999 0 01-1.342.447l-2-1a1 1 0 01-.524-1.136l1-4a1 1 0 011.941.484l-.806 3.222 1.284.641a1 1 0 01.447 1.342zM8 1a7 7 0 100 14A7 7 0 008 1z',
	size: 16,
};

// 16x16/move/outline.svg
export const MOVE_OUTLINE_16 = {
	d: 'M2.293 5.293a.997.997 0 000 1.414.997.997 0 001.414 0L8 2.414l4.293 4.293a.997.997 0 001.414 0 .997.997 0 000-1.414l-5-5a.997.997 0 00-1.414 0l-5 5zm11.414 5.414a.997.997 0 000-1.414.997.997 0 00-1.414 0L8 13.586 3.707 9.293a.997.997 0 00-1.414 0 .997.997 0 000 1.414l5 5a.997.997 0 001.414 0l5-5z',
	size: 16,
};

export const MOVE_16 = MOVE_OUTLINE_16;
// 16x16/move/filled.svg
export const MOVE_FILLED_16 = {
	d: 'M2.293 5.293a.997.997 0 000 1.414A.997.997 0 003 7h10a.997.997 0 001-1 .997.997 0 00-.293-.707l-5-5a.997.997 0 00-1.414 0l-5 5zm11.414 5.414a.997.997 0 000-1.414A.997.997 0 0013 9H3a.997.997 0 00-1 1c0 .256.098.512.293.707l5 5a.997.997 0 001.414 0l5-5z',
	size: 16,
};

// 16x16/warning circle/outline.svg
export const WARNING_CIRCLE_OUTLINE_16 = {
	d: 'M7 9V4h2v5H7zm0 3v-2h2v2H7zm1 2c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM8 0a8 8 0 110 16A8 8 0 018 0z',
	size: 16,
};

export const WARNING_CIRCLE_16 = WARNING_CIRCLE_OUTLINE_16;
// 16x16/warning circle/filled.svg
export const WARNING_CIRCLE_FILLED_16 = {
	d: 'M8 0a8 8 0 110 16A8 8 0 018 0zm1 10H7v2h2v-2zm0-6H7v5h2V4z',
	size: 16,
};

// 16x16/briefcase/outline.svg
export const BRIEFCASE_OUTLINE_16 = {
	d: 'M8 13c-2.696 0-4.76-.307-6-.562L1.993 10H6v1a1 1 0 001 1h2a1 1 0 001-1v-1h4.01l.007 2.436C12.76 12.693 10.696 13 8 13zm0-7c2.696 0 4.76.307 6 .562L14.004 8H1.987l-.004-1.436C3.24 6.307 5.304 6 8 6zM6 3h4v1.055a36.762 36.762 0 00-4 0V3zm8.418 1.604A28.998 28.998 0 0012 4.226V3c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v1.226c-.97.112-1.787.25-2.418.378A1.992 1.992 0 000 6.562v5.876c0 .946.656 1.767 1.582 1.958C2.947 14.675 5.148 15 8 15c2.852 0 5.053-.325 6.418-.604A1.992 1.992 0 0016 12.438V6.562c0-.946-.656-1.767-1.582-1.958z',
	size: 16,
};

export const BRIEFCASE_16 = BRIEFCASE_OUTLINE_16;
// 16x16/briefcase/filled.svg
export const BRIEFCASE_FILLED_16 = {
	d: 'M8 4c.708 0 1.375.021 2 .055V3H6v1.055A36.762 36.762 0 018 4zm8 2.562V8H0V6.562c0-.946.656-1.767 1.582-1.958A28.998 28.998 0 014 4.226V3c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v1.226c.97.112 1.787.25 2.418.378A1.992 1.992 0 0116 6.562zM10 9h6v3.438a1.99 1.99 0 01-1.582 1.957C13.053 14.675 10.852 15 8 15c-2.852 0-5.053-.325-6.418-.605A1.99 1.99 0 010 12.438V9h6v1a1 1 0 001 1h2a1 1 0 001-1V9z',
	size: 16,
};

// 16x16/attachment/outline.svg
export const ATTACHMENT_OUTLINE_16 = {
	d: 'M14.903 1.06A3.81 3.81 0 0012.25 0c-.962 0-1.924.354-2.657 1.06L1.22 9.21a.71.71 0 000 1.026.772.772 0 001.063 0l8.372-8.152a2.316 2.316 0 013.187 0 2.13 2.13 0 010 3.078l-9.435 9.175a.789.789 0 01-1.062 0 .709.709 0 010-1.025L12.07 4.82a.709.709 0 000-1.026.772.772 0 00-1.063 0l-8.724 8.492a2.126 2.126 0 000 3.078c.424.41.99.635 1.593.635a2.28 2.28 0 001.592-.636l9.435-9.177A3.556 3.556 0 0016 3.626a3.553 3.553 0 00-1.097-2.566z',
	size: 16,
};

export const ATTACHMENT_16 = ATTACHMENT_OUTLINE_16;
// 16x16/chevron right/outline.svg
export const CHEVRON_RIGHT_OUTLINE_16 = {
	d: 'M6 2c.256 0 .512.098.707.293l5 5a.997.997 0 010 1.414l-5 5a.997.997 0 01-1.414 0 .997.997 0 010-1.414L9.586 8 5.293 3.707a.997.997 0 010-1.414A.997.997 0 016 2z',
	size: 16,
};

export const CHEVRON_RIGHT_16 = CHEVRON_RIGHT_OUTLINE_16;
// 16x16/chevron right/filled.svg
export const CHEVRON_RIGHT_FILLED_16 = {
	d: 'M6 2c.256 0 .512.098.707.293l5 5a.997.997 0 010 1.414l-5 5a.997.997 0 01-1.414 0A.997.997 0 015 13V3a.997.997 0 011-1z',
	size: 16,
};

// 16x16/arrow down/outline.svg
export const ARROW_DOWN_OUTLINE_16 = {
	d: 'M8.383 14.923a1 1 0 01-1.09-.217l-5-4.999A.993.993 0 012.002 9a.999.999 0 011.707-.707L7 11.586V2a1 1 0 112 0v9.586l3.293-3.293a.999.999 0 111.415 1.414l-5 5a.986.986 0 01-.325.216z',
	size: 16,
};

export const ARROW_DOWN_16 = ARROW_DOWN_OUTLINE_16;
// 16x16/arrow down/filled.svg
export const ARROW_DOWN_FILLED_16 = {
	d: 'M8 15a.997.997 0 00.708-.293l5-5A.996.996 0 0014 9a.996.996 0 00-1-1H9V2a1 1 0 10-2 0v6H3a.998.998 0 00-.707 1.707l5 5a.997.997 0 00.708.293z',
	size: 16,
};

// 16x16/renew horizontal/outline.svg
export const RENEW_HORIZONTAL_OUTLINE_16 = {
	d: 'M13 7a1 1 0 00-1 1c0 1.654-1.346 3-3 3H6V9l-4 3 4 3v-2h3c2.757 0 5-2.243 5-5a1 1 0 00-1-1zM2 8c0-2.757 2.243-5 5-5h3V1l4 3-4 3V5H7C5.346 5 4 6.346 4 8a1 1 0 11-2 0z',
	size: 16,
};

export const RENEW_HORIZONTAL_16 = RENEW_HORIZONTAL_OUTLINE_16;
// 16x16/reject squircle/outline.svg
export const REJECT_SQUIRCLE_OUTLINE_16 = {
	d: 'M10.707 6.707L9.414 8l1.293 1.293a.999.999 0 11-1.414 1.414L8 9.414l-1.293 1.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L6.586 8 5.293 6.707a.999.999 0 111.414-1.414L8 6.586l1.293-1.293a.999.999 0 111.414 1.414zm1.947 4.542a1.835 1.835 0 01-1.405 1.405C10.189 12.884 9.096 13 8 13s-2.189-.116-3.25-.346a1.838 1.838 0 01-1.405-1.405 15.422 15.422 0 010-6.499A1.838 1.838 0 014.75 3.346 15.364 15.364 0 018 3c1.096 0 2.189.116 3.249.346a1.835 1.835 0 011.405 1.405C12.884 5.811 13 6.904 13 8s-.116 2.188-.346 3.249zm1.955-6.921a3.83 3.83 0 00-2.937-2.937A17.357 17.357 0 008 1c-1.26 0-2.488.135-3.672.391a3.828 3.828 0 00-2.937 2.937A17.357 17.357 0 001 8c0 1.26.135 2.488.391 3.672a3.83 3.83 0 002.937 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.488-.135 3.672-.391a3.83 3.83 0 002.937-2.937C14.865 10.488 15 9.26 15 8c0-1.26-.135-2.488-.391-3.672z',
	size: 16,
};

export const REJECT_SQUIRCLE_16 = REJECT_SQUIRCLE_OUTLINE_16;
// 16x16/reject squircle/filled.svg
export const REJECT_SQUIRCLE_FILLED_16 = {
	d: 'M10.707 9.293a.999.999 0 11-1.414 1.414L8 9.414l-1.293 1.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L6.586 8 5.293 6.707a.999.999 0 111.414-1.414L8 6.586l1.293-1.293a.999.999 0 111.414 1.414L9.414 8l1.293 1.293zm3.902-4.965a3.83 3.83 0 00-2.937-2.937A17.357 17.357 0 008 1c-1.26 0-2.488.135-3.672.391a3.828 3.828 0 00-2.937 2.937A17.357 17.357 0 001 8c0 1.26.135 2.488.391 3.672a3.83 3.83 0 002.937 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.488-.135 3.672-.391a3.83 3.83 0 002.937-2.937C14.865 10.488 15 9.26 15 8c0-1.26-.135-2.488-.391-3.672z',
	size: 16,
};

// 16x16/locked large/outline.svg
export const LOCKED_LARGE_OUTLINE_16 = {
	d: 'M9.5 9.5a1.5 1.5 0 00-3 0c0 .442.195.836.5 1.11V13h2v-2.39c.305-.274.5-.668.5-1.11zM8 14c1.871 0 3.225-.241 4.03-.444L12 7.523C10.987 7.283 9.479 7 8 7s-2.987.283-3.992.521L4 13.563c.775.196 2.129.437 4 .437zM6 4v1.139C6.646 5.059 7.319 5 8 5c.682 0 1.354.059 2 .139V4c0-1.103-.897-2-2-2s-2 .897-2 2zm6.453 1.575A2.004 2.004 0 0114 7.523v6.04c0 .906-.604 1.711-1.482 1.932-1 .252-2.506.505-4.518.505s-3.518-.253-4.518-.505C2.604 15.274 2 14.469 2 13.563v-6.04c0-.93.641-1.733 1.547-1.948.138-.032.303-.064.453-.097V4c0-2.206 1.794-4 4-4s4 1.794 4 4v1.478c.15.033.316.065.453.097z',
	size: 16,
};

export const LOCKED_LARGE_16 = LOCKED_LARGE_OUTLINE_16;
// 16x16/locked large/filled.svg
export const LOCKED_LARGE_FILLED_16 = {
	d: 'M9 9.913c.305-.274.5-.668.5-1.11a1.5 1.5 0 10-3 0c0 .442.195.836.5 1.11v3.39h2v-3.39zM6 4v1.07C6.573 5.027 7.229 5 8 5c.771 0 1.427.027 2 .07V4a2 2 0 00-4 0zm6.518 1.47A2.006 2.006 0 0114 7.403v6.194c0 .907-.608 1.692-1.482 1.933-.87.239-2.865.47-4.518.47-1.653 0-3.648-.231-4.518-.47A2.006 2.006 0 012 13.597V7.403c0-.907.608-1.692 1.482-1.933.156-.043.331-.084.518-.125V4c0-2.205 1.795-4 4-4s4 1.795 4 4v1.345c.187.041.362.082.518.125z',
	size: 16,
};

// 16x16/share ios/outline.svg
export const SHARE_IOS_OUTLINE_16 = {
	d: 'M7.041 9.5a1 1 0 102 0V4H11L8 0 5 4h2.041v5.5zM14 13c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V7c0-1.103.897-2 2-2h2.041v2H4v6h8V7h-1.959V5H12c1.103 0 2 .897 2 2v6z',
	size: 16,
};

export const SHARE_IOS_16 = SHARE_IOS_OUTLINE_16;
// 16x16/chevron up/outline.svg
export const CHEVRON_UP_OUTLINE_16 = {
	d: 'M2 10c0-.256.098-.512.293-.707l5-5a.997.997 0 011.414 0l5 5a.997.997 0 010 1.414.997.997 0 01-1.414 0L8 6.414l-4.293 4.293a.997.997 0 01-1.414 0A.997.997 0 012 10z',
	size: 16,
};

export const CHEVRON_UP_16 = CHEVRON_UP_OUTLINE_16;
// 16x16/chevron up/filled.svg
export const CHEVRON_UP_FILLED_16 = {
	d: 'M2 10c0-.256.098-.512.293-.707l5-5a.997.997 0 011.414 0l5 5a.997.997 0 010 1.414A.997.997 0 0113 11H3a.997.997 0 01-1-1z',
	size: 16,
};

// 16x16/device monitor and mobile/outline.svg
export const DEVICE_MONITOR_AND_MOBILE_OUTLINE_16 = {
	d: 'M2 4.543v3.914c0 .466.323.875.769.973C3.952 9.689 5.821 10 8 10v5H4a1 1 0 110-2h1v-1.178a27.136 27.136 0 01-2.661-.439A3.006 3.006 0 010 8.457V4.543c0-1.397.983-2.628 2.339-2.926A26.858 26.858 0 018 1c2.358 0 4.38.336 5.661.617C15.104 1.936 16 2.849 16 4h-2c0-.139-.359-.339-.77-.43A24.838 24.838 0 008 3c-2.179 0-4.048.311-5.231.57A.995.995 0 002 4.543zM11 14h3V7h-3v7zm3-9h-3a2 2 0 00-2 2v7a2 2 0 002 2h3a2 2 0 002-2V7a2 2 0 00-2-2z',
	size: 16,
};

export const DEVICE_MONITOR_AND_MOBILE_16 = DEVICE_MONITOR_AND_MOBILE_OUTLINE_16;
// 16x16/checkbox empty/outline.svg
export const CHECKBOX_EMPTY_OUTLINE_16 = {
	d: 'M8 2a17.627 17.627 0 00-3.77.4A2.38 2.38 0 002.4 4.23a18 18 0 000 7.54 2.38 2.38 0 001.83 1.83A18.24 18.24 0 008 14a18.282 18.282 0 003.77-.4 2.38 2.38 0 001.83-1.83A18.24 18.24 0 0014 8a18.282 18.282 0 00-.4-3.77 2.38 2.38 0 00-1.83-1.83A18.288 18.288 0 008 2zm0-2c1.412-.003 2.82.148 4.2.45a4.36 4.36 0 013.35 3.35c.302 1.38.453 2.788.45 4.2a19.447 19.447 0 01-.45 4.2 4.36 4.36 0 01-3.35 3.35c-1.38.302-2.788.453-4.2.45a19.447 19.447 0 01-4.2-.45A4.36 4.36 0 01.45 12.2 19.448 19.448 0 010 8c-.003-1.412.148-2.82.45-4.2A4.36 4.36 0 013.8.45 19.448 19.448 0 018 0z',
	size: 16,
};

export const CHECKBOX_EMPTY_16 = CHECKBOX_EMPTY_OUTLINE_16;
// 16x16/file excel/outline.svg
export const FILE_EXCEL_OUTLINE_16 = {
	d: 'M14 8a17.9 17.9 0 01-.401 3.773 2.388 2.388 0 01-1.826 1.826 17.9 17.9 0 01-7.547 0 2.388 2.388 0 01-1.825-1.826 17.902 17.902 0 010-7.547 2.387 2.387 0 011.826-1.825 17.9 17.9 0 017.546 0 2.388 2.388 0 011.826 1.826A17.9 17.9 0 0114 8zm2 0c0-1.44-.154-2.844-.446-4.196A4.383 4.383 0 0012.196.446 19.867 19.867 0 008 0C6.56 0 5.156.154 3.804.446A4.38 4.38 0 00.446 3.803 19.876 19.876 0 000 8c0 1.439.154 2.844.446 4.196a4.381 4.381 0 003.358 3.358A19.86 19.86 0 008 16c1.439 0 2.844-.154 4.196-.446a4.383 4.383 0 003.358-3.358A19.86 19.86 0 0016 8zm-7.199-.045l2.232-3.105H9.531L8.359 6.559a3.011 3.011 0 00-.324.623 2.89 2.89 0 00-.314-.614L6.541 4.85H4.922l2.25 3.132-2.287 3.168h1.504l1.215-1.763c.134-.2.251-.414.341-.639.073.207.19.432.317.621l1.224 1.781h1.629L8.801 7.955z',
	size: 16,
};

export const FILE_EXCEL_16 = FILE_EXCEL_OUTLINE_16;
// 16x16/file excel/filled.svg
export const FILE_EXCEL_FILLED_16 = {
	d: 'M9.908 12.047H12L9.03 7.942l2.865-3.989H9.966L8.462 6.15c-.16.232-.313.52-.416.798a3.818 3.818 0 00-.405-.786L6.127 3.953h-2.08l2.888 4.024L4 12.047h1.93L7.49 9.78c.173-.254.324-.532.44-.82.092.266.243.555.405.798l1.572 2.289zm5.646-8.243a19.926 19.926 0 010 8.392 4.381 4.381 0 01-3.358 3.358A19.867 19.867 0 018 16a19.86 19.86 0 01-4.196-.446 4.378 4.378 0 01-3.358-3.358A19.86 19.86 0 010 8c0-1.44.154-2.844.446-4.197A4.379 4.379 0 013.804.446 19.853 19.853 0 018 0c1.44 0 2.844.154 4.196.446a4.383 4.383 0 013.358 3.358z',
	size: 16,
};

// 16x16/file video/outline.svg
export const FILE_VIDEO_OUTLINE_16 = {
	d: 'M6 5l5 3-5 3V5zm2-5c1.439 0 2.844.154 4.196.446a4.383 4.383 0 013.358 3.358A19.86 19.86 0 0116 8c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.867 19.867 0 018 16a19.86 19.86 0 01-4.196-.446 4.381 4.381 0 01-3.358-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.38 4.38 0 013.804.446 19.86 19.86 0 018 0zm0 2a17.9 17.9 0 00-3.773.401 2.387 2.387 0 00-1.826 1.825 17.902 17.902 0 000 7.547 2.388 2.388 0 001.825 1.826 17.916 17.916 0 007.547 0 2.388 2.388 0 001.826-1.826 17.9 17.9 0 000-7.546 2.388 2.388 0 00-1.826-1.826C10.543 2.135 9.273 2 8 2z',
	size: 16,
};

export const FILE_VIDEO_16 = FILE_VIDEO_OUTLINE_16;
// 16x16/file video/filled.svg
export const FILE_VIDEO_FILLED_16 = {
	d: 'M6 11l5-3-5-3v6zm9.554-7.196A19.86 19.86 0 0116 8c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.867 19.867 0 018 16a19.86 19.86 0 01-4.196-.446 4.381 4.381 0 01-3.358-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.38 4.38 0 013.804.446 19.86 19.86 0 018 0c1.439 0 2.844.154 4.196.446a4.383 4.383 0 013.358 3.358z',
	size: 16,
};

// 16x16/device tablet/outline.svg
export const DEVICE_TABLET_OUTLINE_16 = {
	d: 'M8.6 12H7.401A.4.4 0 017 11.6v-1.2a.4.4 0 01.401-.4H8.6a.4.4 0 01.4.4v1.2a.4.4 0 01-.4.4zM3 14h10V2H3v12zM13 0H3a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2z',
	size: 16,
};

export const DEVICE_TABLET_16 = DEVICE_TABLET_OUTLINE_16;
// 16x16/radio button checked/outline.svg
export const RADIO_BUTTON_CHECKED_OUTLINE_16 = {
	d: 'M8 0a8 8 0 100 16A8 8 0 008 0zm0 2a6 6 0 110 12A6 6 0 018 2z',
	size: 16,
};

export const RADIO_BUTTON_CHECKED_16 = RADIO_BUTTON_CHECKED_OUTLINE_16;
// 16x16/radio button checked/filled.svg
export const RADIO_BUTTON_CHECKED_FILLED_16 = {
	d: 'M8 0a8 8 0 110 16A8 8 0 018 0zm0 5a3 3 0 100 6 3 3 0 000-6z',
	size: 16,
};

// 16x16/write/outline.svg
export const WRITE_OUTLINE_16 = {
	d: 'M13 4l-9 9-3 1 1-3 9-9 2 2zm1.666-1.586l-.783.783-2-2 .783-.783a1.415 1.415 0 012 2zM0 16v-1h16v1H0z',
	size: 16,
};

export const WRITE_16 = WRITE_OUTLINE_16;
// 16x16/edit/filled.svg
export const EDIT_FILLED_16 = {
	d: 'M14.719 4.161a.979.979 0 00.28-.7.936.936 0 00-.28-.657l-1.522-1.523a.956.956 0 00-1.357 0l-1.242 1.241 2.88 2.88 1.24-1.24zM2.712 10.408l6.927-6.926 2.879 2.88-6.926 6.926a3.848 3.848 0 01-1.784 1.01L1 15l.702-2.808a3.843 3.843 0 011.01-1.784z',
	size: 16,
};

// 16x16/arrow back group/outine.svg
export const ARROW_BACK_GROUP_OUTINE_16 = {
	d: 'M5 2.342L1.709 5 5 7.658V9L0 5l5-4v1.342zM15 9c0-2.757-2.243-5-5-5H9V1L4 5l5 4V6h1c1.654 0 3 1.346 3 3 0 1.655-1.346 3-3 3H7a1 1 0 100 2h3c2.757 0 5-2.243 5-5z',
	size: 16,
};

// 16x16/volume up/outline.svg
export const VOLUME_UP_OUTLINE_16 = {
	d: 'M7 5.1v5.8L5.3 9.5 4.7 9H3V7h1.7l.6-.5L7 5.1zM8 2c-.2 0-.4.1-.6.2L4 5H2.5C1.7 5 1 5.7 1 6.5v3c0 .8.7 1.5 1.5 1.5H4l3.4 2.8c.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.5-.5.5-.9V3c0-.4-.2-.7-.5-.9C8.3 2 8.2 2 8 2zm5.3 1.3c-.4 0-.7.3-.7.7v8c0 .4.3.7.7.7.4 0 .7-.3.7-.7V4c0-.4-.3-.7-.7-.7zm-2.6 2c-.4 0-.7.3-.7.7v4c0 .4.3.7.7.7.4 0 .7-.3.7-.7V6c-.1-.4-.4-.7-.7-.7z',
	size: 16,
};

export const VOLUME_UP_16 = VOLUME_UP_OUTLINE_16;
// 16x16/volume up/filled.svg
export const VOLUME_UP_FILLED_16 = {
	d: 'M9 3v10c0 .4-.2.7-.5.9-.2.1-.3.1-.5.1s-.4-.1-.6-.2L4 11H2.5C1.7 11 1 10.3 1 9.5v-3C1 5.7 1.7 5 2.5 5H4l3.4-2.8c.2-.1.4-.2.6-.2.2 0 .3 0 .5.1.3.2.5.5.5.9zm1.7 2.3c-.4 0-.7.3-.7.7v4c0 .4.3.7.7.7.4 0 .7-.3.7-.7V6c-.1-.4-.4-.7-.7-.7zm2.6-2c-.4 0-.7.3-.7.7v8c0 .4.3.7.7.7.4 0 .7-.3.7-.7V4c0-.4-.3-.7-.7-.7z',
	size: 16,
};

// 16x16/overflow menu horizontal/filled.svg
export const OVERFLOW_MENU_HORIZONTAL_FILLED_16 = {
	d: 'M4 7a1 1 0 100 2 1 1 0 100-2zm8 0a1 1 0 100 2 1 1 0 100-2zM9 8a1 1 0 11-2 0 1 1 0 112 0z',
	size: 16,
};

// 16x16/selected/outline.svg
export const SELECTED_OUTLINE_16 = {
	d: 'M8 11a3 3 0 100-6 3 3 0 000 6z',
	size: 16,
};

export const SELECTED_16 = SELECTED_OUTLINE_16;
// 16x16/arrow right/outline.svg
export const ARROW_RIGHT_OUTLINE_16 = {
	d: 'M14.924 7.618a.986.986 0 00-.217-.325l-5-5a1 1 0 00-1.414 1.414L11.586 7H2a1 1 0 100 2h9.586l-3.293 3.293a.999.999 0 101.414 1.414l5-5a1 1 0 00.216-1.09z',
	size: 16,
};

export const ARROW_RIGHT_16 = ARROW_RIGHT_OUTLINE_16;
// 16x16/arrow right/filled.svg
export const ARROW_RIGHT_FILLED_16 = {
	d: 'M14.707 7.294l-5-5A.998.998 0 008 3v4H2a1 1 0 100 2h6v4a.997.997 0 001 1 .996.996 0 00.707-.292l5-5a.997.997 0 000-1.414z',
	size: 16,
};

// 16x16/company/outline.svg
export const COMPANY_OUTLINE_16 = {
	d: 'M10.035 12.965V10h-4v2.965H4.003L4.014 9h8l-.01 3.965h-1.969zM12.032 3l-.003 1h-8l.003-1h8zm-.012 4h-8l.003-1h8l-.003 1zM15 12.965h-.997l.032-10.962a.999.999 0 00-1-1.003h-10a1 1 0 00-1 .997l-.032 10.968H1a1 1 0 100 2h14a1 1 0 100-2z',
	size: 16,
};

export const COMPANY_16 = COMPANY_OUTLINE_16;
// 16x16/company/filled.svg
export const COMPANY_FILLED_16 = {
	d: 'M4 4h8V3H4v1zm0 3h8v-.965H4V7zm2.035 6.035h4v-3h-4v3zM15 13h-1V2a1 1 0 00-1-1H3a1 1 0 00-1 1v11H1a1 1 0 100 2h14a1 1 0 100-2z',
	size: 16,
};

// 16x16/visibility off/filled .svg
export const VISIBILITY_OFF_FILLED__16 = {
	d: 'M16 8c0 .2 0 .4-.1.5-.1.1-.5.9-1.4 1.9L6.4 2.2c.5-.1 1-.2 1.6-.2 4.5 0 7.7 5.3 7.9 5.5.1.1.1.3.1.5zM2.7 1.3C2.5 1.1 2.3 1 2 1c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .3.1.5.3.7l1.6 1.6C1.2 5.7.2 7.4.1 7.5c-.1.1-.1.3-.1.5s0 .4.1.5C.3 8.7 3.5 14 8 14c1.3 0 2.5-.4 3.5-1.1l1.8 1.8c.2.2.5.3.7.3.2 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7l-12-12z',
	size: 16,
};

// 16x16/visibility off/outline.svg
export const VISIBILITY_OFF_OUTLINE_16 = {
	d: 'M2.7 1.3C2.5 1.1 2.3 1 2 1c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .3.1.5.3.7l1.6 1.6C1.2 5.7.2 7.4.1 7.5c-.1.1-.1.3-.1.5s0 .4.1.5C.3 8.7 3.5 14 8 14c1.3 0 2.5-.4 3.5-1.1l1.8 1.8c.2.2.5.3.7.3.2 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7l-12-12zM8 12c-2.7 0-5-2.8-5.8-4 .4-.6 1.1-1.5 2.1-2.3l5.8 5.8c-.7.3-1.4.5-2.1.5zm7.9-4.5c.1.1.1.3.1.5s0 .4-.1.5c-.1.1-.5.9-1.4 1.9L13.1 9c.3-.4.6-.7.7-.9-.8-1.2-3-3.9-5.7-4L6.4 2.2c.5-.1 1-.2 1.6-.2 4.5 0 7.7 5.3 7.9 5.5z',
	size: 16,
};

export const VISIBILITY_OFF_16 = VISIBILITY_OFF_OUTLINE_16;
// 16x16/history/outline.svg
export const HISTORY_OUTLINE_16 = {
	d: 'M8 1a7 7 0 00-5.416 2.584L1 2v5h5L4.005 5.005A5.003 5.003 0 018 3c2.757 0 5 2.243 5 5s-2.243 5-5 5a4.983 4.983 0 01-4.931-4.166l-1.972.332A6.975 6.975 0 008 15c3.859 0 7-3.141 7-7s-3.141-7-7-7zm1 4v3.382l1.447.723a1.001 1.001 0 01-.894 1.79l-2-1A1.001 1.001 0 017 9V5a1 1 0 112 0z',
	size: 16,
};

export const HISTORY_16 = HISTORY_OUTLINE_16;
// 16x16/settings/outline.svg
export const SETTINGS_OUTLINE_16 = {
	d: 'M8 9.5c-.827 0-1.5-.673-1.5-1.5S7.173 6.5 8 6.5s1.5.673 1.5 1.5S8.827 9.5 8 9.5zM8 5a3 3 0 100 6 3 3 0 000-6zm6.5 3.156c-.877.18-1.61.783-1.946 1.638a5.348 5.348 0 01-.066.159 2.656 2.656 0 00.219 2.533l-.223.222a2.7 2.7 0 00-1.47-.44 2.65 2.65 0 00-1.061.22 5.348 5.348 0 01-.159.066A2.656 2.656 0 008.156 14.5h-.312a2.66 2.66 0 00-1.638-1.947 3.728 3.728 0 01-.158-.065 2.655 2.655 0 00-1.062-.22 2.7 2.7 0 00-1.47.44l-.223-.222a2.656 2.656 0 00.219-2.533 5.348 5.348 0 01-.066-.159A2.656 2.656 0 001.5 8.156v-.312a2.656 2.656 0 001.946-1.638c.021-.053.043-.106.066-.158a2.658 2.658 0 00-.219-2.534l.223-.222a2.7 2.7 0 001.47.44c.368 0 .725-.074 1.062-.22.052-.023.105-.045.158-.066A2.656 2.656 0 007.844 1.5h.312c.18.877.783 1.61 1.638 1.946l.159.066c.337.146.693.22 1.061.22a2.7 2.7 0 001.47-.44l.223.222a2.656 2.656 0 00-.219 2.533l.066.159A2.656 2.656 0 0014.5 7.844v.312zm.553-1.756c-.486 0-.926-.292-1.104-.743a4.723 4.723 0 00-.085-.207 1.18 1.18 0 01.254-1.305l.67-.67-2.263-2.263-.67.67a1.19 1.19 0 01-1.305.254 4.723 4.723 0 00-.207-.085A1.183 1.183 0 019.6.947V0H6.4v.947c0 .486-.292.926-.743 1.104-.07.027-.139.055-.207.085a1.19 1.19 0 01-1.305-.254l-.67-.67-2.263 2.263.67.67c.343.343.448.859.254 1.305-.03.068-.058.137-.085.207A1.183 1.183 0 01.947 6.4H0v3.2h.947c.486 0 .926.292 1.104.743.027.07.055.139.085.207a1.18 1.18 0 01-.254 1.305l-.67.67 2.263 2.263.67-.67a1.194 1.194 0 011.305-.255c.068.031.137.059.207.086.451.178.743.618.743 1.104V16h3.2v-.947c0-.486.292-.926.743-1.104.07-.027.139-.055.207-.086a1.178 1.178 0 011.305.255l.67.67 2.263-2.263-.67-.67a1.18 1.18 0 01-.254-1.305c.03-.068.058-.137.085-.207a1.183 1.183 0 011.104-.743H16V6.4h-.947z',
	size: 16,
};

export const SETTINGS_16 = SETTINGS_OUTLINE_16;
// 16x16/settings/filled.svg
export const SETTINGS_FILLED_16 = {
	d: 'M8 11a3 3 0 110-6 3 3 0 010 6zm7.053-4.6c-.486 0-.926-.292-1.104-.743a4.723 4.723 0 00-.085-.207 1.18 1.18 0 01.254-1.305l.67-.67-2.263-2.263-.67.67a1.18 1.18 0 01-1.305.254 6.407 6.407 0 00-.207-.086A1.18 1.18 0 019.6.947V0H6.4v.947c0 .486-.292.926-.743 1.103-.07.028-.139.056-.207.086a1.18 1.18 0 01-1.305-.254l-.67-.67-2.263 2.263.67.67c.343.343.448.859.254 1.305-.03.068-.058.137-.085.207A1.183 1.183 0 01.947 6.4H0v3.2h.947c.486 0 .926.292 1.104.743.027.07.055.138.085.207a1.18 1.18 0 01-.254 1.305l-.67.67 2.263 2.263.67-.67a1.182 1.182 0 011.305-.255c.068.031.137.059.207.086.451.178.743.618.743 1.104V16h3.2v-.947c0-.486.292-.926.743-1.104.07-.027.139-.055.207-.086a1.182 1.182 0 011.305.255l.67.67 2.263-2.263-.67-.67a1.18 1.18 0 01-.254-1.305c.03-.069.058-.137.085-.207a1.183 1.183 0 011.104-.743H16V6.4h-.947z',
	size: 16,
};

// 16x16/check squircle/outline.svg
export const CHECK_SQUIRCLE_OUTLINE_16 = {
	d: 'M11.73 5.316a1 1 0 01-.046 1.413l-4.03 3.775a.994.994 0 01-1.39-.022l-2-2a.999.999 0 111.414-1.414l1.316 1.315 3.322-3.113a1.002 1.002 0 011.413.046zm.925 5.933a1.836 1.836 0 01-1.405 1.405 15.428 15.428 0 01-6.5 0 1.836 1.836 0 01-1.405-1.405A15.42 15.42 0 013 8c0-1.097.116-2.19.345-3.25A1.838 1.838 0 014.75 3.345a15.43 15.43 0 016.5 0 1.838 1.838 0 011.405 1.406 15.413 15.413 0 010 6.498zm1.955-6.92a3.833 3.833 0 00-2.938-2.939A17.347 17.347 0 008 1c-1.26 0-2.49.134-3.672.39A3.832 3.832 0 001.39 4.328 17.35 17.35 0 001 8c0 1.26.134 2.488.39 3.671a3.83 3.83 0 002.938 2.938A17.35 17.35 0 008 15c1.258 0 2.488-.135 3.67-.39a3.832 3.832 0 002.939-2.939c.256-1.183.39-2.412.39-3.67 0-1.26-.134-2.49-.39-3.673z',
	size: 16,
};

export const CHECK_SQUIRCLE_16 = CHECK_SQUIRCLE_OUTLINE_16;
// 16x16/check squircle/filled.svg
export const CHECK_SQUIRCLE_FILLED_16 = {
	d: 'M11.684 6.73l-4.03 3.774a.994.994 0 01-1.39-.022l-2-2A.999.999 0 115.68 7.068l1.315 1.315 3.323-3.113a1 1 0 111.367 1.459zm2.926-2.402a3.833 3.833 0 00-2.938-2.938A17.35 17.35 0 008 1c-1.26 0-2.488.134-3.671.39A3.832 3.832 0 001.39 4.328 17.35 17.35 0 001 8c0 1.26.135 2.489.39 3.671a3.83 3.83 0 002.94 2.939c1.183.256 2.412.39 3.67.39 1.26 0 2.49-.134 3.673-.39a3.833 3.833 0 002.938-2.938C14.866 10.488 15 9.258 15 8c0-1.26-.134-2.489-.39-3.672z',
	size: 16,
};

// 16x16/close/outline.svg
export const CLOSE_OUTLINE_16 = {
	d: 'M9.414 8l3.293-3.293C12.901 4.513 13 4.254 13 4a.985.985 0 00-.293-.707.996.996 0 00-1.414 0L8 6.586 4.707 3.293a.997.997 0 00-1.414 0 .997.997 0 000 1.414L6.586 8l-3.293 3.293a.997.997 0 000 1.414.997.997 0 001.414 0L8 9.414l3.293 3.293a.997.997 0 001.414 0 1.003 1.003 0 000-1.414L9.414 8z',
	size: 16,
};

export const CLOSE_16 = CLOSE_OUTLINE_16;
// 16x16/flag cross/outline.svg
export const FLAG_CROSS_OUTLINE_16 = {
	d: 'M10.882 5.102l-1-1-1.5 1.5-1.5-1.5-1 1 1.5 1.5-1.5 1.5 1 1 1.5-1.5 1.5 1.5 1-1-1.5-1.5 1.5-1.5zM13 12.187V3.226C9.682 3.59 7.875 2 6 2c-1.332 0-2.283.172-3 .55v7.8c.782-.252 1.713-.35 3-.35 1.46 0 2.524.64 3.46 1.206 1.058.638 1.989 1.202 3.54.982zm1.61-10.98c.246.19.39.483.39.793v11a1 1 0 01-.741.966 7.4 7.4 0 01-1.925.27c-1.725 0-2.907-.713-3.907-1.318C7.576 12.406 6.904 12 6 12c-1.633 0-2.388.175-3 .534V15a1 1 0 11-2 0V1C2.643.073 5.045 0 6 0c.82 0 1.582.285 2.389.585 1.38.513 2.948 1.095 5.352.45a1 1 0 01.869.173z',
	size: 16,
};

export const FLAG_CROSS_16 = FLAG_CROSS_OUTLINE_16;
// 16x16/flag cross/filled.svg
export const FLAG_CROSS_FILLED_16 = {
	d: 'M10.882 5.102l-1-1-1.5 1.5-1.5-1.5-1 1 1.5 1.5-1.5 1.5 1 1 1.5-1.5 1.5 1.5 1-1-1.5-1.5 1.5-1.5zm3.728-3.895c.246.19.39.483.39.793v11a1 1 0 01-.741.966 7.4 7.4 0 01-1.925.27c-1.725 0-2.907-.713-3.907-1.318C7.576 12.406 6.904 12 6 12c-1.633 0-2.388.175-3 .534V15a1 1 0 11-2 0V1C2.643.073 5.045 0 6 0c.82 0 1.582.285 2.389.585 1.38.513 2.948 1.095 5.352.45a1 1 0 01.869.173z',
	size: 16,
};

// 16x16/bookmark/outline.svg
export const BOOKMARK_OUTLINE_16 = {
	d: 'M11 12.468L8.771 11.13a1.497 1.497 0 00-1.542 0L5 12.468V3h6v9.468zM11 1H5a2 2 0 00-2 2v13l5-3 5 3V3a2 2 0 00-2-2z',
	size: 16,
};

export const BOOKMARK_16 = BOOKMARK_OUTLINE_16;
// 16x16/bookmark/filled.svg
export const BOOKMARK_FILLED_16 = {
	d: 'M11 1H5a2 2 0 00-2 2v13l5-3 5 3V3a2 2 0 00-2-2z',
	size: 16,
};

// 16x16/link/outline.svg
export const LINK_OUTLINE_16 = {
	d: 'M5.252 10.709a.997.997 0 001.414 0l3.96-3.96a.999.999 0 10-1.414-1.414l-3.96 3.96a.999.999 0 000 1.414zm8.584-8.584c-1.5-1.5-4.115-1.5-5.614 0L6.243 4.104 7.656 5.52l1.98-1.981c.744-.744 2.042-.745 2.786 0 .372.372.577.866.577 1.393 0 .526-.205 1.021-.576 1.392l-1.98 1.98 1.413 1.416 1.98-1.981A3.944 3.944 0 0015 4.932a3.94 3.94 0 00-1.163-2.807zm-5.493 8.279l1.412 1.416-1.978 1.979a3.945 3.945 0 01-2.808 1.163 3.944 3.944 0 01-2.807-1.163A3.94 3.94 0 011 10.992c0-1.06.412-2.057 1.162-2.807l1.981-1.981L5.555 7.62 3.576 9.6A1.953 1.953 0 003 10.992c0 .527.204 1.021.576 1.393.744.744 2.042.744 2.786 0l1.981-1.981z',
	size: 16,
};

export const LINK_16 = LINK_OUTLINE_16;
// 16x16/info squircle large/outline.svg
export const INFO_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M7 4v2h2V4H7zm0 3v5h2V7H7zm1-5c5.103 0 6 .897 6 6s-.897 6-6 6-6-.897-6-6 .897-6 6-6zm0 14c6.229 0 8-1.771 8-8s-1.771-8-8-8-8 1.771-8 8 1.771 8 8 8z',
	size: 16,
};

export const INFO_SQUIRCLE_LARGE_16 = INFO_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/info squircle large/filled.svg
export const INFO_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M8 0c6.229 0 8 1.771 8 8s-1.771 8-8 8-8-1.771-8-8 1.771-8 8-8zm1 7H7v5h2V7zm0-3H7v2h2V4z',
	size: 16,
};

// 16x16/share/filled.svg
export const SHARE_FILLED_16 = {
	d: 'M16 7l-6-5v3.143c-2.044-.055-4.15.571-5.795 1.81-.996.737-1.821 1.683-2.364 2.733A7.237 7.237 0 001 12.966a10.08 10.08 0 012.137-2.222 8.034 8.034 0 012.455-1.242c1.469-.44 2.93-.443 4.408-.336V12l6-5z',
	size: 16,
};

// 16x16/file powerpoint/outline.svg
export const FILE_POWERPOINT_OUTLINE_16 = {
	d: 'M8 0c1.439 0 2.844.154 4.196.446a4.383 4.383 0 013.358 3.358A19.86 19.86 0 0116 8c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.867 19.867 0 018 16a19.86 19.86 0 01-4.196-.446 4.381 4.381 0 01-3.358-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.38 4.38 0 013.804.446 19.86 19.86 0 018 0zm0 2a17.9 17.9 0 00-3.773.401 2.387 2.387 0 00-1.826 1.825 17.902 17.902 0 000 7.547 2.388 2.388 0 001.825 1.826 17.916 17.916 0 007.547 0 2.388 2.388 0 001.826-1.826 17.9 17.9 0 000-7.546 2.388 2.388 0 00-1.826-1.826C10.543 2.135 9.273 2 8 2zm-.703 3.867h1.305c.703 0 .955.422.955 1.026 0 .63-.271 1.08-.955 1.08H7.297V5.867zm3.592.99c0-1.099-.675-2.007-1.963-2.007H6v6.3h1.297V8.91h1.557c1.386 0 2.035-.928 2.035-2.053z',
	size: 16,
};

export const FILE_POWERPOINT_16 = FILE_POWERPOINT_OUTLINE_16;
// 16x16/file powerpoint/filled.svg
export const FILE_POWERPOINT_FILLED_16 = {
	d: 'M8.947 9.117h-1.91v2.75H5.443V4.134h3.591c1.581 0 2.41 1.116 2.41 2.464 0 1.38-.797 2.52-2.498 2.52zm6.606-5.313A4.377 4.377 0 0012.196.447a19.874 19.874 0 00-8.393 0A4.376 4.376 0 00.446 3.803 19.883 19.883 0 000 8c0 1.44.154 2.844.446 4.197a4.379 4.379 0 003.357 3.357A19.87 19.87 0 008 16c1.44 0 2.843-.154 4.196-.446a4.379 4.379 0 003.357-3.357 19.87 19.87 0 000-8.393zM8.637 5.382h-1.6v2.585h1.6c.84 0 1.172-.553 1.172-1.325 0-.741-.309-1.26-1.172-1.26z',
	size: 16,
};

// 16x16/warning squircle/outline.svg
export const WARNING_SQUIRCLE_OUTLINE_16 = {
	d: 'M13.5 8c0-2.313-.218-3.688-1.015-4.484C11.688 2.719 10.313 2.5 8 2.5s-3.688.219-4.485 1.016C2.718 4.312 2.5 5.687 2.5 8s.218 3.688 1.015 4.484C4.312 13.281 5.687 13.5 8 13.5s3.688-.219 4.485-1.016C13.282 11.688 13.5 10.313 13.5 8zM15 8c0 2.725-.388 4.475-1.456 5.544C12.475 14.612 10.725 15 8 15c-2.725 0-4.475-.388-5.544-1.456C1.388 12.475 1 10.725 1 8c0-2.725.388-4.475 1.456-5.544C3.525 1.388 5.275 1 8 1c2.725 0 4.475.388 5.544 1.456C14.612 3.525 15 5.275 15 8zm-8 4h2v-2H7v2zm0-3h2V4H7v5z',
	size: 16,
};

export const WARNING_SQUIRCLE_16 = WARNING_SQUIRCLE_OUTLINE_16;
// 16x16/warning squircle/filled.svg
export const WARNING_SQUIRCLE_FILLED_16 = {
	d: 'M7 9h2V4H7v5zm0 3h2v-2H7v2zM8 1c-2.725 0-4.475.388-5.544 1.456C1.388 3.525 1 5.275 1 8c0 2.725.388 4.475 1.456 5.544C3.525 14.612 5.275 15 8 15c2.725 0 4.475-.388 5.544-1.456C14.612 12.475 15 10.725 15 8c0-2.725-.388-4.475-1.456-5.544C12.475 1.388 10.725 1 8 1z',
	size: 16,
};

// 16x16/folder add/outline.svg
export const FOLDER_ADD_OUTLINE_16 = {
	d: 'M15 6H1c-.577 0-1 .428-1 1 0 1.151.115 2.17.292 3.074a3.977 3.977 0 011.837-.971A10.402 10.402 0 012.067 8h11.866c0 2.607-.873 3.957-1.212 4.438-.645.229-2.519.562-4.721.562-.345 0-.677-.011-1.002-.025 0 .008.003.017.003.026 0 .71-.2 1.367-.525 1.945.5.032 1.009.054 1.524.054 2.758 0 5.515-.501 6.017-1.001C14.931 13.088 16 10.628 16 7c0-.574-.423-1-1-1zm0-2a1 1 0 00-1-1H7l-.447-.896C6.214 1.428 5.757 1 5 1H2a1 1 0 00-1 1v3h14V4zm-8.999 9.001a1 1 0 01-1 1h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 112 0v1h1a1 1 0 011 1z',
	size: 16,
};

export const FOLDER_ADD_16 = FOLDER_ADD_OUTLINE_16;
// 16x16/folder add/filled.svg
export const FOLDER_ADD_FILLED_16 = {
	d: 'M5.001 12.001h-1v-1a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 002 0v-1h1a1 1 0 100-2zM15 6H1c-.577 0-1 .432-1 1 0 1.151.115 2.17.292 3.074a3.97 3.97 0 012.709-1.073 4 4 0 014 4c0 .71-.2 1.367-.525 1.945.5.032 1.009.054 1.524.054 2.758 0 5.515-.501 6.017-1.001C14.931 13.088 16 10.633 16 7c0-.573-.423-1-1-1zm0-1H1V2a1 1 0 011-1h3c.757 0 1.214.428 1.553 1.105L7 3h7a1 1 0 011 1v1z',
	size: 16,
};

// 16x16/__library/outline.svg
export const __LIBRARY_OUTLINE_16 = {
	d: 'M5 10h2V5H5v5zm1.61-7h2.78L8 2.166 6.61 3zM9 10h2V5H9v5zm-7.658 1.66L3 10V5a1 1 0 01-.515-1.857l5-3a.997.997 0 011.03 0l5 3A1 1 0 0113 5v5l1.658 1.66a.2.2 0 01-.14.34H1.482a.2.2 0 01-.14-.34zM15 13.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5z',
	size: 16,
};

export const __LIBRARY_16 = __LIBRARY_OUTLINE_16;
// 16x16/time/outline.svg
export const TIME_OUTLINE_16 = {
	d: 'M9.708 10.293a.999.999 0 11-1.414 1.414l-2-2a.997.997 0 01-.263-.949l1-4a1 1 0 011.94.484l-.863 3.451 1.6 1.6zm2.947.956a1.836 1.836 0 01-1.405 1.405C10.189 12.884 9.096 13 8 13c-1.095 0-2.188-.116-3.25-.346a1.836 1.836 0 01-1.404-1.405 15.413 15.413 0 010-6.499A1.837 1.837 0 014.75 3.346 15.362 15.362 0 018 3c1.097 0 2.19.116 3.25.346a1.836 1.836 0 011.405 1.405 15.42 15.42 0 010 6.498zm1.955-6.921a3.832 3.832 0 00-2.938-2.937A17.35 17.35 0 008 1c-1.26 0-2.488.135-3.671.391A3.828 3.828 0 001.39 4.328 17.357 17.357 0 001 8c0 1.26.135 2.488.39 3.672a3.83 3.83 0 002.938 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.489-.135 3.672-.391a3.832 3.832 0 002.938-2.937C14.866 10.488 15 9.26 15 8c0-1.26-.134-2.488-.39-3.672z',
	size: 16,
};

export const TIME_16 = TIME_OUTLINE_16;
// 16x16/time/filled.svg
export const TIME_FILLED_16 = {
	d: 'M9.708 11.707a.997.997 0 01-1.414 0l-2-2a.997.997 0 01-.263-.949l1-4a1 1 0 111.94.484l-.863 3.451 1.6 1.6a.999.999 0 010 1.414zm4.902-7.379a3.832 3.832 0 00-2.938-2.937A17.35 17.35 0 008 1c-1.26 0-2.488.135-3.671.391A3.828 3.828 0 001.39 4.328 17.357 17.357 0 001 8c0 1.26.135 2.488.39 3.672a3.83 3.83 0 002.938 2.937C5.512 14.865 6.74 15 8 15c1.26 0 2.489-.135 3.672-.391a3.832 3.832 0 002.938-2.937C14.866 10.488 15 9.26 15 8c0-1.26-.134-2.488-.39-3.672z',
	size: 16,
};

// 16x16/block/outline.svg
export const BLOCK_OUTLINE_16 = {
	d: 'M8 13a4.964 4.964 0 01-2.753-.833l6.92-6.92C12.691 6.037 13 6.982 13 8c0 2.757-2.243 5-5 5zM3 8c0-2.757 2.243-5 5-5 1.018 0 1.963.309 2.753.833l-6.92 6.92A4.964 4.964 0 013 8zm5-7a7 7 0 100 14A7 7 0 008 1z',
	size: 16,
};

export const BLOCK_16 = BLOCK_OUTLINE_16;
// 16x16/check rosette/outline.svg
export const CHECK_ROSETTE_OUTLINE_16 = {
	d: 'M7 10.75a.75.75 0 01-.53-.22l-2-2a.75.75 0 111.06-1.06L7 8.94l3.47-3.47a.75.75 0 111.06 1.06l-4 4a.748.748 0 01-.53.22zm-.633 2.28l-1.929.48v-1.174a.777.777 0 00-.529-.736l-1.433-.477.48-1.433a.774.774 0 00-.189-.792L1.87 8l.898-.899a.774.774 0 00.188-.792l-.479-1.432L3.91 4.4a.775.775 0 00.53-.735V2.49l1.928.481a.776.776 0 00.734-.203l.9-.898.897.898a.778.778 0 00.735.203l1.928-.48v1.174c0 .334.213.63.53.735l1.432.478-.478 1.432a.773.773 0 00.187.792l.9.9-.9.897a.774.774 0 00-.187.792l.478 1.433-1.432.477a.776.776 0 00-.53.736v1.174l-1.928-.48a.778.778 0 00-.735.202l-.898.9-.899-.9a.774.774 0 00-.734-.203zm2.181 2.743l1.135-1.136 2.465.617a.772.772 0 00.962-.751v-1.61l1.638-.546a.775.775 0 00.49-.979l-.572-1.714 1.107-1.106a.776.776 0 000-1.096l-1.107-1.107.572-1.713a.776.776 0 00-.49-.98l-1.638-.546V1.497a.775.775 0 00-.962-.75l-2.465.615L8.548.226a.778.778 0 00-1.096 0L6.316 1.362 3.851.746a.777.777 0 00-.664.14.778.778 0 00-.298.611v1.61l-1.637.545a.777.777 0 00-.49.98l.572 1.713L.226 7.452a.778.778 0 000 1.096l1.108 1.106-.573 1.714a.775.775 0 00.491.98l1.637.545v1.61a.775.775 0 00.962.751l2.465-.617 1.136 1.136a.771.771 0 001.096 0z',
	size: 16,
};

export const CHECK_ROSETTE_16 = CHECK_ROSETTE_OUTLINE_16;
// 16x16/check rosette/filled.svg
export const CHECK_ROSETTE_FILLED_16 = {
	d: 'M11.707 5.293a.999.999 0 00-1.414 0L7 8.586 5.707 7.293a.999.999 0 10-1.414 1.414l2 2a.997.997 0 001.414 0l4-4a.999.999 0 000-1.414zm4 3.414l-.963.964.504 1.513a.999.999 0 01-.632 1.264l-1.416.473V14.3a.998.998 0 01-.385.788.988.988 0 01-.857.182l-2.251-.563-1 1a.997.997 0 01-1.414 0l-1-1-2.251.563A.998.998 0 012.8 14.3v-1.379l-1.416-.473a.999.999 0 01-.632-1.264l.504-1.513-.963-.964a.999.999 0 010-1.414l.963-.964-.504-1.513a.999.999 0 01.632-1.264L2.8 3.079V1.7A.998.998 0 014.042.73l2.251.563 1-1a.999.999 0 011.414 0l1 1L11.958.73a.998.998 0 011.242.97v1.379l1.416.473c.524.175.807.74.632 1.264l-.504 1.513.963.964a.999.999 0 010 1.414z',
	size: 16,
};

// 16x16/device monitor/outline.svg
export const DEVICE_MONITOR_OUTLINE_16 = {
	d: 'M14 8.457a.995.995 0 01-.769.973C12.048 9.689 10.179 10 8 10s-4.048-.311-5.231-.57A.995.995 0 012 8.457V4.543c0-.466.323-.875.769-.973A24.857 24.857 0 018 3c2.179 0 4.048.311 5.231.57a.995.995 0 01.769.973v3.914zm-.339-6.84A26.858 26.858 0 008 1c-2.358 0-4.38.336-5.661.617A3.006 3.006 0 000 4.543v3.914c0 1.397.983 2.628 2.339 2.926.691.151 1.602.317 2.661.439V13H4a1 1 0 100 2h8a1 1 0 100-2h-1v-1.178a27.136 27.136 0 002.661-.439A3.007 3.007 0 0016 8.457V4.543a3.006 3.006 0 00-2.339-2.926z',
	size: 16,
};

export const DEVICE_MONITOR_16 = DEVICE_MONITOR_OUTLINE_16;
// 16x16/help squircle large/outline.svg
export const HELP_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M8 0c3.114 0 5.114.443 6.336 1.664C15.557 2.886 16 4.886 16 8c0 3.114-.443 5.114-1.664 6.336C13.114 15.556 11.114 16 8 16c-3.115 0-5.115-.443-6.336-1.664C.442 13.114 0 11.114 0 8c0-3.114.442-5.114 1.664-6.336C2.885.443 4.885 0 8 0zm0 2c-2.622 0-4.186.343-4.922 1.078C2.342 3.815 2 5.378 2 8s.342 4.186 1.078 4.922C3.814 13.657 5.378 14 8 14s4.185-.343 4.921-1.078c.736-.736 1.08-2.3 1.08-4.922s-.344-4.185-1.08-4.922C12.185 2.343 10.622 2 8.001 2zm1 9v1H7v-1h2zM8 4c1.654 0 3 1.346 3 3s-1.346 3-3 3H7V8h1a1.001 1.001 0 000-2c-.356 0-.688.192-.867.501a1 1 0 11-1.731-1.002A3.012 3.012 0 018 4z',
	size: 16,
};

export const HELP_SQUIRCLE_LARGE_16 = HELP_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/help squircle large/filled.svg
export const HELP_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M8 0c3.114 0 5.114.443 6.336 1.664C15.557 2.886 16 4.886 16 8c0 3.114-.443 5.114-1.664 6.336C13.114 15.557 11.114 16 8 16c-3.114 0-5.114-.443-6.335-1.664C.443 13.114 0 11.114 0 8c0-3.114.443-5.114 1.665-6.336C2.886.443 4.886 0 8 0zm1 11H7v1h2v-1zM8 4a3.012 3.012 0 00-2.598 1.499 1 1 0 001.667 1.1l.064-.098A1.001 1.001 0 118 8H7v2h1c1.654 0 3-1.346 3-3S9.654 4 8 4z',
	size: 16,
};

// 16x16/check circle/outline.svg
export const CHECK_CIRCLE_OUTLINE_16 = {
	d: 'M7.25 10.5a.997.997 0 01-.707-.293l-1.5-1.5a.999.999 0 111.414-1.414l.793.793 2.33-2.329a.999.999 0 111.413 1.414l-3.036 3.036a.997.997 0 01-.707.293zM8 14c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM8 0a8 8 0 110 16A8 8 0 018 0z',
	size: 16,
};

export const CHECK_CIRCLE_16 = CHECK_CIRCLE_OUTLINE_16;
// 16x16/check circle/filled.svg
export const CHECK_CIRCLE_FILLED_16 = {
	d: 'M10.993 5.757a.999.999 0 00-1.414 0L7.25 8.086l-.793-.793a.999.999 0 10-1.414 1.414l1.5 1.5a.997.997 0 001.414 0l3.036-3.036a.999.999 0 000-1.414zM8 0a8 8 0 110 16A8 8 0 018 0z',
	size: 16,
};

// 16x16/notifications off/outline.svg
export const NOTIFICATIONS_OFF_OUTLINE_16 = {
	d: 'M8 13h2c0 1.1-.9 2-2 2s-2-.9-2-2h2zm6.7 1.7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-3-3c-.7.2-1.5.3-2.3.3-2.9 0-5-1.1-6-2 1.5-1.5 1.9-2.7 2-4.6L1.3 2.7C1.1 2.5 1 2.3 1 2c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0l12 12c.2.2.3.5.3.7 0 .3-.1.5-.3.7zM8.5 10L5.8 7.2c-.2.8-.4 1.5-.8 2.2.7.3 1.8.6 3 .6h.5zM8 3c1.1 0 2 .9 2 2 0 .6.1 1.2.1 1.7l3.5 3.5c.2 0 .3-.1.4-.2-1.6-1.6-2-2.8-2-5s-1.8-4-4-4c-1 0-1.9.4-2.6 1l1.4 1.4c.4-.2.8-.4 1.2-.4z',
	size: 16,
};

export const NOTIFICATIONS_OFF_16 = NOTIFICATIONS_OFF_OUTLINE_16;
// 16x16/notifications off/filled.svg
export const NOTIFICATIONS_OFF_FILLED_16 = {
	d: 'M13.7 10.3L5.4 2C6.1 1.4 7 1 8 1c2.2 0 4 1.8 4 4s.4 3.4 2 5l-.3.3zM6 13c0 1.1.9 2 2 2s2-.9 2-2H6zm8.7.3l-12-12c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7 0 .3.1.5.3.7L4 5.4c-.1 1.9-.5 3.1-2 4.6 1 .9 3.1 2 6 2 .8 0 1.6-.1 2.3-.3l3 3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.2-.2.3-.5.3-.7 0-.3-.1-.5-.3-.7z',
	size: 16,
};

// 16x16/bookmark add alt1/filled.svg
export const BOOKMARK_ADD_ALT1_FILLED_16 = {
	d: 'M10.163 10.33L8 9.19l-2.163 1.14.413-2.41L4.5 6.214l2.418-.35L8 3.67l1.082 2.192 2.418.351L9.75 7.92l.413 2.41zM11 1H5a2 2 0 00-2 2v13l5-3 5 3V3a2 2 0 00-2-2z',
	size: 16,
};

// 16x16/check circle mini/outline.svg
export const CHECK_CIRCLE_MINI_OUTLINE_16 = {
	d: 'M7.25 10.5a.997.997 0 01-.707-.293l-1.5-1.5a.999.999 0 111.414-1.414l.793.793 2.33-2.329a.999.999 0 111.413 1.414l-3.036 3.036a.997.997 0 01-.707.293zM15 8A7 7 0 111 8a7 7 0 0114 0zM2.5 8c0 3.033 2.468 5.5 5.5 5.5s5.5-2.467 5.5-5.5S11.032 2.5 8 2.5A5.506 5.506 0 002.5 8z',
	size: 16,
};

export const CHECK_CIRCLE_MINI_16 = CHECK_CIRCLE_MINI_OUTLINE_16;
// 16x16/check circle mini/filled.svg
export const CHECK_CIRCLE_MINI_FILLED_16 = {
	d: 'M10.993 5.757a.999.999 0 00-1.414 0L7.25 8.086l-.793-.793a.999.999 0 10-1.414 1.414l1.5 1.5a.997.997 0 001.414 0l3.036-3.036a.999.999 0 000-1.414zM15 8A7 7 0 111 8a7 7 0 0114 0z',
	size: 16,
};

// 16x16/minimize alt1/outline.svg
export const MINIMIZE_ALT1_OUTLINE_16 = {
	d: 'M2.793 11.793l-2.5 2.5a.999.999 0 101.414 1.414l2.5-2.5L6 15v-5H1l1.793 1.793zM15.707.293a.999.999 0 00-1.414 0l-2.5 2.5L10 1v5h5l-1.793-1.793 2.5-2.5a.999.999 0 000-1.414zM3 6v2h2V6a1 1 0 011-1h2V3H6C4.346 3 3 4.346 3 6zm8 2h2v2c0 1.654-1.346 3-3 3H8v-2h2a1 1 0 001-1V8z',
	size: 16,
};

export const MINIMIZE_ALT1_16 = MINIMIZE_ALT1_OUTLINE_16;
// 16x16/videocam/outline.svg
export const VIDEOCAM_OUTLINE_16 = {
	d: 'M15.2 3.5L13 5V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1l2.2 1.5c.3.2.8 0 .8-.4V3.9c0-.4-.4-.6-.8-.4zM11 12H3V4h8v8z',
	size: 16,
};

export const VIDEOCAM_16 = VIDEOCAM_OUTLINE_16;
// 16x16/videocam/filled.svg
export const VIDEOCAM_FILLED_16 = {
	d: 'M15.2 3.5L13 5V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1l2.2 1.5c.3.2.8 0 .8-.4V3.9c0-.4-.4-.6-.8-.4z',
	size: 16,
};

// 16x16/file archive/outline.svg
export const FILE_ARCHIVE_OUTLINE_16 = {
	d: 'M3 13h10V6H9v2h2l-3 4-3-4h2V6H3v7zM7 3H4.236l-1 2H7V3zm5.764 2l-1-2H9v2h3.764zm2.025-.422c.139.277.211.584.211.894V13a2 2 0 01-2 2H3a2 2 0 01-2-2V5.472c0-.31.072-.617.211-.894l1.236-2.473A2.002 2.002 0 014.236 1h7.528c.757 0 1.45.428 1.789 1.105l1.236 2.473z',
	size: 16,
};

export const FILE_ARCHIVE_16 = FILE_ARCHIVE_OUTLINE_16;
// 16x16/file archive/filled.svg
export const FILE_ARCHIVE_FILLED_16 = {
	d: 'M13.553 2.105L15 5H9V3H7v2H1l1.448-2.895A1.998 1.998 0 014.237 1h7.527c.758 0 1.45.427 1.789 1.105zM9 6v2h3l-4 5-4-5h3V6H1v7a2 2 0 002 2h10a2 2 0 002-2V6H9z',
	size: 16,
};

// 16x16/locked/outline.svg
export const LOCKED_OUTLINE_16 = {
	d: 'M9 9v3H7V9a1 1 0 112 0zm-1 4c-1.871 0-3.225-.241-4-.437l.008-5.042C5.013 7.283 6.521 7 8 7s2.987.283 4 .523l.03 5.033C11.225 12.759 9.871 13 8 13zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1.139A16.292 16.292 0 008 5c-.681 0-1.354.059-2 .139V4zm6.453 1.575c-.137-.032-.303-.064-.453-.097V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1.478c-.15.033-.315.065-.453.097A2.004 2.004 0 002 7.523v5.04c0 .906.604 1.711 1.482 1.932 1 .252 2.506.505 4.518.505s3.518-.253 4.518-.505c.878-.221 1.482-1.026 1.482-1.932v-5.04c0-.93-.641-1.733-1.547-1.948z',
	size: 16,
};

export const LOCKED_16 = LOCKED_OUTLINE_16;
// 16x16/locked/filled.svg
export const LOCKED_FILLED_16 = {
	d: 'M10 5.139a16.292 16.292 0 00-2-.14c-.681 0-1.354.06-2 .14v-1.14c0-1.101.897-2 2-2s2 .899 2 2v1.14zm-1 6.86H7V9a1 1 0 112 0v3zm3.453-6.423c-.137-.033-.303-.065-.453-.098V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1.478c-.15.033-.315.065-.453.098A2.002 2.002 0 002 7.524v5.04c0 .905.604 1.71 1.482 1.93 1 .253 2.506.506 4.518.506s3.518-.253 4.518-.505c.878-.22 1.482-1.026 1.482-1.931v-5.04c0-.931-.641-1.734-1.547-1.948z',
	size: 16,
};

// 16x16/print/outline.svg
export const PRINT_OUTLINE_16 = {
	d: 'M14 11h-2V9.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V11H2V8h12v3zm-4 2H6v-2h4v2zM5 6h6V3H5v3zm9 0h-1V2a1 1 0 00-1-1H4a1 1 0 00-1 1v4H2C.897 6 0 6.897 0 8v3c0 1.103.897 2 2 2h2v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V13h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z',
	size: 16,
};

export const PRINT_16 = PRINT_OUTLINE_16;
// 16x16/print/filled.svg
export const PRINT_FILLED_16 = {
	d: 'M10 13H6v-2h4v2zM5 6h6V3H5v3zm9 0h-1V2a1 1 0 00-1-1H4a1 1 0 00-1 1v4H2C.897 6 0 6.897 0 8v3c0 1.103.897 2 2 2h2v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V13h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z',
	size: 16,
};

// 16x16/user/outline.svg
export const USER_OUTLINE_16 = {
	d: 'M8 9c-2.761 0-7 .651-7 2 0 2 3 5 7 5s7-3 7-5c0-1.349-4.344-2-7-2zm0 2c1.916 0 3.766.319 4.74.63C12.133 12.565 10.48 14 8 14c-2.488 0-4.145-1.444-4.747-2.38C4.214 11.312 6.043 11 8 11zM8 0C6.259 0 5 1.619 5 3c0 3.36 1 5 3 5s3-1.64 3-5c0-1.381-1.259-3-3-3zm0 2c.567 0 1 .666 1 1 0 1.368-.174 3-1 3-.826 0-1-1.632-1-3 0-.334.433-1 1-1z',
	size: 16,
};

export const USER_16 = USER_OUTLINE_16;
// 16x16/user/filled.svg
export const USER_FILLED_16 = {
	d: 'M8 9c-2.761 0-7 .651-7 2 0 2 3 5 7 5s7-3 7-5c0-1.349-4.344-2-7-2zM5 3c0-1.381 1.259-3 3-3s3 1.619 3 3c0 3.36-1 5-3 5S5 6.36 5 3z',
	size: 16,
};

// 16x16/info/outline.svg
export const INFO_OUTLINE_16 = {
	d: 'M7 6h2V4H7v2zm0 6h2V7H7v5z',
	size: 16,
};

export const INFO_16 = INFO_OUTLINE_16;
// 16x16/checker normal/outline.svg
export const CHECKER_NORMAL_OUTLINE_16 = {
	d: 'M6.293 11.207a.997.997 0 001.414 0l4-4a.999.999 0 10-1.414-1.414L7 9.086 5.707 7.793a.999.999 0 10-1.414 1.414l2 2z',
	size: 16,
};

export const CHECKER_NORMAL_16 = CHECKER_NORMAL_OUTLINE_16;
// 16x16/calendar plus/filled.svg
export const CALENDAR_PLUS_FILLED_16 = {
	d: 'M12 9a1 1 0 00-1-1H9V6a1 1 0 10-2 0v2H5a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 001-1zm4-1a19.447 19.447 0 00-.45-4.2A4.36 4.36 0 0012.2.41H12V1a1 1 0 11-2 0V.1C9.34 0 8.68 0 8 0c-.68 0-1.34 0-2 .1V1a1 1 0 11-2 0V.45h-.2A4.36 4.36 0 00.45 3.8 19.448 19.448 0 000 8c-.003 1.412.148 2.82.45 4.2a4.36 4.36 0 003.35 3.35c1.38.302 2.788.453 4.2.45 1.412.003 2.82-.148 4.2-.45a4.36 4.36 0 003.35-3.35c.302-1.38.453-2.788.45-4.2zm-2 0a18.282 18.282 0 01-.4 3.77 2.38 2.38 0 01-1.83 1.83A18.24 18.24 0 018 14a18.282 18.282 0 01-3.77-.4 2.38 2.38 0 01-1.81-1.83 18 18 0 010-7.54A2.18 2.18 0 012.51 4h11c.034.075.065.152.09.23A18.24 18.24 0 0114 8z',
	size: 16,
};

// 16x16/maximize/outline.svg
export const MAXIMIZE_OUTLINE_16 = {
	d: 'M13 11h2v1c0 1.654-1.346 3-3 3h-1v-2h1c.551 0 1-.448 1-1v-1zm0-2h2V7h-2v2zm2-5v1h-2V4c0-.552-.449-1-1-1h-1V1h1c1.654 0 3 1.346 3 3zM7 3h2V1H7v2zM3 5H1V4c0-1.654 1.346-3 3-3h1v2H4c-.551 0-1 .448-1 1v1zm0 8h5V8H3v5zm5-7H3a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V8a2 2 0 00-2-2z',
	size: 16,
};

export const MAXIMIZE_16 = MAXIMIZE_OUTLINE_16;
// 16x16/crown/filled.svg
export const CROWN_FILLED_16 = {
	d: 'M13.19 13.5a1.998 1.998 0 001.989-1.801L16 3.5l-3 2s1 1 1 2-.609 2-2 2c-1.392 0-2-1-2-2s1-2 1-2l-3-3-3 3s1 1 1 2-.609 2-2 2c-1.392 0-2-1-2-2s1-2 1-2l-3-2 .819 8.199A2 2 0 002.81 13.5h10.38z',
	size: 16,
};

// 16x16/add squircle large/outline.svg
export const ADD_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M11 9H9v2a1 1 0 11-2 0V9H5a1 1 0 110-2h2V5a1 1 0 112 0v2h2a1 1 0 110 2zM12.196.446a4.383 4.383 0 013.358 3.358A19.86 19.86 0 0116 8c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.86 19.86 0 018 16c-1.44 0-2.844-.154-4.197-.446a4.381 4.381 0 01-3.357-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.381 4.381 0 013.804.446 19.86 19.86 0 018 0c1.44 0 2.844.154 4.196.446zm-7.97 1.955a2.385 2.385 0 00-1.825 1.825 17.91 17.91 0 000 7.547 2.387 2.387 0 001.825 1.826 17.916 17.916 0 007.548 0 2.387 2.387 0 001.825-1.826 17.9 17.9 0 000-7.547 2.387 2.387 0 00-1.825-1.825 17.91 17.91 0 00-7.548 0z',
	size: 16,
};

export const ADD_SQUIRCLE_LARGE_16 = ADD_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/add squircle large/filled.svg
export const ADD_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M12 8a1 1 0 00-1-1H9V5a1 1 0 10-2 0v2H5a1 1 0 100 2h2v2a1 1 0 102 0V9h2a1 1 0 001-1zm4 0c0 1.44-.154 2.844-.446 4.196a4.383 4.383 0 01-3.358 3.358A19.86 19.86 0 018 16a19.86 19.86 0 01-4.196-.446 4.381 4.381 0 01-3.358-3.358A19.867 19.867 0 010 8c0-1.44.154-2.844.446-4.197A4.381 4.381 0 013.804.446 19.86 19.86 0 018 0c1.44 0 2.844.154 4.196.446a4.383 4.383 0 013.358 3.358A19.86 19.86 0 0116 8z',
	size: 16,
};

// 16x16/folder open/outline.svg
export const FOLDER_OPEN_OUTLINE_16 = {
	d: 'M11.36 12.232C10.93 12.59 10.046 13 7 13c-2.14 0-3.425-.212-4.454-.517l2.692-4.038A.996.996 0 016.07 8H14c-.03.665-1.544 3.318-2.64 4.232zM14 6H6.07a2.992 2.992 0 00-2.496 1.336L2 9.697V3h1.763c.382 0 .725.211.895.552l.447.895A1 1 0 006 5h6a.36.36 0 01.101.01l-.02-.01h1.92c0-1.197-.805-2-2-2H6.617l-.17-.342A2.984 2.984 0 003.762 1H1a1 1 0 00-1 1v11a1 1 0 00.634.93C2.358 14.608 3.952 15 7 15c2.957 0 4.591-.358 5.64-1.232C13.997 12.636 16 9.404 16 8c0-1.234-.767-2-2-2z',
	size: 16,
};

export const FOLDER_OPEN_16 = FOLDER_OPEN_OUTLINE_16;
// 16x16/folder open/filled.svg
export const FOLDER_OPEN_FILLED_16 = {
	d: 'M12.64 13.769C13.998 12.637 16 9.405 16 7.999c0-1.232-.766-2-2-2H6c-1.005 0-1.868.5-2.425 1.337L.884 11.372a1.979 1.979 0 00-.216 1.788 2.028 2.028 0 001.328 1.246C3.406 14.823 4.904 15 7 15c2.957 0 4.592-.357 5.64-1.231zM3.11 6.336L0 11V2a1 1 0 011-1h2.765a3 3 0 012.683 1.659l.17.34H12c1.197 0 2 .805 2 2H5.606A3 3 0 003.11 6.336z',
	size: 16,
};

// 16x16/check squircle large/outline.svg
export const CHECK_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M8 2a17.627 17.627 0 00-3.77.4A2.38 2.38 0 002.4 4.23a18 18 0 000 7.54 2.38 2.38 0 001.83 1.83A18.24 18.24 0 008 14a18.282 18.282 0 003.77-.4 2.38 2.38 0 001.83-1.83A18.24 18.24 0 0014 8a18.282 18.282 0 00-.4-3.77 2.38 2.38 0 00-1.83-1.83A18.288 18.288 0 008 2zm0-2c1.412-.003 2.82.148 4.2.45a4.36 4.36 0 013.35 3.35c.302 1.38.453 2.788.45 4.2a19.447 19.447 0 01-.45 4.2 4.36 4.36 0 01-3.35 3.35c-1.38.302-2.788.453-4.2.45a19.447 19.447 0 01-4.2-.45A4.36 4.36 0 01.45 12.2 19.448 19.448 0 010 8c-.003-1.412.148-2.82.45-4.2A4.36 4.36 0 013.8.45 19.448 19.448 0 018 0zm3.71 6.71a1.004 1.004 0 00-1.42-1.42L7 8.59l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l2 2a1 1 0 001.42 0l4-4z',
	size: 16,
};

export const CHECK_SQUIRCLE_LARGE_16 = CHECK_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/check squircle large/filled.svg
export const CHECK_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M15.55 3.8c.302 1.38.453 2.788.45 4.2a19.447 19.447 0 01-.45 4.2 4.36 4.36 0 01-3.35 3.35c-1.38.302-2.788.453-4.2.45a19.447 19.447 0 01-4.2-.45A4.36 4.36 0 01.45 12.2 19.446 19.446 0 010 8c-.003-1.412.148-2.82.45-4.2A4.36 4.36 0 013.8.45 19.446 19.446 0 018 0c1.412-.003 2.82.148 4.2.45a4.36 4.36 0 013.35 3.35zm-3.84 2.91a1.004 1.004 0 00-1.42-1.42L7 8.59l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l2 2a1 1 0 001.42 0l4-4z',
	size: 16,
};

// 16x16/read later/outline.svg
export const READ_LATER_OUTLINE_16 = {
	d: 'M16 2.384v10a1.002 1.002 0 01-1.43.903c-1.231-.586-2.461-.465-3.569-.286v-2c.916-.122 1.931-.25 2.999 0V3c-2.288-.504-4.267.797-5 2v1L7 5c-.732-1.203-2.711-2.504-5-2v2L0 7V2.384c0-.431.275-.812.684-.948C1.473 1.172 2.247 1 3 1c2 0 3.576.577 5 2 1.426-1.424 3-2 5-2 .752 0 1.527.172 2.316.436a.998.998 0 01.684.948zM7.717 13.358a.802.802 0 01-1.073.358l-2-1A.8.8 0 014.201 12L4.2 8a.8.8 0 011.6 0l.001 3.506 1.557.778a.802.802 0 01.359 1.074zM5 6a5 5 0 00-5 5 5 5 0 005 5 5 5 0 005-5 5 5 0 00-5-5z',
	size: 16,
};

export const READ_LATER_16 = READ_LATER_OUTLINE_16;
// 16x16/warning squircle large/outline.svg
export const WARNING_SQUIRCLE_LARGE_OUTLINE_16 = {
	d: 'M7 12v-2h2v2H7zm0-3V4h2v5H7zm1 5c5.103 0 6-.897 6-6s-.897-6-6-6-6 .897-6 6 .897 6 6 6zM8 0c6.229 0 8 1.771 8 8s-1.771 8-8 8-8-1.771-8-8 1.771-8 8-8z',
	size: 16,
};

export const WARNING_SQUIRCLE_LARGE_16 = WARNING_SQUIRCLE_LARGE_OUTLINE_16;
// 16x16/warning squircle large/filled.svg
export const WARNING_SQUIRCLE_LARGE_FILLED_16 = {
	d: 'M8 0c6.229 0 8 1.771 8 8s-1.771 8-8 8-8-1.771-8-8 1.771-8 8-8zm1 10H7v2h2v-2zm0-6H7v5h2V4z',
	size: 16,
};

// 16x16/arrow back/outine.svg
export const ARROW_BACK_OUTINE_16 = {
	d: 'M15 9c0 2.757-2.243 5-5 5H7a1 1 0 110-2h3c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v3L1 5l5-4v3h4c2.757 0 5 2.243 5 5z',
	size: 16,
};

// 16x16/filter/outline.svg
export const FILTER_OUTLINE_16 = {
	d: 'M8.75 7.438L8 8.04l-.75-.6a49.705 49.705 0 01-3.316-2.895A16.517 16.517 0 018 4c1.491 0 3.003.26 4.066.544A49.705 49.705 0 018.75 7.438zM8 2C5 2 1 3 1 4s5 5 5 5v4l4 2V9s5-4 5-5-4-2-7-2z',
	size: 16,
};

export const FILTER_16 = FILTER_OUTLINE_16;
// 16x16/filter/filled.svg
export const FILTER_FILLED_16 = {
	d: 'M8 2C5 2 1 3 1 4s5 5 5 5v4l4 2V9s5-4 5-5-4-2-7-2z',
	size: 16,
};

// 16x16/archive/outline.svg
export const ARCHIVE_OUTLINE_16 = {
	d: 'M11 9a1 1 0 01-1 1H6a1 1 0 110-2h4a1 1 0 011 1zm-8 4V7h10l.002 6H3zM2 3h12l.002 2H2V3zm12-2H2C.897 1 0 1.897 0 3v2c0 .736.405 1.375 1 1.722V13c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V6.722c.595-.347 1-.986 1-1.722V3c0-1.103-.897-2-2-2z',
	size: 16,
};

export const ARCHIVE_16 = ARCHIVE_OUTLINE_16;
// 16x16/archive/filled.svg
export const ARCHIVE_FILLED_16 = {
	d: 'M11 9a1 1 0 00-1-1H6a1 1 0 100 2h4a1 1 0 001-1zm4-3v7c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V6h14zm1-4v2a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h14a1 1 0 011 1z',
	size: 16,
};

// 16x16/list/outline.svg
export const LIST_OUTLINE_16 = {
	d: 'M5 4.996h10a1 1 0 100-2H7l-2 2zm-5 5v-2h2v2H0zm15-2a1 1 0 110 2H5a1 1 0 010-2h10zm-15 7v-2h2v2H0zm15-2a1 1 0 010 2H5a1 1 0 110-2h10zm-9.29-12a1 1 0 010 1.41l-3 3a1 1 0 01-1.42 0l-1-1a1 1 0 111.42-1.41l.29.25L4.29.996a1 1 0 011.42 0z',
	size: 16,
};

export const LIST_16 = LIST_OUTLINE_16;
// 16x16/help circle/outline.svg
export const HELP_CIRCLE_OUTLINE_16 = {
	d: 'M11 7c0-1.654-1.346-3-3-3a3.012 3.012 0 00-2.598 1.499 1 1 0 101.731 1.002A1.001 1.001 0 118 8H7v2h1c1.654 0 3-1.346 3-3zm-4 5v-1h2v1H7zm1 2c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM8 0a8 8 0 110 16A8 8 0 018 0z',
	size: 16,
};

export const HELP_CIRCLE_16 = HELP_CIRCLE_OUTLINE_16;
// 16x16/help circle/filled.svg
export const HELP_CIRCLE_FILLED_16 = {
	d: 'M9.566.148c3.149.598 5.688 3.137 6.286 6.286a8.014 8.014 0 01-9.417 9.418C3.285 15.255.746 12.715.149 9.566A8.014 8.014 0 019.566.148zM9 11H7v1h2v-1zM8 4a3.012 3.012 0 00-2.598 1.5 1 1 0 101.731 1A1.001 1.001 0 118 8H7v2h1c1.654 0 3-1.346 3-3S9.654 4 8 4z',
	size: 16,
};

// 16x16/comment empty/outline.svg
export const COMMENT_EMPTY_OUTLINE_16 = {
	d: 'M13 3c-1.2-.8-3-1-5-1s-3.8.2-5 1c-1.2.8-2 2-2 4s.8 3.2 2 4v4l4-3h1c2 0 3.8-.2 5-1 1.2-.8 2-2 2-4s-.8-3.2-2-4zm-1 6.3c-.8.5-2.2.7-4 .7H7l-2.6 2V9.5s-.225-.095-.4-.2C3.5 9 3 8.5 3 7c0-1.5.5-2 1-2.3.8-.5 2.2-.7 4-.7 1.8 0 3.2.2 4 .7.5.3 1 .8 1 2.3 0 1.5-.5 2-1 2.3z',
	size: 16,
};

export const COMMENT_EMPTY_16 = COMMENT_EMPTY_OUTLINE_16;
// 16x16/comment empty/filled.svg
export const COMMENT_EMPTY_FILLED_16 = {
	d: 'M13 3c-1.2-.8-3-1-5-1s-3.8.2-5 1c-1.2.8-2 2-2 4s.8 3.2 2 4v4l4-3h1c2 0 3.8-.2 5-1 1.2-.8 2-2 2-4s-.8-3.2-2-4z',
	size: 16,
};

// 16x16/help/outline.svg
export const HELP_OUTLINE_16 = {
	d: 'M8 4a3.012 3.012 0 00-2.598 1.499 1 1 0 101.731 1.002A1.001 1.001 0 118 8H7v2h1c1.654 0 3-1.346 3-3S9.654 4 8 4zm-1 8h2v-1H7v1z',
	size: 16,
};

export const HELP_16 = HELP_OUTLINE_16;
// 16x16/star/outline.svg
export const STAR_OUTLINE_16 = {
	d: 'M8 0a.607.607 0 00-.561.357L5.322 4.881l-4.796.735A.624.624 0 000 6.239c0 .155.057.301.177.424l3.491 3.589-.817 5.026a.617.617 0 00.91.643L8 13.57l4.239 2.351a.617.617 0 00.91-.643l-.817-5.026 3.491-3.589A.594.594 0 0016 6.239a.624.624 0 00-.526-.623l-4.796-.735L8.561.357A.607.607 0 008 0zm0 3.878l.866 1.851.452.967 1.057.161 2.148.33-1.625 1.669-.702.722.162.994.361 2.219-1.749-.97-.97-.537-.97.537-1.749.97.361-2.219.162-.994-.702-.722-1.625-1.669 2.148-.33 1.057-.161.452-.967L8 3.878z',
	size: 16,
};

export const STAR_16 = STAR_OUTLINE_16;
// 16x16/star/filled.svg
export const STAR_FILLED_16 = {
	d: 'M16 6.24a.624.624 0 00-.526-.624l-4.796-.735L8.561.357A.607.607 0 008 0a.607.607 0 00-.561.357L5.322 4.881l-4.796.735A.624.624 0 000 6.24c0 .154.057.301.177.424l3.491 3.59-.817 5.025a.617.617 0 00.91.643L8 13.571l4.239 2.35a.617.617 0 00.91-.643l-.817-5.026 3.491-3.589A.596.596 0 0016 6.24z',
	size: 16,
};

// 16x16/plus/outline.svg
export const PLUS_OUTLINE_16 = {
	d: 'M12 7H9V4a1 1 0 10-2 0v3H4a1 1 0 100 2h3v3a1 1 0 102 0V9h3a1 1 0 100-2z',
	size: 16,
};

export const PLUS_16 = PLUS_OUTLINE_16;
// 16x16/mail group alt/outline.svg
export const MAIL_GROUP_ALT_OUTLINE_16 = {
	d: 'M12 1H4v2h8c1.103 0 2 .897 2 2v4h2V5c0-2.206-1.794-4-4-4zm-1 11V9.268l-4.5 1.636L2 9.268V12a1 1 0 001 1h7a1 1 0 001-1zM2 7v.459l4.5 1.637L11 7.459V7a1 1 0 00-1-1H3a1 1 0 00-1 1zm11 0v5c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h7c1.654 0 3 1.346 3 3z',
	size: 16,
};

export const MAIL_GROUP_ALT_16 = MAIL_GROUP_ALT_OUTLINE_16;
// 16x16/mail group alt/filled.svg
export const MAIL_GROUP_ALT_FILLED_16 = {
	d: 'M16 5v4h-2V5c0-1.103-.897-2-2-2H4V1h8c2.206 0 4 1.794 4 4zm-9.5 5.915l6.5-2.6V12c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V8.315l6.5 2.6zM.05 6.505l6.45 2.58 6.45-2.58A2.999 2.999 0 0010 4H3A2.999 2.999 0 00.05 6.505z',
	size: 16,
};

// 16x16/share android/outline.svg
export const SHARE_ANDROID_OUTLINE_16 = {
	d: 'M11.5 11c-.587 0-1.12.211-1.547.55L5.956 9.434C5.978 9.291 6 9.148 6 9c0-.254-.041-.496-.101-.731l3.267-2.178C9.786 6.65 10.6 7 11.5 7A3.5 3.5 0 108 3.5c0 .307.052.598.126.881L4.789 6.604A2.975 2.975 0 003 6a3 3 0 100 6 2.98 2.98 0 002.023-.798l3.996 2.115c-.005.062-.019.121-.019.183a2.5 2.5 0 102.5-2.5z',
	size: 16,
};

export const SHARE_ANDROID_16 = SHARE_ANDROID_OUTLINE_16;
// 16x16/folder/outline.svg
export const FOLDER_OUTLINE_16 = {
	d: 'M15 5H1V2a1 1 0 011-1h3c.757 0 1.214.428 1.553 1.105L7 3h7a1 1 0 011 1v1zm-2.279 7.439C12.076 12.667 10.202 13 8 13s-4.076-.333-4.721-.561C2.94 11.957 2.067 10.596 2.067 8h11.866c0 2.607-.873 3.957-1.212 4.439zM15 6H1c-.577 0-1 .428-1 1 0 3.628 1.069 6.088 1.983 6.999C2.485 14.499 5.242 15 8 15c2.758 0 5.515-.501 6.017-1.001C14.931 13.088 16 10.628 16 7c0-.574-.423-1-1-1z',
	size: 16,
};

export const FOLDER_16 = FOLDER_OUTLINE_16;
// 16x16/folder/filled.svg
export const FOLDER_FILLED_16 = {
	d: 'M7 3l-.447-.895C6.214 1.428 5.757 1 5 1H2a1 1 0 00-1 1v3h14V4a1 1 0 00-1-1H7zm9 4c0 3.633-1.069 6.088-1.983 6.999C13.515 14.499 10.758 15 8 15c-2.758 0-5.515-.501-6.017-1.001C1.069 13.088 0 10.628 0 7c0-.568.423-1 1-1h14c.577 0 1 .427 1 1z',
	size: 16,
};

// 16x16/windows/outline.svg
export const WINDOWS_OUTLINE_16 = {
	d: 'M15 3v6c0 1.103-.897 2-2 2h-1V9h1V3H7v1H5V3c0-1.103.897-2 2-2h6c1.103 0 2 .897 2 2zM3 13h6V7H3v6zm6-8H3a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z',
	size: 16,
};

export const WINDOWS_16 = WINDOWS_OUTLINE_16;
// 16x16/windows/filled.svg
export const WINDOWS_FILLED_16 = {
	d: 'M13 1H7a2 2 0 00-2 2v1h5a2 2 0 012 2v5h1a2 2 0 002-2V3a2 2 0 00-2-2zm-2 6v6a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2z',
	size: 16,
};

// 16x16/arrow left/outline.svg
export const ARROW_LEFT_OUTLINE_16 = {
	d: 'M4.413 7l3.293-3.293a.999.999 0 10-1.414-1.414l-5 5a1 1 0 000 1.415l5 4.999a.997.997 0 001.414 0 .999.999 0 000-1.414L4.413 9H14a1 1 0 100-2H4.413z',
	size: 16,
};

export const ARROW_LEFT_16 = ARROW_LEFT_OUTLINE_16;
// 16x16/arrow left/filled.svg
export const ARROW_LEFT_FILLED_16 = {
	d: 'M1.293 7.294l5-5A.998.998 0 018 3v4h6a1 1 0 110 2H8v4a.997.997 0 01-1 1 .996.996 0 01-.707-.292l-5-5a.997.997 0 010-1.414z',
	size: 16,
};

// 16x16/maximize alt1/outline.svg
export const MAXIMIZE_ALT1_OUTLINE_16 = {
	d: 'M5.293 9.293l-2.5 2.5L1 10v5h5l-1.793-1.793 2.5-2.5a.999.999 0 10-1.414-1.414zM10 1l1.793 1.793-2.5 2.5a.999.999 0 101.414 1.414l2.5-2.5L15 6V1h-5zm3 11a1 1 0 01-1 1H9v2h3c1.654 0 3-1.346 3-3V9h-2v3zM4 1h3v2H4a1 1 0 00-1 1v3H1V4c0-1.654 1.346-3 3-3z',
	size: 16,
};

export const MAXIMIZE_ALT1_16 = MAXIMIZE_ALT1_OUTLINE_16;
// 16x16/camera/outline.svg
export const CAMERA_OUTLINE_16 = {
	d: 'M8 10c-.827 0-1.5-.673-1.5-1.5S7.173 7 8 7s1.5.673 1.5 1.5S8.827 10 8 10zm0-5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm5.994 7.381C12.495 12.663 10.237 13 8 13c-2.237 0-4.495-.337-6-.62l.001-6.876a25.566 25.566 0 012.327-.531l1.005-.167.456-.911L6.236 3h3.528l.447.895.456.911 1.005.167c.613.102 1.418.286 2.328.532l-.006 6.876zm.526-8.808A27.607 27.607 0 0012 3l-.724-1.447A.998.998 0 0010.382 1H5.618a.998.998 0 00-.894.553L4 3c-.818.136-1.758.367-2.52.573A1.998 1.998 0 000 5.505v6.875c0 .965.688 1.788 1.636 1.967C3.17 14.636 5.585 15 8 15s4.83-.364 6.364-.653A2.003 2.003 0 0016 12.38V5.505c0-.906-.605-1.696-1.48-1.932z',
	size: 16,
};

export const CAMERA_16 = CAMERA_OUTLINE_16;
// 16x16/camera/filled.svg
export const CAMERA_FILLED_16 = {
	d: 'M11.5 8.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zM16 5.505v6.875c0 .965-.687 1.788-1.636 1.967C12.83 14.636 10.415 15 8 15s-4.83-.364-6.364-.653A2.002 2.002 0 010 12.38V5.505c0-.906.605-1.696 1.48-1.932A27.607 27.607 0 014 3l.724-1.447A.998.998 0 015.618 1h4.764c.379 0 .725.214.894.553L12 3c.818.136 1.758.367 2.52.573A1.998 1.998 0 0116 5.505zM9.5 8.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S7.173 7 8 7s1.5.673 1.5 1.5z',
	size: 16,
};

// 16x16/search/outline.svg
export const SEARCH_OUTLINE_16 = {
	d: 'M7 11c-2.205 0-4-1.795-4-4 0-2.206 1.795-4 4-4 2.206 0 4 1.794 4 4 0 2.205-1.794 4-4 4zm7 1.533c-.363-.317-1.37-1.179-2.292-1.821A5.97 5.97 0 0013 7 6 6 0 001 7a6 6 0 006 6 5.967 5.967 0 003.688-1.274c.623.899 1.454 1.88 1.808 2.274.693.771.95 1 1.504 1a1 1 0 001-1c0-.553-.331-.88-1-1.467z',
	size: 16,
};

export const SEARCH_16 = SEARCH_OUTLINE_16;
// 16x16/file word/outline.svg
export const FILE_WORD_OUTLINE_16 = {
	d: 'M10.98 5.112l-1.062 4.24c-.044.18-.107.487-.134.74a6.32 6.32 0 00-.136-.74l-1.044-4.24h-1.18l-1.026 4.24c-.044.18-.1.495-.135.756-.026-.26-.091-.576-.127-.756l-1.045-4.24H3.732l1.694 6.302h1.593L7.9 7.84c.045-.216.092-.523.117-.756.02.233.056.54.11.756l.88 3.574h1.595l1.665-6.302H10.98zm2.618 6.661c.268-1.23.402-2.5.402-3.773a17.78 17.78 0 00-.402-3.774 2.385 2.385 0 00-1.825-1.825 17.82 17.82 0 00-3.772-.4c-1.273 0-2.542.133-3.774.4A2.384 2.384 0 002.4 4.225 17.846 17.846 0 002.002 8c0 1.272.134 2.543.4 3.773a2.386 2.386 0 001.825 1.825 17.86 17.86 0 007.548 0 2.385 2.385 0 001.825-1.825zm1.955-7.97a19.87 19.87 0 010 8.393 4.379 4.379 0 01-3.357 3.357 19.874 19.874 0 01-8.393 0 4.377 4.377 0 01-3.356-3.357A19.874 19.874 0 010 8c0-1.44.154-2.844.446-4.198A4.378 4.378 0 013.804.446 19.87 19.87 0 018 0c1.439 0 2.843.154 4.196.446a4.38 4.38 0 013.357 3.357z',
	size: 16,
};

export const FILE_WORD_16 = FILE_WORD_OUTLINE_16;
// 16x16/file word/filled.svg
export const FILE_WORD_FILLED_16 = {
	d: 'M11.049 11.955l1.95-7.384h-1.507L10.247 9.54c-.052.21-.126.569-.158.864a7.127 7.127 0 00-.158-.864L8.707 4.571H7.325L6.123 9.54c-.053.21-.117.58-.158.886-.032-.306-.106-.676-.148-.886L4.593 4.571H3l1.984 7.384H6.85l1.033-4.187c.053-.253.106-.613.138-.886.02.273.063.633.127.886l1.033 4.187h1.867zm4.505-8.151C15.846 5.156 16 6.559 16 8c0 1.44-.154 2.844-.446 4.196a4.381 4.381 0 01-3.358 3.358A19.86 19.86 0 018 16a19.86 19.86 0 01-4.196-.446 4.381 4.381 0 01-3.358-3.358A19.867 19.867 0 010 8c0-1.441.154-2.844.446-4.197A4.379 4.379 0 013.804.446 19.86 19.86 0 018 0c1.44 0 2.844.154 4.196.446a4.38 4.38 0 013.358 3.358z',
	size: 16,
};

// 16x16/edit text/outline.svg
export const EDIT_TEXT_OUTLINE_16 = {
	d: 'M13.793 2.52l-1.086 1.086 1.828 1.828 1.086-1.086a1.292 1.292 0 10-1.828-1.828zM3.707 12.606l8-8 1.828 1.828-7.999 8L3.142 15l.565-2.394zM6 8l-2 2H1V8h5zm3-3L7 7H1V5h8zm1-1l2-2H1v2h9z',
	size: 16,
};

export const EDIT_TEXT_16 = EDIT_TEXT_OUTLINE_16;
// 16x16/edit text/filled.svg
export const EDIT_TEXT_FILLED_16 = {
	d: 'M15.414 4.414a2 2 0 10-2.828-2.828l-1 1 2.828 2.828 1-1zM3.586 10.586l7-7 2.828 2.828-7 7L2 15l1.586-4.414zM7 5L5 7H1V5h6zm1-1l2-2H1v2h7z',
	size: 16,
};

// 16x16/mail/outline.svg
export const MAIL_OUTLINE_16 = {
	d: 'M8 13c-2.015 0-3.753-.278-4.857-.513a1.006 1.006 0 01-.307-.122l2.922-2.922L8 11.045l2.242-1.602 2.894 2.895a.98.98 0 01-.363.167A23.93 23.93 0 018 13zm-5.805-2.396A18.423 18.423 0 012 8c0-.418.034-.804.058-1.2l2.298 1.642-2.161 2.162zm.948-7.091A23.77 23.77 0 018 3c1.977 0 3.687.27 4.773.495a.979.979 0 01.758.74c.045.2.093.432.138.67L8 8.956 2.279 4.869c.036-.203.055-.427.099-.621a.972.972 0 01.765-.735zM14 8c0 .89-.107 1.778-.238 2.56l-2.118-2.118 2.296-1.64c.035.394.06.796.06 1.198zm1.482-4.205a2.973 2.973 0 00-2.301-2.258A25.778 25.778 0 008 1c-2.149 0-4.01.289-5.272.556A2.977 2.977 0 00.427 3.809C.204 4.799 0 6.195 0 7.999c0 1.806.204 3.202.427 4.193a2.977 2.977 0 002.301 2.252C3.99 14.71 5.851 15 8 15c2.098 0 3.921-.275 5.181-.537a2.973 2.973 0 002.301-2.257C15.738 11.072 16 9.536 16 8c0-1.536-.262-3.072-.518-4.205z',
	size: 16,
};

export const MAIL_16 = MAIL_OUTLINE_16;
// 16x16/mail/filled.svg
export const MAIL_FILLED_16 = {
	d: 'M10.206 9.408L8 11.062 5.794 9.408 1.41 13.793c.373.314.821.546 1.32.651C3.99 14.711 5.85 15 8 15c2.098 0 3.921-.276 5.181-.537a2.988 2.988 0 001.38-.7l-4.355-4.355zM.186 5.201A20.67 20.67 0 000 8.001c0 1.803.204 3.2.427 4.191.01.047.03.091.042.138L4.42 8.378.185 5.201zM16 8.001c0-.955-.106-1.899-.244-2.756L11.58 8.378l3.885 3.884c.004-.019.012-.037.017-.056C15.738 11.072 16 9.536 16 8zM.567 3.362a2.99 2.99 0 012.161-1.808A25.896 25.896 0 018 1c2.098 0 3.921.275 5.181.537a2.976 2.976 0 012.185 1.876L8 8.937.567 3.363z',
	size: 16,
};

// 8x8/external_link/outline.svg
export const EXTERNAL_LINK_OUTLINE_8 = {
	d: 'M2 0l2.293 2.293-3 3a.999.999 0 101.414 1.414l3-3L8 6V0H2z',
	size: 8,
};

export const EXTERNAL_LINK_8 = EXTERNAL_LINK_OUTLINE_8;
// 8x8/__library/outline.svg
export const __LIBRARY_OUTLINE_8 = {
	d: 'M2 7h1V4H2v3zm2-4.899L5.349 3H2.651L4 2.101zM5 7h1V4H5v3zM0 8h8L7 7V4a.5.5 0 00.277-.916l-3-2a.499.499 0 00-.554 0l-3 2A.5.5 0 001 4v3L0 8z',
	size: 8,
};

export const __LIBRARY_8 = __LIBRARY_OUTLINE_8;
// 8x8/dot/outline.svg
export const DOT_OUTLINE_8 = {
	d: 'M4 1a3 3 0 100 6 3 3 0 000-6z',
	size: 8,
};

export const DOT_8 = DOT_OUTLINE_8;
// 24x24/promote/outline.svg
export const PROMOTE_OUTLINE_24 = {
	d: 'M20 9V3l-7 3H7c-2.8 0-5 2.2-5 5s2.2 5 5 5v3.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V16h3l7 3v-6c1.1 0 2-.9 2-2s-.9-2-2-2zM7 14c-1.7 0-3-1.3-3-3s1.3-3 3-3h5v6H7zm11 2l-4-1.7V7.7L18 6v10z',
	size: 24,
};

export const PROMOTE_OUTLINE = PROMOTE_OUTLINE_24;
export const PROMOTE_24 = PROMOTE_OUTLINE_24;
export const PROMOTE = PROMOTE_OUTLINE_24;
// 24x24/promote/filled.svg
export const PROMOTE_FILLED_24 = {
	d: 'M22 11c0 1.1-.9 2-2 2v6l-7-3V6l7-3v6c1.1 0 2 .9 2 2zM2 11c0 2.8 2.2 5 5 5v3.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V16h2V6H7c-2.8 0-5 2.2-5 5z',
	size: 24,
};

export const PROMOTE_FILLED = PROMOTE_FILLED_24;
// 24x24/user group/outline.svg
export const USER_GROUP_OUTLINE_24 = {
	d: 'M16 3c-1.657 0-3 1.351-3 3v1c0 2.412 1.343 4 3 4s3-1.588 3-4V6c0-1.649-1.343-3-3-3zm0 2a1 1 0 011 1v1c0 1.235-.52 2-1 2s-1-.765-1-2V6a1 1 0 011-1zM8 5C6.343 5 5 6.351 5 8v1c0 2.412 1.343 4 3 4s3-1.588 3-4V8c0-1.649-1.343-3-3-3zm0 2a1 1 0 011 1v1c0 1.235-.52 2-1 2s-1-.765-1-2V8a1 1 0 011-1zm-.019 6.965C4 13.965 1 15 1 17c0 1.53 2.981 4 7 4s7-2.478 7-4c0-2-3.036-3.035-7.019-3.035zm0 2c3.019 0 4.573.641 4.962 1.014C12.523 17.609 10.724 19 8 19c-2.731 0-4.53-1.392-4.944-2.021.33-.299 1.693-1.014 4.925-1.014zM23 15c0 2.031-4 4-8 4 1.197-1.108 1.907-2.737 1-4-.821-1.145-2.006-1.871-4-2 .804-.413 2-1.035 3.979-1.035C21 11.965 23 13.602 23 15z',
	size: 24,
};

export const USER_GROUP_OUTLINE = USER_GROUP_OUTLINE_24;
export const USER_GROUP_24 = USER_GROUP_OUTLINE_24;
export const USER_GROUP = USER_GROUP_OUTLINE_24;
// 24x24/user group/filled.svg
export const USER_GROUP_FILLED_24 = {
	d: 'M16 3c-1.657 0-3 1.351-3 3v1c0 2.412 1.343 4 3 4s3-1.588 3-4V6c0-1.649-1.343-3-3-3zM8 5C6.343 5 5 6.351 5 8v1c0 2.412 1.343 4 3 4s3-1.588 3-4V8c0-1.649-1.343-3-3-3zm-.019 8.965C4 13.965 1 15 1 17c0 1.53 2.981 4 7 4s7-2.478 7-4c0-2-3.036-3.035-7.019-3.035zM23 15c0 2.031-4 4-8 4 1.197-1.108 1.907-2.737 1-4-.821-1.145-2.006-1.871-4-2 .804-.413 2-1.035 3.979-1.035C21 11.965 23 13.602 23 15z',
	size: 24,
};

export const USER_GROUP_FILLED = USER_GROUP_FILLED_24;
// 24x24/mail insert in/outline.svg
export const MAIL_INSERT_IN_OUTLINE_24 = {
	d: 'M18.57 17.957c-.409.334-.9.57-1.449.657-3.224.512-7.022.512-10.243 0a3.042 3.042 0 01-1.448-.657l4.272-4.43L12 15.25l2.297-1.723 4.272 4.43zm-10.48-5.64l-3.723 3.861-.012-.048A24.59 24.59 0 014 12c0-.979.051-1.912.123-2.657l3.967 2.974zm11.541 3.861l-3.722-3.861 3.967-2.974c.073.745.124 1.678.124 2.657 0 1.361-.12 2.751-.356 4.13-.003.016-.009.032-.013.048zM22.001 12c0-1.51-.129-3.585-.41-4.571-.087-.31-.32-1.132-5.039-4.262l-1.105 1.666c1.301.863 2.763 1.923 3.605 2.628L12 12.75 4.947 7.461c.843-.705 2.305-1.765 3.605-2.628L7.447 3.167c-4.717 3.13-4.95 3.952-5.04 4.262C2.127 8.414 2 10.489 2 12c0 1.473.13 2.976.383 4.467a5.039 5.039 0 004.181 4.122A34.83 34.83 0 0012 21c1.891 0 3.72-.139 5.435-.411a5.032 5.032 0 004.18-4.122c.256-1.49.385-2.992.385-4.467zm-10-2l3-4h-2V2h-2v4H9l3 4z',
	size: 24,
};

export const MAIL_INSERT_IN_OUTLINE = MAIL_INSERT_IN_OUTLINE_24;
export const MAIL_INSERT_IN_24 = MAIL_INSERT_IN_OUTLINE_24;
export const MAIL_INSERT_IN = MAIL_INSERT_IN_OUTLINE_24;
// 24x24/minimize/outline.svg
export const MINIMIZE_OUTLINE_24 = {
	d: 'M15 18v-2h-2v2a1 1 0 01-1 1h-2v2h2c1.654 0 3-1.346 3-3zm-7 1H6a1 1 0 01-1-1v-2H3v2c0 1.654 1.346 3 3 3h2v-2zm-3-7a1 1 0 011-1h2V9H6c-1.654 0-3 1.346-3 3v2h2v-2zm10 0c0-1.654-1.346-3-3-3h-2v2h2a1 1 0 011 1v2h2v-2zm3 9h-1v-2h1a1 1 0 001-1V7c0-1.103-.897-2-2-2H6a1 1 0 00-1 1v1H3V6c0-1.654 1.346-3 3-3h11c2.206 0 4 1.794 4 4v11c0 1.654-1.346 3-3 3z',
	size: 24,
};

export const MINIMIZE_OUTLINE = MINIMIZE_OUTLINE_24;
export const MINIMIZE_24 = MINIMIZE_OUTLINE_24;
export const MINIMIZE = MINIMIZE_OUTLINE_24;
// 24x24/mail crown/oulline.svg
export const MAIL_CROWN_OULLINE_24 = {
	d: 'M17 2l-1 6H8L7 2l3 3 2-3 2 3 3-3zm1.569 15.957c-.408.334-.9.57-1.448.657-3.224.512-7.021.512-10.243 0a3.034 3.034 0 01-1.447-.657l4.272-4.43L12 15.25l2.297-1.723 4.272 4.43zM8.09 12.317l-3.722 3.861c-.003-.016-.01-.032-.013-.048A24.694 24.694 0 014 12c0-.979.051-1.912.124-2.657l3.966 2.974zm11.542 3.861l-3.723-3.861 3.967-2.974c.073.745.124 1.678.124 2.657 0 1.361-.12 2.751-.355 4.13-.003.016-.009.032-.013.048zM22 12c0-1.51-.128-3.585-.408-4.571-.069-.242-.227-.797-2.541-2.52l-1.414 1.454c.548.404 1.043.785 1.416 1.098L12 12.75 4.947 7.461a31.34 31.34 0 011.481-1.145L4.948 4.91c-2.313 1.723-2.471 2.277-2.54 2.519C2.127 8.414 2 10.489 2 12c0 1.473.129 2.976.384 4.467a5.037 5.037 0 004.18 4.122A34.84 34.84 0 0012 21c1.892 0 3.721-.139 5.436-.411a5.032 5.032 0 004.179-4.122c.256-1.49.385-2.992.385-4.467z',
	size: 24,
};

export const MAIL_CROWN_OULLINE = MAIL_CROWN_OULLINE_24;
// 24x24/home/outline.svg
export const HOME_OUTLINE_24 = {
	d: 'M18 19a1 1 0 01-1 1h-2v-6a3 3 0 10-6 0v6H7a1 1 0 01-1-1V9.671l6-5.333 6 5.333V19zm3.664-8.748l-9-8a.998.998 0 00-1.328 0l-9 8a1.001 1.001 0 00-.083 1.413c.366.411.999.447 1.411.083L4 11.449V19c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-7.551l.336.299a.997.997 0 001.411-.083A.986.986 0 0022 11a1.012 1.012 0 00-.336-.748z',
	size: 24,
};

export const HOME_OUTLINE = HOME_OUTLINE_24;
export const HOME_24 = HOME_OUTLINE_24;
export const HOME = HOME_OUTLINE_24;
// 24x24/home/filled.svg
export const HOME_FILLED_24 = {
	d: 'M15 20H9v-6a3 3 0 116 0v6zM12.664 2.252A1.008 1.008 0 0012 2a.988.988 0 00-.664.252l-9 8A.99.99 0 002 11c.001.235.085.475.253.665.366.411.998.447 1.411.083L4 11.449V19c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-7.551l.336.299a.997.997 0 001.411-.083c.169-.19.252-.43.253-.665a.99.99 0 00-.336-.748l-9-8z',
	size: 24,
};

export const HOME_FILLED = HOME_FILLED_24;
// 24x24/side panel/outline.svg
export const SIDE_PANEL_OUTLINE_24 = {
	d: 'M20 17a1 1 0 01-1 1h-2V6h2a1 1 0 011 1v10zM4 17V7a1 1 0 011-1h10v12H5a1 1 0 01-1-1zM19 4H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z',
	size: 24,
};

export const SIDE_PANEL_OUTLINE = SIDE_PANEL_OUTLINE_24;
export const SIDE_PANEL_24 = SIDE_PANEL_OUTLINE_24;
export const SIDE_PANEL = SIDE_PANEL_OUTLINE_24;
// 24x24/side panel/filled.svg
export const SIDE_PANEL_FILLED_24 = {
	d: 'M20 17a1 1 0 01-1 1h-2V8h3v9zM4 17V8h11v10H5a1 1 0 01-1-1zM19 4H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z',
	size: 24,
};

export const SIDE_PANEL_FILLED = SIDE_PANEL_FILLED_24;
// 24x24/bookmark add/outline.svg
export const BOOKMARK_ADD_OUTLINE_24 = {
	d: 'M20 6h-3V3a1 1 0 10-2 0v3h-3a1 1 0 100 2h3v3a1 1 0 102 0V8h3a1 1 0 100-2zm-5 8h2v7.767l-6-3.601-6 3.601V5c0-1.654 1.346-3 3-3h5v2H8a1 1 0 00-1 1v13.233l2.971-1.782a1.998 1.998 0 012.057-.001L15 18.233V14z',
	size: 24,
};

export const BOOKMARK_ADD_OUTLINE = BOOKMARK_ADD_OUTLINE_24;
export const BOOKMARK_ADD_24 = BOOKMARK_ADD_OUTLINE_24;
export const BOOKMARK_ADD = BOOKMARK_ADD_OUTLINE_24;
// 24x24/bookmark add/filled.svg
export const BOOKMARK_ADD_FILLED_24 = {
	d: 'M20 6h-3V3a1 1 0 10-2 0v3h-3a1 1 0 100 2h3v3a1 1 0 102 0V8h3a1 1 0 100-2zm-3 8v8l-6-4-6 4V5c0-1.718 1.292-3 3-3h5v2h-1a3 3 0 100 6h1a4 4 0 004 4z',
	size: 24,
};

export const BOOKMARK_ADD_FILLED = BOOKMARK_ADD_FILLED_24;
// 24x24/add squircle/outline.svg
export const ADD_SQUIRCLE_OUTLINE_24 = {
	d: 'M20 12c0-1.629-.173-3.252-.514-4.822a3.479 3.479 0 00-2.662-2.664A22.789 22.789 0 0012 4c-1.629 0-3.251.173-4.821.513a3.484 3.484 0 00-2.666 2.664A22.844 22.844 0 004 12c0 1.629.173 3.251.513 4.822a3.483 3.483 0 002.663 2.664C8.748 19.827 10.37 20 12 20s3.252-.173 4.821-.514a3.48 3.48 0 002.665-2.663C19.827 15.252 20 13.63 20 12zm2 0c0 1.8-.192 3.555-.559 5.245a5.47 5.47 0 01-4.195 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.472 5.472 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.472 5.472 0 014.197-4.196A24.695 24.695 0 0112 2c1.8 0 3.555.191 5.246.559a5.47 5.47 0 014.195 4.195C21.808 8.445 22 10.2 22 12zm-5 0a1 1 0 01-1 1h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3V8a1 1 0 112 0v3h3a1 1 0 011 1z',
	size: 24,
};

export const ADD_SQUIRCLE_OUTLINE = ADD_SQUIRCLE_OUTLINE_24;
export const ADD_SQUIRCLE_24 = ADD_SQUIRCLE_OUTLINE_24;
export const ADD_SQUIRCLE = ADD_SQUIRCLE_OUTLINE_24;
// 24x24/add squircle/filled.svg
export const ADD_SQUIRCLE_FILLED_24 = {
	d: 'M16 13h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3V8a1 1 0 112 0v3h3a1 1 0 110 2zm5.441-6.246a5.47 5.47 0 00-4.195-4.195A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.47 5.47 0 004.195-4.196C21.808 15.555 22 13.8 22 12c0-1.8-.192-3.555-.559-5.246z',
	size: 24,
};

export const ADD_SQUIRCLE_FILLED = ADD_SQUIRCLE_FILLED_24;
// 24x24/user add/outline.svg
export const USER_ADD_OUTLINE_24 = {
	d: 'M21 17h-2v-2a1 1 0 10-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2zm-9 3c-3.697 0-6.375-2.663-6.908-3.744C5.821 15.767 8.075 15 12 15c1.141 0 2.139.064 3 .167l1.221-1.845C15.008 13.117 13.591 13 12 13c-5.563 0-9 1.439-9 3 0 1.977 4 6 9 6 .96 0 1.882-.149 2.747-.402a4.939 4.939 0 01-.675-1.881A7.839 7.839 0 0112 20zM11 6c0 2.219.823 3 1 3 .177 0 1-.781 1-3 0-2-.486-2-1-2s-1 0-1 2zM9 6c0-2.904 1.136-4 3-4s3 1.096 3 4c0 3.202-1.426 5-3 5S9 9.202 9 6z',
	size: 24,
};

export const USER_ADD_OUTLINE = USER_ADD_OUTLINE_24;
export const USER_ADD_24 = USER_ADD_OUTLINE_24;
export const USER_ADD = USER_ADD_OUTLINE_24;
// 24x24/phone retro/filled.svg
export const PHONE_RETRO_FILLED_24 = {
	d: 'M15 13c0-1.104-1.343-2-3-2s-3 .896-3 2 1.343 2 3 2 3-.896 3-2zm5 3v1.438c0 .946-.656 1.768-1.582 1.958-1.365.279-3.566.604-6.418.604-2.852 0-5.053-.325-6.418-.604A1.991 1.991 0 014 17.438V16c0-2 2-4 4-6V8h8v2c2 2 4 4 4 6zm2-9.31V9a1 1 0 01-1 1h-2a1 1 0 01-1-1V6.935C16.454 6.465 14.334 6 12 6s-4.454.465-6 .935V9a1 1 0 01-1 1H3a1 1 0 01-1-1V6.69c0-.421.259-.795.656-.939C4.145 5.215 7.965 4 12 4c4.035 0 7.855 1.215 9.344 1.751A.994.994 0 0122 6.69z',
	size: 24,
};

export const PHONE_RETRO_FILLED = PHONE_RETRO_FILLED_24;
// 24x24/comment/outline.svg
export const COMMENT_OUTLINE_24 = {
	d: 'M13.5 10.5a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm4.5 0a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0118 10.5zm-9 0a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019 10.5zm3 5.5h-.605l-.504.336L8 18.263v-2.534l-1.22-.517C5.405 14.629 4 13.554 4 10c0-3.8 1.309-6 8-6s8 2.2 8 6-1.309 6-8 6zm0-14C5.415 2 2 4.073 2 10c0 3.73 1.355 5.932 4 7.053V22l6-4c6.585 0 10-2.073 10-8s-3.415-8-10-8z',
	size: 24,
};

export const COMMENT_OUTLINE = COMMENT_OUTLINE_24;
export const COMMENT_24 = COMMENT_OUTLINE_24;
export const COMMENT = COMMENT_OUTLINE_24;
// 24x24/comment/filled.svg
export const COMMENT_FILLED_24 = {
	d: 'M16.5 12a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0116.5 12zM12 12a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112 12zm-4.5 0a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 12zM12 2C5.415 2 2 4.073 2 10c0 3.73 1.355 5.932 4 7.053V22l6-4c6.585 0 10-2.073 10-8s-3.415-8-10-8z',
	size: 24,
};

export const COMMENT_FILLED = COMMENT_FILLED_24;
// 24x24/label add/outline.svg
export const LABEL_ADD_OUTLINE_24 = {
	d: 'M22 4v8c0 .266-.105.52-.293.707l-1.064 1.064L19 12.586l1-1V5h-6.586l-9 9L11 20.586 12.586 19l1.185 1.643-2.064 2.064a.997.997 0 01-1.414 0l-8-8a.999.999 0 010-1.414l10-10A.997.997 0 0113 3h8a1 1 0 011 1zm0 14a1 1 0 01-1 1h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 112 0v2h2a1 1 0 011 1zm-6-7a2 2 0 10-.001-4.001A2 2 0 0016 11z',
	size: 24,
};

export const LABEL_ADD_OUTLINE = LABEL_ADD_OUTLINE_24;
export const LABEL_ADD_24 = LABEL_ADD_OUTLINE_24;
export const LABEL_ADD = LABEL_ADD_OUTLINE_24;
// 24x24/trash/outline.svg
export const TRASH_OUTLINE_24 = {
	d: 'M19 4a1 1 0 01-1 1H6a1 1 0 110-2h3a1 1 0 011-1h4a1 1 0 011 1h3a1 1 0 011 1zM8 8h8v11a1 1 0 01-1 1H9a1 1 0 01-1-1V8zM6 19a3 3 0 003 3h6a3 3 0 003-3V6H6v13z',
	size: 24,
};

export const TRASH_OUTLINE = TRASH_OUTLINE_24;
export const TRASH_24 = TRASH_OUTLINE_24;
export const TRASH = TRASH_OUTLINE_24;
// 24x24/trash/filled.svg
export const TRASH_FILLED_24 = {
	d: 'M18 3h-3a1 1 0 00-1-1h-4a1 1 0 00-1 1H6a1 1 0 100 2h12a1 1 0 100-2zM6 6h12v13a3 3 0 01-3 3H9a3 3 0 01-3-3V6z',
	size: 24,
};

export const TRASH_FILLED = TRASH_FILLED_24;
// 24x24/headphones/outline.svg
export const HEADPHONES_OUTLINE_24 = {
	d: 'M20 19c0 .826-1.632 1-3 1v-6c1.368 0 3 .174 3 1v4zM7 14v6c-1.369 0-3-.174-3-1v-4c0-.826 1.631-1 3-1zm5-12C6.486 2 2 6.486 2 12v7c0 1.99 1.682 3 5 3 1.103 0 2-.897 2-2v-6c0-1.103-.897-2-2-2-1.225 0-2.223.14-3 .414V12c0-4.411 3.589-8 8-8s8 3.589 8 8v.414c-.776-.274-1.775-.414-3-.414-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2 3.317 0 5-1.01 5-3v-7c0-5.514-4.486-10-10-10z',
	size: 24,
};

export const HEADPHONES_OUTLINE = HEADPHONES_OUTLINE_24;
export const HEADPHONES_24 = HEADPHONES_OUTLINE_24;
export const HEADPHONES = HEADPHONES_OUTLINE_24;
// 24x24/headphones/filled.svg
export const HEADPHONES_FILLED_24 = {
	d: 'M12 2C6.486 2 2 6.486 2 12v7c0 1.99 1.683 3 5 3 1.103 0 2-.897 2-2v-6c0-1.103-.897-2-2-2-1.225 0-2.224.14-3 .414V12c0-4.411 3.589-8 8-8s8 3.589 8 8v.414c-.776-.274-1.775-.414-3-.414-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2 3.317 0 5-1.01 5-3v-7c0-5.514-4.486-10-10-10z',
	size: 24,
};

export const HEADPHONES_FILLED = HEADPHONES_FILLED_24;
// 24x24/visibility/outline.svg
export const VISIBILITY_OUTLINE_24 = {
	d: 'M15.615 9.322c.56.75.902 1.67.902 2.678a4.5 4.5 0 11-4.5-4.5c.378 0 .74.06 1.088.147a1.8 1.8 0 102.51 1.675zM12.017 18c-4.216 0-7.71-4.45-8.797-6 1.087-1.549 4.581-6 8.797-6 4.217 0 7.71 4.451 8.797 6-1.087 1.55-4.58 6-8.797 6zm10.853-6.523C22.683 11.173 18.203 4 12 4 5.797 4 1.351 11.173 1.165 11.477 1.067 11.637 1 11.82 1 12s.067.362.165.522C1.351 12.827 5.815 20 12.017 20c6.203 0 10.666-7.173 10.853-7.478A.975.975 0 0023 12a.974.974 0 00-.13-.523z',
	size: 24,
};

export const VISIBILITY_OUTLINE = VISIBILITY_OUTLINE_24;
export const VISIBILITY_24 = VISIBILITY_OUTLINE_24;
export const VISIBILITY = VISIBILITY_OUTLINE_24;
// 24x24/visibility/filled.svg
export const VISIBILITY_FILLED_24 = {
	d: 'M16.5 12A4.5 4.5 0 1112 7.5c.377 0 .738.061 1.088.147A1.8 1.8 0 0013.8 11.1c.987 0 1.786-.794 1.798-1.778.559.75.902 1.67.902 2.678zM12 18a6 6 0 010-12 6 6 0 010 12zm10.853-6.522C22.666 11.173 18.203 4 12 4 5.797 4 1.334 11.173 1.147 11.478a1.005 1.005 0 000 1.044C1.334 12.827 5.797 20 12 20c6.203 0 10.666-7.173 10.853-7.478a.999.999 0 000-1.044z',
	size: 24,
};

export const VISIBILITY_FILLED = VISIBILITY_FILLED_24;
// 24x24/menu burger/outline.svg
export const MENU_BURGER_OUTLINE_24 = {
	d: 'M3 19h18a1 1 0 100-2H3a1 1 0 100 2zm0-6h18a1 1 0 100-2H3a1 1 0 100 2zm0-8h18a1 1 0 110 2H3a1 1 0 110-2z',
	size: 24,
};

export const MENU_BURGER_OUTLINE = MENU_BURGER_OUTLINE_24;
export const MENU_BURGER_24 = MENU_BURGER_OUTLINE_24;
export const MENU_BURGER = MENU_BURGER_OUTLINE_24;
// 24x24/phone/filled.svg
export const PHONE_FILLED_24 = {
	d: 'M19 15h-2c-1.932 0-2.421.95-2.544 1.672l-.289 1.688c-3.654-1.217-6.574-4.295-7.697-8.117l2.181-.578C9.53 9.433 10 8.959 10 8V5c0-1.154-.91-2-2-2H6c-1.046 0-1.871.864-1.932 1.971-.076 1.372-.153 2.589.158 4.299.986 5.42 4.594 9.911 10.854 11.495 1.261.319 2.77.247 4.066.167C20.189 20.866 21 20.106 21 19v-2c0-1.444-.91-2-2-2z',
	size: 24,
};

export const PHONE_FILLED = PHONE_FILLED_24;
// 24x24/checker light/outline.svg
export const CHECKER_LIGHT_OUTLINE_24 = {
	d: 'M9.625 17.25a.623.623 0 01-.442-.183l-4-4a.625.625 0 01.884-.883l3.558 3.558 8.558-8.558a.625.625 0 01.884.884l-9 9a.623.623 0 01-.442.182z',
	size: 24,
};

export const CHECKER_LIGHT_OUTLINE = CHECKER_LIGHT_OUTLINE_24;
export const CHECKER_LIGHT_24 = CHECKER_LIGHT_OUTLINE_24;
export const CHECKER_LIGHT = CHECKER_LIGHT_OUTLINE_24;
// 24x24/arrow forward round/outine.svg
export const ARROW_FORWARD_ROUND_OUTINE_24 = {
	d: 'M9.727 7h5.27V4.07a.5.5 0 01.82-.39l5 3.94a.489.489 0 010 .76l-5 3.94a.5.5 0 01-.82-.39V9h-5.3a4.64 4.64 0 00-4.7 4.05 4.51 4.51 0 004.5 4.95h3.5a1 1 0 110 2h-3.5a6.5 6.5 0 01-6.44-7.36A6.65 6.65 0 019.727 7z',
	size: 24,
};

export const ARROW_FORWARD_ROUND_OUTINE = ARROW_FORWARD_ROUND_OUTINE_24;
// 24x24/notes/outline.svg
export const NOTES_OUTLINE_24 = {
	d: 'M19 16c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h4V3H8C5.243 3 3 5.243 3 8v8c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5v-4h-2v4zm1.385-9.412c.82-.821.82-2.151 0-2.973a2.104 2.104 0 00-2.973 0l-.495.496 2.972 2.972.496-.495zM9 12l7-7 3 3-7 7-4 1 1-4z',
	size: 24,
};

export const NOTES_OUTLINE = NOTES_OUTLINE_24;
export const NOTES_24 = NOTES_OUTLINE_24;
export const NOTES = NOTES_OUTLINE_24;
// 24x24/book/outline.svg
export const BOOK_OUTLINE_24 = {
	d: 'M17 20v-2H7a1 1 0 100 2h10zM6 16h12V4H7a1 1 0 00-1 1v11zm13 1.723V20a1 1 0 110 2H7a3 3 0 01-3-3V5a3 3 0 013-3h11a2 2 0 012 2v12c0 .738-.404 1.376-1 1.723zM17 7.5A1.5 1.5 0 0115.5 9h-7a1.5 1.5 0 010-3h7A1.5 1.5 0 0117 7.5z',
	size: 24,
};

export const BOOK_OUTLINE = BOOK_OUTLINE_24;
export const BOOK_24 = BOOK_OUTLINE_24;
export const BOOK = BOOK_OUTLINE_24;
// 24x24/book/filled.svg
export const BOOK_FILLED_24 = {
	d: 'M15.5 9h-7a1.5 1.5 0 010-3h7a1.5 1.5 0 010 3zM17 20H7a1 1 0 110-2h10v2zm3-4V4a2 2 0 00-2-2H7a3 3 0 00-3 3v14a3 3 0 003 3h12a1 1 0 100-2v-2.277c.596-.347 1-.985 1-1.723z',
	size: 24,
};

export const BOOK_FILLED = BOOK_FILLED_24;
// 24x24/external link alt/outline.svg
export const EXTERNAL_LINK_ALT_OUTLINE_24 = {
	d: 'M19 14v2a3 3 0 01-3 3H8a3 3 0 01-3-3V8a3 3 0 013-3h2V3H8a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5v-2h-2zm1-11a1 1 0 011 1v6a1 1 0 11-2 0V6.41l-6.79 6.8a1 1 0 01-1.42 0 1 1 0 010-1.42L17.59 5H14a1 1 0 110-2h6z',
	size: 24,
};

export const EXTERNAL_LINK_ALT_OUTLINE = EXTERNAL_LINK_ALT_OUTLINE_24;
export const EXTERNAL_LINK_ALT_24 = EXTERNAL_LINK_ALT_OUTLINE_24;
export const EXTERNAL_LINK_ALT = EXTERNAL_LINK_ALT_OUTLINE_24;
// 24x24/folder move/outline.svg
export const FOLDER_MOVE_OUTLINE_24 = {
	d: 'M18.777 17.586C19.264 16.119 20 13.902 20 11H4c0 2.902.735 5.119 1.222 6.586l.065.194a.982.982 0 00.724.66c1.182.24 3.088.56 5.99.56 2.9 0 4.806-.32 5.987-.56a.985.985 0 00.725-.66l.064-.194zM20 9c1.336 0 2 .785 2 2 0 3.36-.873 5.849-1.389 7.408a2.969 2.969 0 01-2.224 1.991C17.02 20.678 15 21 12 21c-3 0-5.02-.322-6.388-.601a2.972 2.972 0 01-2.224-1.991C2.872 16.849 2 14.36 2 11c0-1.215.663-2 2-2h16.001zM4.981 5v3h-2V5c0-1.102.916-2 2.02-2h3c1.356 0 2.086 1.122 2.573 2H18c1.755 0 2.981 1.233 2.981 3h-2c0-.663-.33-1-.98-1H9.98a1 1 0 01-.874-.514l-.153-.28C8.694 5.726 8.3 5 8 5H4.981zm7.02 13l5-3-5-3v2H8a1 1 0 100 2h4v2z',
	size: 24,
};

export const FOLDER_MOVE_OUTLINE = FOLDER_MOVE_OUTLINE_24;
export const FOLDER_MOVE_24 = FOLDER_MOVE_OUTLINE_24;
export const FOLDER_MOVE = FOLDER_MOVE_OUTLINE_24;
// 24x24/folder move/filled.svg
export const FOLDER_MOVE_FILLED_24 = {
	d: 'M17 15l-5 3v-2H8a1 1 0 110-2h4v-2l5 3zm5-4c0-1.215-.664-2-2-2H4c-1.336 0-2 .785-2 2 0 3.36.873 5.849 1.389 7.408a2.97 2.97 0 002.223 1.991C6.98 20.678 9 21 12 21s5.02-.322 6.388-.601a2.97 2.97 0 002.223-1.991C21.127 16.849 22 14.36 22 11zM4.98 8h16c0-1.767-1.225-3-2.98-3h-7.426C10.087 4.121 9.357 3 8 3H5c-1.103 0-2.02.897-2.02 2v3h2z',
	size: 24,
};

export const FOLDER_MOVE_FILLED = FOLDER_MOVE_FILLED_24;
// 24x24/emoji activated/outline.svg
export const EMOJI_ACTIVATED_OUTLINE_24 = {
	d: 'M12 13H7c0 2 2.266 4 5 4s5-2 5-4h-5zM8.978 7.647c-.829 0-1.5.839-1.5 1.875s.671 1.875 1.5 1.875c.828 0 1.5-.839 1.5-1.875s-.672-1.875-1.5-1.875zm6 0c-.829 0-1.5.839-1.5 1.875s.671 1.875 1.5 1.875 1.5-.839 1.5-1.875-.671-1.875-1.5-1.875zM12 2c-1.8 0-3.555.192-5.246.559a5.473 5.473 0 00-4.196 4.195A24.776 24.776 0 002 12c0 1.8.192 3.555.558 5.246a5.473 5.473 0 004.196 4.195C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.245-.558a5.472 5.472 0 004.197-4.196c.366-1.69.558-3.445.558-5.246 0-1.8-.192-3.555-.558-5.246a5.472 5.472 0 00-4.196-4.195A24.711 24.711 0 0012 2zm0 2c1.626 0 3.249.173 4.823.513a3.486 3.486 0 012.664 2.664 22.886 22.886 0 010 9.646 3.484 3.484 0 01-2.664 2.664 22.886 22.886 0 01-9.646 0 3.486 3.486 0 01-2.664-2.664A22.82 22.82 0 014 12c0-1.626.172-3.249.513-4.823a3.486 3.486 0 012.664-2.664A22.886 22.886 0 0112 4z',
	size: 24,
};

export const EMOJI_ACTIVATED_OUTLINE = EMOJI_ACTIVATED_OUTLINE_24;
export const EMOJI_ACTIVATED_24 = EMOJI_ACTIVATED_OUTLINE_24;
export const EMOJI_ACTIVATED = EMOJI_ACTIVATED_OUTLINE_24;
// 24x24/emoji activated/filled.svg
export const EMOJI_ACTIVATED_FILLED_24 = {
	d: 'M12 13H7c0 2 2.266 4 5 4s5-2 5-4h-5zm-3.022-1.603c.829 0 1.5-.839 1.5-1.875s-.671-1.875-1.5-1.875-1.5.839-1.5 1.875.671 1.875 1.5 1.875zm6 0c.829 0 1.5-.839 1.5-1.875s-.671-1.875-1.5-1.875-1.5.839-1.5 1.875.671 1.875 1.5 1.875zM12 22c-1.8 0-3.555-.192-5.246-.558a5.476 5.476 0 01-4.196-4.197A24.76 24.76 0 012 12c0-1.8.192-3.555.558-5.245a5.476 5.476 0 014.196-4.197A24.776 24.776 0 0112 2c1.8 0 3.555.192 5.246.558a5.474 5.474 0 014.196 4.197A24.76 24.76 0 0122 12c0 1.801-.192 3.556-.558 5.246a5.472 5.472 0 01-4.197 4.196A24.76 24.76 0 0112 22z',
	size: 24,
};

export const EMOJI_ACTIVATED_FILLED = EMOJI_ACTIVATED_FILLED_24;
// 24x24/pin/outline.svg
export const PIN_OUTLINE_24 = {
	d: 'M9.12 16.467c-.706-1.446-.177-3.134-.172-3.15.12-.36.026-.756-.24-1.024L4.413 8 7 5.414l4.293 4.293c.265.266.66.357 1.02.243.02-.005 1.708-.536 3.154.169L9.12 16.467zM22 21l-7.584-7.002 3.291-3.291a.999.999 0 000-1.414c-1.829-1.83-4.266-1.625-5.4-1.4l-4.6-4.6A1.007 1.007 0 007 3a.987.987 0 00-.707.293l-4 4a.997.997 0 000 1.414l4.6 4.6c-.225 1.135-.428 3.572 1.4 5.4A.993.993 0 009 19a.993.993 0 00.707-.293l3.295-3.295L19 21h3z',
	size: 24,
};

export const PIN_OUTLINE = PIN_OUTLINE_24;
export const PIN_24 = PIN_OUTLINE_24;
export const PIN = PIN_OUTLINE_24;
// 24x24/pin/filled.svg
export const PIN_FILLED_24 = {
	d: 'M22 21l-7.584-7.002 3.291-3.291a.999.999 0 000-1.414c-1.829-1.829-4.266-1.625-5.399-1.399L7.707 3.293A1.007 1.007 0 007 3a.99.99 0 00-.707.293l-4 4a.997.997 0 000 1.414l4.601 4.601c-.226 1.133-.429 3.571 1.399 5.399a.997.997 0 001.414 0l3.295-3.295L19 21h3z',
	size: 24,
};

export const PIN_FILLED = PIN_FILLED_24;
// 24x24/github/filled.svg
export const GITHUB_FILLED_24 = {
	d: 'M12 2C6.478 2 2 6.478 2 12c0 4.686 3.227 8.606 7.576 9.691a1.473 1.473 0 01-.076-.485v-1.71H8.243c-.684 0-1.293-.294-1.588-.84-.327-.608-.384-1.537-1.195-2.105-.24-.19-.058-.405.22-.376.512.144.937.497 1.338 1.018.398.523.586.641 1.33.641.36 0 .9-.02 1.41-.1.272-.695.744-1.335 1.322-1.636-3.33-.342-4.92-1.999-4.92-4.248 0-.968.413-1.906 1.114-2.695-.23-.783-.519-2.38.088-2.989 1.498 0 2.405.972 2.622 1.234a7.514 7.514 0 012.428-.4c.863 0 1.687.145 2.436.402.215-.26 1.121-1.236 2.623-1.236.61.61.317 2.214.085 2.995.696.788 1.106 1.722 1.106 2.69 0 2.247-1.587 3.902-4.91 4.247.914.477 1.581 1.818 1.581 2.83v2.278c0 .086-.019.148-.029.223C19.2 20.063 22 16.363 22 12c0-5.522-4.478-10-10-10z',
	size: 24,
};

export const GITHUB_FILLED = GITHUB_FILLED_24;
// 24x24/refresh/outline.svg
export const REFRESH_OUTLINE_24 = {
	d: 'M21 10V2l-3.082 3.082a5.203 5.203 0 00-1.944-.873 20.309 20.309 0 00-8.517 0 5.238 5.238 0 00-4.004 4.004A20.15 20.15 0 003 12.471c0 1.435.152 2.869.453 4.258a5.237 5.237 0 004.003 4.004 20.167 20.167 0 008.517 0 5.237 5.237 0 004.005-4.004 1 1 0 00-1.956-.421 3.229 3.229 0 01-2.472 2.47c-2.5.54-5.167.541-7.671 0a3.23 3.23 0 01-2.471-2.471 18.219 18.219 0 010-7.672A3.231 3.231 0 017.88 6.164a18.336 18.336 0 017.672 0c.33.071.639.196.924.36L13 10h8z',
	size: 24,
};

export const REFRESH_OUTLINE = REFRESH_OUTLINE_24;
export const REFRESH_24 = REFRESH_OUTLINE_24;
export const REFRESH = REFRESH_OUTLINE_24;
// 24x24/slack/filled.svg
export const SLACK_FILLED_24 = {
	d: 'M12.435 17.652v2.174a2.174 2.174 0 102.174-2.174h-2.174zm2.174-5.218a2.174 2.174 0 100 4.348h5.218a2.173 2.173 0 000-4.348h-5.218zm-5.218 0c-1.2 0-2.174.974-2.174 2.175v5.217a2.175 2.175 0 004.349 0v-5.218a2.174 2.174 0 00-2.175-2.174zm-5.217 0a2.174 2.174 0 102.174 2.175v-2.175H4.174zm15.653-5.218a2.174 2.174 0 00-2.174 2.174v2.175h2.174a2.174 2.174 0 000-4.349zm-15.653 0a2.174 2.174 0 000 4.35H9.39a2.175 2.175 0 000-4.35H4.174zM14.609 2a2.173 2.173 0 00-2.174 2.173V9.39a2.174 2.174 0 104.348 0V4.173A2.173 2.173 0 0014.609 2zM9.39 2a2.173 2.173 0 100 4.347h2.175V4.173A2.174 2.174 0 009.39 2z',
	size: 24,
};

export const SLACK_FILLED = SLACK_FILLED_24;
// 24x24/mail alt1/outline.svg
export const MAIL_ALT1_OUTLINE_24 = {
	d: 'M19 18H5a1 1 0 01-1-1v-6.461l8 3.556 8-3.556V17a1 1 0 01-1 1zM5 7h14a1 1 0 011 1v.35l-8 3.555L4 8.35V8a1 1 0 011-1zm14-2H5a3 3 0 00-3 3v9a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3z',
	size: 24,
};

export const MAIL_ALT1_OUTLINE = MAIL_ALT1_OUTLINE_24;
export const MAIL_ALT1_24 = MAIL_ALT1_OUTLINE_24;
export const MAIL_ALT1 = MAIL_ALT1_OUTLINE_24;
// 24x24/mail alt1/filled.svg
export const MAIL_ALT1_FILLED_24 = {
	d: 'M12 14.099L2 9.553V17a3 3 0 003 3h14a3 3 0 003-3V9.553l-10 4.546zM2.064 7.386A3.001 3.001 0 015 5h14a3.001 3.001 0 012.936 2.386L12 11.902 2.064 7.386z',
	size: 24,
};

export const MAIL_ALT1_FILLED = MAIL_ALT1_FILLED_24;
// 24x24/poi/outline.svg
export const POI_OUTLINE_24 = {
	d: 'M12 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-8a5 5 0 00-5 5 5 5 0 005 5 5 5 0 005-5 5 5 0 00-5-5zm-.002 15.245C9.598 17.821 6 13.448 6 10c0-3.309 2.691-6 6-6s6 2.691 6 6c0 3.437-3.601 7.816-6.002 10.245zM12 2a8 8 0 00-8 8c0 6 8 13 8 13s8-7 8-13a8 8 0 00-8-8z',
	size: 24,
};

export const POI_OUTLINE = POI_OUTLINE_24;
export const POI_24 = POI_OUTLINE_24;
export const POI = POI_OUTLINE_24;
// 24x24/poi/filled.svg
export const POI_FILLED_24 = {
	d: 'M12 15a5 5 0 110-10 5 5 0 010 10zm0-13a8 8 0 00-8 8c0 6 8 13 8 13s8-7 8-13a8 8 0 00-8-8z',
	size: 24,
};

export const POI_FILLED = POI_FILLED_24;
// 24x24/mail paper/outline.svg
export const MAIL_PAPER_OUTLINE_24 = {
	d: 'M17.121 18.614a3.033 3.033 0 001.448-.657l-4.272-4.43L12 15.25l-2.297-1.723-4.272 4.43c.408.334.9.57 1.447.657 3.222.512 7.022.512 10.243 0zM4.368 16.177l3.722-3.86-3.928-2.946A24.386 24.386 0 004 12.001c0 1.36.12 2.748.355 4.13.003.015.01.031.013.046zM7 4v5l5 3.75L17 9V4H7zm8.91 8.317l3.722 3.86c.003-.016.01-.032.012-.048A24.57 24.57 0 0020 12c0-.867-.066-1.747-.162-2.629l-3.928 2.946zm5.706-4.783A26.56 26.56 0 0122 12c0 1.472-.129 2.975-.384 4.466a5.037 5.037 0 01-4.18 4.123A34.827 34.827 0 0112 21a34.84 34.84 0 01-5.436-.41 5.037 5.037 0 01-4.18-4.123A26.598 26.598 0 012 12c0-1.473.13-2.976.384-4.466a.999.999 0 01.447-.675l2.17-1.385V3a1 1 0 011-1h12a1 1 0 011 1v2.437l2.178 1.43a1 1 0 01.437.667z',
	size: 24,
};

export const MAIL_PAPER_OUTLINE = MAIL_PAPER_OUTLINE_24;
export const MAIL_PAPER_24 = MAIL_PAPER_OUTLINE_24;
export const MAIL_PAPER = MAIL_PAPER_OUTLINE_24;
// 24x24/device mobil/outline.svg
export const DEVICE_MOBIL_OUTLINE_24 = {
	d: 'M12.6 18h-1.2a.4.4 0 01-.4-.4v-1.2a.4.4 0 01.4-.4h1.2a.4.4 0 01.4.4v1.2a.4.4 0 01-.4.4zM8 20h8V4H8v16zm8-18H8a2 2 0 00-2 2v16a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2z',
	size: 24,
};

export const DEVICE_MOBIL_OUTLINE = DEVICE_MOBIL_OUTLINE_24;
export const DEVICE_MOBIL_24 = DEVICE_MOBIL_OUTLINE_24;
export const DEVICE_MOBIL = DEVICE_MOBIL_OUTLINE_24;
// 24x24/mail check/outline.svg
export const MAIL_CHECK_OUTLINE_24 = {
	d: 'M17 22a.997.997 0 00.707-.293l4-4a.999.999 0 10-1.414-1.414L17 19.586l-1.293-1.293a.999.999 0 10-1.414 1.414l2 2A.997.997 0 0017 22zm2.4-14.8c.01-.007.022-.008.032-.014a3.036 3.036 0 00-2.31-1.8 32.997 32.997 0 00-5.161-.385 32.942 32.942 0 00-5.16.397c-1.009.165-1.838.852-2.235 1.786.011.007.024.008.034.016l7.4 5.55 7.4-5.55zM4.368 16.178l3.722-3.861-3.927-2.945A24.103 24.103 0 004 12c0 1.36.12 2.749.355 4.13.003.016.01.032.013.048zm17.248-8.645A26.58 26.58 0 0122 12c0 .661-.035 1.33-.087 2h-2c.056-.67.087-1.339.087-2 0-.867-.066-1.747-.163-2.628L12 15.25l-2.297-1.723-4.272 4.43c.408.334.9.57 1.447.657 1.615.257 3.368.377 5.122.37V21a34.84 34.84 0 01-5.436-.411 5.037 5.037 0 01-4.18-4.122A26.58 26.58 0 012 12c0-1.473.129-2.976.384-4.466.362-2.12 2.009-3.771 4.097-4.11A34.95 34.95 0 0112 3c1.861 0 3.72.139 5.436.411a5.037 5.037 0 014.18 4.122z',
	size: 24,
};

export const MAIL_CHECK_OUTLINE = MAIL_CHECK_OUTLINE_24;
export const MAIL_CHECK_24 = MAIL_CHECK_OUTLINE_24;
export const MAIL_CHECK = MAIL_CHECK_OUTLINE_24;
// 24x24/favorite/outline.svg
export const FAVORITE_OUTLINE_24 = {
	d: 'M16.5 4A5.49 5.49 0 0012 6.344 5.49 5.49 0 007.5 4 5.5 5.5 0 002 9.5c0 .223.017.44.043.655C2.475 14.613 7.232 18.14 12 21c4.768-2.86 9.525-6.387 9.957-10.845.026-.215.043-.432.043-.655A5.5 5.5 0 0016.5 4zm0 2C18.43 6 20 7.57 20 9.5c0 .12-.01.258-.033.463-.328 3.38-4.239 6.371-7.967 8.693-3.728-2.322-7.639-5.316-7.972-8.737A3.842 3.842 0 014 9.5C4 7.57 5.57 6 7.5 6 10 6 12 9 12 9s2-3 4.5-3z',
	size: 24,
};

export const FAVORITE_OUTLINE = FAVORITE_OUTLINE_24;
export const FAVORITE_24 = FAVORITE_OUTLINE_24;
export const FAVORITE = FAVORITE_OUTLINE_24;
// 24x24/favorite/filled.svg
export const FAVORITE_FILLED_24 = {
	d: 'M16.5 4A5.49 5.49 0 0012 6.344 5.49 5.49 0 007.5 4 5.5 5.5 0 002 9.5c0 .223.017.44.043.655C2.475 14.613 7.232 18.14 12 21c4.768-2.86 9.525-6.387 9.957-10.845.026-.215.043-.432.043-.655A5.5 5.5 0 0016.5 4z',
	size: 24,
};

export const FAVORITE_FILLED = FAVORITE_FILLED_24;
// 24x24/microphone/outline.svg
export const MICROPHONE_OUTLINE_24 = {
	d: 'M11 12a1 1 0 002 0V5a1 1 0 00-2 0v7zm-2 0V5a3 3 0 116 0v7a3 3 0 11-6 0zm4 6.92V20h2a1 1 0 110 2H9a1 1 0 110-2h2v-1.08c-3.387-.488-6-3.401-6-6.92a1 1 0 112 0c0 2.757 2.243 5 5 5s5-2.243 5-5a1 1 0 112 0c0 3.519-2.613 6.432-6 6.92z',
	size: 24,
};

export const MICROPHONE_OUTLINE = MICROPHONE_OUTLINE_24;
export const MICROPHONE_24 = MICROPHONE_OUTLINE_24;
export const MICROPHONE = MICROPHONE_OUTLINE_24;
// 24x24/microphone/filled.svg
export const MICROPHONE_FILLED_24 = {
	d: 'M9 12V5a3 3 0 116 0v7a3 3 0 11-6 0zm4 6.92V20h2a1 1 0 110 2H9a1 1 0 110-2h2v-1.08c-3.387-.488-6-3.401-6-6.92a1 1 0 112 0c0 2.757 2.243 5 5 5s5-2.243 5-5a1 1 0 112 0c0 3.519-2.613 6.432-6 6.92z',
	size: 24,
};

export const MICROPHONE_FILLED = MICROPHONE_FILLED_24;
// 24x24/calendar/filled.svg
export const CALENDAR_FILLED_24 = {
	d: 'M7.617 12.621a1.418 1.418 0 11.001-2.837 1.418 1.418 0 010 2.837zM12 9.784a1.418 1.418 0 110 2.836 1.418 1.418 0 010-2.836zm0 4.473a1.418 1.418 0 110 2.837 1.418 1.418 0 010-2.837zm4.383-4.473a1.418 1.418 0 110 2.836 1.418 1.418 0 010-2.836zm0 4.473a1.418 1.418 0 110 2.837 1.418 1.418 0 010-2.837zM12 19.847c-1.15 0-2.136-.042-2.985-.146V16.54a2.281 2.281 0 00-2.282-2.282H4.226A30.165 30.165 0 014.153 12c0-1.634.082-2.942.31-3.983h15.075c.226 1.041.308 2.35.308 3.983 0 6.527-1.319 7.847-7.846 7.847zM2 12c0 .822.02 1.572.076 2.257.113 1.42 1.104 2.62 2.463 4.294 1.358 1.674 2.852 3.137 4.497 3.308.868.09 1.85.141 2.964.141 4.107 0 6.393-.61 7.891-2.108 1.497-1.499 2.11-3.785 2.11-7.892 0-4.108-.613-6.394-2.11-7.892-.737-.736-1.668-1.257-2.91-1.597a.207.207 0 00-.26.201v1.34c0 .583-.426 1.104-1.007 1.16A1.118 1.118 0 0114.487 4.1V2.48a.416.416 0 00-.387-.414A30.77 30.77 0 0012 2c-.762 0-1.458.022-2.1.066a.415.415 0 00-.387.413v1.573c0 .583-.426 1.104-1.007 1.16A1.118 1.118 0 017.278 4.1V2.712a.207.207 0 00-.26-.2c-1.242.34-2.172.86-2.91 1.596C2.611 5.606 2 7.892 2 12z',
	size: 24,
};

export const CALENDAR_FILLED = CALENDAR_FILLED_24;
// 24x24/mail unread/outline.svg
export const MAIL_UNREAD_OUTLINE_24 = {
	d: 'M19 4a3 3 0 110 6 3 3 0 010-6zm-1.879 14.614c-3.221.512-7.021.512-10.243 0a3.034 3.034 0 01-1.447-.657l4.272-4.43L12 15.25l2.297-1.723 4.272 4.43c-.408.334-.9.57-1.448.657zM4.355 16.13A24.694 24.694 0 014 12c0-.867.066-1.747.163-2.628l3.927 2.945-3.722 3.861c-.003-.016-.01-.032-.013-.048zm15.642-4.231c0 .034.003.068.003.101 0 1.36-.12 2.749-.355 4.129-.003.017-.01.032-.013.049l-3.722-3.861 1.029-.772a5 5 0 01-1.67-1.246L12 12.75 4.6 7.2c-.011-.008-.023-.009-.034-.016.397-.934 1.226-1.622 2.236-1.786C8.418 5.136 10.23 5.002 12 5c.806-.001 1.6.033 2.383.087a4.974 4.974 0 011.381-1.869A36.071 36.071 0 0012 3c-1.892 0-3.783.143-5.518.424-2.089.338-3.736 1.99-4.098 4.109A26.58 26.58 0 002 12c0 1.473.129 2.976.384 4.467a5.037 5.037 0 004.18 4.122A34.84 34.84 0 0012 21c1.893 0 3.721-.139 5.435-.411a5.037 5.037 0 004.181-4.123A26.56 26.56 0 0022 12c0-.326-.03-.658-.043-.987a4.947 4.947 0 01-1.96.886z',
	size: 24,
};

export const MAIL_UNREAD_OUTLINE = MAIL_UNREAD_OUTLINE_24;
export const MAIL_UNREAD_24 = MAIL_UNREAD_OUTLINE_24;
export const MAIL_UNREAD = MAIL_UNREAD_OUTLINE_24;
// 24x24/mail unread/filled.svg
export const MAIL_UNREAD_FILLED_24 = {
	d: 'M19 12a4.996 4.996 0 01-1.871-.369l-1.121.785 5.186 5.348c.193-.407.343-.838.421-1.297.256-1.49.385-2.992.385-4.467 0-.328-.025-.659-.041-.989A4.955 4.955 0 0119 12zm-7 3.221l-2.348-1.644-5.628 5.803a5.03 5.03 0 002.54 1.209C8.279 20.861 10.108 21 12 21s3.721-.139 5.436-.411a5.03 5.03 0 002.54-1.209l-5.628-5.803L12 15.221zm-9.729-6.81A26.444 26.444 0 002 12c0 1.475.129 2.977.385 4.466.078.459.228.89.421 1.298l5.186-5.348-5.721-4.005zm13.098 2.01A4.976 4.976 0 0114 7c0-1.521.693-2.866 1.765-3.783A35.338 35.338 0 0012 3c-1.876.002-3.797.145-5.519.424-1.666.27-3.037 1.382-3.712 2.893L12 12.779l3.369-2.358zM19 4a3 3 0 110 6 3 3 0 010-6z',
	size: 24,
};

export const MAIL_UNREAD_FILLED = MAIL_UNREAD_FILLED_24;
// 24x24/wallet/outline.svg
export const WALLET_OUTLINE_24 = {
	d: 'M18 13a2 2 0 11-4.001-.001A2 2 0 0118 13zm2 6H5a1 1 0 01-1-1V8a1 1 0 011-1h15v12zm0-14V3a1 1 0 00-1.21-.978S6.161 4.71 4.802 5.02C3.008 5.43 2 6.411 2 8v10a3 3 0 003 3h15a2 2 0 002-2V7a2 2 0 00-2-2z',
	size: 24,
};

export const WALLET_OUTLINE = WALLET_OUTLINE_24;
export const WALLET_24 = WALLET_OUTLINE_24;
export const WALLET = WALLET_OUTLINE_24;
// 24x24/wallet/filled.svg
export const WALLET_FILLED_24 = {
	d: 'M19.629 2.223a.985.985 0 00-.84-.2M16 15a2 2 0 110-4 2 2 0 010 4zm4-9h-6.5a.5.5 0 110-1H20V3a1.001 1.001 0 00-1.21-.977S6.162 4.71 4.803 5.02C3.008 5.43 2 6.41 2 8v10a3 3 0 003 3h15a2 2 0 002-2V8a2 2 0 00-2-2z',
	size: 24,
};

export const WALLET_FILLED = WALLET_FILLED_24;
// 24x24/volume mute/outline.svg
export const VOLUME_MUTE_OUTLINE_24 = {
	d: 'M13 5v14c0 .6-.5 1-1 1-.2 0-.4-.1-.6-.2L6 16H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2l5.4-3.8c.2-.1.4-.2.6-.2.5 0 1 .4 1 1zm-2 1.9L7.2 9.6l-.6.4H4v4h2.6l.5.4 3.9 2.7V6.9zm10.8 7.5c.4.4.3 1.1-.1 1.4-.2.1-.5.2-.7.2-.3 0-.6-.1-.8-.4l-1.7-2.1-1.7 2.1c-.2.3-.5.4-.8.4-.2 0-.5-.1-.6-.2-.4-.4-.5-1-.1-1.4l2-2.4-2-2.4c-.4-.4-.3-1.1.1-1.4.1-.1.4-.2.6-.2.3 0 .6.1.8.4l1.7 2.1 1.7-2.1c.2-.3.5-.4.8-.4.2 0 .5.1.6.2.4.4.5 1 .1 1.4l-2 2.4 2.1 2.4z',
	size: 24,
};

export const VOLUME_MUTE_OUTLINE = VOLUME_MUTE_OUTLINE_24;
export const VOLUME_MUTE_24 = VOLUME_MUTE_OUTLINE_24;
export const VOLUME_MUTE = VOLUME_MUTE_OUTLINE_24;
// 24x24/volume mute/filled.svg
export const VOLUME_MUTE_FILLED_24 = {
	d: 'M21.8 14.4c.4.4.3 1.1-.1 1.4-.2.1-.5.2-.7.2-.3 0-.6-.1-.8-.4l-1.7-2.1-1.7 2.1c-.2.3-.5.4-.8.4-.2 0-.5-.1-.6-.2-.4-.4-.5-1-.1-1.4l2-2.4-2-2.4c-.4-.4-.3-1.1.1-1.4.1-.1.4-.2.6-.2.3 0 .6.1.8.4l1.7 2.1 1.7-2.1c.2-.3.5-.4.8-.4.2 0 .5.1.6.2.4.4.5 1 .1 1.4l-2 2.4 2.1 2.4zM12 4c-.2 0-.4.1-.6.2L6 8H4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2l5.4 3.8c.2.1.4.2.6.2.5 0 1-.4 1-1V5c0-.6-.5-1-1-1z',
	size: 24,
};

export const VOLUME_MUTE_FILLED = VOLUME_MUTE_FILLED_24;
// 24x24/cloud arrow right/outline.svg
export const CLOUD_ARROW_RIGHT_OUTLINE_24 = {
	d: 'M18 9.027V9c0-3.309-2.691-6-6-6-2.106 0-4.06.95-5.227 2.541-.906 1.235-1.257 2.772-1.03 4.425-.876.093-1.671.421-2.313.966A4.078 4.078 0 002 14c0 .684.176 1.36.509 1.953l1.744-.98A1.979 1.979 0 014 14c0-.58.271-1.158.725-1.543.528-.448 1.258-.61 2.113-.47A1 1 0 007.954 10.7c-.488-1.55-.339-2.926.432-3.977C9.166 5.66 10.551 5 12 5c2.206 0 4 1.794 4 4 0 .09-.024.187-.031.28a4.51 4.51 0 00-2.365 1.968.998.998 0 00.864 1.501 1 1 0 00.866-.499 2.502 2.502 0 014.437 2.298C19.7 14.698 19.05 16 17.782 16h-6l2 2h4c1.9 0 3.233-1.4 3.797-2.599a4.423 4.423 0 00.421-1.9 4.507 4.507 0 00-4-4.474zM7 14l5 4-5 4v-3H3v-2h4v-3z',
	size: 24,
};

export const CLOUD_ARROW_RIGHT_OUTLINE = CLOUD_ARROW_RIGHT_OUTLINE_24;
export const CLOUD_ARROW_RIGHT_24 = CLOUD_ARROW_RIGHT_OUTLINE_24;
export const CLOUD_ARROW_RIGHT = CLOUD_ARROW_RIGHT_OUTLINE_24;
// 24x24/save/filled.svg
export const SAVE_FILLED_24 = {
	d: 'M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM5 9h10V5H5v4z',
	size: 24,
};

export const SAVE_FILLED = SAVE_FILLED_24;
// 24x24/facebook/filled.svg
export const FACEBOOK_FILLED_24 = {
	d: 'M12 2C6.478 2 2 6.501 2 12.052c0 5.039 3.693 9.2 8.505 9.927v-7.264H8.031v-2.642h2.474v-1.758c0-2.911 1.411-4.188 3.817-4.188 1.153 0 1.763.086 2.051.125v2.306h-1.642c-1.021 0-1.377.974-1.377 2.071v1.444h2.994l-.407 2.642h-2.587V22c4.88-.665 8.646-4.86 8.646-9.948C22 6.501 17.522 2 12 2z',
	size: 24,
};

export const FACEBOOK_FILLED = FACEBOOK_FILLED_24;
// 24x24/volume down/outline.svg
export const VOLUME_DOWN_OUTLINE_24 = {
	d: 'M14 4c-.2 0-.4.1-.6.2L8 8H6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2l5.4 3.8c.2.1.4.2.6.2.5 0 1-.4 1-1V5c0-.6-.5-1-1-1zm-1 13.1l-3.8-2.7-.6-.4H6v-4h2.6l.5-.4L13 6.9v10.2zM19 9v6c0 .6-.4 1-1 1s-1-.4-1-1V9c0-.6.4-1 1-1s1 .4 1 1z',
	size: 24,
};

export const VOLUME_DOWN_OUTLINE = VOLUME_DOWN_OUTLINE_24;
export const VOLUME_DOWN_24 = VOLUME_DOWN_OUTLINE_24;
export const VOLUME_DOWN = VOLUME_DOWN_OUTLINE_24;
// 24x24/volume down/filled.svg
export const VOLUME_DOWN_FILLED_24 = {
	d: 'M15 5v14c0 .6-.5 1-1 1-.2 0-.4-.1-.6-.2L8 16H6c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2l5.4-3.8c.2-.1.4-.2.6-.2.5 0 1 .4 1 1zm3 3c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1s1-.4 1-1V9c0-.6-.4-1-1-1z',
	size: 24,
};

export const VOLUME_DOWN_FILLED = VOLUME_DOWN_FILLED_24;
// 24x24/renew vertical/outline.svg
export const RENEW_VERTICAL_OUTLINE_24 = {
	d: 'M12 18h-2c-1.654 0-3-1.346-3-3V9h3L6 3 2 9h3v6c0 2.757 2.243 5 5 5h2a1 1 0 100-2zm7-3h3l-4 6-4-6h3V9c0-1.654-1.346-3-3-3h-2a1 1 0 110-2h2c2.757 0 5 2.243 5 5v6z',
	size: 24,
};

export const RENEW_VERTICAL_OUTLINE = RENEW_VERTICAL_OUTLINE_24;
export const RENEW_VERTICAL_24 = RENEW_VERTICAL_OUTLINE_24;
export const RENEW_VERTICAL = RENEW_VERTICAL_OUTLINE_24;
// 24x24/menu rubik/outline.svg
export const MENU_RUBIK_OUTLINE_24 = {
	d: 'M7.888 7.05a1.09 1.09 0 01-.839.838 4.963 4.963 0 01-2.098 0 1.095 1.095 0 01-.84-.839 4.96 4.96 0 010-2.098c.092-.42.42-.748.84-.84a4.96 4.96 0 012.098 0c.42.092.749.42.84.84a4.96 4.96 0 010 2.098zm-.839 6.839c.42-.091.749-.42.84-.84a4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.961 4.961 0 00-2.098 0 1.1 1.1 0 00-.84.84 4.96 4.96 0 000 2.098c.092.42.42.748.84.84a4.96 4.96 0 002.098 0zm0 6c.42-.091.749-.42.84-.84a4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.961 4.961 0 00-2.098 0 1.1 1.1 0 00-.84.84 4.96 4.96 0 000 2.098c.092.42.42.748.84.84a4.96 4.96 0 002.098 0zm6.84-.84c-.091.42-.42.749-.84.84a4.967 4.967 0 01-2.098 0 1.095 1.095 0 01-.84-.84 4.96 4.96 0 010-2.098 1.1 1.1 0 01.84-.84 4.96 4.96 0 012.098 0c.42.091.748.42.84.84a4.96 4.96 0 010 2.098zm-.84-5.16a1.1 1.1 0 00.84-.84 4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.962 4.962 0 00-2.098 0 1.1 1.1 0 00-.84.84 4.96 4.96 0 000 2.098c.091.42.42.748.84.84a4.96 4.96 0 002.098 0zm6.84 5.16c-.091.42-.42.749-.84.84a4.967 4.967 0 01-2.098 0 1.095 1.095 0 01-.84-.84 4.96 4.96 0 010-2.098 1.1 1.1 0 01.84-.84 4.96 4.96 0 012.098 0c.42.091.748.42.84.84a4.96 4.96 0 010 2.098zm-.84-5.16a1.1 1.1 0 00.84-.84 4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.962 4.962 0 00-2.098 0 1.1 1.1 0 00-.84.84 4.96 4.96 0 000 2.098c.091.42.42.748.84.84a4.96 4.96 0 002.098 0zm-6-6a1.1 1.1 0 00.84-.84 4.96 4.96 0 000-2.098 1.095 1.095 0 00-.84-.84 4.962 4.962 0 00-2.098 0c-.42.092-.748.42-.84.84a4.96 4.96 0 000 2.098c.091.42.42.748.84.84a4.957 4.957 0 002.098 0zm6.84-.84c-.091.42-.42.749-.84.84a4.963 4.963 0 01-2.098 0 1.095 1.095 0 01-.84-.84 4.96 4.96 0 010-2.098 1.1 1.1 0 01.84-.84 4.96 4.96 0 012.098 0c.42.092.748.42.84.84a4.96 4.96 0 010 2.098z',
	size: 24,
};

export const MENU_RUBIK_OUTLINE = MENU_RUBIK_OUTLINE_24;
export const MENU_RUBIK_24 = MENU_RUBIK_OUTLINE_24;
export const MENU_RUBIK = MENU_RUBIK_OUTLINE_24;
// 24x24/chevron down/outline.svg
export const CHEVRON_DOWN_OUTLINE_24 = {
	d: 'M12 14.586L5.707 8.293a.997.997 0 00-1.414 0A1.006 1.006 0 004 9a.989.989 0 00.293.707l7 7a.997.997 0 001.414 0l7-7a.997.997 0 000-1.414A1.006 1.006 0 0019 8a.989.989 0 00-.707.293L12 14.586z',
	size: 24,
};

export const CHEVRON_DOWN_OUTLINE = CHEVRON_DOWN_OUTLINE_24;
export const CHEVRON_DOWN_24 = CHEVRON_DOWN_OUTLINE_24;
export const CHEVRON_DOWN = CHEVRON_DOWN_OUTLINE_24;
// 24x24/chevron down/filled.svg
export const CHEVRON_DOWN_FILLED_24 = {
	d: 'M5 8a.997.997 0 00-1 1 .989.989 0 00.293.707l7 7a.997.997 0 001.414 0l7-7a.997.997 0 000-1.414A.997.997 0 0019 8H5z',
	size: 24,
};

export const CHEVRON_DOWN_FILLED = CHEVRON_DOWN_FILLED_24;
// 24x24/label/outline.svg
export const LABEL_OUTLINE_24 = {
	d: 'M18 9a2 2 0 10-4.001.001A2 2 0 0018 9zM4.414 14L11 20.586l9-9V5h-6.586l-9 9zM11 23a.997.997 0 01-.707-.293l-8-8a.999.999 0 010-1.414l10-10A.996.996 0 0113 3h8a1 1 0 011 1v8c0 .266-.105.52-.293.707l-10 10A.997.997 0 0111 23z',
	size: 24,
};

export const LABEL_OUTLINE = LABEL_OUTLINE_24;
export const LABEL_24 = LABEL_OUTLINE_24;
export const LABEL = LABEL_OUTLINE_24;
// 24x24/label/filled.svg
export const LABEL_FILLED_24 = {
	d: 'M16 11a2 2 0 11.001-4.001A2 2 0 0116 11zm5-8h-8a.996.996 0 00-.707.293l-10 10A1.006 1.006 0 002 14a.989.989 0 00.293.707l8 8a.997.997 0 001.414 0l10-10A.996.996 0 0022 12V4a1 1 0 00-1-1z',
	size: 24,
};

export const LABEL_FILLED = LABEL_FILLED_24;
// 24x24/warning/outline.svg
export const WARNING_OUTLINE_24 = {
	d: 'M13 17a1 1 0 11-2 0 1 1 0 012 0zm-1-7a1 1 0 011 1v4h-2v-4a1 1 0 011-1zm-7.29 9L12 6.04 19.29 19H4.71zm17.162.51l-9-16A.953.953 0 0012 3a.953.953 0 00-.872.51l-9 16A.946.946 0 002 20a.999.999 0 001 1h18a.999.999 0 00.872-1.49z',
	size: 24,
};

export const WARNING_OUTLINE = WARNING_OUTLINE_24;
export const WARNING_24 = WARNING_OUTLINE_24;
export const WARNING = WARNING_OUTLINE_24;
// 24x24/warning/filled.svg
export const WARNING_FILLED_24 = {
	d: 'M13 15h-2v-4a1 1 0 112 0v4zm-1 3a1 1 0 110-2 1 1 0 110 2zm9.871 1.51l-9-16a.944.944 0 00-.87-.51.944.944 0 00-.872.51l-9 16a.994.994 0 00.008.995A.999.999 0 003 21h18a.999.999 0 00.871-1.49z',
	size: 24,
};

export const WARNING_FILLED = WARNING_FILLED_24;
// 24x24/copy to clipboard alt1/outline.svg
export const COPY_TO_CLIPBOARD_ALT1_OUTLINE_24 = {
	d: 'M19 2H8a1 1 0 00-1 1v3H4a1 1 0 00-1 1v14a1 1 0 001 1h11a1 1 0 001-1v-3h3a1 1 0 001-1V3a1 1 0 00-1-1zm-5 18H5V8h9v12zm4-4h-2V7a1 1 0 00-1-1H9V4h9v12zM7.29 14.71a1 1 0 010-1.42l2.5-2.5L8 9h5v5l-1.79-1.79-2.5 2.5a1 1 0 01-1.42 0z',
	size: 24,
};

export const COPY_TO_CLIPBOARD_ALT1_OUTLINE = COPY_TO_CLIPBOARD_ALT1_OUTLINE_24;
export const COPY_TO_CLIPBOARD_ALT1_24 = COPY_TO_CLIPBOARD_ALT1_OUTLINE_24;
export const COPY_TO_CLIPBOARD_ALT1 = COPY_TO_CLIPBOARD_ALT1_OUTLINE_24;
// 24x24/qr code/outline.svg
export const QR_CODE_OUTLINE_24 = {
	d: 'M21 3v2h-5v6h5v10H11v-4H7v2H5v-2H3V7h2v4h4.001V6H14V3h7zM5 19v2H3v-2h2zm14-6h-6v6h6v-6zm-1.999 1.999V17H15v-2.001h2.001zM11 11H9.001v2H7v2h4v-4zm3-3h-3v3h3V8zm6.001-1.001V9h-2V6.999h2zM7 5v2H5V5h2zm4.001-2v2h-2V3h2zM5 3v2H3V3h2z',
	size: 24,
};

export const QR_CODE_OUTLINE = QR_CODE_OUTLINE_24;
export const QR_CODE_24 = QR_CODE_OUTLINE_24;
export const QR_CODE = QR_CODE_OUTLINE_24;
// 24x24/info squircle/outline.svg
export const INFO_SQUIRCLE_OUTLINE_24 = {
	d: 'M11 17h2v-6h-2v6zm2.5-8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113.5 8.5zm5.987 8.323a3.487 3.487 0 01-2.664 2.664 22.893 22.893 0 01-9.646 0 3.486 3.486 0 01-2.664-2.664 22.886 22.886 0 010-9.646 3.484 3.484 0 012.664-2.664 22.886 22.886 0 019.646 0 3.487 3.487 0 012.664 2.664 22.893 22.893 0 010 9.646zm1.954-10.069a5.47 5.47 0 00-4.195-4.195A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.47 5.47 0 004.195-4.196C21.808 15.555 22 13.8 22 12c0-1.8-.192-3.555-.559-5.246z',
	size: 24,
};

export const INFO_SQUIRCLE_OUTLINE = INFO_SQUIRCLE_OUTLINE_24;
export const INFO_SQUIRCLE_24 = INFO_SQUIRCLE_OUTLINE_24;
export const INFO_SQUIRCLE = INFO_SQUIRCLE_OUTLINE_24;
// 24x24/info squircle/filled.svg
export const INFO_SQUIRCLE_FILLED_24 = {
	d: 'M12 10a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112 10zm-1 7h2v-6h-2v6zM21.441 6.754a5.47 5.47 0 00-4.195-4.195A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.47 5.47 0 004.195-4.196C21.808 15.555 22 13.8 22 12c0-1.8-.192-3.555-.559-5.246z',
	size: 24,
};

export const INFO_SQUIRCLE_FILLED = INFO_SQUIRCLE_FILLED_24;
// 24x24/file document/outline.svg
export const FILE_DOCUMENT_OUTLINE_24 = {
	d: 'M11 17v-5h10v5H11zm7 .998V19c0 .552-.449 1-1 1H7c-.551 0-1-.448-1-1V5c0-.552.449-1 1-1h6v5h5v2h2V7.586L14.414 2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1.002h-2z',
	size: 24,
};

export const FILE_DOCUMENT_OUTLINE = FILE_DOCUMENT_OUTLINE_24;
export const FILE_DOCUMENT_24 = FILE_DOCUMENT_OUTLINE_24;
export const FILE_DOCUMENT = FILE_DOCUMENT_OUTLINE_24;
// 24x24/file document/filled.svg
export const FILE_DOCUMENT_FILLED_24 = {
	d: 'M19 12v4.998L10 17v-5h9zm2-2h-1V9h-7V2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3h1v-9zm-1.586-2L14 2.586V8h5.414z',
	size: 24,
};

export const FILE_DOCUMENT_FILLED = FILE_DOCUMENT_FILLED_24;
// 24x24/notifications/outline.svg
export const NOTIFICATIONS_OUTLINE_24 = {
	d: 'M12 20h2a2 2 0 01-4 0h2zM8 8c0-2.935 2.393-4 4-4 1.607 0 4 1.065 4 4 0 3.696 1.01 6.135 2.006 7.642C16.754 16.293 14.76 17 12 17c-2.762 0-4.757-.708-6.007-1.357C6.989 14.136 8 11.696 8 8zm13 8s-3-2-3-8c0-4-3.238-6-6-6S6 4 6 8c0 6-3 8-3 8s3 3 9 3 9-3 9-3z',
	size: 24,
};

export const NOTIFICATIONS_OUTLINE = NOTIFICATIONS_OUTLINE_24;
export const NOTIFICATIONS_24 = NOTIFICATIONS_OUTLINE_24;
export const NOTIFICATIONS = NOTIFICATIONS_OUTLINE_24;
// 24x24/notifications/filled.svg
export const NOTIFICATIONS_FILLED_24 = {
	d: 'M10 20a2 2 0 004 0h-4zm2-1c-6 0-9-3-9-3s3-2 3-8c0-4 3.239-6 6-6 2.762 0 6 2 6 6 0 6 3 8 3 8s-3 3-9 3z',
	size: 24,
};

export const NOTIFICATIONS_FILLED = NOTIFICATIONS_FILLED_24;
// 24x24/mail question/outline.svg
export const MAIL_QUESTION_OUTLINE_24 = {
	d: 'M18 11V9h2v2h-2zm-1.59-7.514a1 1 0 101.725 1.01A1.001 1.001 0 1119 6a1 1 0 100 2c1.654 0 3-1.346 3-3s-1.346-3-3-3a3.01 3.01 0 00-2.59 1.486zm.711 15.128a3.033 3.033 0 001.448-.657l-4.272-4.43L12 15.25l-2.297-1.723-4.272 4.43c.408.334.9.57 1.447.657 3.222.512 7.022.512 10.243 0zM4.355 16.13c.003.016.01.032.013.048l3.722-3.861-3.927-2.945A24.103 24.103 0 004 12c0 1.36.12 2.749.355 4.13zm15.29-.001C19.88 14.749 20 13.36 20 12h2a26.56 26.56 0 01-.384 4.466 5.037 5.037 0 01-4.181 4.123A34.817 34.817 0 0112 21a34.84 34.84 0 01-5.436-.411 5.037 5.037 0 01-4.18-4.122A26.58 26.58 0 012 12c0-1.473.129-2.976.384-4.467.362-2.119 2.009-3.771 4.098-4.109A34.982 34.982 0 0112 3c1.013 0 2.015.056 3 .144 0 0-.313 1.21-.617 1.943A33.976 33.976 0 0012 5c-1.77.002-3.582.136-5.198.398-1.01.164-1.839.852-2.236 1.786.011.007.023.008.034.016l7.4 5.55 3.269-2.451a5 5 0 001.67 1.246l-1.029.772 3.722 3.861c.003-.017.01-.032.013-.049z',
	size: 24,
};

export const MAIL_QUESTION_OUTLINE = MAIL_QUESTION_OUTLINE_24;
export const MAIL_QUESTION_24 = MAIL_QUESTION_OUTLINE_24;
export const MAIL_QUESTION = MAIL_QUESTION_OUTLINE_24;
// 24x24/web/outline.svg
export const WEB_OUTLINE_24 = {
	d: 'M14.926 19.863c.676-1.03 1.204-2.42 1.524-4.063h3.032a8.433 8.433 0 01-4.556 4.063zM4.519 15.8h3.03c.32 1.643.85 3.033 1.525 4.063A8.431 8.431 0 014.519 15.8zM9.074 4.135C8.399 5.167 7.87 6.556 7.55 8.2H4.519a8.442 8.442 0 014.555-4.065zM12 3.8c1.063 0 2.21 1.738 2.8 4.4H9.2c.589-2.662 1.738-4.4 2.8-4.4zM3.6 12c0-.763.11-1.498.303-2.2h3.413a21.017 21.017 0 000 4.4H3.903A8.323 8.323 0 013.6 12zm5.332 2.2A18.77 18.77 0 018.8 12c0-.77.05-1.504.132-2.2h6.137a18.777 18.777 0 010 4.4H8.932zm3.068 6c-1.062 0-2.211-1.738-2.8-4.4h5.6c-.59 2.662-1.737 4.4-2.8 4.4zm8.4-8.2c0 .762-.111 1.498-.302 2.2h-3.413a21.313 21.313 0 000-4.4h3.413a8.4 8.4 0 01.303 2.2zm-.918-3.8H16.45c-.32-1.644-.848-3.033-1.524-4.065A8.444 8.444 0 0119.482 8.2zM12 2C6.478 2 2 6.477 2 12c0 5.522 4.478 10 10 10 5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10z',
	size: 24,
};

export const WEB_OUTLINE = WEB_OUTLINE_24;
export const WEB_24 = WEB_OUTLINE_24;
export const WEB = WEB_OUTLINE_24;
// 24x24/arrow forward/outine.svg
export const ARROW_FORWARD_OUTINE_24 = {
	d: 'M15 20.5a1 1 0 01-1 1H9c-3.859 0-7-3.141-7-7s3.141-7 7-7h5v-5l8 6-8 6v-5H9c-2.757 0-5 2.243-5 5s2.243 5 5 5h5a1 1 0 011 1z',
	size: 24,
};

export const ARROW_FORWARD_OUTINE = ARROW_FORWARD_OUTINE_24;
// 24x24/send/outline.svg
export const SEND_OUTLINE_24 = {
	d: 'M13.745 18.993L11.8 16.4a1 1 0 00-.996-.38l-1.102.22 9.345-10.124-5.302 12.877zM4.92 9.505L16.062 6.41l-8.259 6.007c-.03-.042-.059-.086-.096-.123L4.92 9.505zm16.83-6.168a.995.995 0 00-1.017-.3l-18 5a1 1 0 00-.439 1.67l3.621 3.622-.895 4.475a1.002 1.002 0 001.177 1.176l4.382-.876L13.2 21.6a1.002 1.002 0 001.725-.218l7-17a.998.998 0 00-.177-1.044z',
	size: 24,
};

export const SEND_OUTLINE = SEND_OUTLINE_24;
export const SEND_24 = SEND_OUTLINE_24;
export const SEND = SEND_OUTLINE_24;
// 24x24/send/filled.svg
export const SEND_FILLED_24 = {
	d: 'M9.701 16.24l-2.427.485L8 13l11.296-7.489-9.595 10.73zM21.748 3.337a1.017 1.017 0 00-1.016-.3l-18 5a1 1 0 00-.439 1.67l3.621 3.622-.895 4.474a1.001 1.001 0 001.177 1.177l4.382-.876L13.2 21.6a.997.997 0 001.725-.218l7-17a.81.81 0 00.075-.38c0-.193-.087-.479-.252-.664z',
	size: 24,
};

export const SEND_FILLED = SEND_FILLED_24;
// 24x24/youtube/filled.svg
export const YOUTUBE_FILLED_24 = {
	d: 'M10.007 14.998V9.002L15.213 12l-5.206 2.998zm11.58-7.808a2.504 2.504 0 00-1.762-1.762C18.26 5 12 5 12 5s-6.26 0-7.825.412A2.559 2.559 0 002.412 7.19C2 8.755 2 12 2 12s0 3.261.412 4.81a2.506 2.506 0 001.763 1.761C5.755 19 12 19 12 19s6.26 0 7.825-.412a2.505 2.505 0 001.764-1.762c.41-1.565.41-4.809.41-4.809s.018-3.262-.411-4.827z',
	size: 24,
};

export const YOUTUBE_FILLED = YOUTUBE_FILLED_24;
// 24x24/web move/outline.svg
export const WEB_MOVE_OUTLINE_24 = {
	d: 'M22 12l-5 4v-3h-4v-2h4V8l5 4zM4.615 16h2.976c.323 1.557.835 2.875 1.483 3.863A8.441 8.441 0 014.615 16zM3.6 12c0-.763.111-1.498.302-2.2h3.413a21.298 21.298 0 00-.023 4.2H3.851a8.358 8.358 0 01-.251-2zm5.474-7.864C8.398 5.167 7.87 6.557 7.55 8.2H4.519a8.433 8.433 0 014.555-4.064zm9.327 13.284a8.457 8.457 0 01-3.475 2.443c.457-.696.842-1.564 1.144-2.557a5.47 5.47 0 01-1.491-.652C13.951 18.823 12.943 20.2 12 20.2c-1.036 0-2.156-1.65-2.757-4.2h4.489a5.501 5.501 0 01-1.351-2H8.909a18.544 18.544 0 01.023-4.2h3.529a5.52 5.52 0 011.068-1.6H9.2c.589-2.662 1.737-4.4 2.8-4.4.943 0 1.952 1.375 2.58 3.546a5.456 5.456 0 011.487-.651c-.303-.992-.685-1.863-1.141-2.559a8.425 8.425 0 013.463 2.442 5.476 5.476 0 012.692 1.253C19.499 4.393 16.033 2 12 2 6.477 2 2 6.478 2 12s4.477 10 10 10c4.033 0 7.499-2.393 9.081-5.831a5.472 5.472 0 01-2.68 1.251z',
	size: 24,
};

export const WEB_MOVE_OUTLINE = WEB_MOVE_OUTLINE_24;
export const WEB_MOVE_24 = WEB_MOVE_OUTLINE_24;
export const WEB_MOVE = WEB_MOVE_OUTLINE_24;
// 24x24/subtract squircle/outline.svg
export const SUBTRACT_SQUIRCLE_OUTLINE_24 = {
	d: 'M20 12c0-1.629-.173-3.252-.514-4.822a3.479 3.479 0 00-2.662-2.664A22.789 22.789 0 0012 4c-1.629 0-3.251.173-4.821.513a3.484 3.484 0 00-2.666 2.664A22.844 22.844 0 004 12c0 1.629.173 3.251.513 4.822a3.483 3.483 0 002.663 2.664C8.748 19.827 10.37 20 12 20s3.252-.173 4.821-.514a3.48 3.48 0 002.665-2.663C19.827 15.252 20 13.63 20 12zm2 0c0 1.8-.192 3.555-.559 5.245a5.47 5.47 0 01-4.195 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.472 5.472 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.472 5.472 0 014.197-4.196A24.695 24.695 0 0112 2c1.8 0 3.555.191 5.246.559a5.47 5.47 0 014.195 4.195C21.808 8.445 22 10.2 22 12zm-6 1H8a1 1 0 110-2h8a1 1 0 110 2z',
	size: 24,
};

export const SUBTRACT_SQUIRCLE_OUTLINE = SUBTRACT_SQUIRCLE_OUTLINE_24;
export const SUBTRACT_SQUIRCLE_24 = SUBTRACT_SQUIRCLE_OUTLINE_24;
export const SUBTRACT_SQUIRCLE = SUBTRACT_SQUIRCLE_OUTLINE_24;
// 24x24/subtract squircle/filled.svg
export const SUBTRACT_SQUIRCLE_FILLED_24 = {
	d: 'M8 13a1 1 0 110-2h8a1 1 0 110 2H8zm9.246-10.441A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.47 5.47 0 004.195-4.196C21.808 15.555 22 13.8 22 12c0-1.8-.192-3.555-.559-5.246a5.47 5.47 0 00-4.195-4.195z',
	size: 24,
};

export const SUBTRACT_SQUIRCLE_FILLED = SUBTRACT_SQUIRCLE_FILLED_24;
// 24x24/help squircle/outline.svg
export const HELP_SQUIRCLE_OUTLINE_24 = {
	d: 'M13.5 16.5a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM16 9c0 1.535-1.124 2.285-1.945 2.832-.749.5-1.055.745-1.055 1.168v1h-2v-1c0-1.535 1.124-2.285 1.945-2.832C13.694 9.668 14 9.355 14 9c0-.603-.856-1-2-1-.805 0-2 .269-2 1a1 1 0 11-2 0c0-1.883 1.683-3 4-3s4 1.117 4 3zm-4-7c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.473 5.473 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.245a5.473 5.473 0 00-4.196-4.196A24.711 24.711 0 0012 2zm0 2c1.627 0 3.249.173 4.823.513a3.487 3.487 0 012.664 2.664 22.886 22.886 0 010 9.646 3.487 3.487 0 01-2.664 2.664 22.886 22.886 0 01-9.646 0 3.486 3.486 0 01-2.664-2.664 22.886 22.886 0 010-9.646 3.484 3.484 0 012.664-2.664A22.886 22.886 0 0112 4z',
	size: 24,
};

export const HELP_SQUIRCLE_OUTLINE = HELP_SQUIRCLE_OUTLINE_24;
export const HELP_SQUIRCLE_24 = HELP_SQUIRCLE_OUTLINE_24;
export const HELP_SQUIRCLE = HELP_SQUIRCLE_OUTLINE_24;
// 24x24/help squircle/filled.svg
export const HELP_SQUIRCLE_FILLED_24 = {
	d: 'M14.055 11.832c-.75.5-1.055.745-1.055 1.168v1h-2v-1c0-1.535 1.124-2.285 1.946-2.832C13.695 9.668 14 9.355 14 9c0-.603-.856-1-2-1-.804 0-2 .269-2 1a1 1 0 11-2 0c0-1.883 1.683-3 4-3 2.318 0 4 1.117 4 3 0 1.535-1.124 2.285-1.945 2.832zM12 18a1.5 1.5 0 110-3.001A1.5 1.5 0 0112 18zm9.442-11.246a5.472 5.472 0 00-4.196-4.195A24.711 24.711 0 0012 2c-1.8 0-3.554.192-5.245.558a5.473 5.473 0 00-4.197 4.196A24.827 24.827 0 002 12c0 1.8.193 3.555.558 5.245a5.473 5.473 0 004.196 4.196C8.446 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.472 5.472 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.246z',
	size: 24,
};

export const HELP_SQUIRCLE_FILLED = HELP_SQUIRCLE_FILLED_24;
// 24x24/flag/outline.svg
export const FLAG_OUTLINE_24 = {
	d: 'M17.143 12.743L18.046 15H14V9h4.046l-.903 2.257-.297.743.297.743zM7 13V6h5v7H7zm14-6h-7V6a2 2 0 00-2-2H7V3a1 1 0 10-2 0v18a1 1 0 102 0v-6h5a2 2 0 002 2h7l-2-5 2-5z',
	size: 24,
};

export const FLAG_OUTLINE = FLAG_OUTLINE_24;
export const FLAG_24 = FLAG_OUTLINE_24;
export const FLAG = FLAG_OUTLINE_24;
// 24x24/flag/filled.svg
export const FLAG_FILLED_24 = {
	d: 'M21 7h-7v8a2 2 0 002 2h5l-2-5 2-5zm-8-1v9H7v6a1 1 0 11-2 0V3a1 1 0 112 0v1h4a2 2 0 012 2z',
	size: 24,
};

export const FLAG_FILLED = FLAG_FILLED_24;
// 24x24/skype/filled.svg
export const SKYPE_FILLED_24 = {
	d: 'M12.114 17.385c-2.997 0-4.718-1.571-4.718-3.112 0-.786.823-1.038 1.153-1.038.76 0 1.013.621 1.152.905.774 1.59 1.518 1.38 2.25 1.449.646.061 2.165-.225 2.165-1.334 0-.105.167-.827-1.144-1.185-.838-.229-2.316-.51-3.53-.978-1.144-.439-1.814-1.346-1.814-2.514 0-.584.3-2.963 4.347-2.963 2.702 0 4.141 1.384 4.141 2.602 0 .28-.107.526-.322.749a1.175 1.175 0 01-1.482.124c-.166-.107-.303-.329-.468-.618-.198-.362-.524-1.062-2.018-1.062-1.45 0-1.853.692-1.853.98 0 .97 1.85 1.173 2.347 1.302 1.816.467 4.282.897 4.282 3.342 0 2.808-2.921 3.351-4.488 3.351zm9.027-4.17c.054-.398.09-.803.09-1.215 0-5.097-4.134-9.231-9.23-9.231-.412 0-.817.037-1.215.09A5.734 5.734 0 007.768 2 5.769 5.769 0 002 7.769c0 1.107.317 2.137.858 3.016-.053.399-.09.803-.09 1.215 0 5.098 4.134 9.231 9.233 9.231.412 0 .816-.036 1.215-.089.878.54 1.909.858 3.014.858A5.77 5.77 0 0022 16.231a5.74 5.74 0 00-.858-3.016z',
	size: 24,
};

export const SKYPE_FILLED = SKYPE_FILLED_24;
// 24x24/chevron left/outline.svg
export const CHEVRON_LEFT_OUTLINE_24 = {
	d: 'M9.414 12l6.293-6.293a.997.997 0 000-1.414A1.006 1.006 0 0015 4a.989.989 0 00-.707.293l-7 7a.997.997 0 000 1.414l7 7a.997.997 0 001.414 0c.194-.194.292-.452.293-.707a.989.989 0 00-.293-.707L9.414 12z',
	size: 24,
};

export const CHEVRON_LEFT_OUTLINE = CHEVRON_LEFT_OUTLINE_24;
export const CHEVRON_LEFT_24 = CHEVRON_LEFT_OUTLINE_24;
export const CHEVRON_LEFT = CHEVRON_LEFT_OUTLINE_24;
// 24x24/chevron left/filled.svg
export const CHEVRON_LEFT_FILLED_24 = {
	d: 'M16 5a.997.997 0 00-1-1 .991.991 0 00-.707.293l-7 7a.997.997 0 000 1.414l7 7a.997.997 0 001.414 0c.194-.194.292-.452.293-.707V5z',
	size: 24,
};

export const CHEVRON_LEFT_FILLED = CHEVRON_LEFT_FILLED_24;
// 24x24/square pattern/outline.svg
export const SQUARE_PATTERN_OUTLINE_24 = {
	d: 'M20 13a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm-10 0a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6a1 1 0 011-1h6zm9 2h-4v4h4v-4zM9 15H5v4h4v-4zM20 3a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6zM10 3a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6zm9 2h-4v4h4V5zM9 5H5v4h4V5z',
	size: 24,
};

export const SQUARE_PATTERN_OUTLINE = SQUARE_PATTERN_OUTLINE_24;
export const SQUARE_PATTERN_24 = SQUARE_PATTERN_OUTLINE_24;
export const SQUARE_PATTERN = SQUARE_PATTERN_OUTLINE_24;
// 24x24/arrow up/outline.svg
export const ARROW_UP_OUTLINE_24 = {
	d: 'M11.293 2.293l-6 6a.997.997 0 000 1.414c.194.194.452.292.707.293a.989.989 0 00.707-.293L11 5.414V21a1 1 0 102 0V5.414l4.293 4.293a.997.997 0 001.414 0c.194-.194.292-.452.293-.707a.989.989 0 00-.293-.707l-6-6a.997.997 0 00-1.414 0z',
	size: 24,
};

export const ARROW_UP_OUTLINE = ARROW_UP_OUTLINE_24;
export const ARROW_UP_24 = ARROW_UP_OUTLINE_24;
export const ARROW_UP = ARROW_UP_OUTLINE_24;
// 24x24/arrow up/filled.svg
export const ARROW_UP_FILLED_24 = {
	d: 'M13 21V11h5a1 1 0 00.759-1.65l-6-7a.999.999 0 00-1.518 0l-6 7a.993.993 0 00-.15 1.068A1 1 0 006 11h5v10a1 1 0 102 0z',
	size: 24,
};

export const ARROW_UP_FILLED = ARROW_UP_FILLED_24;
// 24x24/download/outline.svg
export const DOWNLOAD_OUTLINE_24 = {
	d: 'M6 4h1c2.206 0 4 1.794 4 4v3H6l6 8 6-8h-5V8c0-3.309-2.691-6-6-6H6a1 1 0 100 2zm16 13v2c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-2a1 1 0 112 0v2a1 1 0 001 1h14a1 1 0 001-1v-2a1 1 0 112 0z',
	size: 24,
};

export const DOWNLOAD_OUTLINE = DOWNLOAD_OUTLINE_24;
export const DOWNLOAD_24 = DOWNLOAD_OUTLINE_24;
export const DOWNLOAD = DOWNLOAD_OUTLINE_24;
// 24x24/download/filled.svg
export const DOWNLOAD_FILLED_24 = {
	d: 'M8.69 6.973c.334.838.531 1.635.626 2.458.072.507.103 1.032.13 1.569H6l6 8 6-8h-3.513a9.823 9.823 0 00-.64-2.865c-.504-1.264-1.282-2.442-2.254-3.338a9.81 9.81 0 00-3.17-2.008A11.887 11.887 0 005 1.999c.802.84 1.553 1.66 2.194 2.484.64.827 1.151 1.663 1.496 2.49zM22 17v2c0 1.655-1.346 3-3 3H5c-1.655 0-3-1.345-3-3v-2a1 1 0 112 0v2a1 1 0 001 1h14c.551 0 1-.448 1-1v-2a1 1 0 112 0z',
	size: 24,
};

export const DOWNLOAD_FILLED = DOWNLOAD_FILLED_24;
// 24x24/new window/outline.svg
export const NEW_WINDOW_OUTLINE_24 = {
	d: 'M17 19H7c-1.103 0-2-.897-2-2V9h14v8c0 1.103-.897 2-2 2zM7 5h10c1.103 0 2 .897 2 2H5c0-1.103.897-2 2-2zm10-2H7C4.794 3 3 4.794 3 7v10c0 2.206 1.794 4 4 4h10c2.206 0 4-1.794 4-4V7c0-2.206-1.794-4-4-4z',
	size: 24,
};

export const NEW_WINDOW_OUTLINE = NEW_WINDOW_OUTLINE_24;
export const NEW_WINDOW_24 = NEW_WINDOW_OUTLINE_24;
export const NEW_WINDOW = NEW_WINDOW_OUTLINE_24;
// 24x24/new window/filled.svg
export const NEW_WINDOW_FILLED_24 = {
	d: 'M19 17c0 1.103-.897 2-2 2H7c-1.103 0-2-.897-2-2V8h14v9zM17 3H7C4.794 3 3 4.794 3 7v10c0 2.206 1.794 4 4 4h10c2.206 0 4-1.794 4-4V7c0-2.206-1.794-4-4-4z',
	size: 24,
};

export const NEW_WINDOW_FILLED = NEW_WINDOW_FILLED_24;
// 24x24/like/filled.svg
export const LIKE_FILLED_24 = {
	d: 'M19 8c-2.088 0-4.047.244-5.724.56C13.824 7.655 15 5.535 15 4c0-1-.593-3-2-3-.563 0-.968 1.019-1.618 2.722C10.731 5.426 9.213 8.203 8 10v9c0 1.064 1 2 2 2h4c4.094 0 7-6.154 7-10 0-2-.729-3-2-3zM6 21H4a1 1 0 01-1-1v-9a1 1 0 011-1h3v10a1 1 0 01-1 1z',
	size: 24,
};

export const LIKE_FILLED = LIKE_FILLED_24;
// 24x24/android/filled.svg
export const ANDROID_FILLED_24 = {
	d: 'M17.6 9.5l1.8-3.2c.2-.3 0-.7-.3-.8-.3-.2-.6-.1-.8.2l-1.9 3.2c-2.9-1.2-6.1-1.2-8.9 0L5.7 5.7c-.2-.3-.6-.4-.9-.2-.3.2-.4.5-.2.8l1.8 3.2c-3.1 1.8-5.1 5-5.4 8.5h22c-.3-3.6-2.3-6.8-5.4-8.5zM7 15.2c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2 1.2.6 1.2 1.2-.5 1.2-1.2 1.2zm10 0c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2 1.2.6 1.2 1.2-.5 1.2-1.2 1.2z',
	size: 24,
};

export const ANDROID_FILLED = ANDROID_FILLED_24;
// 24x24/overflow menu vertical/filled.svg
export const OVERFLOW_MENU_VERTICAL_FILLED_24 = {
	d: 'M12 4a2 2 0 10.001 4.001A2 2 0 0012 4zm0 6a2 2 0 10.001 4.001A2 2 0 0012 10zm2 8a2 2 0 11-4.001-.001A2 2 0 0114 18z',
	size: 24,
};

export const OVERFLOW_MENU_VERTICAL_FILLED = OVERFLOW_MENU_VERTICAL_FILLED_24;
// 24x24/download ios/outline.svg
export const DOWNLOAD_IOS_OUTLINE_24 = {
	d: 'M12 18l5-7h-4V3a1 1 0 10-2 0v8H7l5 7zm9-10v11c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h3v2H6a1 1 0 00-1 1v11a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1h-3V5h3c1.654 0 3 1.346 3 3z',
	size: 24,
};

export const DOWNLOAD_IOS_OUTLINE = DOWNLOAD_IOS_OUTLINE_24;
export const DOWNLOAD_IOS_24 = DOWNLOAD_IOS_OUTLINE_24;
export const DOWNLOAD_IOS = DOWNLOAD_IOS_OUTLINE_24;
// 24x24/image/outline.svg
export const IMAGE_OUTLINE_24 = {
	d: 'M8 9a2 2 0 114.001.001A2 2 0 018 9zm4 11c-4.05 0-6.127-.507-7.138-2.397l3.044-2.283 1.387 1.387c.361.361.936.391 1.332.074l4.362-3.49 4.427 3.689C18.531 19.386 16.462 20 12 20zm0-16c6.654 0 8 1.346 8 8 0 1.053-.039 1.959-.122 2.762l-4.237-3.531a1.004 1.004 0 00-1.266-.012l-4.301 3.441-1.367-1.367A.997.997 0 007.4 13.2l-3.169 2.377C4.068 14.599 4 13.428 4 12c0-6.654 1.346-8 8-8zm0-2C4.215 2 2 4.215 2 12s2.215 10 10 10 10-2.215 10-10S19.785 2 12 2z',
	size: 24,
};

export const IMAGE_OUTLINE = IMAGE_OUTLINE_24;
export const IMAGE_24 = IMAGE_OUTLINE_24;
export const IMAGE = IMAGE_OUTLINE_24;
// 24x24/image/filled.svg
export const IMAGE_FILLED_24 = {
	d: 'M8 9a2 2 0 114.001.001A2 2 0 018 9zm4-5c6.654 0 8 1.346 8 8 0 1.053-.039 1.959-.123 2.762l-4.236-3.531a1.004 1.004 0 00-1.266-.012l-4.301 3.441-1.367-1.367A.997.997 0 007.4 13.2l-3.169 2.377C4.068 14.599 4 13.428 4 12c0-6.654 1.346-8 8-8zm0-2C4.215 2 2 4.215 2 12s2.215 10 10 10 10-2.215 10-10S19.785 2 12 2z',
	size: 24,
};

export const IMAGE_FILLED = IMAGE_FILLED_24;
// 24x24/external link/outline.svg
export const EXTERNAL_LINK_OUTLINE_24 = {
	d: 'M14 3l2.793 2.793-6.5 6.5a.999.999 0 101.414 1.414l6.5-6.5L21 10V3h-7zm5 9h2v4c0 2.757-2.243 5-5 5H8c-2.757 0-5-2.243-5-5V8c0-2.757 2.243-5 5-5h4v2H8C6.346 5 5 6.346 5 8v8c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3v-4z',
	size: 24,
};

export const EXTERNAL_LINK_OUTLINE = EXTERNAL_LINK_OUTLINE_24;
export const EXTERNAL_LINK_24 = EXTERNAL_LINK_OUTLINE_24;
export const EXTERNAL_LINK = EXTERNAL_LINK_OUTLINE_24;
// 24x24/time alt1/outline.svg
export const TIME_ALT1_OUTLINE_24 = {
	d: 'M20 12c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8zm2 0c0 5.522-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2s10 4.478 10 10zm-7.293 3.293a.999.999 0 11-1.414 1.414l-3-3a.997.997 0 01-.279-.871l1-6a.993.993 0 011.15-.822c.545.09.913.606.822 1.15l-.915 5.493 2.636 2.636z',
	size: 24,
};

export const TIME_ALT1_OUTLINE = TIME_ALT1_OUTLINE_24;
export const TIME_ALT1_24 = TIME_ALT1_OUTLINE_24;
export const TIME_ALT1 = TIME_ALT1_OUTLINE_24;
// 24x24/time alt1/filled.svg
export const TIME_ALT1_FILLED_24 = {
	d: 'M14.707 16.707a.997.997 0 01-1.414 0l-3-3a.998.998 0 01-.279-.871l1-6a.993.993 0 011.15-.822c.545.09.913.606.822 1.15l-.915 5.493 2.636 2.636a.999.999 0 010 1.414zM12 2C6.477 2 2 6.478 2 12s4.477 10 10 10c5.522 0 10-4.478 10-10S17.522 2 12 2z',
	size: 24,
};

export const TIME_ALT1_FILLED = TIME_ALT1_FILLED_24;
// 24x24/move/outline.svg
export const MOVE_OUTLINE_24 = {
	d: 'M18.293 10.707L12 4.414l-6.293 6.293A.989.989 0 015 11a.997.997 0 01-.707-1.707l7-7a.997.997 0 011.414 0l7 7c.196.196.294.45.293.707a.997.997 0 01-1.707.707zM5.707 13.293L12 19.586l6.293-6.293A.989.989 0 0119 13a.997.997 0 01.707 1.707l-7 7a.997.997 0 01-1.414 0l-7-7A.989.989 0 014 14a.997.997 0 011.707-.707z',
	size: 24,
};

export const MOVE_OUTLINE = MOVE_OUTLINE_24;
export const MOVE_24 = MOVE_OUTLINE_24;
export const MOVE = MOVE_OUTLINE_24;
// 24x24/move/filled.svg
export const MOVE_FILLED_24 = {
	d: 'M19.707 10.707A.997.997 0 0119 11H5a.997.997 0 01-.707-1.707l7-7.001A.996.996 0 0112 2c.256 0 .512.097.707.292l7 7.001c.196.195.294.45.293.707a1.007 1.007 0 01-.293.707zM4.293 13.293A.997.997 0 015 13h14a.997.997 0 011 1 .997.997 0 01-.293.707l-7 7a.997.997 0 01-1.414 0l-7-7A.989.989 0 014 14c.001-.255.099-.513.293-.707z',
	size: 24,
};

export const MOVE_FILLED = MOVE_FILLED_24;
// 24x24/warning circle/outline.svg
export const WARNING_CIRCLE_OUTLINE_24 = {
	d: 'M12 6c-1 0-2 1-2 2s1 5 1 5h2s1-4 1-5-1-2-2-2zm0 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8-2c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8zm2 0c0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10S6.477 2 12 2c5.522 0 10 4.478 10 10z',
	size: 24,
};

export const WARNING_CIRCLE_OUTLINE = WARNING_CIRCLE_OUTLINE_24;
export const WARNING_CIRCLE_24 = WARNING_CIRCLE_OUTLINE_24;
export const WARNING_CIRCLE = WARNING_CIRCLE_OUTLINE_24;
// 24x24/warning circle/filled.svg
export const WARNING_CIRCLE_FILLED_24 = {
	d: 'M14 8c0-1-1-2-2-2s-2 1-2 2 1 5 1 5h2s1-4 1-5zm-.5 7.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM22 12c0 5.522-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2s10 4.478 10 10z',
	size: 24,
};

export const WARNING_CIRCLE_FILLED = WARNING_CIRCLE_FILLED_24;
// 24x24/briefcase/outline.svg
export const BRIEFCASE_OUTLINE_24 = {
	d: 'M19.152 18.443C17.365 18.697 14.673 19 12 19s-5.366-.303-7.153-.557A.998.998 0 014 17.454V13h6v1a1 1 0 001 1h2a1 1 0 001-1v-1h6v4.454a1 1 0 01-.848.99zM4.842 8.507A49.838 49.838 0 0112 8c3.073 0 5.59.276 7.158.507a.989.989 0 01.842.99V11H4V9.496c0-.5.354-.916.841-.989zM9 5h6v1.086a52.687 52.687 0 00-6 0V5zm10.45 1.53A46.83 46.83 0 0017 6.234V5c0-1.103-.898-2-2-2H9c-1.103 0-2 .897-2 2v1.235c-.932.088-1.757.191-2.45.294A2.991 2.991 0 002 9.496v7.958a2.993 2.993 0 002.566 2.968C6.486 20.695 9.242 21 12 21c2.757 0 5.514-.305 7.433-.578A2.994 2.994 0 0022 17.454V9.496c0-1.486-1.08-2.75-2.55-2.967z',
	size: 24,
};

export const BRIEFCASE_OUTLINE = BRIEFCASE_OUTLINE_24;
export const BRIEFCASE_24 = BRIEFCASE_OUTLINE_24;
export const BRIEFCASE = BRIEFCASE_OUTLINE_24;
// 24x24/briefcase/filled.svg
export const BRIEFCASE_FILLED_24 = {
	d: 'M12 6c1.069 0 2.069.033 3 .086V5H9v1.086A52.687 52.687 0 0112 6zm10 3.496V11H2V9.496c0-1.485 1.08-2.75 2.55-2.967A47.658 47.658 0 017 6.235V5c0-1.103.897-2 2-2h6c1.103 0 2 .897 2 2v1.235c.932.088 1.757.192 2.45.294A2.992 2.992 0 0122 9.496zM14 13h8v4.454a2.995 2.995 0 01-2.566 2.969C17.515 20.695 14.758 21 12 21s-5.515-.305-7.434-.577A2.995 2.995 0 012 17.454V13h8v1a1 1 0 001 1h2a1 1 0 001-1v-1z',
	size: 24,
};

export const BRIEFCASE_FILLED = BRIEFCASE_FILLED_24;
// 24x24/attachment/outline.svg
export const ATTACHMENT_OUTLINE_24 = {
	d: 'M19.589 3.416C18.66 2.485 17.469 2 16.229 2c-1.294 0-2.51.459-3.463 1.417l-9.518 9.562a.853.853 0 000 1.201.841.841 0 001.195 0l9.518-9.562a3.13 3.13 0 014.432-.001 3.167 3.167 0 010 4.454L7.55 19.965a1.145 1.145 0 01-1.62 0 1.156 1.156 0 010-1.626L16.775 7.445a.852.852 0 000-1.201.844.844 0 00-1.196 0L4.735 17.139a2.86 2.86 0 000 4.026A2.81 2.81 0 006.74 22c.757 0 1.469-.296 2.004-.835L19.59 10.271A4.839 4.839 0 0021 6.845c0-1.242-.47-2.484-1.411-3.429z',
	size: 24,
};

export const ATTACHMENT_OUTLINE = ATTACHMENT_OUTLINE_24;
export const ATTACHMENT_24 = ATTACHMENT_OUTLINE_24;
export const ATTACHMENT = ATTACHMENT_OUTLINE_24;
// 24x24/chevron right/outline.svg
export const CHEVRON_RIGHT_OUTLINE_24 = {
	d: 'M14.586 12l-6.293 6.293a.997.997 0 000 1.414c.194.194.452.292.707.293a.989.989 0 00.707-.293l7-7a.997.997 0 000-1.414l-7-7a.997.997 0 00-1.414 0A1.006 1.006 0 008 5a.989.989 0 00.293.707L14.586 12z',
	size: 24,
};

export const CHEVRON_RIGHT_OUTLINE = CHEVRON_RIGHT_OUTLINE_24;
export const CHEVRON_RIGHT_24 = CHEVRON_RIGHT_OUTLINE_24;
export const CHEVRON_RIGHT = CHEVRON_RIGHT_OUTLINE_24;
// 24x24/chevron right/filled.svg
export const CHEVRON_RIGHT_FILLED_24 = {
	d: 'M9 19a.997.997 0 001 1 .989.989 0 00.707-.293l7-7a.997.997 0 000-1.414l-7-7a.997.997 0 00-1.414 0A1.007 1.007 0 009 5v14z',
	size: 24,
};

export const CHEVRON_RIGHT_FILLED = CHEVRON_RIGHT_FILLED_24;
// 24x24/arrow down/outline.svg
export const ARROW_DOWN_OUTLINE_24 = {
	d: 'M12.707 21.707l6-6a.997.997 0 000-1.414A1.006 1.006 0 0018 14a.989.989 0 00-.707.293L13 18.586V3a1 1 0 10-2 0v15.586l-4.293-4.293a.997.997 0 00-1.414 0A1.006 1.006 0 005 15a.989.989 0 00.293.707l6 6a.997.997 0 001.414 0z',
	size: 24,
};

export const ARROW_DOWN_OUTLINE = ARROW_DOWN_OUTLINE_24;
export const ARROW_DOWN_24 = ARROW_DOWN_OUTLINE_24;
export const ARROW_DOWN = ARROW_DOWN_OUTLINE_24;
// 24x24/arrow down/filled.svg
export const ARROW_DOWN_FILLED_24 = {
	d: 'M11 3v10H6a1 1 0 00-.759 1.65l6 7a.999.999 0 001.518 0l6-7a.993.993 0 00.149-1.068A1 1 0 0018 13h-5V3a1 1 0 10-2 0z',
	size: 24,
};

export const ARROW_DOWN_FILLED = ARROW_DOWN_FILLED_24;
// 24x24/subtitles/outline.svg
export const SUBTITLES_OUTLINE_24 = {
	d: 'M6 14h6c.6 0 1-.4 1-1s-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1zm11 1H6c-.6 0-1 .4-1 1s.4 1 1 1h11c.6 0 1-.4 1-1s-.4-1-1-1z',
	size: 24,
};

export const SUBTITLES_OUTLINE = SUBTITLES_OUTLINE_24;
export const SUBTITLES_24 = SUBTITLES_OUTLINE_24;
export const SUBTITLES = SUBTITLES_OUTLINE_24;
// 24x24/subtitles/filled.svg
export const SUBTITLES_FILLED_24 = {
	d: 'M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zM6 12h6a1 1 0 010 2H6a1 1 0 010-2zm11 5H6a1 1 0 010-2h11a1 1 0 010 2z',
	size: 24,
};

export const SUBTITLES_FILLED = SUBTITLES_FILLED_24;
// 24x24/renew horizontal/outline.svg
export const RENEW_HORIZONTAL_OUTLINE_24 = {
	d: 'M5.071 13.071a1 1 0 001-1v-2c0-1.654 1.346-3 3-3h6v3.071l6.071-4.07L15.071 2v3.071h-6c-2.757 0-5 2.243-5 5v2a1 1 0 001 1zm15-1v2c0 2.757-2.243 5-5 5h-6v3.071L3 18.072 9.071 14v3.071h6c1.654 0 3-1.346 3-3v-2a1 1 0 112 0z',
	size: 24,
};

export const RENEW_HORIZONTAL_OUTLINE = RENEW_HORIZONTAL_OUTLINE_24;
export const RENEW_HORIZONTAL_24 = RENEW_HORIZONTAL_OUTLINE_24;
export const RENEW_HORIZONTAL = RENEW_HORIZONTAL_OUTLINE_24;
// 24x24/mail download/outline.svg
export const MAIL_DOWNLOAD_OUTLINE_24 = {
	d: 'M18 17v-3a1 1 0 10-2 0v3h-3l4 5 4-5h-3zm1.4-9.8c.01-.007.022-.008.032-.014a3.036 3.036 0 00-2.31-1.8 32.997 32.997 0 00-5.161-.385 32.942 32.942 0 00-5.16.397c-1.009.164-1.838.852-2.235 1.786.011.007.024.008.034.016l7.4 5.55 7.4-5.55zM4.368 16.178l3.722-3.861-3.927-2.945A24.103 24.103 0 004 12c0 1.36.12 2.749.355 4.13.003.016.01.032.013.048zm17.248-8.645A26.58 26.58 0 0122 12c0 .661-.035 1.33-.087 2h-2c.056-.67.087-1.339.087-2 0-.867-.066-1.747-.163-2.628L12 15.25l-2.297-1.723-4.272 4.43c.408.334.9.57 1.447.657 1.615.257 3.368.377 5.122.37V21a34.84 34.84 0 01-5.436-.411 5.037 5.037 0 01-4.18-4.122A26.58 26.58 0 012 12c0-1.473.129-2.976.384-4.466.362-2.12 2.009-3.771 4.097-4.11A34.95 34.95 0 0112 3c1.861 0 3.72.139 5.436.411a5.037 5.037 0 014.18 4.122z',
	size: 24,
};

export const MAIL_DOWNLOAD_OUTLINE = MAIL_DOWNLOAD_OUTLINE_24;
export const MAIL_DOWNLOAD_24 = MAIL_DOWNLOAD_OUTLINE_24;
export const MAIL_DOWNLOAD = MAIL_DOWNLOAD_OUTLINE_24;
// 24x24/reject squircle/outline.svg
export const REJECT_SQUIRCLE_OUTLINE_24 = {
	d: 'M13.414 12l2.293-2.293a.999.999 0 10-1.414-1.414L12 10.586 9.707 8.293a.999.999 0 10-1.414 1.414L10.586 12l-2.293 2.293a.999.999 0 101.414 1.414L12 13.414l2.293 2.293a.997.997 0 001.414 0 .999.999 0 000-1.414L13.414 12zM12 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.473 5.473 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.245a5.473 5.473 0 00-4.196-4.196A24.711 24.711 0 0012 2zm0 2c1.627 0 3.25.173 4.823.513a3.487 3.487 0 012.664 2.664 22.886 22.886 0 010 9.646 3.487 3.487 0 01-2.664 2.664 22.886 22.886 0 01-9.646 0 3.486 3.486 0 01-2.664-2.664 22.886 22.886 0 010-9.646 3.484 3.484 0 012.664-2.664A22.886 22.886 0 0112 4z',
	size: 24,
};

export const REJECT_SQUIRCLE_OUTLINE = REJECT_SQUIRCLE_OUTLINE_24;
export const REJECT_SQUIRCLE_24 = REJECT_SQUIRCLE_OUTLINE_24;
export const REJECT_SQUIRCLE = REJECT_SQUIRCLE_OUTLINE_24;
// 24x24/reject squircle/filled.svg
export const REJECT_SQUIRCLE_FILLED_24 = {
	d: 'M9 16a.999.999 0 01-.707-1.707L10.586 12 8.293 9.707a.999.999 0 111.414-1.414L12 10.586l2.293-2.293a.997.997 0 011.414 0 .999.999 0 010 1.414L13.414 12l2.293 2.293a.999.999 0 11-1.414 1.414L12 13.414l-2.293 2.293A.997.997 0 019 16zm12.441-9.246a5.47 5.47 0 00-4.195-4.195A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.47 5.47 0 004.195-4.196C21.808 15.555 22 13.8 22 12c0-1.8-.192-3.555-.559-5.246z',
	size: 24,
};

export const REJECT_SQUIRCLE_FILLED = REJECT_SQUIRCLE_FILLED_24;
// 24x24/share ios/outline.svg
export const SHARE_IOS_OUTLINE_24 = {
	d: 'M8 6h3v8a1 1 0 102 0V6h3l-4-5-4 5zM6 8h3v2H6v10h12V10h-3V8h3a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2z',
	size: 24,
};

export const SHARE_IOS_OUTLINE = SHARE_IOS_OUTLINE_24;
export const SHARE_IOS_24 = SHARE_IOS_OUTLINE_24;
export const SHARE_IOS = SHARE_IOS_OUTLINE_24;
// 24x24/instagram/outline.svg
export const INSTAGRAM_OUTLINE_24 = {
	d: 'M10.976 2.001h2.089c1.772.004 2.154.018 3.066.062 1.063.047 1.79.218 2.427.465a4.92 4.92 0 011.77 1.152c.512.5.902 1.102 1.157 1.774.246.633.418 1.364.465 2.426.04.915.048 1.295.05 3.095v1.574c-.002 2.221-.015 2.585-.058 3.576-.047 1.062-.22 1.789-.465 2.426a5.116 5.116 0 01-2.927 2.926c-.633.246-1.364.418-2.427.465-.99.044-1.355.057-3.576.058h-1.094c-2.221-.001-2.585-.014-3.576-.058-1.063-.047-1.79-.219-2.426-.465a4.922 4.922 0 01-1.77-1.152 4.931 4.931 0 01-1.157-1.774c-.247-.633-.419-1.364-.466-2.426-.04-.915-.054-1.295-.057-3.095v-2.088c.003-1.772.018-2.154.061-3.066.047-1.062.22-1.789.465-2.426.25-.664.645-1.27 1.153-1.77a4.881 4.881 0 011.774-1.156c.634-.246 1.364-.418 2.427-.465.915-.04 1.295-.055 3.095-.058h2.089-2.089zm1.592 1.816h-1.112c-2.164.002-2.508.015-3.485.059-.973.043-1.504.207-1.856.343-.434.16-.825.415-1.149.747a3.04 3.04 0 00-.75 1.148c-.137.352-.301.88-.344 1.856-.042.935-.056 1.291-.058 3.233v1.614c.002 1.941.016 2.296.058 3.233.043.973.207 1.505.344 1.856.16.434.414.825.746 1.149.32.332.715.586 1.149.746.352.137.88.301 1.856.344 1.012.045 1.347.058 3.754.058h.574c2.406 0 2.738-.013 3.754-.058.973-.043 1.504-.207 1.856-.344a3.318 3.318 0 001.9-1.899c.136-.351.3-.879.343-1.856.042-.937.056-1.288.058-3.23v-1.612c-.002-1.942-.016-2.296-.058-3.234-.043-.973-.207-1.504-.344-1.856a3.109 3.109 0 00-.746-1.148 3.076 3.076 0 00-1.15-.747c-.35-.136-.878-.3-1.855-.343-.974-.044-1.317-.057-3.485-.059zM12 6.932a5.07 5.07 0 010 10.137 5.07 5.07 0 01-5.069-5.068 5.07 5.07 0 015.07-5.07zm0 1.78a3.288 3.288 0 10.001 6.577 3.288 3.288 0 000-6.576zm5.206-3.15a1.233 1.233 0 110 2.466 1.233 1.233 0 010-2.466z',
	size: 24,
};

export const INSTAGRAM_OUTLINE = INSTAGRAM_OUTLINE_24;
export const INSTAGRAM_24 = INSTAGRAM_OUTLINE_24;
export const INSTAGRAM = INSTAGRAM_OUTLINE_24;
// 24x24/chevron up/outline.svg
export const CHEVRON_UP_OUTLINE_24 = {
	d: 'M12 9.414l6.293 6.293a.997.997 0 001.414 0c.194-.194.292-.452.293-.707a.989.989 0 00-.293-.707l-7-7a.997.997 0 00-1.414 0l-7 7a.997.997 0 000 1.414c.194.194.452.292.707.293a.989.989 0 00.707-.293L12 9.414z',
	size: 24,
};

export const CHEVRON_UP_OUTLINE = CHEVRON_UP_OUTLINE_24;
export const CHEVRON_UP_24 = CHEVRON_UP_OUTLINE_24;
export const CHEVRON_UP = CHEVRON_UP_OUTLINE_24;
// 24x24/chevron up/filled.svg
export const CHEVRON_UP_FILLED_24 = {
	d: 'M19 16a.997.997 0 001-1 .987.987 0 00-.293-.707l-7-7.001A.996.996 0 0012 7a.996.996 0 00-.707.292l-7 7.001a.997.997 0 000 1.414c.194.194.452.292.707.293h14z',
	size: 24,
};

export const CHEVRON_UP_FILLED = CHEVRON_UP_FILLED_24;
// 24x24/discover/filled.svg
export const DISCOVER_FILLED_24 = {
	d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5.9 4.8l-3.5 7.6-7.6 3.5c-.5.2-1-.3-.8-.8l3.5-7.6L17.1 6c.6-.2 1.1.3.8.8zM13 12c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z',
	size: 24,
};

export const DISCOVER_FILLED = DISCOVER_FILLED_24;
// 24x24/device monitor and mobile/outline.svg
export const DEVICE_MONITOR_AND_MOBILE_OUTLINE_24 = {
	d: 'M6.13 15.565c1.987.289 3.962.435 5.87.435v5H7a1 1 0 110-2h2v-1.11a44.76 44.76 0 01-3.157-.345C3.652 17.225 2 15.312 2 13.09V7.91c0-2.222 1.652-4.136 3.844-4.453A42.385 42.385 0 0112 3c2.038 0 4.076.153 6.157.457C20.347 3.774 22 5.727 22 8h-2c0-1.265-.935-2.39-2.131-2.565a39.939 39.939 0 00-11.737 0A2.508 2.508 0 004 7.91v5.182c0 1.235.916 2.296 2.13 2.474zM16 20v-8h4l.002 8H16zm4-10h-4c-1.102 0-2 .898-2 2v8c0 1.102.898 2 2 2h4c1.103 0 2-.898 2-2v-8c0-1.102-.897-2-2-2z',
	size: 24,
};

export const DEVICE_MONITOR_AND_MOBILE_OUTLINE = DEVICE_MONITOR_AND_MOBILE_OUTLINE_24;
export const DEVICE_MONITOR_AND_MOBILE_24 = DEVICE_MONITOR_AND_MOBILE_OUTLINE_24;
export const DEVICE_MONITOR_AND_MOBILE = DEVICE_MONITOR_AND_MOBILE_OUTLINE_24;
// 24x24/checkbox empty/outline.svg
export const CHECKBOX_EMPTY_OUTLINE_24 = {
	d: 'M19.487 16.823a22.886 22.886 0 000-9.646 3.487 3.487 0 00-2.664-2.664 22.88 22.88 0 00-9.646 0 3.484 3.484 0 00-2.664 2.664 22.886 22.886 0 000 9.646 3.486 3.486 0 002.664 2.664 22.886 22.886 0 009.646 0 3.487 3.487 0 002.664-2.664zm1.954-10.069C21.808 8.445 22 10.2 22 12c0 1.8-.192 3.555-.559 5.246a5.47 5.47 0 01-4.195 4.195A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.472 5.472 0 01-4.196-4.195A24.776 24.776 0 012 12c0-1.801.192-3.556.558-5.246a5.472 5.472 0 014.197-4.196A24.76 24.76 0 0112 2c1.8 0 3.555.192 5.246.559a5.47 5.47 0 014.195 4.195z',
	size: 24,
};

export const CHECKBOX_EMPTY_OUTLINE = CHECKBOX_EMPTY_OUTLINE_24;
export const CHECKBOX_EMPTY_24 = CHECKBOX_EMPTY_OUTLINE_24;
export const CHECKBOX_EMPTY = CHECKBOX_EMPTY_OUTLINE_24;
// 24x24/file excel/outline.svg
export const FILE_EXCEL_OUTLINE_24 = {
	d: 'M12 2c1.8 0 3.555.192 5.246.559a5.473 5.473 0 014.196 4.195C21.807 8.445 22 10.2 22 12c0 1.8-.193 3.555-.558 5.245a5.473 5.473 0 01-4.196 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.47 5.47 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.472 5.472 0 014.196-4.196A24.776 24.776 0 0112 2zm0 2c-1.626 0-3.249.173-4.823.513a3.481 3.481 0 00-2.664 2.664A22.814 22.814 0 004 12c0 1.626.172 3.249.513 4.823a3.484 3.484 0 002.664 2.664 22.886 22.886 0 009.646 0 3.486 3.486 0 002.664-2.664A22.82 22.82 0 0020 12c0-1.626-.172-3.248-.513-4.823a3.486 3.486 0 00-2.664-2.664A22.872 22.872 0 0012 4zM9.659 7H7.058l3.613 4.972L7 17h2.413l1.951-2.8a5.25 5.25 0 00.549-1.014c.116.329.304.685.506.985L14.384 17H17l-3.714-5.071L16.869 7h-2.413l-1.878 2.715a4.53 4.53 0 00-.52.985 4.763 4.763 0 00-.506-.971L9.659 7z',
	size: 24,
};

export const FILE_EXCEL_OUTLINE = FILE_EXCEL_OUTLINE_24;
export const FILE_EXCEL_24 = FILE_EXCEL_OUTLINE_24;
export const FILE_EXCEL = FILE_EXCEL_OUTLINE_24;
// 24x24/file excel/filled.svg
export const FILE_EXCEL_FILLED_24 = {
	d: 'M14.384 17H17l-3.714-5.071L16.869 7h-2.413l-1.878 2.715c-.202.286-.39.641-.52.985a4.713 4.713 0 00-.506-.971L9.659 7H7.058l3.613 4.972L7 17h2.413l1.95-2.8a5.25 5.25 0 00.55-1.014c.117.329.304.685.506.985L14.384 17zm7.058-10.246C21.808 8.445 22 10.2 22 12c0 1.8-.192 3.555-.558 5.245a5.472 5.472 0 01-4.196 4.196A24.711 24.711 0 0112 22c-1.8 0-3.554-.192-5.246-.559a5.473 5.473 0 01-4.196-4.196A24.825 24.825 0 012 12c0-1.801.193-3.556.558-5.246a5.473 5.473 0 014.197-4.196A24.766 24.766 0 0112 2c1.8 0 3.555.192 5.246.559a5.472 5.472 0 014.196 4.195z',
	size: 24,
};

export const FILE_EXCEL_FILLED = FILE_EXCEL_FILLED_24;
// 24x24/file video/outline.svg
export const FILE_VIDEO_OUTLINE_24 = {
	d: 'M9 7l8 5-8 5V7zm3-5c1.8 0 3.555.192 5.246.559a5.473 5.473 0 014.196 4.195C21.807 8.445 22 10.2 22 12c0 1.8-.193 3.555-.558 5.245a5.473 5.473 0 01-4.196 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.47 5.47 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.472 5.472 0 014.196-4.196A24.776 24.776 0 0112 2zm0 2c-1.626 0-3.249.173-4.823.513a3.481 3.481 0 00-2.664 2.664A22.814 22.814 0 004 12c0 1.626.172 3.249.513 4.823a3.484 3.484 0 002.664 2.664 22.886 22.886 0 009.646 0 3.486 3.486 0 002.664-2.664A22.82 22.82 0 0020 12c0-1.626-.172-3.248-.513-4.823a3.486 3.486 0 00-2.664-2.664A22.872 22.872 0 0012 4z',
	size: 24,
};

export const FILE_VIDEO_OUTLINE = FILE_VIDEO_OUTLINE_24;
export const FILE_VIDEO_24 = FILE_VIDEO_OUTLINE_24;
export const FILE_VIDEO = FILE_VIDEO_OUTLINE_24;
// 24x24/file video/filled.svg
export const FILE_VIDEO_FILLED_24 = {
	d: 'M9 17l8-5-8-5v10zM21.442 6.754C21.808 8.445 22 10.2 22 12c0 1.8-.192 3.555-.558 5.245a5.473 5.473 0 01-4.196 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.472 5.472 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.473 5.473 0 014.196-4.196A24.776 24.776 0 0112 2c1.8 0 3.555.192 5.246.559a5.473 5.473 0 014.196 4.195z',
	size: 24,
};

export const FILE_VIDEO_FILLED = FILE_VIDEO_FILLED_24;
// 24x24/device tablet/outline.svg
export const DEVICE_TABLET_OUTLINE_24 = {
	d: 'M12.6 18h-1.2a.4.4 0 01-.4-.4v-1.2a.4.4 0 01.4-.4h1.2a.4.4 0 01.4.4v1.2a.4.4 0 01-.4.4zM6 20h12V4H6v16zM18 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2z',
	size: 24,
};

export const DEVICE_TABLET_OUTLINE = DEVICE_TABLET_OUTLINE_24;
export const DEVICE_TABLET_24 = DEVICE_TABLET_OUTLINE_24;
export const DEVICE_TABLET = DEVICE_TABLET_OUTLINE_24;
// 24x24/radio button checked/filled.svg
export const RADIO_BUTTON_CHECKED_FILLED_24 = {
	d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 6a4 4 0 100 8 4 4 0 000-8z',
	size: 24,
};

export const RADIO_BUTTON_CHECKED_FILLED = RADIO_BUTTON_CHECKED_FILLED_24;
// 24x24/write/outline.svg
export const WRITE_OUTLINE_24 = {
	d: 'M20.5 21.5a1 1 0 100-2h-17a1 1 0 100 2h17zm-.586-18.414a2 2 0 010 2.828l-1 1-2.828-2.828 1-1a2 2 0 012.828 0zm-4.828 2l2.828 2.828-9 9L4.5 18.5l1.586-4.414 9-9z',
	size: 24,
};

export const WRITE_OUTLINE = WRITE_OUTLINE_24;
export const WRITE_24 = WRITE_OUTLINE_24;
export const WRITE = WRITE_OUTLINE_24;
// 24x24/diamond/outline.svg
export const DIAMOND_OUTLINE_24 = {
	d: 'M7.48 5h2.01l-1 3H5.081l2.4-3zm8.076 5h3.334l-5 6.111L15.556 10zm-5.38-2l1-3h1.629l1.014 3h-3.643zm3.723 2L12 16.96 10.102 10h3.796zm-5.456 0l1.668 6.111-5-6.111h3.332zM18.92 8h-3.412l-1.014-3h2.027l2.399 3zm2.863.375l-4-5A1.004 1.004 0 0017 3H7c-.304 0-.59.138-.782.375l-4 5a1.005 1.005 0 00.007 1.258l9 11a1.002 1.002 0 001.549 0l9-11A1.02 1.02 0 0022 9a.989.989 0 00-.218-.625z',
	size: 24,
};

export const DIAMOND_OUTLINE = DIAMOND_OUTLINE_24;
export const DIAMOND_24 = DIAMOND_OUTLINE_24;
export const DIAMOND = DIAMOND_OUTLINE_24;
// 24x24/gitlab/filled.svg
export const GITLAB_FILLED_24 = {
	d: 'M21.94 13.36l-1.049-3.224a.436.436 0 00-.026-.087L18.761 3.57a.839.839 0 00-.8-.57.823.823 0 00-.789.575l-2.005 6.173h-6.33l-2.01-6.174A.82.82 0 006.04 3h-.005a.839.839 0 00-.797.575l-2.106 6.487c0 .006-.005.01-.006.017l-1.068 3.28a1.195 1.195 0 00.435 1.34l9.225 6.705c.167.122.393.12.56-.003l9.226-6.701c.421-.306.597-.848.435-1.34z',
	size: 24,
};

export const GITLAB_FILLED = GITLAB_FILLED_24;
// 24x24/edit/filled.svg
export const EDIT_FILLED_24 = {
	d: 'M20.7 6.37c.204-.204.3-.473.3-.739 0-.259-.105-.512-.3-.708L19.077 3.3a1.008 1.008 0 00-.707-.3c-.268 0-.536.096-.74.3l-1.324 1.323 3.071 3.07L20.7 6.37zM4.825 16.103L15.282 5.646l3.071 3.072L7.896 19.175a4.11 4.11 0 01-1.902 1.077L3 21l.748-2.994a4.118 4.118 0 011.077-1.903z',
	size: 24,
};

export const EDIT_FILLED = EDIT_FILLED_24;
// 24x24/mail move/outline.svg
export const MAIL_MOVE_OUTLINE_24 = {
	d: 'M12 3c1.892 0 3.783.143 5.518.424 2.089.338 3.736 1.99 4.098 4.109A26.58 26.58 0 0122 12a26.58 26.58 0 01-.384 4.467 5.037 5.037 0 01-4.18 4.122A34.84 34.84 0 0112 21c-1.893 0-3.721-.139-5.435-.411a5.037 5.037 0 01-4.181-4.123A26.56 26.56 0 012 12h2c0 1.36.12 2.749.355 4.129.003.017.01.032.013.049l3.722-3.861-.707-.53L9 10.491l3 2.258 7.4-5.55c.011-.008.023-.009.034-.016-.397-.934-1.226-1.622-2.236-1.786A33.593 33.593 0 0012 5h-1L9 3.144A33.71 33.71 0 0112 3zm2.297 10.527L12 15.25l-2.297-1.723-4.272 4.43c.408.334.9.57 1.448.657 3.221.512 7.021.512 10.243 0a3.034 3.034 0 001.447-.657l-4.272-4.43zm5.54-4.155l-3.927 2.945 3.722 3.861.013-.048C19.88 14.749 20 13.36 20 12c0-.867-.066-1.747-.163-2.628zM5 3l5 4-5 4V8H2a1 1 0 110-2h3V3z',
	size: 24,
};

export const MAIL_MOVE_OUTLINE = MAIL_MOVE_OUTLINE_24;
export const MAIL_MOVE_24 = MAIL_MOVE_OUTLINE_24;
export const MAIL_MOVE = MAIL_MOVE_OUTLINE_24;
// 24x24/arrow back group/outine.svg
export const ARROW_BACK_GROUP_OUTINE_24 = {
	d: 'M15 7.5c3.859 0 7 3.141 7 7s-3.141 7-7 7h-5a1 1 0 110-2h5c2.757 0 5-2.243 5-5s-2.243-5-5-5h-1v5l-8-6 8-6v5h1zm-6 7v-2l-5.505-4L9 4.5v-2l-8 6 8 6z',
	size: 24,
};

export const ARROW_BACK_GROUP_OUTINE = ARROW_BACK_GROUP_OUTINE_24;
// 24x24/volume up/outline.svg
export const VOLUME_UP_OUTLINE_24 = {
	d: 'M12 4c-.2 0-.4.1-.6.2L6 8H4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2l5.4 3.8c.2.1.4.2.6.2.5 0 1-.4 1-1V5c0-.6-.5-1-1-1zm-1 13.1l-3.8-2.7-.6-.4H4v-4h2.6l.5-.4L11 6.9v10.2zM17 9v6c0 .6-.4 1-1 1s-1-.4-1-1V9c0-.6.4-1 1-1s1 .4 1 1zm4-3v12c0 .6-.4 1-1 1s-1-.4-1-1V6c0-.6.4-1 1-1s1 .4 1 1z',
	size: 24,
};

export const VOLUME_UP_OUTLINE = VOLUME_UP_OUTLINE_24;
export const VOLUME_UP_24 = VOLUME_UP_OUTLINE_24;
export const VOLUME_UP = VOLUME_UP_OUTLINE_24;
// 24x24/volume up/filled.svg
export const VOLUME_UP_FILLED_24 = {
	d: 'M13 5v14c0 .6-.5 1-1 1-.2 0-.4-.1-.6-.2L6 16H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2l5.4-3.8c.2-.1.4-.2.6-.2.5 0 1 .4 1 1zm3 3c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1s1-.4 1-1V9c0-.6-.4-1-1-1zm4-3c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1s1-.4 1-1V6c0-.6-.4-1-1-1z',
	size: 24,
};

export const VOLUME_UP_FILLED = VOLUME_UP_FILLED_24;
// 24x24/overflow menu horizontal/filled.svg
export const OVERFLOW_MENU_HORIZONTAL_FILLED_24 = {
	d: 'M20 12a2 2 0 10-4.001.001A2 2 0 0020 12zm-6 0a2 2 0 10-4.001.001A2 2 0 0014 12zm-8 2a2 2 0 11.001-4.001A2 2 0 016 14z',
	size: 24,
};

export const OVERFLOW_MENU_HORIZONTAL_FILLED = OVERFLOW_MENU_HORIZONTAL_FILLED_24;
// 24x24/lightbulb/outline.svg
export const LIGHTBULB_OUTLINE_24 = {
	d: 'M15.583 12.407c-.587.678-1.229 1.435-1.475 2.593H13v-3.382l1.447-.724a1 1 0 10-.894-1.789L12 9.882l-1.553-.777a1 1 0 10-.894 1.789l1.447.724V15H9.892c-.246-1.158-.888-1.915-1.475-2.593C7.657 11.53 7 10.77 7 9c0-2.99 2.585-5 5-5s5 2.01 5 5c0 1.77-.657 2.53-1.417 3.407zM13 20h-2a.99.99 0 01-.979-.9h3.958A.99.99 0 0113 20zm-3-2.1h4V17h-4v.9zM12 2C8.634 2 5 4.677 5 9c0 2.516 1.057 3.736 1.905 4.717C7.564 14.477 8 14.98 8 16v3c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3v-3c0-1.02.436-1.523 1.095-2.283C17.943 12.737 19 11.517 19 9c0-4.323-3.634-7-7-7z',
	size: 24,
};

export const LIGHTBULB_OUTLINE = LIGHTBULB_OUTLINE_24;
export const LIGHTBULB_24 = LIGHTBULB_OUTLINE_24;
export const LIGHTBULB = LIGHTBULB_OUTLINE_24;
// 24x24/lightbulb/filled.svg
export const LIGHTBULB_FILLED_24 = {
	d: 'M10 18h4v-1h-4v1zm3 2h-2a1 1 0 01-1-1h4a1 1 0 01-1 1zm-3.357-9.284a.8.8 0 01.714-1.432l1.643.821 1.643-.821a.8.8 0 11.714 1.432l-1.557.778V15h-1.6v-3.506l-1.557-.778zM12 2C8.634 2 5 4.677 5 9c0 2.517 1.057 3.736 1.905 4.717C7.564 14.478 8 14.98 8 16v3c0 .505.138.974.358 1.392l.031.055c.067.121.139.239.222.348.009.013.02.023.029.035.155.199.332.376.531.531.033.026.063.055.097.08.07.05.145.091.22.135.081.049.163.095.249.136a3.097 3.097 0 00.537.189c.06.015.118.033.178.043.179.034.36.056.548.056h2c.188 0 .369-.022.548-.056.06-.01.118-.028.178-.043a3.097 3.097 0 00.537-.189 2.85 2.85 0 00.249-.136c.075-.044.15-.085.22-.135.035-.025.064-.054.097-.081.198-.154.376-.331.53-.529.01-.013.021-.023.03-.036.083-.11.155-.227.222-.347l.031-.056c.221-.418.358-.887.358-1.392v-3c0-1.02.436-1.522 1.095-2.283C17.943 12.736 19 11.517 19 9c0-4.323-3.634-7-7-7z',
	size: 24,
};

export const LIGHTBULB_FILLED = LIGHTBULB_FILLED_24;
// 24x24/selected/outline.svg
export const SELECTED_OUTLINE_24 = {
	d: 'M12 15a3 3 0 100-6 3 3 0 000 6z',
	size: 24,
};

export const SELECTED_OUTLINE = SELECTED_OUTLINE_24;
export const SELECTED_24 = SELECTED_OUTLINE_24;
export const SELECTED = SELECTED_OUTLINE_24;
// 24x24/arrow right/outline.svg
export const ARROW_RIGHT_OUTLINE_24 = {
	d: 'M21.707 11.293l-6-6a.997.997 0 00-1.414 0A1.006 1.006 0 0014 6a.989.989 0 00.293.707L18.586 11H3a1 1 0 100 2h15.586l-4.293 4.293a.997.997 0 000 1.414c.194.194.452.292.707.293a.989.989 0 00.707-.293l6-6a.997.997 0 000-1.414z',
	size: 24,
};

export const ARROW_RIGHT_OUTLINE = ARROW_RIGHT_OUTLINE_24;
export const ARROW_RIGHT_24 = ARROW_RIGHT_OUTLINE_24;
export const ARROW_RIGHT = ARROW_RIGHT_OUTLINE_24;
// 24x24/arrow right/filled.svg
export const ARROW_RIGHT_FILLED_24 = {
	d: 'M21.65 11.24l-7-6a1.001 1.001 0 00-1.65.759v5H3a1 1 0 100 2h10v5a.998.998 0 001.65.759l7-6a1.001 1.001 0 000-1.518z',
	size: 24,
};

export const ARROW_RIGHT_FILLED = ARROW_RIGHT_FILLED_24;
// 24x24/company/outline.svg
export const COMPANY_OUTLINE_24 = {
	d: 'M14 20v-5h-4v5H7v-7h10v7h-3zM7 7h10V5H7v2zm0 4h10V9H7v2zm14 9h-2V4a1 1 0 00-1-1H6a1 1 0 00-1 1v16H3a1 1 0 100 2h18a1 1 0 100-2z',
	size: 24,
};

export const COMPANY_OUTLINE = COMPANY_OUTLINE_24;
export const COMPANY_24 = COMPANY_OUTLINE_24;
export const COMPANY = COMPANY_OUTLINE_24;
// 24x24/company/filled.svg
export const COMPANY_FILLED_24 = {
	d: 'M10 20h4v-5h-4v5zm-3-9h10V9H7v2zm0-4h10V5H7v2zm14 13h-2V4a1 1 0 00-1-1H6a1 1 0 00-1 1v16H3a1 1 0 100 2h18a1 1 0 100-2z',
	size: 24,
};

export const COMPANY_FILLED = COMPANY_FILLED_24;
// 24x24/visibility off/outline.svg
export const VISIBILITY_OFF_OUTLINE_24 = {
	d: 'M15.583 16.986L6.759 8.162C5.066 9.523 3.801 11.174 3.221 12c1.087 1.548 4.58 6 8.797 6 1.27 0 2.472-.408 3.565-1.014zm5.135 2.307a1 1 0 01-1.414 1.414l-2.257-2.257c-1.477.907-3.174 1.55-5.029 1.55-6.204 0-10.666-7.173-10.853-7.478A1.02 1.02 0 011 12c0-.182.067-.363.165-.523.109-.178 1.664-2.68 4.166-4.743L3.304 4.707a.999.999 0 111.414-1.414l16 16zM23.011 12a.99.99 0 01-.148.522c-.091.15-1.213 1.944-3.056 3.738l-1.415-1.415a20.648 20.648 0 002.417-2.844c-1.087-1.548-4.581-6-8.798-6a6.62 6.62 0 00-2.102.362L8.372 4.826c1.123-.5 2.34-.826 3.639-.826 6.203 0 10.666 7.173 10.852 7.477.099.16.148.341.148.523z',
	size: 24,
};

export const VISIBILITY_OFF_OUTLINE = VISIBILITY_OFF_OUTLINE_24;
export const VISIBILITY_OFF_24 = VISIBILITY_OFF_OUTLINE_24;
export const VISIBILITY_OFF = VISIBILITY_OFF_OUTLINE_24;
// 24x24/visibility off/filled.svg
export const VISIBILITY_OFF_FILLED_24 = {
	d: 'M22.853 11.477C22.666 11.172 18.204 4 12 4c-1.298 0-2.515.326-3.638.827L19.796 16.26c1.844-1.794 2.966-3.59 3.057-3.738a.99.99 0 00.147-.524.99.99 0 00-.147-.522zm-2.146 7.816a.999.999 0 11-1.414 1.413l-2.261-2.26c-1.478.907-3.175 1.553-5.032 1.553-6.203 0-10.666-7.171-10.852-7.476a1 1 0 010-1.046c.108-.178 1.669-2.68 4.175-4.74l-2.03-2.03a1 1 0 011.414-1.414l16 16z',
	size: 24,
};

export const VISIBILITY_OFF_FILLED = VISIBILITY_OFF_FILLED_24;
// 24x24/history/outline.svg
export const HISTORY_OUTLINE_24 = {
	d: 'M12 6a1 1 0 00-1 1v6c0 .334.167.646.445.832l3 2a1.004 1.004 0 001.387-.277 1 1 0 00-.277-1.387L13 12.465V7a1 1 0 00-1-1zm10 6c0 5.514-4.486 10-10 10a9.966 9.966 0 01-9.948-8.979l1.99-.202A7.97 7.97 0 0012 20c4.411 0 8-3.589 8-8s-3.589-8-8-8a7.983 7.983 0 00-6.122 2.878L8 9H2V3l2.461 2.461C6.34 3.298 9.067 2 12 2c5.514 0 10 4.486 10 10z',
	size: 24,
};

export const HISTORY_OUTLINE = HISTORY_OUTLINE_24;
export const HISTORY_24 = HISTORY_OUTLINE_24;
export const HISTORY = HISTORY_OUTLINE_24;
// 24x24/settings/outline.svg
export const SETTINGS_OUTLINE_24 = {
	d: 'M12 14c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6a4 4 0 100 8 4 4 0 000-8zm6.176 9.044l.047.047-1.132 1.131-.046-.046a2.321 2.321 0 00-2.576-.496l-.199.083a2.315 2.315 0 00-1.47 2.171V20h-1.6v-.066c0-.968-.577-1.82-1.469-2.171l-.202-.083a2.315 2.315 0 00-2.574.496l-.046.046-1.132-1.131.048-.047a2.317 2.317 0 00.497-2.57l-.085-.203A2.313 2.313 0 004.065 12.8H4v-1.6h.065a2.31 2.31 0 002.17-1.465l.085-.206a2.315 2.315 0 00-.496-2.573l-.047-.047 1.132-1.131.046.046a2.319 2.319 0 002.576.496l.199-.083a2.315 2.315 0 001.47-2.172V4h1.6v.065c0 .969.577 1.821 1.469 2.172l.202.083a2.32 2.32 0 002.574-.496l.046-.046 1.132 1.131-.048.047a2.317 2.317 0 00-.497 2.57l.085.203a2.311 2.311 0 002.172 1.471H20v1.6h-.065c-.969 0-1.822.577-2.171 1.466l-.084.205a2.315 2.315 0 00.496 2.573zm1.448-2.043a.332.332 0 01.311-.201H22V9.2h-2.065a.333.333 0 01-.313-.208l-.108-.26a.326.326 0 01.076-.362l1.461-1.461-3.96-3.96-1.46 1.46a.328.328 0 01-.361.078 6.52 6.52 0 00-.268-.111.33.33 0 01-.202-.311V2H9.2v2.065a.33.33 0 01-.203.311 7.29 7.29 0 00-.265.11.328.328 0 01-.363-.076l-1.46-1.461-3.96 3.96 1.46 1.46c.1.1.13.242.075.366l-.108.264a.332.332 0 01-.311.201H2v5.6h2.065c.139 0 .263.081.312.205l.109.263a.326.326 0 01-.076.362l-1.461 1.461 3.96 3.96 1.46-1.46a.322.322 0 01.361-.078c.088.039.176.075.268.111a.33.33 0 01.202.31V22h5.6v-2.066a.33.33 0 01.203-.31 7.29 7.29 0 00.265-.11.33.33 0 01.363.076l1.46 1.461 3.96-3.96-1.46-1.46a.326.326 0 01-.075-.366l.108-.264z',
	size: 24,
};

export const SETTINGS_OUTLINE = SETTINGS_OUTLINE_24;
export const SETTINGS_24 = SETTINGS_OUTLINE_24;
export const SETTINGS = SETTINGS_OUTLINE_24;
// 24x24/settings/filled.svg
export const SETTINGS_FILLED_24 = {
	d: 'M12 16a4 4 0 110-8 4 4 0 010 8zm8.815-6a1.476 1.476 0 01-1.378-.929c-.035-.087-.07-.174-.107-.259a1.477 1.477 0 01.317-1.631l.838-.838-2.828-2.828-.838.837a1.476 1.476 0 01-1.631.318c-.085-.037-.172-.072-.259-.107A1.476 1.476 0 0114 3.184V2h-4v1.184c0 .607-.364 1.157-.929 1.379-.087.035-.174.07-.259.107a1.476 1.476 0 01-1.631-.318l-.838-.837-2.828 2.828.837.838c.429.428.56 1.074.318 1.631-.037.085-.072.172-.107.259A1.476 1.476 0 013.184 10H2v4h1.184c.607 0 1.157.364 1.379.929.035.087.07.174.107.259a1.476 1.476 0 01-.318 1.631l-.837.838 2.828 2.828.838-.838a1.477 1.477 0 011.631-.317c.085.037.172.072.259.107.565.222.929.772.929 1.378V22h4v-1.185c0-.606.364-1.156.929-1.378.087-.035.174-.07.259-.107a1.477 1.477 0 011.631.317l.838.838 2.828-2.828-.838-.838a1.477 1.477 0 01-.317-1.631c.037-.085.072-.172.107-.259A1.476 1.476 0 0120.815 14H22v-4h-1.185z',
	size: 24,
};

export const SETTINGS_FILLED = SETTINGS_FILLED_24;
// 24x24/copy to clipboard/outline.svg
export const COPY_TO_CLIPBOARD_OUTLINE_24 = {
	d: 'M19 2H8a1 1 0 00-1 1v3H4a1 1 0 00-1 1v14a1 1 0 001 1h11a1 1 0 001-1v-3h3a1 1 0 001-1V3a1 1 0 00-1-1zm-8 6.83L13.17 11H11V8.83zM5 20V8h4v5h5v7H5zm13-4h-2v-5l-5-5H9V4h9v12z',
	size: 24,
};

export const COPY_TO_CLIPBOARD_OUTLINE = COPY_TO_CLIPBOARD_OUTLINE_24;
export const COPY_TO_CLIPBOARD_24 = COPY_TO_CLIPBOARD_OUTLINE_24;
export const COPY_TO_CLIPBOARD = COPY_TO_CLIPBOARD_OUTLINE_24;
// 24x24/check squircle/outline.svg
export const CHECK_SQUIRCLE_OUTLINE_24 = {
	d: 'M11.769 15.641l6-6a1.003 1.003 0 00-.128-1.41 1.002 1.002 0 00-1.41.128c-.352.423-5.298 5.16-5.298 5.16l-2.226-2.226a.999.999 0 10-1.414 1.414l3 3A1 1 0 0011 16l.045-.001c.28-.013.543-.143.724-.358zM11.999 2c-1.8 0-3.554.192-5.244.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.444 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.473 5.473 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.245a5.473 5.473 0 00-4.196-4.196A24.711 24.711 0 0012 2zm4.824 2.513a3.487 3.487 0 012.664 2.664 22.886 22.886 0 010 9.646 3.487 3.487 0 01-2.664 2.664 22.886 22.886 0 01-9.646 0 3.486 3.486 0 01-2.664-2.664 22.886 22.886 0 010-9.646 3.484 3.484 0 012.664-2.664 22.886 22.886 0 019.646 0z',
	size: 24,
};

export const CHECK_SQUIRCLE_OUTLINE = CHECK_SQUIRCLE_OUTLINE_24;
export const CHECK_SQUIRCLE_24 = CHECK_SQUIRCLE_OUTLINE_24;
export const CHECK_SQUIRCLE = CHECK_SQUIRCLE_OUTLINE_24;
// 24x24/check squircle/filled.svg
export const CHECK_SQUIRCLE_FILLED_24 = {
	d: 'M12 2c1.8 0 3.555.192 5.246.559a5.47 5.47 0 014.195 4.195C21.808 8.445 22 10.2 22 12c0 1.8-.192 3.555-.559 5.245a5.47 5.47 0 01-4.195 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.472 5.472 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.473 5.473 0 014.196-4.196A24.776 24.776 0 0112 2zM7.293 12.707l3 3A.995.995 0 0011 16l.045-.001c.281-.013.543-.143.723-.358l6.001-6a1.004 1.004 0 00-.128-1.41 1.005 1.005 0 00-1.41.128l-5.298 5.16-2.226-2.226a.997.997 0 00-1.414 0 .999.999 0 000 1.414z',
	size: 24,
};

export const CHECK_SQUIRCLE_FILLED = CHECK_SQUIRCLE_FILLED_24;
// 24x24/close/outline.svg
export const CLOSE_OUTLINE_24 = {
	d: 'M13.414 12l4.293-4.293C17.901 7.513 18 7.254 18 7a.985.985 0 00-.293-.707.996.996 0 00-1.414 0L12 10.586 7.707 6.293a.997.997 0 00-1.414 0 .997.997 0 000 1.414L10.586 12l-4.293 4.293a.997.997 0 000 1.414.997.997 0 001.414 0L12 13.414l4.293 4.293a.997.997 0 001.414 0 1.003 1.003 0 000-1.414L13.414 12z',
	size: 24,
};

export const CLOSE_OUTLINE = CLOSE_OUTLINE_24;
export const CLOSE_24 = CLOSE_OUTLINE_24;
export const CLOSE = CLOSE_OUTLINE_24;
// 24x24/whatsapp/outline.svg
export const WHATSAPP_OUTLINE_24 = {
	d: 'M16.508 13.982c-.248-.124-1.465-.723-1.692-.806-.227-.082-.392-.124-.557.124-.165.248-.64.805-.784.97-.144.166-.288.187-.536.063-.248-.124-1.045-.386-1.99-1.23-.737-.655-1.234-1.466-1.378-1.714-.144-.248-.015-.382.109-.505.111-.111.247-.29.37-.434.125-.144.166-.248.248-.413.083-.165.042-.31-.02-.434s-.557-1.342-.763-1.838c-.201-.482-.405-.417-.557-.425a9.919 9.919 0 00-.475-.008.91.91 0 00-.66.31c-.227.247-.866.846-.866 2.065 0 1.218.887 2.395 1.01 2.56.124.166 1.746 2.666 4.23 3.739.59.255 1.051.407 1.41.52.594.19 1.133.163 1.56.099.476-.071 1.464-.599 1.67-1.177.207-.578.207-1.074.145-1.177-.062-.104-.227-.166-.474-.29zm-4.517 6.167h-.003a8.223 8.223 0 01-4.192-1.148l-.3-.178-3.117.817.832-3.038-.196-.312a8.215 8.215 0 01-1.26-4.382c.003-4.54 3.697-8.235 8.24-8.235a8.181 8.181 0 015.821 2.415 8.185 8.185 0 012.41 5.826c-.002 4.54-3.696 8.235-8.235 8.235zm7.008-15.243A9.843 9.843 0 0011.991 2C6.53 2 2.085 6.444 2.083 11.907a9.89 9.89 0 001.323 4.953L2 21.994l5.252-1.378a9.898 9.898 0 004.735 1.206h.004c5.46 0 9.905-4.444 9.907-9.907A9.848 9.848 0 0019 4.905z',
	size: 24,
};

export const WHATSAPP_OUTLINE = WHATSAPP_OUTLINE_24;
export const WHATSAPP_24 = WHATSAPP_OUTLINE_24;
export const WHATSAPP = WHATSAPP_OUTLINE_24;
// 24x24/whatsapp/filled.svg
export const WHATSAPP_FILLED_24 = {
	d: 'M16.508 13.982c-.248-.124-1.465-.723-1.692-.806-.227-.082-.392-.124-.557.124-.165.248-.64.805-.784.97-.144.166-.288.187-.536.063-.248-.124-1.045-.386-1.99-1.23-.737-.655-1.234-1.466-1.378-1.714-.144-.248-.015-.382.109-.505.111-.111.247-.29.37-.434.125-.144.166-.248.248-.413.083-.165.042-.31-.02-.434s-.557-1.342-.763-1.838c-.201-.482-.405-.417-.557-.425a9.92 9.92 0 00-.475-.008.91.91 0 00-.66.31c-.227.247-.866.846-.866 2.065 0 1.218.887 2.395 1.01 2.56.124.166 1.746 2.666 4.23 3.739.59.255 1.051.407 1.41.52.594.19 1.133.163 1.56.099.476-.071 1.464-.599 1.67-1.177.207-.578.207-1.074.145-1.177-.062-.104-.227-.166-.474-.29zm2.491-9.076A9.843 9.843 0 0011.991 2C6.53 2 2.085 6.444 2.083 11.907a9.89 9.89 0 001.323 4.953L2 21.994l5.252-1.378a9.897 9.897 0 004.735 1.206h.004c5.46 0 9.905-4.444 9.907-9.907A9.848 9.848 0 0019 4.905z',
	size: 24,
};

export const WHATSAPP_FILLED = WHATSAPP_FILLED_24;
// 24x24/calendar search/filled.svg
export const CALENDAR_SEARCH_FILLED_24 = {
	d: 'M11 21.979v-1.994c-2.667-.076-4.38-.486-5.439-1.546C4.374 17.252 4 15.251 4 12c0-.814.023-1.55.077-2.213.054-.664.138-1.257.26-1.786h15.326c.121.529.206 1.122.26 1.786.03.379.049.787.061 1.213h1.995c-.103-3.236-.722-5.44-2.13-6.847-.726-.727-1.67-1.237-2.849-1.583V4a1 1 0 11-2 0V2.172A24.231 24.231 0 0012 2a24.22 24.22 0 00-3 .17V4a1 1 0 11-2 0V2.569c-1.179.346-2.123.856-2.849 1.583C2.601 5.702 2 8.202 2 11.999c0 3.8.601 6.3 2.151 7.85 1.409 1.407 3.612 2.026 6.849 2.13zM6.199 11.203a1.418 1.418 0 112.835-.001 1.418 1.418 0 01-2.835 0zM15 18c1.654 0 3-1.346 3-3 0-1.655-1.346-3-3-3s-3 1.345-3 3c0 1.654 1.346 3 3 3zm6.631 2.241c.239.233.365.474.37.759a.988.988 0 01-1 1c-.215-.002-.507-.113-.76-.37-.862-.87-1.696-1.951-2.222-2.671A4.946 4.946 0 0115 19.998c-2.757 0-5-2.242-5-5 0-2.756 2.243-5 5-5s5 2.244 5 5c0 1.143-.4 2.184-1.047 3.027.731.543 1.833 1.396 2.678 2.215z',
	size: 24,
};

export const CALENDAR_SEARCH_FILLED = CALENDAR_SEARCH_FILLED_24;
// 24x24/squircle crossed/outline.svg
export const SQUIRCLE_CROSSED_OUTLINE_24 = {
	d: 'M18.83 9.413l1.742-1.742a22.256 22.256 0 01-.075 9.05 4.925 4.925 0 01-3.776 3.777 22.224 22.224 0 01-9.051.073l1.743-1.742c.856.109 1.72.171 2.587.171 1.45 0 2.895-.154 4.298-.457a2.936 2.936 0 002.245-2.244c.303-1.404.457-2.85.457-4.299 0-.866-.062-1.731-.17-2.587zM5.17 14.587L3.428 16.33a22.301 22.301 0 01.074-9.052A4.928 4.928 0 017.28 3.502a22.322 22.322 0 019.05-.073l-1.742 1.742A20.3 20.3 0 0012 5c-1.45 0-2.896.153-4.298.457a2.933 2.933 0 00-2.245 2.244A20.399 20.399 0 005 12c0 .867.061 1.731.171 2.587zM4.001 21a.997.997 0 00.706-.293l16-16a.999.999 0 10-1.414-1.414l-16 16A.999.999 0 004 21z',
	size: 24,
};

export const SQUIRCLE_CROSSED_OUTLINE = SQUIRCLE_CROSSED_OUTLINE_24;
export const SQUIRCLE_CROSSED_24 = SQUIRCLE_CROSSED_OUTLINE_24;
export const SQUIRCLE_CROSSED = SQUIRCLE_CROSSED_OUTLINE_24;
// 24x24/radio alt1/outline.svg
export const RADIO_ALT1_OUTLINE_24 = {
	d: 'M18 15a1 1 0 01-1 1h-3a1 1 0 110-2h3a1 1 0 011 1zm0-4a1 1 0 01-1 1h-3a1 1 0 110-2h3a1 1 0 011 1zm-6 2a3 3 0 11-6 0 3 3 0 016 0zm8 2.579a2 2 0 01-1.74 1.984c-2.271.291-4.377.437-6.26.437s-3.989-.146-6.26-.437A2 2 0 014 15.579v-5.158a2 2 0 011.74-1.984C8.011 8.146 10.117 8 12 8s3.989.146 6.26.437c.072.009.14.03.21.046l.276.107c.025.01.051.007.076.014A1.998 1.998 0 0120 10.421v5.158zm-.893-8.994L7.359 2.066a1.003 1.003 0 00-1.293.575c-.198.515.06 1.094.575 1.293L12.014 6H12c-2.343 0-4.685.22-6.513.453A3.994 3.994 0 002 10.421v5.158a3.984 3.984 0 003 3.859V21a1 1 0 102 0v-1.279c1.527.158 3.263.279 5 .279s3.473-.121 5-.279V21a1 1 0 102 0v-1.562a3.984 3.984 0 003-3.859v-5.158a3.988 3.988 0 00-2.893-3.836z',
	size: 24,
};

export const RADIO_ALT1_OUTLINE = RADIO_ALT1_OUTLINE_24;
export const RADIO_ALT1_24 = RADIO_ALT1_OUTLINE_24;
export const RADIO_ALT1 = RADIO_ALT1_OUTLINE_24;
// 24x24/radio alt1/filled.svg
export const RADIO_ALT1_FILLED_24 = {
	d: 'M19 11a1 1 0 00-1-1h-3a1 1 0 100 2h3a1 1 0 001-1zm0 4a1 1 0 00-1-1h-3a1 1 0 100 2h3a1 1 0 001-1zm-6-2a4 4 0 10-8 0 4 4 0 008 0zm9-2.579v5.158a3.984 3.984 0 01-3 3.859V21a1 1 0 11-2 0v-1.279A49.318 49.318 0 0112 20c-1.737 0-3.473-.121-5-.279V21a1 1 0 11-2 0v-1.562a3.984 3.984 0 01-3-3.859v-5.158a3.994 3.994 0 013.487-3.968C7.315 6.22 9.657 6 12 6h.014L6.641 3.934a1.002 1.002 0 01-.575-1.293 1.003 1.003 0 011.293-.575l11.748 4.519A3.988 3.988 0 0122 10.421zM11 13c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2z',
	size: 24,
};

export const RADIO_ALT1_FILLED = RADIO_ALT1_FILLED_24;
// 24x24/play/outline.svg
export const PLAY_OUTLINE_24 = {
	d: 'M6.999 3A1 1 0 006 4v16a1 1 0 001.555.832l12-8a1.001 1.001 0 000-1.664l-12-8A1.007 1.007 0 006.999 3zM8 5.868L17.197 12 8 18.132V5.868z',
	size: 24,
};

export const PLAY_OUTLINE = PLAY_OUTLINE_24;
export const PLAY_24 = PLAY_OUTLINE_24;
export const PLAY = PLAY_OUTLINE_24;
// 24x24/play/filled.svg
export const PLAY_FILLED_24 = {
	d: 'M19.555 11.168l-12-8a1.005 1.005 0 00-1.026-.05 1 1 0 00-.53.882v16a1 1 0 001.556.832l12-8a1 1 0 000-1.664z',
	size: 24,
};

export const PLAY_FILLED = PLAY_FILLED_24;
// 24x24/flag cross/outline.svg
export const FLAG_CROSS_OUTLINE_24 = {
	d: 'M15.207 8.707a.999.999 0 10-1.414-1.414L12 9.086l-1.793-1.793a.999.999 0 10-1.414 1.414l1.793 1.793-1.793 1.793a.999.999 0 101.414 1.414L12 11.914l1.793 1.793a.997.997 0 001.414 0 .999.999 0 000-1.414L13.414 10.5l1.793-1.793zM18.5 17.13V5.315c-2.77.614-4.669-.01-6.369-.57C10.968 4.362 9.87 4 8.5 4c-1.089 0-2.095.206-3 .614v10.805c.79-.272 1.711-.419 3-.419 1.759 0 3.022.557 4.243 1.096 1.554.685 3.028 1.339 5.757 1.034zm1.584-13.942A1 1 0 0120.5 4v14a1 1 0 01-.835.986c-.921.154-1.739.219-2.475.219-2.355 0-3.875-.671-5.255-1.279C10.81 17.429 9.838 17 8.5 17c-1.522 0-2.32.242-3 .589V21a1 1 0 11-2 0V3a1 1 0 011-1c.38 0 .699.22.868.531A9.385 9.385 0 018.5 2c1.69 0 2.995.43 4.257.846 1.902.625 3.543 1.166 6.427.206a.991.991 0 01.9.136z',
	size: 24,
};

export const FLAG_CROSS_OUTLINE = FLAG_CROSS_OUTLINE_24;
export const FLAG_CROSS_24 = FLAG_CROSS_OUTLINE_24;
export const FLAG_CROSS = FLAG_CROSS_OUTLINE_24;
// 24x24/flag cross/filled.svg
export const FLAG_CROSS_FILLED_24 = {
	d: 'M15.207 12.293L13.414 10.5l1.793-1.793a.999.999 0 10-1.414-1.414L12 9.086l-1.793-1.793a.999.999 0 10-1.414 1.414l1.793 1.793-1.793 1.793a.999.999 0 101.414 1.414L12 11.914l1.793 1.793a.997.997 0 001.414 0 .999.999 0 000-1.414zm4.878-9.104A1 1 0 0120.5 4v14a1 1 0 01-.836.986c-.92.154-1.737.219-2.474.219-2.355 0-3.876-.671-5.255-1.279C10.81 17.429 9.838 17 8.5 17c-1.522 0-2.319.242-3 .59V21a1 1 0 11-2 0V3a1 1 0 011-1c.38 0 .699.22.868.531A9.42 9.42 0 018.5 2c1.69 0 2.995.43 4.257.846 1.902.626 3.545 1.166 6.427.206a.992.992 0 01.901.137z',
	size: 24,
};

export const FLAG_CROSS_FILLED = FLAG_CROSS_FILLED_24;
// 24x24/bookmark/outline.svg
export const BOOKMARK_OUTLINE_24 = {
	d: 'M16 18.263l-2.891-1.927a2.004 2.004 0 00-2.218 0L8 18.263V5c0-.87.627-1 1-1h6c.373 0 1 .13 1 1v13.263zM15 2H9C7.294 2 6 3.212 6 5v17l6-4 6 4V5c0-1.788-1.294-3-3-3z',
	size: 24,
};

export const BOOKMARK_OUTLINE = BOOKMARK_OUTLINE_24;
export const BOOKMARK_24 = BOOKMARK_OUTLINE_24;
export const BOOKMARK = BOOKMARK_OUTLINE_24;
// 24x24/bookmark/filled.svg
export const BOOKMARK_FILLED_24 = {
	d: 'M9 2C7.294 2 6 3.212 6 5v17l6-4 6 4V5c0-1.788-1.294-3-3-3H9z',
	size: 24,
};

export const BOOKMARK_FILLED = BOOKMARK_FILLED_24;
// 24x24/link/outline.svg
export const LINK_OUTLINE_24 = {
	d: 'M14.293 8.293l-6 6a.999.999 0 101.414 1.414l6-6a.999.999 0 10-1.414-1.414zm6.242-4.828A4.965 4.965 0 0017 2a4.965 4.965 0 00-3.535 1.465l-3.001 3 1.414 1.414 3.001-3c1.133-1.133 3.109-1.133 4.242 0C19.688 5.445 20 6.198 20 7s-.312 1.555-.879 2.121l-3 3 1.414 1.414 3-3A4.96 4.96 0 0022 7a4.96 4.96 0 00-1.465-3.535zm-8.413 12.656l1.414 1.414-3 3A4.967 4.967 0 017 22a4.968 4.968 0 01-3.536-1.465A4.966 4.966 0 012 17c0-1.336.52-2.591 1.464-3.535l3-3 1.415 1.414-3.001 3A2.98 2.98 0 004 17c0 .802.312 1.555.878 2.121 1.134 1.133 3.11 1.133 4.244 0l3-3z',
	size: 24,
};

export const LINK_OUTLINE = LINK_OUTLINE_24;
export const LINK_24 = LINK_OUTLINE_24;
export const LINK = LINK_OUTLINE_24;
// 24x24/mail add/outline.svg
export const MAIL_ADD_OUTLINE_24 = {
	d: 'M22 18a1 1 0 00-1-1h-2v-2a1 1 0 10-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 001-1zM4.368 16.178l3.722-3.861-3.927-2.945A24.103 24.103 0 004 12c0 1.36.12 2.749.355 4.13.003.016.01.032.013.048zm2.433-10.78c-1.009.164-1.838.852-2.235 1.786.011.007.024.008.034.016l7.4 5.55 7.4-5.55c.01-.007.022-.008.032-.014a3.036 3.036 0 00-2.311-1.8 32.975 32.975 0 00-5.16-.385 32.942 32.942 0 00-5.16.397zM12 15.25l-2.297-1.723-4.272 4.43c.408.334.9.57 1.447.657 1.615.257 3.368.377 5.122.37V21a34.84 34.84 0 01-5.436-.411 5.037 5.037 0 01-4.18-4.122A26.58 26.58 0 012 12c0-1.473.129-2.976.384-4.466.362-2.12 2.009-3.771 4.097-4.11A34.95 34.95 0 0112 3c1.861 0 3.721.139 5.436.411a5.037 5.037 0 014.18 4.122A26.58 26.58 0 0122 12c0 .331-.028.666-.043 1h-2c.015-.334.043-.67.043-1 0-.867-.066-1.747-.162-2.628L12 15.25z',
	size: 24,
};

export const MAIL_ADD_OUTLINE = MAIL_ADD_OUTLINE_24;
export const MAIL_ADD_24 = MAIL_ADD_OUTLINE_24;
export const MAIL_ADD = MAIL_ADD_OUTLINE_24;
// 24x24/share/filled.svg
export const SHARE_FILLED_24 = {
	d: 'M23 11l-9-8v4.939c-.867.061-1.732.197-2.584.405-1.567.409-3.097 1.049-4.45 1.969-1.361.898-2.553 2.059-3.415 3.385A9.632 9.632 0 002 17.965c1.047-1.041 2.156-1.855 3.289-2.456a13.036 13.036 0 013.47-1.229 20.422 20.422 0 013.521-.348c.574-.02 1.146-.014 1.72-.003V19l9-8z',
	size: 24,
};

export const SHARE_FILLED = SHARE_FILLED_24;
// 24x24/file powerpoint/outline.svg
export const FILE_POWERPOINT_OUTLINE_24 = {
	d: 'M12 2c1.8 0 3.555.192 5.246.559a5.473 5.473 0 014.196 4.195C21.807 8.445 22 10.2 22 12c0 1.8-.193 3.555-.558 5.245a5.473 5.473 0 01-4.196 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.47 5.47 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.801.192-3.556.558-5.246a5.472 5.472 0 014.196-4.196A24.776 24.776 0 0112 2zm0 2c-1.626 0-3.249.173-4.823.513a3.481 3.481 0 00-2.664 2.664A22.814 22.814 0 004 12c0 1.626.172 3.249.513 4.823a3.484 3.484 0 002.664 2.664 22.886 22.886 0 009.646 0 3.486 3.486 0 002.664-2.664A22.82 22.82 0 0020 12c0-1.626-.172-3.248-.513-4.823a3.486 3.486 0 00-2.664-2.664A22.872 22.872 0 0012 4zm-.878 4.665h2.136c1.149 0 1.561.692 1.561 1.68 0 1.031-.441 1.768-1.561 1.768h-2.136V8.665zM17 10.286C17 8.488 15.895 7 13.789 7H9v10.004h2.122v-3.358h2.548c2.269 0 3.33-1.519 3.33-3.36z',
	size: 24,
};

export const FILE_POWERPOINT_OUTLINE = FILE_POWERPOINT_OUTLINE_24;
export const FILE_POWERPOINT_24 = FILE_POWERPOINT_OUTLINE_24;
export const FILE_POWERPOINT = FILE_POWERPOINT_OUTLINE_24;
// 24x24/file powerpoint/filled.svg
export const FILE_POWERPOINT_FILLED_24 = {
	d: 'M13.67 13.645h-2.549v3.359H9V7h4.788C15.896 7 17 8.488 17 10.286c0 1.841-1.061 3.359-3.33 3.359zm7.772-6.891a5.476 5.476 0 00-4.196-4.196A24.776 24.776 0 0012 2c-1.8 0-3.555.192-5.246.557a5.476 5.476 0 00-4.196 4.197A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.807 10.2 22 12 22c1.8 0 3.555-.193 5.246-.559a5.473 5.473 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.246zm-8.184 1.911h-2.137v3.448h2.137c1.12 0 1.561-.737 1.561-1.768 0-.988-.412-1.68-1.561-1.68z',
	size: 24,
};

export const FILE_POWERPOINT_FILLED = FILE_POWERPOINT_FILLED_24;
// 24x24/maximize alt2/outline.svg
export const MAXIMIZE_ALT2_OUTLINE_24 = {
	d: 'M15 3h4c1.1 0 2 .9 2 2v4c0 .6-.4 1-1 1s-1-.4-1-1V5h-4c-.6 0-1-.4-1-1s.4-1 1-1zM4 10c.6 0 1-.4 1-1V5h4c.6 0 1-.4 1-1s-.4-1-1-1H5c-1.1 0-2 .9-2 2v4c0 .6.4 1 1 1zm6 10c0-.6-.4-1-1-1H5v-4c0-.6-.4-1-1-1s-1 .4-1 1v4c0 1.1.9 2 2 2h4c.6 0 1-.4 1-1zm10-6c-.6 0-1 .4-1 1v4h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c1.1 0 2-.9 2-2v-4c0-.6-.4-1-1-1z',
	size: 24,
};

export const MAXIMIZE_ALT2_OUTLINE = MAXIMIZE_ALT2_OUTLINE_24;
export const MAXIMIZE_ALT2_24 = MAXIMIZE_ALT2_OUTLINE_24;
export const MAXIMIZE_ALT2 = MAXIMIZE_ALT2_OUTLINE_24;
// 24x24/warning squircle/outline.svg
export const WARNING_SQUIRCLE_OUTLINE_24 = {
	d: 'M14 8c0 1-1 5-1 5h-2s-1-4-1-5 1-2 2-2 2 1 2 2zm-.5 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM12 20c-6.654 0-8-1.346-8-8s1.346-8 8-8 8 1.346 8 8-1.346 8-8 8zm0-18C4.215 2 2 4.215 2 12s2.215 10 10 10 10-2.215 10-10S19.785 2 12 2z',
	size: 24,
};

export const WARNING_SQUIRCLE_OUTLINE = WARNING_SQUIRCLE_OUTLINE_24;
export const WARNING_SQUIRCLE_24 = WARNING_SQUIRCLE_OUTLINE_24;
export const WARNING_SQUIRCLE = WARNING_SQUIRCLE_OUTLINE_24;
// 24x24/warning squircle/filled.svg
export const WARNING_SQUIRCLE_FILLED_24 = {
	d: 'M13 13h-2s-1-4-1-5 1-2 2-2 2 1 2 2-1 5-1 5zm-1 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-15C4.215 2 2 4.215 2 12s2.215 10 10 10 10-2.215 10-10S19.785 2 12 2z',
	size: 24,
};

export const WARNING_SQUIRCLE_FILLED = WARNING_SQUIRCLE_FILLED_24;
// 24x24/folder add/outline 1.svg
export const FOLDER_ADD_OUTLINE_1_24 = {
	d: 'M20 9c1.336 0 2 .785 2 2 0 3.36-.873 5.849-1.389 7.408a2.97 2.97 0 01-2.223 1.991C17.02 20.678 15 21 12 21c-.716 0-1.372-.02-1.98-.051a4.948 4.948 0 00.88-1.966c.351.01.715.017 1.1.017 2.901 0 4.808-.32 5.988-.561a.98.98 0 00.725-.659l.064-.194C19.264 16.119 20 13.902 20 11H4c0 .848.067 1.629.168 2.357a5.005 5.005 0 00-1.824 1.253A19.293 19.293 0 012 11c0-1.215.664-2 2-2h16zM4.98 5v3h-2V5c0-1.103.916-2 2.02-2h3c1.357 0 2.088 1.122 2.574 2H18c1.756 0 2.98 1.233 2.98 3h-2c0-.663-.33-1-.98-1H9.98a.999.999 0 01-.873-.514l-.153-.28C8.693 5.726 8.301 5 8 5H4.98zM9 17H7v-2a1 1 0 10-2 0v2H3a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2z',
	size: 24,
};

export const FOLDER_ADD_OUTLINE_1 = FOLDER_ADD_OUTLINE_1_24;
// 24x24/folder add/filled 1.svg
export const FOLDER_ADD_FILLED_1_24 = {
	d: 'M20 9c1.336 0 2 .785 2 2 0 3.36-.873 5.849-1.389 7.408a2.97 2.97 0 01-2.223 1.991C17.02 20.678 15 21 12 21c-.716 0-1.372-.02-1.98-.051A4.96 4.96 0 0011 18a5 5 0 00-5-5 4.975 4.975 0 00-3.656 1.61A19.293 19.293 0 012 11c0-1.215.664-2 2-2h16zm.98-1h-18V5c0-1.103.917-2 2.02-2h3c1.357 0 2.087 1.121 2.574 2H18c1.755 0 2.98 1.233 2.98 3zM9 17H7v-2a1 1 0 10-2 0v2H3a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2z',
	size: 24,
};

export const FOLDER_ADD_FILLED_1 = FOLDER_ADD_FILLED_1_24;
// 24x24/folder add/outline.svg
export const FOLDER_ADD_OUTLINE_24 = {
	d: 'M20 9H4c-1.336 0-2 .785-2 2 0 1.347.143 2.547.344 3.61a5.005 5.005 0 011.824-1.253A17.031 17.031 0 014 11h16c0 2.902-.736 5.119-1.223 6.586l-.064.194a.98.98 0 01-.725.659C16.808 18.68 14.901 19 12 19c-.385 0-.749-.007-1.1-.017a4.948 4.948 0 01-.88 1.966c.608.031 1.264.051 1.98.051 3 0 5.02-.322 6.388-.601a2.97 2.97 0 002.223-1.991C21.127 16.849 22 14.36 22 11c0-1.215-.664-2-2-2zM4.98 5H8c.301 0 .693.726.954 1.206l.153.28A.999.999 0 009.98 7H18c.65 0 .98.337.98 1h2c0-1.767-1.224-3-2.98-3h-7.426C10.088 4.122 9.357 3 8 3H5c-1.104 0-2.02.897-2.02 2v3h2V5zM10 18a1 1 0 01-1 1H7v2a1 1 0 11-2 0v-2H3a1 1 0 110-2h2v-2a1 1 0 112 0v2h2a1 1 0 011 1z',
	size: 24,
};

export const FOLDER_ADD_OUTLINE = FOLDER_ADD_OUTLINE_24;
export const FOLDER_ADD_24 = FOLDER_ADD_OUTLINE_24;
export const FOLDER_ADD = FOLDER_ADD_OUTLINE_24;
// 24x24/folder add/filled.svg
export const FOLDER_ADD_FILLED_24 = {
	d: 'M20 9H4c-1.336 0-2 .785-2 2 0 1.347.143 2.547.344 3.61A4.975 4.975 0 016 13a5 5 0 015 5 4.96 4.96 0 01-.98 2.949c.608.031 1.264.051 1.98.051 3 0 5.02-.322 6.388-.601a2.97 2.97 0 002.223-1.991C21.127 16.849 22 14.36 22 11c0-1.215-.664-2-2-2zm.98-1c0-1.767-1.225-3-2.98-3h-7.426C10.087 4.121 9.357 3 8 3H5c-1.103 0-2.02.897-2.02 2v3h18zM10 18a1 1 0 01-1 1H7v2a1 1 0 11-2 0v-2H3a1 1 0 110-2h2v-2a1 1 0 112 0v2h2a1 1 0 011 1z',
	size: 24,
};

export const FOLDER_ADD_FILLED = FOLDER_ADD_FILLED_24;
// 24x24/__library/outline.svg
export const __LIBRARY_OUTLINE_24 = {
	d: 'M21 19.5v1a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5zM7 16h2V9H7v7zm5-10.848L15.234 7H8.766L12 5.152zM15 16h2V9h-2v7zm-4 0h2V9h-2v7zm-7.518 2h17.036a.2.2 0 00.14-.341L19 16V9a1 1 0 00.496-1.868l-7-4a.998.998 0 00-.992 0l-7 4A1 1 0 005 9v7l-1.658 1.659a.2.2 0 00.14.341z',
	size: 24,
};

export const __LIBRARY_OUTLINE = __LIBRARY_OUTLINE_24;
export const __LIBRARY_24 = __LIBRARY_OUTLINE_24;
export const __LIBRARY = __LIBRARY_OUTLINE_24;
// 24x24/mail search alt/outline.svg
export const MAIL_SEARCH_ALT_OUTLINE_24 = {
	d: 'M5 9.618l2.553 1.276.894-1.789-3.419-1.709c.069-.399.357-.73.754-.812C7.085 6.317 9.222 6 12 6s4.915.317 6.218.584a.994.994 0 01.782.977v.44h2v-.44a3 3 0 00-2.382-2.936C17.226 4.34 14.946 4 12 4s-5.226.34-6.618.625A3 3 0 003 7.561v7.994a3.01 3.01 0 002.17 2.883c.978.282 1.894.47 2.725.556l.21-1.988a14.21 14.21 0 01-2.383-.49.99.99 0 01-.722-.96V9.617zM15 18c2.206 0 4-1.795 4-4 0-2.206-1.794-4-4-4-2.205 0-4 1.794-4 4 0 2.205 1.795 4 4 4zm7 1.533c.669.587 1 .914 1 1.467a1 1 0 01-1 1c-.553 0-.812-.229-1.504-1a26.616 26.616 0 01-1.808-2.275A5.962 5.962 0 0115 20a6 6 0 116-6 5.97 5.97 0 01-1.292 3.712c.923.641 1.929 1.504 2.292 1.821z',
	size: 24,
};

export const MAIL_SEARCH_ALT_OUTLINE = MAIL_SEARCH_ALT_OUTLINE_24;
export const MAIL_SEARCH_ALT_24 = MAIL_SEARCH_ALT_OUTLINE_24;
export const MAIL_SEARCH_ALT = MAIL_SEARCH_ALT_OUTLINE_24;
// 24x24/arrow back round/outine.svg
export const ARROW_BACK_ROUND_OUTINE_24 = {
	d: 'M14.27 7H9V4.07a.5.5 0 00-.82-.39l-5 3.94a.49.49 0 000 .76l5 3.94a.5.5 0 00.82-.39V9h5.3a4.64 4.64 0 014.7 4.05A4.51 4.51 0 0114.5 18H11a1 1 0 100 2h3.5a6.5 6.5 0 006.44-7.36A6.65 6.65 0 0014.27 7z',
	size: 24,
};

export const ARROW_BACK_ROUND_OUTINE = ARROW_BACK_ROUND_OUTINE_24;
// 24x24/time/outline.svg
export const TIME_OUTLINE_24 = {
	d: 'M14.707 15.293a.999.999 0 11-1.414 1.414l-3-3a.997.997 0 01-.279-.871l1-6a.995.995 0 011.15-.822 1 1 0 01.822 1.15l-.915 5.493 2.636 2.636zm4.78 1.53a3.487 3.487 0 01-2.664 2.664 22.886 22.886 0 01-9.646 0 3.486 3.486 0 01-2.664-2.664 22.886 22.886 0 010-9.646 3.484 3.484 0 012.664-2.664 22.886 22.886 0 019.646 0 3.487 3.487 0 012.664 2.664 22.886 22.886 0 010 9.646zm1.954-10.069a5.47 5.47 0 00-4.195-4.195A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.245.558a5.472 5.472 0 00-4.197 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.246a5.472 5.472 0 004.196 4.195C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.47 5.47 0 004.195-4.195C21.808 15.555 22 13.8 22 12c0-1.8-.192-3.555-.559-5.246z',
	size: 24,
};

export const TIME_OUTLINE = TIME_OUTLINE_24;
export const TIME_24 = TIME_OUTLINE_24;
export const TIME = TIME_OUTLINE_24;
// 24x24/time/filled.svg
export const TIME_FILLED_24 = {
	d: 'M14.707 16.707a.997.997 0 01-1.414 0l-3-3a.996.996 0 01-.279-.871l1-6a.999.999 0 111.972.328l-.915 5.493 2.636 2.636a.999.999 0 010 1.414zm6.735-9.953a5.476 5.476 0 00-4.196-4.196A24.776 24.776 0 0012 2c-1.8 0-3.555.192-5.246.558a5.472 5.472 0 00-4.196 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.47 5.47 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.473 5.473 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.246z',
	size: 24,
};

export const TIME_FILLED = TIME_FILLED_24;
// 24x24/block/outline.svg
export const BLOCK_OUTLINE_24 = {
	d: 'M12 20a7.954 7.954 0 01-4.897-1.688L18.312 7.103A7.952 7.952 0 0120 12c0 4.411-3.589 8-8 8zm-8-8c0-4.411 3.589-8 8-8 1.846 0 3.543.635 4.897 1.688L5.688 16.897A7.946 7.946 0 014 12zm8-10C6.477 2 2 6.478 2 12s4.477 10 10 10c5.522 0 10-4.478 10-10S17.522 2 12 2z',
	size: 24,
};

export const BLOCK_OUTLINE = BLOCK_OUTLINE_24;
export const BLOCK_24 = BLOCK_OUTLINE_24;
export const BLOCK = BLOCK_OUTLINE_24;
// 24x24/check rosette/outline.svg
export const CHECK_ROSETTE_OUTLINE_24 = {
	d: 'M11 15a.997.997 0 01-.707-.293l-2-2a.999.999 0 111.414-1.414L11 12.586l3.293-3.293a.999.999 0 111.414 1.414l-4 4A.997.997 0 0111 15zm-1.243 4.03L7 19.719V18a.997.997 0 00-.684-.948l-2.051-.685.684-2.051a1.001 1.001 0 00-.242-1.023L3.414 12l1.293-1.293c.268-.268.361-.664.242-1.023l-.684-2.051 2.051-.685A.998.998 0 007 6V4.281l2.757.689a.997.997 0 00.95-.263L12 3.414l1.293 1.293a.993.993 0 00.95.263L17 4.281V6c0 .431.275.812.684.948l2.051.685-.684 2.051c-.119.359-.026.755.242 1.023L20.586 12l-1.293 1.293a1.001 1.001 0 00-.242 1.023l.684 2.051-2.051.685A.997.997 0 0017 18v1.719l-2.757-.689a1 1 0 00-.95.263L12 20.586l-1.293-1.293a1 1 0 00-.95-.263zm2.95 3.677l1.6-1.6 3.45.863A.998.998 0 0019 21v-2.279l2.316-.773a.999.999 0 00.633-1.264l-.805-2.414 1.563-1.563a.999.999 0 000-1.414l-1.563-1.564.805-2.413a.999.999 0 00-.633-1.264L19 5.279V3a.998.998 0 00-.385-.788.985.985 0 00-.858-.182l-3.45.863-1.6-1.6a.999.999 0 00-1.414 0l-1.6 1.6-3.45-.863A.998.998 0 005 3v2.279l-2.316.773a.999.999 0 00-.633 1.264l.805 2.413-1.563 1.564a.999.999 0 000 1.414l1.563 1.563-.805 2.414a.999.999 0 00.633 1.264L5 18.721V21a.998.998 0 001.243.97l3.45-.863 1.6 1.6a.997.997 0 001.414 0z',
	size: 24,
};

export const CHECK_ROSETTE_OUTLINE = CHECK_ROSETTE_OUTLINE_24;
export const CHECK_ROSETTE_24 = CHECK_ROSETTE_OUTLINE_24;
export const CHECK_ROSETTE = CHECK_ROSETTE_OUTLINE_24;
// 24x24/check rosette/filled.svg
export const CHECK_ROSETTE_FILLED_24 = {
	d: 'M15.884 9.116a1.25 1.25 0 00-1.768 0L11 12.233l-1.116-1.117a1.25 1.25 0 00-1.768 1.768l2 2a1.248 1.248 0 001.768 0l4-4a1.25 1.25 0 000-1.768zm6.823 3.59l-1.562 1.565.803 2.413a.998.998 0 01-.631 1.264L19 18.72V21a.995.995 0 01-.385.788.988.988 0 01-.857.182l-3.451-.862-1.6 1.599A.993.993 0 0112 23a.993.993 0 01-.707-.293l-1.6-1.6-3.451.863A.998.998 0 015 21v-2.28l-2.316-.772a.998.998 0 01-.632-1.264l.804-2.413-1.563-1.564a1 1 0 010-1.414L2.856 9.73l-.804-2.413a.999.999 0 01.632-1.265L5 5.28V3a1.001 1.001 0 011.242-.97l3.452.863 1.599-1.6a1 1 0 011.414 0l1.6 1.6 3.45-.863a.987.987 0 01.858.182c.244.19.385.48.385.788v2.28l2.317.772a1 1 0 01.63 1.265l-.802 2.413 1.562 1.563a.999.999 0 010 1.414z',
	size: 24,
};

export const CHECK_ROSETTE_FILLED = CHECK_ROSETTE_FILLED_24;
// 24x24/device monitor/outline.svg
export const DEVICE_MONITOR_OUTLINE_24 = {
	d: 'M20 13.09a2.509 2.509 0 01-2.132 2.475 39.94 39.94 0 01-11.737 0A2.509 2.509 0 014 13.09V7.909c0-1.234.916-2.297 2.132-2.473A40.9 40.9 0 0112 5c1.908 0 3.883.147 5.869.436A2.507 2.507 0 0120 7.909v5.182zm-1.843-9.633A42.409 42.409 0 0012 3c-2.038 0-4.076.153-6.156.457C3.652 3.775 2 5.689 2 7.909v5.182c0 2.22 1.652 4.135 3.843 4.452 1.057.154 2.112.269 3.157.346v1.11H7a1 1 0 100 2h10a1 1 0 100-2h-2v-1.11a44.61 44.61 0 003.156-.346C20.348 17.226 22 15.312 22 13.09V7.909c0-2.22-1.652-4.134-3.843-4.452z',
	size: 24,
};

export const DEVICE_MONITOR_OUTLINE = DEVICE_MONITOR_OUTLINE_24;
export const DEVICE_MONITOR_24 = DEVICE_MONITOR_OUTLINE_24;
export const DEVICE_MONITOR = DEVICE_MONITOR_OUTLINE_24;
// 24x24/check circle/outline.svg
export const CHECK_CIRCLE_OUTLINE_24 = {
	d: 'M16.707 10.707l-5 5a.997.997 0 01-1.414 0l-3-3a.999.999 0 111.414-1.414L11 13.586l4.293-4.293a.999.999 0 111.414 1.414zM22 12c0 5.522-4.478 10-10 10S2 17.522 2 12C2 6.477 6.478 2 12 2s10 4.477 10 10zm-2 0c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8z',
	size: 24,
};

export const CHECK_CIRCLE_OUTLINE = CHECK_CIRCLE_OUTLINE_24;
export const CHECK_CIRCLE_24 = CHECK_CIRCLE_OUTLINE_24;
export const CHECK_CIRCLE = CHECK_CIRCLE_OUTLINE_24;
// 24x24/check circle/filled.svg
export const CHECK_CIRCLE_FILLED_24 = {
	d: 'M16.884 9.116a1.25 1.25 0 00-1.768 0L11 13.233l-2.116-2.117a1.25 1.25 0 00-1.768 1.768l3 3a1.248 1.248 0 001.768 0l5-5a1.25 1.25 0 000-1.768zM22 12c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10S6.478 2 12 2c5.523 0 10 4.477 10 10z',
	size: 24,
};

export const CHECK_CIRCLE_FILLED = CHECK_CIRCLE_FILLED_24;
// 24x24/notifications off/outline.svg
export const NOTIFICATIONS_OFF_OUTLINE_24 = {
	d: 'M12 20h2c0 1.1-.9 2-2 2s-2-.9-2-2h2zm9.7 1.7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-3.4-3.4c-1.4.4-3 .7-4.9.7-6 0-9-3-9-3s3-2 3-8v-.5L2.3 3.7C2.1 3.5 2 3.3 2 3c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0l18 18c.2.2.3.5.3.7 0 .3-.1.5-.3.7zm-6.5-5.1L8 9.4c-.2 2.9-1.1 5-2 6.3 1.2.6 3.2 1.4 6 1.4 1.2-.1 2.3-.3 3.2-.5zM12 4c1.6 0 4 1.1 4 4 0 2.3.4 4.1.9 5.5l3.2 3.2c.6-.4.9-.7.9-.7s-3-2-3-8c0-4-3.2-6-6-6-1.6 0-3.4.7-4.6 2l1.4 1.4C9.7 4.4 11 4 12 4z',
	size: 24,
};

export const NOTIFICATIONS_OFF_OUTLINE = NOTIFICATIONS_OFF_OUTLINE_24;
export const NOTIFICATIONS_OFF_24 = NOTIFICATIONS_OFF_OUTLINE_24;
export const NOTIFICATIONS_OFF = NOTIFICATIONS_OFF_OUTLINE_24;
// 24x24/notifications off/filled.svg
export const NOTIFICATIONS_OFF_FILLED_24 = {
	d: 'M21.7 21.7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-3.4-3.4c-1.4.4-3 .7-4.9.7-6 0-9-3-9-3s3-2 3-8v-.5L2.3 3.7C2.1 3.5 2 3.3 2 3c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0l18 18c.2.2.3.5.3.7 0 .3-.1.5-.3.7zM21 16s-3-2-3-8c0-4-3.2-6-6-6-1.6 0-3.4.7-4.6 2l12.7 12.7c.6-.4.9-.7.9-.7zm-11 4c0 1.1.9 2 2 2s2-.9 2-2h-4z',
	size: 24,
};

export const NOTIFICATIONS_OFF_FILLED = NOTIFICATIONS_OFF_FILLED_24;
// 24x24/bookmark add alt1/filled.svg
export const BOOKMARK_ADD_ALT1_FILLED_24 = {
	d: 'M14.6 15L12 13.634 9.4 15l.498-2.895-2.104-2.049 2.907-.422L12 7l1.3 2.634 2.906.422-2.103 2.049L14.6 15zM15 2H9C7.294 2 6 3.212 6 5v17l6-4 6 4V5c0-1.788-1.294-3-3-3z',
	size: 24,
};

export const BOOKMARK_ADD_ALT1_FILLED = BOOKMARK_ADD_ALT1_FILLED_24;
// 24x24/pause/outline.svg
export const PAUSE_OUTLINE_24 = {
	d: 'M17.5 5.5v13h-2v-13h2zm-9 0v13h-2v-13h2zM18 4h-3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zM9 4H6c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z',
	size: 24,
};

export const PAUSE_OUTLINE = PAUSE_OUTLINE_24;
export const PAUSE_24 = PAUSE_OUTLINE_24;
export const PAUSE = PAUSE_OUTLINE_24;
// 24x24/pause/filled.svg
export const PAUSE_FILLED_24 = {
	d: 'M19 5v14c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h3c.6 0 1 .4 1 1zM9 4H6c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z',
	size: 24,
};

export const PAUSE_FILLED = PAUSE_FILLED_24;
// 24x24/refresh alt/outline.svg
export const REFRESH_ALT_OUTLINE_24 = {
	d: 'M18.772 11.901c.61 0 1.228.447 1.228 1.298 0 1.583-2.494 6.802-8 6.802a7.951 7.951 0 01-4.04-1.105l-.404.404-.106.11c-.301.317-.562.591-1.094.591-.689 0-1.227-.54-1.227-1.228v-3.386c0-.605.458-1.228 1.227-1.228h3.386c.666 0 1.228.562 1.228 1.228 0 .537-.269.794-.691 1.199l-.495.493a5.47 5.47 0 002.216.466c3.58 0 5.193-2.989 5.547-4.57.154-.682.6-1.074 1.225-1.074zM17.643 4c.689 0 1.228.54 1.228 1.228v3.386c0 .604-.46 1.228-1.228 1.228h-3.386a1.244 1.244 0 01-1.227-1.228c0-.537.268-.795.69-1.199l.495-.494A5.456 5.456 0 0012 6.455c-3.58 0-5.194 2.99-5.548 4.57-.154.683-.6 1.074-1.224 1.074-.61 0-1.228-.446-1.228-1.298C4 9.218 6.494 4 12 4a7.96 7.96 0 014.04 1.105l.403-.404.106-.11c.301-.316.562-.591 1.094-.591z',
	size: 24,
};

export const REFRESH_ALT_OUTLINE = REFRESH_ALT_OUTLINE_24;
export const REFRESH_ALT_24 = REFRESH_ALT_OUTLINE_24;
export const REFRESH_ALT = REFRESH_ALT_OUTLINE_24;
// 24x24/minimize alt1/outline.svg
export const MINIMIZE_ALT1_OUTLINE_24 = {
	d: 'M5.293 17.293l-3 3a.999.999 0 101.414 1.414l3-3L9 21v-6H3l2.293 2.293zm16.414-15a.999.999 0 00-1.414 0l-3 3L15 3v6h6l-2.293-2.293 3-3a.999.999 0 000-1.414zM8 9a1 1 0 011-1h3V6H9C7.346 6 6 7.346 6 9v3h2V9zm8 3h2v3c0 1.654-1.346 3-3 3h-3v-2h3a1 1 0 001-1v-3z',
	size: 24,
};

export const MINIMIZE_ALT1_OUTLINE = MINIMIZE_ALT1_OUTLINE_24;
export const MINIMIZE_ALT1_24 = MINIMIZE_ALT1_OUTLINE_24;
export const MINIMIZE_ALT1 = MINIMIZE_ALT1_OUTLINE_24;
// 24x24/videocam/outline.svg
export const VIDEOCAM_OUTLINE_24 = {
	d: 'M22.2 6.5L18 9V7c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-2l4.2 2.5c.3.2.8 0 .8-.4V6.9c0-.4-.4-.6-.8-.4zM16 17H4V7h12v10z',
	size: 24,
};

export const VIDEOCAM_OUTLINE = VIDEOCAM_OUTLINE_24;
export const VIDEOCAM_24 = VIDEOCAM_OUTLINE_24;
export const VIDEOCAM = VIDEOCAM_OUTLINE_24;
// 24x24/videocam/filled.svg
export const VIDEOCAM_FILLED_24 = {
	d: 'M22.2 6.5L18 9V7c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-2l4.2 2.5c.3.2.8 0 .8-.4V6.9c0-.4-.4-.6-.8-.4z',
	size: 24,
};

export const VIDEOCAM_FILLED = VIDEOCAM_FILLED_24;
// 24x24/connect group/outline.svg
export const CONNECT_GROUP_OUTLINE_24 = {
	d: 'M7.99 16.948C5.475 16.69 3.5 14.582 3.5 12c0-2.757 2.243-5 5-5s5 2.243 5 5c0 .647-.136 1.26-.361 1.83l1.713 1.096A6.942 6.942 0 0015.5 12c0-3.86-3.14-7-7-7s-7 3.14-7 7 3.14 7 7 7c.416 0 .823-.04 1.219-.112l-1.729-1.94zM22.5 12c0 3.86-3.141 7-7 7-3.86 0-7-3.14-7-7 0-1.045.234-2.035.647-2.926l1.714 1.097a4.947 4.947 0 00-.361 1.83c0 2.756 2.243 5 5 5s5-2.244 5-5c0-2.583-1.976-4.69-4.49-4.949l-1.729-1.94A6.9 6.9 0 0115.5 5c3.859 0 7 3.14 7 7z',
	size: 24,
};

export const CONNECT_GROUP_OUTLINE = CONNECT_GROUP_OUTLINE_24;
export const CONNECT_GROUP_24 = CONNECT_GROUP_OUTLINE_24;
export const CONNECT_GROUP = CONNECT_GROUP_OUTLINE_24;
// 24x24/file archive/outline.svg
export const FILE_ARCHIVE_OUTLINE_24 = {
	d: 'M19 19V9h-6v4h3l-4 5-4-5h3V9H5v10h14zM11 5H7.132L5.933 7H11V5zm7.067 2l-1.199-2H13v2h5.067zm2.363.05c.373.622.57 1.225.57 1.95v10a2 2 0 01-2 2H5a2 2 0 01-2-2V9c0-.725.197-1.328.57-1.95l1.847-3.079A2 2 0 017.132 3h9.736a2 2 0 011.715.971L20.43 7.05z',
	size: 24,
};

export const FILE_ARCHIVE_OUTLINE = FILE_ARCHIVE_OUTLINE_24;
export const FILE_ARCHIVE_24 = FILE_ARCHIVE_OUTLINE_24;
export const FILE_ARCHIVE = FILE_ARCHIVE_OUTLINE_24;
// 24x24/file archive/filled.svg
export const FILE_ARCHIVE_FILLED_24 = {
	d: 'M21 8h-8V6h-2v2H3l2.4-3.2c.378-.503.971-.8 1.6-.8h10c.629 0 1.222.297 1.6.8L21 8zm0 1h-8v4h3l-4 5-4-5h3V9H3v10a2 2 0 002 2h14a2 2 0 002-2V9z',
	size: 24,
};

export const FILE_ARCHIVE_FILLED = FILE_ARCHIVE_FILLED_24;
// 24x24/radio button empty/outline.svg
export const RADIO_BUTTON_EMPTY_OUTLINE_24 = {
	d: 'M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 2a8 8 0 110 16 8 8 0 010-16z',
	size: 24,
};

export const RADIO_BUTTON_EMPTY_OUTLINE = RADIO_BUTTON_EMPTY_OUTLINE_24;
export const RADIO_BUTTON_EMPTY_24 = RADIO_BUTTON_EMPTY_OUTLINE_24;
export const RADIO_BUTTON_EMPTY = RADIO_BUTTON_EMPTY_OUTLINE_24;
// 24x24/navigation/outline.svg
export const NAVIGATION_OUTLINE_24 = {
	d: 'M15 2l-5 7h4v4a1 1 0 01-1 1H8c-1.654 0-3 1.346-3 3v4a1 1 0 102 0v-4a1 1 0 011-1h5c1.654 0 3-1.346 3-3V9h4l-5-7z',
	size: 24,
};

export const NAVIGATION_OUTLINE = NAVIGATION_OUTLINE_24;
export const NAVIGATION_24 = NAVIGATION_OUTLINE_24;
export const NAVIGATION = NAVIGATION_OUTLINE_24;
// 24x24/locked/outline.svg
export const LOCKED_OUTLINE_24 = {
	d: 'M14 13c0 .738-.404 1.376-1 1.723V19h-2v-4.277c-.596-.347-1-.985-1-1.723a2 2 0 014 0zm-2 7c-2.185 0-4.977-.318-6-.543l-.017-8.91C7.023 10.318 9.815 10 12 10c2.185 0 4.977.318 6 .543l.017 8.91c-1.04.229-3.832.547-6.017.547zM9.5 6.5C9.5 5.121 10.621 4 12 4s2.5 1.121 2.5 2.5v1.602A35.212 35.212 0 0012 8c-.784 0-1.65.04-2.5.102V6.5zm8.946 2.094a21.899 21.899 0 00-1.946-.303V6.5C16.5 4.019 14.481 2 12 2a4.505 4.505 0 00-4.5 4.5v1.791c-.795.095-1.484.201-1.946.303A1.99 1.99 0 004 10.543v8.914a1.99 1.99 0 001.554 1.949C6.815 21.684 9.749 22 12 22c2.251 0 5.185-.316 6.446-.594A1.99 1.99 0 0020 19.457v-8.914a1.99 1.99 0 00-1.554-1.949z',
	size: 24,
};

export const LOCKED_OUTLINE = LOCKED_OUTLINE_24;
export const LOCKED_24 = LOCKED_OUTLINE_24;
export const LOCKED = LOCKED_OUTLINE_24;
// 24x24/locked/filled.svg
export const LOCKED_FILLED_24 = {
	d: 'M14.5 8.102A35.212 35.212 0 0012 8c-.784 0-1.65.04-2.5.102V6.5C9.5 5.122 10.621 4 12 4s2.5 1.122 2.5 2.5v1.602zm-1.5 6.62V19h-2v-4.277A1.99 1.99 0 0110 13a2 2 0 014 0 1.99 1.99 0 01-1 1.723zm5.446-6.128A22.277 22.277 0 0016.5 8.29V6.5C16.5 4.019 14.481 2 12 2a4.505 4.505 0 00-4.5 4.5v1.79c-.795.096-1.484.203-1.946.304A1.991 1.991 0 004 10.543v8.914c0 .933.643 1.749 1.554 1.95C6.815 21.684 9.749 22 12 22c2.251 0 5.185-.316 6.446-.593A1.993 1.993 0 0020 19.457v-8.914c0-.932-.643-1.75-1.554-1.95z',
	size: 24,
};

export const LOCKED_FILLED = LOCKED_FILLED_24;
// 24x24/print/outline.svg
export const PRINT_OUTLINE_24 = {
	d: 'M20 15a1 1 0 01-1 1h-1v-1a1 1 0 00-1-1H7a1 1 0 00-1 1v1H5a1 1 0 01-1-1v-3a1 1 0 011-1h14a1 1 0 011 1v3zm-4 4H8v-3h8v3zM7 9h10V5H7v4zm12 0V4a1 1 0 00-1-1H6a1 1 0 00-1 1v5c-1.654 0-3 1.346-3 3v3c0 1.654 1.346 3 3 3h1v2a1 1 0 001 1h10a1 1 0 001-1v-2h1c1.654 0 3-1.346 3-3v-3c0-1.654-1.346-3-3-3z',
	size: 24,
};

export const PRINT_OUTLINE = PRINT_OUTLINE_24;
export const PRINT_24 = PRINT_OUTLINE_24;
export const PRINT = PRINT_OUTLINE_24;
// 24x24/print/filled.svg
export const PRINT_FILLED_24 = {
	d: 'M16 19H8v-3h8v3zM7 9h10V5H7v4zm12 0V4a1 1 0 00-1-1H6a1 1 0 00-1 1v5c-1.654 0-3 1.346-3 3v3c0 1.654 1.346 3 3 3h1v2a1 1 0 001 1h10a1 1 0 001-1v-2h1c1.654 0 3-1.346 3-3v-3c0-1.654-1.346-3-3-3z',
	size: 24,
};

export const PRINT_FILLED = PRINT_FILLED_24;
// 24x24/user/outline.svg
export const USER_OUTLINE_24 = {
	d: 'M12 13c-5.563 0-9 1.439-9 3 0 1.977 4 6 9 6s9-4 9-6c0-1.584-3.458-3-9-3zm0 2c3.922 0 6.171.759 6.902 1.245C18.354 17.371 15.696 20 12 20c-3.697 0-6.376-2.663-6.908-3.744C5.821 15.767 8.074 15 12 15zm0-13c-1.864 0-3 1.096-3 4 0 3.202 1.426 5 3 5s3-1.798 3-5c0-2.904-1.136-4-3-4zm0 2c.515 0 1 0 1 2 0 2.219-.823 3-1 3-.177 0-1-.781-1-3 0-2 .485-2 1-2z',
	size: 24,
};

export const USER_OUTLINE = USER_OUTLINE_24;
export const USER_24 = USER_OUTLINE_24;
export const USER = USER_OUTLINE_24;
// 24x24/user/filled.svg
export const USER_FILLED_24 = {
	d: 'M12 13c-5.563 0-9 1.439-9 3 0 1.977 4 6 9 6s9-4 9-6c0-1.584-3.458-3-9-3zm3-7c0 3.202-1.426 5-3 5S9 9.202 9 6c0-2.904 1.136-4 3-4s3 1.096 3 4z',
	size: 24,
};

export const USER_FILLED = USER_FILLED_24;
// 24x24/info/outline.svg
export const INFO_OUTLINE_24 = {
	d: 'M11 17h2v-6h-2v6zm2.5-8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113.5 8.5z',
	size: 24,
};

export const INFO_OUTLINE = INFO_OUTLINE_24;
export const INFO_24 = INFO_OUTLINE_24;
export const INFO = INFO_OUTLINE_24;
// 24x24/checker normal/outline.svg
export const CHECKER_NORMAL_OUTLINE_24 = {
	d: 'M10 17a.997.997 0 01-.707-.293l-3-3a.999.999 0 111.414-1.414L10 14.586l6.293-6.293a.999.999 0 111.414 1.414l-7 7A.997.997 0 0110 17z',
	size: 24,
};

export const CHECKER_NORMAL_OUTLINE = CHECKER_NORMAL_OUTLINE_24;
export const CHECKER_NORMAL_24 = CHECKER_NORMAL_OUTLINE_24;
export const CHECKER_NORMAL = CHECKER_NORMAL_OUTLINE_24;
// 24x24/user cross/outline.svg
export const USER_CROSS_OUTLINE_24 = {
	d: 'M21.707 20.293L19.914 18.5l1.793-1.793a.999.999 0 10-1.414-1.414L18.5 17.086l-1.793-1.793a.999.999 0 10-1.414 1.414l1.793 1.793-1.793 1.793a.999.999 0 101.414 1.414l1.793-1.793 1.793 1.793a.997.997 0 001.414 0 .999.999 0 000-1.414zM12 20c-3.697 0-6.376-2.663-6.908-3.744C5.821 15.767 8.075 15 12 15c.716 0 1.377.025 1.982.069.368-.591.98-1.444 1.447-1.864A26.988 26.988 0 0012 13c-5.564 0-9 1.439-9 3 0 1.977 4 6 9 6 .686 0 1.36-.079 2.001-.215v-2.049A7.807 7.807 0 0112 20zm0-16c-.514 0-1 0-1 2 0 2.219.823 3 1 3 .177 0 1-.781 1-3 0-2-.486-2-1-2zm0 7c-1.574 0-3-1.798-3-5 0-2.904 1.136-4 3-4s3 1.096 3 4c0 3.202-1.426 5-3 5z',
	size: 24,
};

export const USER_CROSS_OUTLINE = USER_CROSS_OUTLINE_24;
export const USER_CROSS_24 = USER_CROSS_OUTLINE_24;
export const USER_CROSS = USER_CROSS_OUTLINE_24;
// 24x24/game console controller/outline.svg
export const GAME_CONSOLE_CONTROLLER_OUTLINE_24 = {
	d: 'M21 14c0-2.836-.302-4.656-1.154-6.954C19.343 5.688 18.385 5 17 5a3.016 3.016 0 00-2.6 1.501.997.997 0 01-.865.499h-3.07a.997.997 0 01-.866-.5A3.012 3.012 0 007 5c-1.385 0-2.343.688-2.846 2.046C3.302 9.344 3 11.164 3 14c0 2.757.897 5 2 5 2.176 0 3.022-3.213 3.03-3.245.114-.443.513-.755.97-.755h6a1 1 0 01.97.758c.008.029.854 3.242 3.03 3.242 1.103 0 2-2.243 2-5zm2 0c0 3.484-1.237 7-4 7-2.851 0-4.216-2.654-4.725-4h-4.55C9.216 18.346 7.851 21 5 21c-2.763 0-4-3.516-4-7 0-3.062.347-5.135 1.279-7.649C3.068 4.222 4.789 3 7 3a5.02 5.02 0 014 2h2a5.022 5.022 0 014-2c2.211 0 3.932 1.222 4.721 3.351C22.653 8.865 23 10.938 23 14zm-5.5-3a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0017.5 11zM17 9.5a1.5 1.5 0 10-3.001.001A1.5 1.5 0 0017 9.5zM9 10h2v2H9v2H7v-2H5v-2h2V8h2v2z',
	size: 24,
};

export const GAME_CONSOLE_CONTROLLER_OUTLINE = GAME_CONSOLE_CONTROLLER_OUTLINE_24;
export const GAME_CONSOLE_CONTROLLER_24 = GAME_CONSOLE_CONTROLLER_OUTLINE_24;
export const GAME_CONSOLE_CONTROLLER = GAME_CONSOLE_CONTROLLER_OUTLINE_24;
// 24x24/game console controller/filled.svg
export const GAME_CONSOLE_CONTROLLER_FILLED_24 = {
	d: 'M17.5 14a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0117.5 14zM14 9.5a1.5 1.5 0 113.001.001A1.5 1.5 0 0114 9.5zM11 12H9v2H7v-2H5v-2h2V8h2v2h2v2zm10.721-5.649C20.932 4.222 19.211 3 17 3a5.02 5.02 0 00-4 2h-2a5.02 5.02 0 00-4-2C4.789 3 3.068 4.222 2.279 6.351 1.347 8.865 1 10.938 1 14c0 3.484 1.237 7 4 7 2.851 0 4.216-2.654 4.725-4h4.55c.509 1.346 1.874 4 4.725 4 2.763 0 4-3.516 4-7 0-3.062-.347-5.135-1.279-7.649z',
	size: 24,
};

export const GAME_CONSOLE_CONTROLLER_FILLED = GAME_CONSOLE_CONTROLLER_FILLED_24;
// 24x24/calendar plus/filled.svg
export const CALENDAR_PLUS_FILLED_24 = {
	d: 'M15 13h-2v-2a1 1 0 10-2 0v2H9a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2zm5-1c0-1.345-.125-2.686-.358-4H4.357A23.033 23.033 0 004 12c0 1.626.173 3.249.513 4.823a3.486 3.486 0 002.664 2.664 22.886 22.886 0 009.646 0 3.487 3.487 0 002.664-2.664c.34-1.574.513-3.197.513-4.823zm2 0c0 1.8-.192 3.555-.559 5.245a5.47 5.47 0 01-4.195 4.196A24.711 24.711 0 0112 22c-1.8 0-3.555-.192-5.246-.559a5.472 5.472 0 01-4.196-4.196A24.76 24.76 0 012 12c0-1.8.192-3.556.558-5.246C3.013 4.651 4.743 3 7 2.512V4a1 1 0 102 0V2.187C9.984 2.067 10.983 2 12 2s2.016.067 3 .187V4a1 1 0 102 0V2.512c2.519.556 3.987 2.14 4.441 4.242C21.808 8.445 22 10.2 22 12z',
	size: 24,
};

export const CALENDAR_PLUS_FILLED = CALENDAR_PLUS_FILLED_24;
// 24x24/maximize/outline.svg
export const MAXIMIZE_OUTLINE_24 = {
	d: 'M19 18a1 1 0 01-1 1h-1v2h1c1.654 0 3-1.346 3-3v-2h-2v2zM5 19h8v-8H5v8zm10-8v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8a2 2 0 012-2h8a2 2 0 012 2zm4 3h2v-4h-2v4zM18 3h-2v2h2a1 1 0 011 1v2h2V6c0-1.654-1.346-3-3-3zM5 6c0-.552.449-1 1-1h2V3H6C4.346 3 3 4.346 3 6v1h2V6zm5-1h4V3h-4v2z',
	size: 24,
};

export const MAXIMIZE_OUTLINE = MAXIMIZE_OUTLINE_24;
export const MAXIMIZE_24 = MAXIMIZE_OUTLINE_24;
export const MAXIMIZE = MAXIMIZE_OUTLINE_24;
// 24x24/crown/filled.svg
export const CROWN_FILLED_24 = {
	d: 'M18.488 18.75c1.283 0 2.36-.973 2.486-2.251L22 6.25l-3.75 2.5s1.25 1.25 1.25 2.5-.761 2.5-2.5 2.5c-1.74 0-2.5-1.25-2.5-2.5s1.25-2.5 1.25-2.5L12 5 8.25 8.75S9.5 10 9.5 11.25s-.761 2.5-2.5 2.5c-1.74 0-2.5-1.25-2.5-2.5s1.25-2.5 1.25-2.5L2 6.25l1.024 10.249a2.5 2.5 0 002.489 2.251h12.975z',
	size: 24,
};

export const CROWN_FILLED = CROWN_FILLED_24;
// 24x24/messenger/filled.svg
export const MESSENGER_FILLED_24 = {
	d: 'M12 2c5.634 0 10 4.127 10 9.7 0 5.574-4.366 9.7-10 9.7-1.012 0-1.984-.132-2.895-.384a.798.798 0 00-.534.04l-1.983.876a.801.801 0 01-1.123-.709l-.055-1.778a.806.806 0 00-.27-.57C3.196 17.135 2 14.615 2 11.7 2 6.127 6.366 2 12 2zm6.004 7.465c.284-.447-.268-.952-.688-.632l-3.155 2.394a.6.6 0 01-.722.002l-2.336-1.752a1.501 1.501 0 00-2.17.4l-2.937 4.66c-.284.447.268.952.688.632l3.155-2.394a.6.6 0 01.722-.002l2.336 1.752c.7.525 1.703.34 2.17-.4l2.937-4.66z',
	size: 24,
};

export const MESSENGER_FILLED = MESSENGER_FILLED_24;
// 24x24/google/filled.svg
export const GOOGLE_FILLED_24 = {
	d: 'M12.01 2C6.483 2 2 6.478 2 12s4.483 10 10.01 10c8.348 0 10.229-7.744 9.445-11.667h-9.448v3.334h6.453A6.669 6.669 0 015.336 12a6.669 6.669 0 016.67-6.667 6.64 6.64 0 014.374 1.641l2.37-2.367A9.974 9.974 0 0012.01 2z',
	size: 24,
};

export const GOOGLE_FILLED = GOOGLE_FILLED_24;
// 24x24/folder open/outline.svg
export const FOLDER_OPEN_OUTLINE_24 = {
	d: 'M17.419 18.186c-.567.404-2.772.814-6.42.814-2.492 0-4.945-.244-6.628-.642l2.97-6.806A.994.994 0 018.237 11H19c.37 0 1 .211 1 1 0 1.82-1.792 5.623-2.581 6.187zM18.999 9H8.237c-1.143 0-2.171.636-2.705 1.706L4 14.21V5h2.764c.382 0 .724.212.894.553l.448.895A.998.998 0 009 7h7c.552 0 1 .449 1 1h2c0-1.654-1.346-3-3-3H9.618l-.171-.341a2.984 2.984 0 00-2.683-1.66H4c-1.102 0-2 .899-2 2v14a1 1 0 00.66.942C4.829 20.72 8.39 21 11 21c2.7 0 6.208-.206 7.58-1.186 1.44-1.027 3.42-5.556 3.42-7.815 0-1.947-1.546-3-3-3z',
	size: 24,
};

export const FOLDER_OPEN_OUTLINE = FOLDER_OPEN_OUTLINE_24;
export const FOLDER_OPEN_24 = FOLDER_OPEN_OUTLINE_24;
export const FOLDER_OPEN = FOLDER_OPEN_OUTLINE_24;
// 24x24/folder open/filled.svg
export const FOLDER_OPEN_FILLED_24 = {
	d: 'M6.979 8h12.02c0-1.654-1.345-3-3-3H9.62l-.171-.342A3.002 3.002 0 006.764 3H4a2 2 0 00-2 2v10l2.22-5.182A3.001 3.001 0 016.98 8zm15.02 4c0 2.259-1.98 6.786-3.418 7.813C17.208 20.794 13.701 21 11 21c-1.997 0-4.018-.149-5.69-.421a2.978 2.978 0 01-2.155-1.525 2.98 2.98 0 01-.115-2.64l2.493-5.709C6.065 9.636 7.092 9 8.237 9H19c1.454 0 3 1.052 3 3z',
	size: 24,
};

export const FOLDER_OPEN_FILLED = FOLDER_OPEN_FILLED_24;
// 24x24/read later/outline.svg
export const READ_LATER_OUTLINE_24 = {
	d: 'M22 3.353v11.674a.962.962 0 01-.385.766 1.002 1.002 0 01-.857.177c-1.988-.483-3.891-.485-5.758-.023v-2.01a13.552 13.552 0 015-.105V4.097c-2.327-.468-5.295.208-7 1.626v4.44c-.574-.604-1.247-1.2-2-1.587V5.747c-1.703-1.428-4.668-2.12-7-1.65V9.55c-.753.387-1.426.983-2 1.586V3.353c0-.419.275-.79.684-.923C5.66 1.463 9.55 2.181 12 4.033c2.45-1.852 6.34-2.57 9.316-1.603a.974.974 0 01.684.923zM10.895 18.697a1.002 1.002 0 01-1.342.447l-2-1A1.001 1.001 0 017 17.25v-4a1 1 0 112 0v3.382l1.447.724a1 1 0 01.448 1.342zM8 10a6 6 0 10.002 12.002A6 6 0 008 10z',
	size: 24,
};

export const READ_LATER_OUTLINE = READ_LATER_OUTLINE_24;
export const READ_LATER_24 = READ_LATER_OUTLINE_24;
export const READ_LATER = READ_LATER_OUTLINE_24;
// 24x24/card/outline.svg
export const CARD_OUTLINE_24 = {
	d: 'M6 16h6v-2H6v2zm0-3h9v-2H6v2zm14-5H4V7c0-.552.449-1 1-1h14a1 1 0 011 1v1zm0 9a1 1 0 01-1 1H5c-.551 0-1-.448-1-1v-7h16v7zM19 4H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z',
	size: 24,
};

export const CARD_OUTLINE = CARD_OUTLINE_24;
export const CARD_24 = CARD_OUTLINE_24;
export const CARD = CARD_OUTLINE_24;
// 24x24/play previous/outline.svg
export const PLAY_PREVIOUS_OUTLINE_24 = {
	d: 'M12 9.868L8.803 12 12 14.132V9.868zM14 8v8a1 1 0 01-1.555.832l-6-4a1.001 1.001 0 010-1.664l6-4A1 1 0 0114 8zm6 1.868L16.803 12 20 14.132V9.868zM22 8v8a1 1 0 01-1.555.832l-6-4a1.001 1.001 0 010-1.664l6-4A1 1 0 0122 8zM6 5v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h2a1 1 0 011 1z',
	size: 24,
};

export const PLAY_PREVIOUS_OUTLINE = PLAY_PREVIOUS_OUTLINE_24;
export const PLAY_PREVIOUS_24 = PLAY_PREVIOUS_OUTLINE_24;
export const PLAY_PREVIOUS = PLAY_PREVIOUS_OUTLINE_24;
// 24x24/play previous/filled.svg
export const PLAY_PREVIOUS_FILLED_24 = {
	d: 'M13.472 7.118a1 1 0 00-1.026.05l-6 4a.998.998 0 000 1.664l6 4A1 1 0 0014 16V8a1 1 0 00-.528-.882zm8 0a1 1 0 00-1.026.05l-6 4a.998.998 0 000 1.664l6 4A1 1 0 0022 16V8a1 1 0 00-.528-.882zM6 5v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h2a1 1 0 011 1z',
	size: 24,
};

export const PLAY_PREVIOUS_FILLED = PLAY_PREVIOUS_FILLED_24;
// 24x24/arrow back/outine.svg
export const ARROW_BACK_OUTINE_24 = {
	d: 'M22 14.5c0 3.859-3.14 7-7 7h-5a1 1 0 110-2h5c2.757 0 5-2.243 5-5s-2.243-5-5-5h-5v5l-8-6 8-6v5h5c3.86 0 7 3.141 7 7z',
	size: 24,
};

export const ARROW_BACK_OUTINE = ARROW_BACK_OUTINE_24;
// 24x24/filter/outline.svg
export const FILTER_OUTLINE_24 = {
	d: 'M12 3C7 3 3 4 3 5s7 8 7 8v6l4 3v-9s7-7 7-8-4-2-9-2zm0 2c2.757 0 4.891.31 6.178.629-1.275 1.506-3.563 3.928-5.592 5.957l-.586.586V18v-5.828l-.586-.586C9.385 9.557 7.097 7.135 5.822 5.629 7.109 5.31 9.243 5 12 5z',
	size: 24,
};

export const FILTER_OUTLINE = FILTER_OUTLINE_24;
export const FILTER_24 = FILTER_OUTLINE_24;
export const FILTER = FILTER_OUTLINE_24;
// 24x24/filter/filled.svg
export const FILTER_FILLED_24 = {
	d: 'M12 3C7 3 3 4 3 5s7 8 7 8v6l4 3v-9s7-7 7-8-4-2-9-2z',
	size: 24,
};

export const FILTER_FILLED = FILTER_FILLED_24;
// 24x24/mail cross/outline.svg
export const MAIL_CROSS_OUTLINE_24 = {
	d: 'M8.09 12.318l-3.723 3.86-.012-.047A24.59 24.59 0 014 12c0-.868.066-1.747.162-2.629l3.928 2.946zM4.566 7.183c.397-.933 1.226-1.62 2.235-1.785a32.812 32.812 0 015.16-.397 33.098 33.098 0 015.16.384 3.035 3.035 0 012.31 1.8c-.009.007-.022.008-.03.015L12 12.75 4.6 7.2c-.01-.008-.025-.009-.035-.017zm5.136 6.345L12 15.25l7.837-5.879c.096.882.163 1.76.163 2.629 0 .33-.029.665-.044 1h2c.015-.335.044-.67.044-1 0-1.473-.13-2.977-.384-4.468a5.038 5.038 0 00-4.18-4.122A35.006 35.006 0 0012 3.001c-1.889 0-3.78.14-5.519.422-2.089.34-3.735 1.991-4.098 4.11A26.684 26.684 0 002 12.001c0 1.472.13 2.975.383 4.466a5.038 5.038 0 004.181 4.122A34.83 34.83 0 0012 21v-2.017a32.203 32.203 0 01-5.122-.37 3.042 3.042 0 01-1.448-.657l4.272-4.43zm12.005 3.18a1 1 0 00-1.414-1.414L18.5 17.087l-1.793-1.793a.999.999 0 10-1.414 1.413l1.793 1.793-1.793 1.794a.999.999 0 101.414 1.413l1.793-1.793 1.793 1.793a.997.997 0 001.414 0 1 1 0 000-1.413L19.914 18.5l1.793-1.793z',
	size: 24,
};

export const MAIL_CROSS_OUTLINE = MAIL_CROSS_OUTLINE_24;
export const MAIL_CROSS_24 = MAIL_CROSS_OUTLINE_24;
export const MAIL_CROSS = MAIL_CROSS_OUTLINE_24;
// 24x24/archive/outline.svg
export const ARCHIVE_OUTLINE_24 = {
	d: 'M16 12a1 1 0 01-1 1H9a1 1 0 110-2h6a1 1 0 011 1zM5 19V9h14l.001 10H5zM4 5h16l.001 2H4V5zm16-2H4c-1.103 0-2 .897-2 2v2c0 .736.405 1.375 1 1.722V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V8.722c.595-.347 1-.986 1-1.722V5c0-1.103-.897-2-2-2z',
	size: 24,
};

export const ARCHIVE_OUTLINE = ARCHIVE_OUTLINE_24;
export const ARCHIVE_24 = ARCHIVE_OUTLINE_24;
export const ARCHIVE = ARCHIVE_OUTLINE_24;
// 24x24/archive/filled.svg
export const ARCHIVE_FILLED_24 = {
	d: 'M16 12a1 1 0 00-1-1H9a1 1 0 100 2h6a1 1 0 001-1zm5-3v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V9h18zm1-4v1c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2z',
	size: 24,
};

export const ARCHIVE_FILLED = ARCHIVE_FILLED_24;
// 24x24/twitter/filled.svg
export const TWITTER_FILLED_24 = {
	d: 'M22 5.924a8.214 8.214 0 01-2.356.646 4.11 4.11 0 001.803-2.27 8.221 8.221 0 01-2.606.996 4.104 4.104 0 00-6.991 3.741A11.645 11.645 0 013.393 4.75a4.087 4.087 0 00-.555 2.064c0 1.423.724 2.678 1.824 3.414a4.095 4.095 0 01-1.858-.513v.052a4.103 4.103 0 003.292 4.022 4.107 4.107 0 01-1.854.072 4.11 4.11 0 003.833 2.849A8.229 8.229 0 012 18.409a11.614 11.614 0 006.29 1.843c7.547 0 11.673-6.252 11.673-11.674 0-.177-.004-.354-.012-.531A8.338 8.338 0 0022 5.924z',
	size: 24,
};

export const TWITTER_FILLED = TWITTER_FILLED_24;
// 24x24/list/outline.svg
export const LIST_OUTLINE_24 = {
	d: 'M2 18h2v2H2v-2zm19 0H7c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zM2 13h2v-2H2v2zm19-2H7c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zm0-5c.6 0 1-.4 1-1s-.4-1-1-1h-9l-2 2h11zM9.7 2.3c-.4-.4-1-.4-1.4 0L5 5.6 3.7 4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4z',
	size: 24,
};

export const LIST_OUTLINE = LIST_OUTLINE_24;
export const LIST_24 = LIST_OUTLINE_24;
export const LIST = LIST_OUTLINE_24;
// 24x24/help circle/outline.svg
export const HELP_CIRCLE_OUTLINE_24 = {
	d: 'M22 12c0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10S6.477 2 12 2c5.522 0 10 4.478 10 10zM4 12c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm8 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-9C9.683 6 8 7.117 8 9a1 1 0 102 0c0-.731 1.196-1 2-1 1.144 0 2 .397 2 1 0 .355-.306.668-1.055 1.168C12.124 10.715 11 11.465 11 13v1h2v-1c0-.423.306-.668 1.055-1.168C14.876 11.285 16 10.535 16 9c0-1.883-1.683-3-4-3z',
	size: 24,
};

export const HELP_CIRCLE_OUTLINE = HELP_CIRCLE_OUTLINE_24;
export const HELP_CIRCLE_24 = HELP_CIRCLE_OUTLINE_24;
export const HELP_CIRCLE = HELP_CIRCLE_OUTLINE_24;
// 24x24/help circle/filled.svg
export const HELP_CIRCLE_FILLED_24 = {
	d: 'M16 9c0-1.883-1.682-3.25-4-3.25-2.317 0-4 1.367-4 3.25a1 1 0 102 0c0-.988 1.309-1.25 2-1.25.582 0 1.132.144 1.508.394.442.294.492.629.492.856 0 .423-.305.668-1.054 1.168C12.124 10.715 11 11.465 11 13v1h2v-1c0-.423.306-.668 1.055-1.168C14.875 11.285 16 10.535 16 9zm-2.5 7.5a1.5 1.5 0 10-3.001.001 1.5 1.5 0 003-.001zM22 12c0 5.522-4.477 10-10 10-5.522 0-10-4.478-10-10S6.478 2 12 2c5.523 0 10 4.478 10 10z',
	size: 24,
};

export const HELP_CIRCLE_FILLED = HELP_CIRCLE_FILLED_24;
// 24x24/menu burger typo/outline.svg
export const MENU_BURGER_TYPO_OUTLINE_24 = {
	d: 'M21 11a1 1 0 00-1-1H4a1 1 0 100 2h16a1 1 0 001-1zm0-5a1 1 0 00-1-1H4a1 1 0 100 2h16a1 1 0 001-1zm-1 8.832v3.16c0 .746-.368 1.161-1 1.161s-1-.575-1-1.321v-3h-1v3c0 1.526.981 2.168 2 2.168 1.019 0 2-.481 2-2.008v-3.16h-1zm-5 3l-2-3h-1v5h1v-3l2 3h1v-5h-1v3zm-7 2h3v-1H9v-1h2v-1H9v-1h2v-1H8v5zm-2-5h1v5H6v-3l-1 2.133-1-2.133v3H3v-5h1l1 2.344 1-2.344z',
	size: 24,
};

export const MENU_BURGER_TYPO_OUTLINE = MENU_BURGER_TYPO_OUTLINE_24;
export const MENU_BURGER_TYPO_24 = MENU_BURGER_TYPO_OUTLINE_24;
export const MENU_BURGER_TYPO = MENU_BURGER_TYPO_OUTLINE_24;
// 24x24/tools/outline.svg
export const TOOLS_OUTLINE_24 = {
	d: 'M18 14a3.99 3.99 0 00-1.637.363L15 13l-2 2 1.364 1.364A4.013 4.013 0 0014 18a3.993 3.993 0 001.174 2.84 4.006 4.006 0 003.857 1.024l-2.441-2.44.709-2.125 2.125-.709 2.44 2.44a3.998 3.998 0 00-1.024-3.856A4.012 4.012 0 0018 14zm-.793-5.793l-12.5 12.5a.997.997 0 01-1.414 0 .999.999 0 010-1.414l7-7-2.656-2.656A3.99 3.99 0 016 10a4.012 4.012 0 01-2.84-1.174A3.998 3.998 0 012.136 4.97l2.44 2.44 2.125-.709.709-2.125-2.441-2.44A4.006 4.006 0 018.826 3.16 3.993 3.993 0 0110 6a4.01 4.01 0 01-.364 1.636l2.657 2.657 3.5-3.5L12 3h4l6 6-2 2-2.793-2.793z',
	size: 24,
};

export const TOOLS_OUTLINE = TOOLS_OUTLINE_24;
export const TOOLS_24 = TOOLS_OUTLINE_24;
export const TOOLS = TOOLS_OUTLINE_24;
// 24x24/comment empty/outline.svg
export const COMMENT_EMPTY_OUTLINE_24 = {
	d: 'M12 3C5.415 3 2 5 2 10c0 3.73 1.355 4.932 4 6.053V21l6-4c6.585 0 10-2 10-7s-3.415-7-10-7zm0 2c7.382 0 8 2.581 8 5s-.618 5-8 5h-.605l-.504.336L8 17.263v-2.534l-1.22-.517C4.721 13.339 4 12.784 4 10c0-2.419.618-5 8-5z',
	size: 24,
};

export const COMMENT_EMPTY_OUTLINE = COMMENT_EMPTY_OUTLINE_24;
export const COMMENT_EMPTY_24 = COMMENT_EMPTY_OUTLINE_24;
export const COMMENT_EMPTY = COMMENT_EMPTY_OUTLINE_24;
// 24x24/comment empty/filled.svg
export const COMMENT_EMPTY_FILLED_24 = {
	d: 'M12 3C5.415 3 2 5 2 10c0 3.73 1.355 4.932 4 6.053V21l6-4c6.585 0 10-2 10-7s-3.415-7-10-7z',
	size: 24,
};

export const COMMENT_EMPTY_FILLED = COMMENT_EMPTY_FILLED_24;
// 24x24/help/outline.svg
export const HELP_OUTLINE_24 = {
	d: 'M16 9c0 1.5-1.1 2.3-1.9 2.8-.8.5-1.1.8-1.1 1.2v1h-2v-1c0-1.5 1.1-2.3 1.9-2.8.8-.5 1.1-.8 1.1-1.2 0-.6-.9-1-2-1-.8 0-2 .3-2 1 0 .6-.4 1-1 1s-1-.4-1-1c0-1.9 1.7-3 4-3s4 1.1 4 3zm-2.5 7.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z',
	size: 24,
};

export const HELP_OUTLINE = HELP_OUTLINE_24;
export const HELP_24 = HELP_OUTLINE_24;
export const HELP = HELP_OUTLINE_24;
// 24x24/star/outline.svg
export const STAR_OUTLINE_24 = {
	d: 'M12 2a.8.8 0 00-.736.479L8.619 8.091l-5.916.9C2.27 9.057 2 9.449 2 9.838c0 .274.075.442.249.619l4.28 4.368-1.01 6.168c-.092.558.332 1.007.814 1.007a.77.77 0 00.376-.101L12 19l5.291 2.899a.767.767 0 00.376.101c.482 0 .905-.449.814-1.007l-1.01-6.168 4.28-4.368A.79.79 0 0022 9.838c0-.389-.27-.781-.703-.847l-5.916-.9-2.645-5.612A.8.8 0 0012 2zm0 3.608l1.572 3.336.454.964 1.054.16 3.7.563-2.738 2.795-.708.723.163.999.628 3.831-3.164-1.733L12 16.72l-.961.526-3.164 1.733.628-3.831.163-.999-.709-.723-2.737-2.795 3.7-.563 1.054-.16.454-.964L12 5.608z',
	size: 24,
};

export const STAR_OUTLINE = STAR_OUTLINE_24;
export const STAR_24 = STAR_OUTLINE_24;
export const STAR = STAR_OUTLINE_24;
// 24x24/star/filled.svg
export const STAR_FILLED_24 = {
	d: 'M22 9.838c0-.39-.27-.781-.703-.847l-5.916-.9-2.645-5.612a.8.8 0 00-.736-.48.8.8 0 00-.736.48L8.619 8.09l-5.916.9C2.27 9.057 2 9.449 2 9.838c0 .274.075.442.249.619l4.28 4.368-1.01 6.168c-.092.558.332 1.007.814 1.007a.78.78 0 00.376-.1L12 19l5.291 2.9c.123.068.252.1.376.1.482 0 .905-.45.814-1.007l-1.01-6.168 4.28-4.368a.79.79 0 00.249-.62z',
	size: 24,
};

export const STAR_FILLED = STAR_FILLED_24;
// 24x24/minimize alt2/outline.svg
export const MINIMIZE_ALT2_OUTLINE_24 = {
	d: 'M14 8V4c0-.6.4-1 1-1s1 .4 1 1v4h4c.6 0 1 .4 1 1s-.4 1-1 1h-4c-1.1 0-2-.9-2-2zM9 3c-.6 0-1 .4-1 1v4H4c-.6 0-1 .4-1 1s.4 1 1 1h4c1.1 0 2-.9 2-2V4c0-.6-.4-1-1-1zM8 14H4c-.6 0-1 .4-1 1s.4 1 1 1h4v4c0 .6.4 1 1 1s1-.4 1-1v-4c0-1.1-.9-2-2-2zm12 0h-4c-1.1 0-2 .9-2 2v4c0 .6.4 1 1 1s1-.4 1-1v-4h4c.6 0 1-.4 1-1s-.4-1-1-1z',
	size: 24,
};

export const MINIMIZE_ALT2_OUTLINE = MINIMIZE_ALT2_OUTLINE_24;
export const MINIMIZE_ALT2_24 = MINIMIZE_ALT2_OUTLINE_24;
export const MINIMIZE_ALT2 = MINIMIZE_ALT2_OUTLINE_24;
// 24x24/plus/outline.svg
export const PLUS_OUTLINE_24 = {
	d: 'M17 11h-4V7a1 1 0 10-2 0v4H7a1 1 0 100 2h4v4a1 1 0 102 0v-4h4a1 1 0 100-2z',
	size: 24,
};

export const PLUS_OUTLINE = PLUS_OUTLINE_24;
export const PLUS_24 = PLUS_OUTLINE_24;
export const PLUS = PLUS_OUTLINE_24;
// 24x24/mail group alt/outline.svg
export const MAIL_GROUP_ALT_OUTLINE_24 = {
	d: 'M19 3H9v2h10c1.654 0 3 1.346 3 3v5h2V8c0-2.757-2.243-5-5-5zm-1 14v-4.685l-6.5 2.6-6.5-2.6V17c0 .552.449 1 1 1h11c.551 0 1-.448 1-1zM5 10v.484l6.5 2.601 6.5-2.601V10c0-.552-.449-1-1-1H6c-.551 0-1 .448-1 1zm15 0v7c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3v-7c0-1.654 1.346-3 3-3h11c1.654 0 3 1.346 3 3z',
	size: 24,
};

export const MAIL_GROUP_ALT_OUTLINE = MAIL_GROUP_ALT_OUTLINE_24;
export const MAIL_GROUP_ALT_24 = MAIL_GROUP_ALT_OUTLINE_24;
export const MAIL_GROUP_ALT = MAIL_GROUP_ALT_OUTLINE_24;
// 24x24/mail group alt/filled.svg
export const MAIL_GROUP_ALT_FILLED_24 = {
	d: 'M19 3c2.757 0 5 2.243 5 5v5h-2V8c0-1.654-1.346-3-3-3H9V3h10zm.969 6.697L11.5 13.085 3.03 9.697C3.185 8.187 4.449 7 6 7h11c1.551 0 2.814 1.187 2.969 2.697zM11.5 14.915L3 11.516V17c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-5.484l-8.5 3.399z',
	size: 24,
};

export const MAIL_GROUP_ALT_FILLED = MAIL_GROUP_ALT_FILLED_24;
// 24x24/share android/outline.svg
export const SHARE_ANDROID_OUTLINE_24 = {
	d: 'M15.5 17a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM6 14a2 2 0 11.001-4.001A2 2 0 016 14zM17 4a2 2 0 11-.001 4.001A2 2 0 0117 4zm0 6c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4c0 .312.045.613.112.905L8.891 9.25A3.98 3.98 0 006 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c.976 0 1.858-.365 2.554-.947l3.576 2.554c-.076.287-.13.582-.13.893 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5c-.894 0-1.701.347-2.32.899l-3.456-2.468A3.96 3.96 0 0010 12c0-.347-.059-.678-.142-1l4.188-2.326A3.976 3.976 0 0017 10z',
	size: 24,
};

export const SHARE_ANDROID_OUTLINE = SHARE_ANDROID_OUTLINE_24;
export const SHARE_ANDROID_24 = SHARE_ANDROID_OUTLINE_24;
export const SHARE_ANDROID = SHARE_ANDROID_OUTLINE_24;
// 24x24/share android/filled.svg
export const SHARE_ANDROID_FILLED_24 = {
	d: 'M17 10c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4c0 .312.045.613.112.905L8.891 9.25A3.98 3.98 0 006 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c.976 0 1.858-.365 2.554-.947l3.576 2.554c-.076.287-.13.582-.13.893 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5c-.894 0-1.701.347-2.32.899l-3.456-2.468A3.96 3.96 0 0010 12c0-.347-.059-.678-.142-1l4.188-2.326A3.976 3.976 0 0017 10z',
	size: 24,
};

export const SHARE_ANDROID_FILLED = SHARE_ANDROID_FILLED_24;
// 24x24/folder/outline.svg
export const FOLDER_OUTLINE_24 = {
	d: 'M20 11H4c0 2.902.736 5.119 1.223 6.586l.064.194a.98.98 0 00.724.659C7.193 18.68 9.099 19 12 19s4.807-.32 5.989-.561a.98.98 0 00.724-.659l.064-.194C19.264 16.119 20 13.902 20 11zm2 0c0 3.36-.873 5.849-1.388 7.408a2.972 2.972 0 01-2.224 1.991C17.02 20.678 15 21 12 21s-5.02-.322-6.388-.601a2.972 2.972 0 01-2.224-1.991C2.873 16.849 2 14.36 2 11c0-1.215.664-2 2-2h16c1.336 0 2 .785 2 2zM4.981 8h-2V5c0-1.103.916-2 2.019-2h3c1.357 0 2.087 1.122 2.574 2H18c1.755 0 2.981 1.233 2.981 3h-2c0-.663-.33-1-.981-1H9.981a1 1 0 01-.874-.514l-.153-.28C8.694 5.726 8.301 5 8 5H4.981v3z',
	size: 24,
};

export const FOLDER_OUTLINE = FOLDER_OUTLINE_24;
export const FOLDER_24 = FOLDER_OUTLINE_24;
export const FOLDER = FOLDER_OUTLINE_24;
// 24x24/folder/filled.svg
export const FOLDER_FILLED_24 = {
	d: 'M22 11c0 3.36-.873 5.849-1.389 7.408a2.97 2.97 0 01-2.223 1.991C17.02 20.678 15 21 12 21s-5.02-.322-6.388-.601a2.97 2.97 0 01-2.223-1.991C2.873 16.849 2 14.36 2 11c0-1.215.664-2 2-2h16c1.336 0 2 .785 2 2zm-1.02-3h-18V5c0-1.103.917-2 2.02-2h3c1.357 0 2.087 1.121 2.574 2H18c1.755 0 2.98 1.233 2.98 3z',
	size: 24,
};

export const FOLDER_FILLED = FOLDER_FILLED_24;
// 24x24/windows/outline.svg
export const WINDOWS_OUTLINE_24 = {
	d: 'M22 6v6c0 1.654-1.346 3-3 3h-1v-2h1a1 1 0 001-1V6a1 1 0 00-1-1h-8a1 1 0 00-1 1v1H8V6c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3zm-8 13a1 1 0 01-1 1H5a1 1 0 01-1-1v-7a1 1 0 011-1h8a1 1 0 011 1v7zM13 9H5c-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3v-7c0-1.654-1.346-3-3-3z',
	size: 24,
};

export const WINDOWS_OUTLINE = WINDOWS_OUTLINE_24;
export const WINDOWS_24 = WINDOWS_OUTLINE_24;
export const WINDOWS = WINDOWS_OUTLINE_24;
// 24x24/windows/filled.svg
export const WINDOWS_FILLED_24 = {
	d: 'M19 3h-8C9.346 3 8 4.346 8 6v1h5c2.757 0 5 2.243 5 5v3h1c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3zm-3 9v7c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-7c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3z',
	size: 24,
};

export const WINDOWS_FILLED = WINDOWS_FILLED_24;
// 24x24/arrow left/outline.svg
export const ARROW_LEFT_OUTLINE_24 = {
	d: 'M2.293 12.707l6 6a.997.997 0 001.414 0c.194-.194.292-.452.293-.707a.989.989 0 00-.293-.707L5.414 13H21a1 1 0 100-2H5.414l4.293-4.293a.997.997 0 000-1.414A1.006 1.006 0 009 5a.989.989 0 00-.707.293l-6 6a.997.997 0 000 1.414z',
	size: 24,
};

export const ARROW_LEFT_OUTLINE = ARROW_LEFT_OUTLINE_24;
export const ARROW_LEFT_24 = ARROW_LEFT_OUTLINE_24;
export const ARROW_LEFT = ARROW_LEFT_OUTLINE_24;
// 24x24/arrow left/filled.svg
export const ARROW_LEFT_FILLED_24 = {
	d: 'M21 11H11V6a1 1 0 00-1.65-.759l-7 6a.999.999 0 000 1.518l7 6a.993.993 0 001.068.149A1 1 0 0011 18v-5h10a1 1 0 100-2z',
	size: 24,
};

export const ARROW_LEFT_FILLED = ARROW_LEFT_FILLED_24;
// 24x24/linkedin/filled.svg
export const LINKEDIN_FILLED_24 = {
	d: 'M17.73 17.728h-2.41V13.95c0-.901-.017-2.06-1.254-2.06-1.256 0-1.45.982-1.45 1.994v3.843h-2.411V9.96h2.315v1.062h.032c.324-.61 1.11-1.255 2.284-1.255 2.444 0 2.896 1.608 2.896 3.7v4.26zM7.46 8.85a1.407 1.407 0 11-.002-2.815A1.407 1.407 0 017.46 8.85zm-1.183 8.877H8.69V9.96H6.276v7.767zM19.364 3H4.636C3.733 3 3 3.733 3 4.636v14.728C3 20.268 3.733 21 4.636 21h14.728c.904 0 1.637-.732 1.637-1.636V4.636A1.638 1.638 0 0019.364 3z',
	size: 24,
};

export const LINKEDIN_FILLED = LINKEDIN_FILLED_24;
// 24x24/maximize alt1/outline.svg
export const MAXIMIZE_ALT1_OUTLINE_24 = {
	d: 'M15 3l2.293 2.293-3 3a.999.999 0 101.414 1.414l3-3L21 9V3h-6zM8.293 14.293l-3 3L3 15v6h6l-2.293-2.293 3-3a.999.999 0 10-1.414-1.414zM19 18a1 1 0 01-1 1h-5v2h5c1.654 0 3-1.346 3-3v-5h-2v5zM6 3h5v2H6a1 1 0 00-1 1v5H3V6c0-1.654 1.346-3 3-3z',
	size: 24,
};

export const MAXIMIZE_ALT1_OUTLINE = MAXIMIZE_ALT1_OUTLINE_24;
export const MAXIMIZE_ALT1_24 = MAXIMIZE_ALT1_OUTLINE_24;
export const MAXIMIZE_ALT1 = MAXIMIZE_ALT1_OUTLINE_24;
// 24x24/lightbulb alt1/outline.svg
export const LIGHTBULB_ALT1_OUTLINE_24 = {
	d: 'M8 20h8l-.7 1.4c-.2.4-.5.6-.9.6H9.6c-.4 0-.7-.2-.9-.6L8 20zm11-10c0 2.4-1.2 4.5-3 5.7V19H8v-3.3c-1.8-1.2-3-3.3-3-5.7 0-3.9 3.1-7 7-7s7 3.1 7 7zm-2 0c0-2.8-2.2-5-5-5s-5 2.2-5 5c0 1.6.8 3.1 2.1 4.1l.9.6V17h4v-2.3l.9-.6c1.3-1 2.1-2.5 2.1-4.1zm-4-1.5c0 .8.7 1.5 1.5 1.5S16 9.3 16 8.5 15.3 7 14.5 7 13 7.7 13 8.5z',
	size: 24,
};

export const LIGHTBULB_ALT1_OUTLINE = LIGHTBULB_ALT1_OUTLINE_24;
export const LIGHTBULB_ALT1_24 = LIGHTBULB_ALT1_OUTLINE_24;
export const LIGHTBULB_ALT1 = LIGHTBULB_ALT1_OUTLINE_24;
// 24x24/lightbulb alt1/filled.svg
export const LIGHTBULB_ALT1_FILLED_24 = {
	d: 'M8 20h8l-.7 1.4c-.2.4-.5.6-.9.6H9.6c-.4 0-.7-.2-.9-.6L8 20zm11-10c0 2.4-1.2 4.5-3 5.7V19H8v-3.3c-1.8-1.2-3-3.3-3-5.7 0-3.9 3.1-7 7-7s7 3.1 7 7zm-3-1.5c0-.8-.7-1.5-1.5-1.5S13 7.7 13 8.5s.7 1.5 1.5 1.5S16 9.3 16 8.5z',
	size: 24,
};

export const LIGHTBULB_ALT1_FILLED = LIGHTBULB_ALT1_FILLED_24;
// 24x24/connect point/outline.svg
export const CONNECT_POINT_OUTLINE_24 = {
	d: 'M12 8c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm10 12c0-.738-.404-1.376-1-1.723V14a1 1 0 00-1-1h-7V9.858A3.99 3.99 0 0016 6a4 4 0 00-8 0 3.99 3.99 0 003 3.858V13H4a1 1 0 00-1 1v4.277c-.596.347-1 .985-1 1.723a2 2 0 004 0c0-.738-.404-1.376-1-1.723V15h6v3.277c-.596.347-1 .985-1 1.723a2 2 0 004 0c0-.738-.404-1.376-1-1.723V15h6v3.277c-.596.347-1 .985-1 1.723a2 2 0 004 0z',
	size: 24,
};

export const CONNECT_POINT_OUTLINE = CONNECT_POINT_OUTLINE_24;
export const CONNECT_POINT_24 = CONNECT_POINT_OUTLINE_24;
export const CONNECT_POINT = CONNECT_POINT_OUTLINE_24;
// 24x24/camera/outline.svg
export const CAMERA_OUTLINE_24 = {
	d: 'M12 9a4 4 0 100 8 4 4 0 000-8zm0 2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm2.465-8h-4.93c-.334 0-.646.167-.832.445L7 6c-.873.074-1.793.233-2.603.403A3.004 3.004 0 002 9.344v8.16c0 1.485 1.08 2.75 2.55 2.967A51.56 51.56 0 0012 21c3.116 0 5.693-.27 7.45-.529A2.992 2.992 0 0022 17.504v-8.16a3.004 3.004 0 00-2.397-2.941c-.81-.17-1.73-.329-2.603-.403l-1.703-2.555A1.001 1.001 0 0014.465 3zm-.535 2l1.406 2.109.534.801.959.083c.681.058 1.476.182 2.363.367.476.1.808.504.808.984v8.16a.986.986 0 01-.842.988A49.646 49.646 0 0112 19c-3.073 0-5.589-.276-7.158-.508A.986.986 0 014 17.504v-8.16c0-.48.332-.884.808-.984a20.222 20.222 0 012.363-.367l.959-.083.534-.801L10.07 5h3.86z',
	size: 24,
};

export const CAMERA_OUTLINE = CAMERA_OUTLINE_24;
export const CAMERA_24 = CAMERA_OUTLINE_24;
export const CAMERA = CAMERA_OUTLINE_24;
// 24x24/camera/filled.svg
export const CAMERA_FILLED_24 = {
	d: 'M16 13a4 4 0 10-8 0 4 4 0 008 0zm6-3.656v8.16c0 1.485-1.08 2.75-2.55 2.967A51.56 51.56 0 0112 21a51.56 51.56 0 01-7.45-.529A2.992 2.992 0 012 17.504v-8.16a3.004 3.004 0 012.397-2.941C5.207 6.233 6.127 6.074 7 6l1.703-2.555c.186-.278.498-.445.832-.445h4.93c.334 0 .646.167.832.445L17 6c.873.074 1.793.233 2.603.403A3.004 3.004 0 0122 9.344zM14 13c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2z',
	size: 24,
};

export const CAMERA_FILLED = CAMERA_FILLED_24;
// 24x24/search/outline.svg
export const SEARCH_OUTLINE_24 = {
	d: 'M10.5 17A6.508 6.508 0 014 10.5C4 6.916 6.916 4 10.5 4S17 6.916 17 10.5 14.084 17 10.5 17zM21 18.666c-.802-.681-2.498-2.097-3.85-2.881A8.451 8.451 0 0019 10.5a8.5 8.5 0 10-8.5 8.5 8.455 8.455 0 005.282-1.848c.786 1.353 2.204 3.052 2.884 3.848.639.748 1.006 1 1.834 1a1.5 1.5 0 001.5-1.5c0-.828-.341-1.273-1-1.834z',
	size: 24,
};

export const SEARCH_OUTLINE = SEARCH_OUTLINE_24;
export const SEARCH_24 = SEARCH_OUTLINE_24;
export const SEARCH = SEARCH_OUTLINE_24;
// 24x24/file word/outline.svg
export const FILE_WORD_OUTLINE_24 = {
	d: 'M19.487 16.823a3.486 3.486 0 01-2.664 2.664 22.886 22.886 0 01-9.646 0 3.484 3.484 0 01-2.664-2.664A22.82 22.82 0 014 12c0-1.627.172-3.249.513-4.823a3.481 3.481 0 012.664-2.664 22.886 22.886 0 019.646 0 3.486 3.486 0 012.664 2.664C19.828 8.752 20 10.374 20 12a22.82 22.82 0 01-.513 4.823zm1.955-10.069a5.473 5.473 0 00-4.196-4.195A24.711 24.711 0 0012 2c-1.8 0-3.555.192-5.246.558a5.473 5.473 0 00-4.196 4.196A24.762 24.762 0 002 12c0 1.8.192 3.555.558 5.245a5.472 5.472 0 004.196 4.196C8.445 21.808 10.2 22 12 22c1.8 0 3.555-.192 5.246-.559a5.473 5.473 0 004.196-4.196A24.76 24.76 0 0022 12c0-1.8-.192-3.555-.558-5.246zm-6.939 8.352c-.038-.354-1.658-7-1.658-7h-1.658s-1.582 6.659-1.633 7.025c-.038-.366-1.646-7.025-1.646-7.025h-1.91l2.379 8.861h2.241s1.367-5.759 1.405-6.088c.024.329 1.392 6.088 1.392 6.088h2.241l2.342-8.861h-1.811s-1.645 6.646-1.684 7z',
	size: 24,
};

export const FILE_WORD_OUTLINE = FILE_WORD_OUTLINE_24;
export const FILE_WORD_24 = FILE_WORD_OUTLINE_24;
export const FILE_WORD = FILE_WORD_OUTLINE_24;
// 24x24/file word/filled.svg
export const FILE_WORD_FILLED_24 = {
	d: 'M15.656 16.967l2.342-8.86h-1.812s-1.644 6.645-1.682 7c-.038-.355-1.659-7-1.659-7h-1.659s-1.582 6.658-1.632 7.024c-.038-.366-1.646-7.024-1.646-7.024h-1.91l2.379 8.86h2.241s1.366-5.759 1.404-6.088c.026.329 1.393 6.088 1.393 6.088h2.241zm5.785-10.213C21.807 8.446 22 10.2 22 12c0 1.8-.193 3.555-.559 5.245a5.473 5.473 0 01-4.195 4.197A24.783 24.783 0 0112 22c-1.8 0-3.555-.192-5.246-.558a5.474 5.474 0 01-4.197-4.197A24.825 24.825 0 012 12c0-1.801.192-3.555.557-5.246a5.474 5.474 0 014.198-4.196A24.825 24.825 0 0112 2c1.8 0 3.554.193 5.246.559a5.474 5.474 0 014.195 4.195z',
	size: 24,
};

export const FILE_WORD_FILLED = FILE_WORD_FILLED_24;
// 24x24/edit text/outline.svg
export const EDIT_TEXT_OUTLINE_24 = {
	d: 'M21.414 3.586c.391.391.586.902.586 1.414a1.99 1.99 0 01-.586 1.414l-1 1-2.828-2.828 1-1A1.99 1.99 0 0120 3a1.99 1.99 0 011.414.586zm-4.828 2l2.828 2.828-11 11L4 21l1.586-4.414 11-11zM8 11l-2 2H2v-2h6zm4-4l-2 2H2V7h10zm2-2l2-2H2v2h12z',
	size: 24,
};

export const EDIT_TEXT_OUTLINE = EDIT_TEXT_OUTLINE_24;
export const EDIT_TEXT_24 = EDIT_TEXT_OUTLINE_24;
export const EDIT_TEXT = EDIT_TEXT_OUTLINE_24;
// 24x24/edit text/filled.svg
export const EDIT_TEXT_FILLED_24 = {
	d: 'M16 5l1.172-1.172A2.848 2.848 0 0119.197 3c.803 0 1.429.283 1.975.828.552.553.828 1.276.828 2 0 .725-.276 1.448-.828 2L20 9l-4-4zm-1 1l4 4-9 9-6 2 2-6 9-9zm-8 5l-2 2H2v-2h5zm4-4L9 9H2V7h9zm2-2l2-2H2v2h11z',
	size: 24,
};

export const EDIT_TEXT_FILLED = EDIT_TEXT_FILLED_24;
// 24x24/mail/outline.svg
export const MAIL_OUTLINE_24 = {
	d: 'M17.121 18.614c-3.22.512-7.02.512-10.243 0a3.034 3.034 0 01-1.447-.657l4.272-4.43L12 15.25l2.297-1.723 4.272 4.43c-.408.334-.9.57-1.448.657zM4.368 16.177c-.003-.015-.01-.03-.013-.047A24.694 24.694 0 014 12c0-.867.066-1.747.163-2.628l3.927 2.945-3.722 3.86zM6.802 5.398C8.418 5.135 10.23 5.002 12 5a32.59 32.59 0 015.121.386 3.038 3.038 0 012.311 1.8c-.01.006-.022.007-.032.014L12 12.75 4.6 7.2c-.01-.008-.023-.009-.034-.017.397-.933 1.226-1.622 2.236-1.785zm9.108 6.92l3.927-2.946c.097.881.163 1.761.163 2.628 0 1.36-.12 2.75-.356 4.13-.002.015-.009.031-.012.047l-3.722-3.86zm5.706-4.785a5.041 5.041 0 00-4.18-4.123A35.131 35.131 0 0012 3c-1.892 0-3.783.142-5.518.424-2.089.337-3.736 1.99-4.098 4.11A26.58 26.58 0 002 12c0 1.472.13 2.975.384 4.467a5.037 5.037 0 004.18 4.122A34.84 34.84 0 0012 21c1.892 0 3.721-.139 5.435-.41a5.037 5.037 0 004.181-4.124c.255-1.49.384-2.994.384-4.466s-.129-2.975-.384-4.467z',
	size: 24,
};

export const MAIL_OUTLINE = MAIL_OUTLINE_24;
export const MAIL_24 = MAIL_OUTLINE_24;
export const MAIL = MAIL_OUTLINE_24;
// 24x24/mail/filled.svg
export const MAIL_FILLED_24 = {
	d: 'M14.348 13.577L12 15.221l-2.347-1.644-5.628 5.803a5.03 5.03 0 002.54 1.21c1.715.27 3.544.41 5.435.41 1.892 0 3.72-.139 5.436-.41a5.03 5.03 0 002.54-1.21l-5.628-5.803zm1.66-1.16l5.187 5.347a5.04 5.04 0 00.42-1.297A26.46 26.46 0 0022 12c0-1.186-.106-2.389-.271-3.589l-5.721 4.005zM12 12.778l9.23-6.46a5.033 5.033 0 00-3.794-2.909A34.665 34.665 0 0012 3c-1.876.002-3.797.144-5.518.424-1.666.27-3.037 1.382-3.713 2.893l9.23 6.462zm-9.615 3.687A26.45 26.45 0 012 12c0-1.186.107-2.389.272-3.589l5.72 4.005-5.186 5.348a5.022 5.022 0 01-.421-1.298z',
	size: 24,
};

export const MAIL_FILLED = MAIL_FILLED_24;
